import { HttpClient } from '@angular/common/http';
import { NgModule, Component, ViewChild , OnInit, OnDestroy, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ReportService } from '../../services/report.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng-lts/api';
import { NgxSpinnerService } from 'ngx-spinner';
import {DialogModule} from 'primeng-lts/dialog';
import { MomentService } from 'src/app/vehicles/services/moment.service';
import { EvaluationCriteria } from 'src/app/events/models/interfaces';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { TabService } from 'src/app/panel/services/tab.service';
import { UserDataService } from 'src/app/profile-config/services/user-data.service';
import { EvaluationCriteriaService } from 'src/app/events/services/evaluation-criteria.service';
import { filter, take  } from 'rxjs/operators';

import { getFileExportParadasMovimientos } from './utils/rep-paradas-movimientos.util';
import { getFileExportExcesosVelocidad } from './utils/rep-excesos-velocidad.util';
import { getFileExportEntradaSalida } from './utils/rep-entrada-salida.util';
import { getFileExportResumenPorDia } from './utils/rep-resumen-por-dia.util';
import { getFileExportCombustible } from './utils/rep-combustible.util';
import { getFileExportCombustibleResumen } from './utils/rep-combustible-resumen.util';
import { getFileExportCombustibleResumenDash } from './utils/rep-combustible-resumen-dash.util';
import { BehaviorSubject} from 'rxjs';

import { getFileExportGeneral } from './utils/rep-general.util';
import { getFileExportEventosEvaluacionCIPIA } from './utils/rep-eventos-evaluacion-cipia.util';
import { getFileExportEventosCIPIA } from './utils/rep-eventos-cipia.util';
import { getFileExportPosicion } from './utils/rep-posicion.util';

import { getFileExportEstadoTransmisionEventos } from './utils/rep-estado-transmision-eventos.util';
import { getFileExportMonitoreoCantidadEventosUnidad } from './utils/rep-monitoreo-cantidad-eventos-unidad.util';
import { getFileExportOperatividadEquipos } from './utils/rep-operatividad-equipos.util';




import { getReportTextHtml } from './utils/result.utils';



import { AllRows, Columns, ReportData } from './result.interface';



// import { AnyARecord } from 'dns';
// declare var $: any;
declare var $j: any;
declare var pdfMake: any;
declare var kendo: any

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})

export class ResultComponent implements OnDestroy, OnInit {
  // COMMENT DEVELOP - TEST
  @ViewChild(DataTableDirective)
  dtElement!: DataTableDirective;
  currentActiveTables: string[] = [];
  directSorting: boolean = true;

  dtOptions: any = {};
  dtOptions2: any = {};
  dtOptions3: any = {};
  dtOptions4: any = {};
  dtOptions5: any = {};

  seeTableRepGerencial: boolean = true;
  indexTRG = 0;
  dtTrigger = new Subject<any>();
  data: any; //holds the data to be rendered
  sortedData: any; //holds the data to be exported
  sortedDataOneTabla: any; //holds the data to be exported
  exportOneTable = false;
  table_hide = 'd-none';
  report_data: ReportData = {
    num_rep: '',
    rep_title: '',
    rep_subtitle: '',
  };
  eC: any = {};
  chkRiesgo: boolean = true;
  str_nombre_eventos = '';

  period: string='';
  table_headers: any;
  table_data: any;
  chkDateHour: any;
  chkFatigaSomnolencia: any;
  chkFatigaDistraccion: any;
  chkFrenada: any;
  chkAceleracion: any;
  chkDuracion: any;
  chkOdomV: any;
  params:any;
  repTitle: any;
  Math = Math;

  //@Output() localStorageReportData = new EventEmitter();
  is_new_tab: boolean = false;
  dt_completed = 0;

  reportOption = 0;

  dtRendered = localStorage.getItem("report_data") !== null;

  /* EXPORTAR */
  t1=14; // Titulo Principal
  t2=9; // Sub titulos
  t2_c=9; // Contenido Sub titulos
  t3=9; // Cabeceras
  c1=9; // Cuerpo
  r1=9; // RESUMEN

  t1_2=14; // Titulo Principal
  tt1_2=9; // Titulo Principal linea 2
  t2_2=9; // Sub titulos
  c1_2=9; // Cuerpo del nuevo formato

  /* ANCHOS COLUMNAS */
  w_item = 40; // index
  w_date_hour = 94;
  w_date = 80;
  w_hour = 64;
  w_date_and_hour = 115;
  w_date_ini_fin= 94;
  w_hour_ini_fin= 86;
  w_codigo = 80;
  w_placa = 70;
  w_velocidad = 96;
  w_velocidad_gps_can = 130;
  w_velocidad_gps_can_short = 88;
  w_odometro = 110;
  w_duracion = 173;
  w_lat_long = 140;

  //Width de col en px = (ancho de caracter * nro de letras) + 5
  //char_to_px = 9; // Ancho de un caracter en pixeles, considerando M como la letra más ancha, y tamaño de fuente 9
  char_to_px = 9; // Ancho de un caracter en pixeles

  isChromium = window.chrome? true:false;
	winNav = window.navigator;
	vendorName = this.winNav.vendor;
	isOpera = typeof window.opr !== "undefined";
	isIEedge = this.winNav.userAgent.indexOf("Edge") > -1;
	isIOSChrome = this.winNav.userAgent.match("CriOS");
	isChrome = false;
  isFirefox = false;
  isSafari = false;
  isEdge = false;

  modalDetalleRepExcesosEnZona = false;
  modalDetalleRepNoRostro = false;
  modalDetalleRepFatigaExtrema = false;

  detalleExcesosEnZona : any = "";
  detalleNoRostro : any = "";
  detalleFatigaExtrema : any = "";
  tablaString = "";

  headerBackground = '#fff';
  headerTextColor = '#244062';
  headerBold: boolean = true;
  headerRowSpan = 3;

  vehicleHeaderBackground = '#a6a6a6';
  vehicleHeaderTextColor = '#fff';
  vehicleHeaderBold: boolean = false;
  periodHeaderBackground = '#a6a6a6';
  periodHeaderTextColor = '#fff';
  periodHeaderBold: boolean = false;
  rutaHeaderBackground = '#a6a6a6';
  rutaHeaderTextColor = '#fff';
  rutaHeaderBold: boolean = false;

  vehicleContentBackground = '#eeece1';
  vehicleContentTextColor = '#000';
  vehicleContentBold: boolean = false;
  periodContentBackground = '#eeece1';
  periodContentTextColor = '#000';
  periodContentBold: boolean = false;
  rutaContentBackground = '#eeece1';
  rutaContentTextColor = '#000';
  rutaContentBold: boolean = false;

  subHeaderContentRowSpan = 2;
  subHeaderContentHeight = 12;

  colsHeaderBackground = '#244062';
  colsHeaderTextColor = '#fff';
  colsHeaderBold : boolean = false;
  freezeRowBorderColor = '#000';


  overviewTotalLeftBackground = '#c5d9f1';
  overviewTotalRightBackground = '#95b3d7';
  overviewTotalLeftTextColor = '#000';
  overviewTotalRightTextColor = '#000';
  overviewTotalLeftBold = false;
  overviewTotalRightBold = false;

  headersBorderColor = '#fff';
  headersBorderSize = 1;

  headerRowsHeight = 12;
  subHeaderRepPosicionHeight = 15;
  subHeaderHeight = 12;
  colsHeaderHeight = 18.75;
  colsHeaderHeightTwoLine = this.colsHeaderHeight * 2 + 2.5;
  bodyRowsHeight = 12;
  overviewRowsHeight = this.bodyRowsHeight;

  excelUnitstoPxRatio = 4/3;

  headerCellConfig = {
    bold: this.headerBold,
    color: this.headerTextColor,
    background: this.headerBackground,
    vAlign: "center",
    hAlign: "center",
    fontSize: this.t1,
    rowSpan: this.headerRowSpan,
    wrap: true,
  };

  subHeaderVehicleHeaderConfig = {
    bold: this.vehicleHeaderBold,
    color: this.vehicleHeaderTextColor,
    background: this.vehicleHeaderBackground,
    vAlign: "center",
    hAlign: "center",
    fontSize: this.t2,
    borderRight: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderLeft: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderTop: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
  };
  subHeaderPeriodHeaderConfig = {
    bold: this.periodHeaderBold,
    color: this.periodHeaderTextColor,
    background: this.periodHeaderBackground,
    vAlign: "center",
    hAlign: "center",
    fontSize: this.t2,
    borderRight: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderLeft: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderTop: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
  };
  subHeaderRutaHeaderConfig = {
    bold: this.rutaHeaderBold,
    color: this.rutaHeaderTextColor,
    background: this.rutaHeaderBackground,
    vAlign: "center",
    hAlign: "center",
    fontSize: this.t2,
    borderRight: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderLeft: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderTop: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
  };

  subHeaderVehicleContentConfig = {
    bold: this.vehicleContentBold,
    color: this.vehicleContentTextColor,
    background: this.vehicleContentBackground,
    vAlign: "center",
    hAlign: "center",
    fontSize: this.t2,
    rowSpan: this.subHeaderContentRowSpan,
    borderRight: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderLeft: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderTop: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
  };
  subHeaderPeriodContentConfig = {
    bold: this.periodContentBold,
    color: this.periodContentTextColor,
    background: this.periodContentBackground,
    vAlign: "center",
    hAlign: "center",
    fontSize: this.t2,
    rowSpan: this.subHeaderContentRowSpan,
    borderRight: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderLeft: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderTop: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
  };
  subHeaderRutaContentConfig = {
    bold: this.rutaContentBold,
    color: this.rutaContentTextColor,
    background: this.rutaContentBackground,
    vAlign: "center",
    hAlign: "center",
    fontSize: this.t2,
    rowSpan: this.subHeaderContentRowSpan,
    borderRight: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderLeft: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderTop: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
  };

  colHeaderConfig = {
    bold: this.colsHeaderBold,
    color: this.colsHeaderTextColor,
    background: this.colsHeaderBackground,
    vAlign: "center",
    hAlign: "center",
    fontSize: this.t3,
    borderRight: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderLeft: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
    borderTop: {
      color: this.headersBorderColor,
      size: this.headersBorderSize
    },
  };

  bodyRowsConfig = {
    vAlign: "center",
    hAlign: "center",
    fontSize: this.c1
  };

  overviewLeftConfig = {
    bold: this.overviewTotalLeftBold,
    color: this.overviewTotalLeftTextColor,
    background: this.overviewTotalLeftBackground,
    vAlign: "center",
    hAlign: "center",
    fontSize: this.r1,
    colSpan: 3,
  }
  overviewRightConfig = {
    bold: this.overviewTotalRightBold,
    color: this.overviewTotalRightTextColor,
    background: this.overviewTotalRightBackground,
    vAlign: "center",
    hAlign: "center",
    fontSize: this.r1,
    colSpan: 2,
  }

  spaceBetweenTables:any = [];

  //Web Report
  reportTableVehicleDropdownOptions: any = [];
  reportTableVehicleSelected = {
    name: '',
    dataSize: '',
    index: -1,
  };
  reportTableDropdownData: any = [];
  singleTableReportIDs = ['R008', 'R020', 'R021'];
  chkTableDropdown: boolean = false;


  columnsConfig: any = [];

  tablaFormatoBetsy_1: any = [];

  dtTableCurrentOrder = [[0, 'asc']];

  dataTableStartingIndex: number = -1;
  dataTableEndingIndex: number = -1;
  user_id: any;

  userLineaIDs: number[] = [945,946,947,956,958]; //928,935

  operators: string[] = [];
  constructor(
    public evaluationCriteriaService: EvaluationCriteriaService,
    private spinner: NgxSpinnerService,
    private http:HttpClient,
    public reportService:ReportService,
    private titleService:Title,
    private toastr:ToastrService,
    private confirmationService:ConfirmationService,
    private tabService: TabService,
    private momentService: MomentService,
    public userDataService: UserDataService,
    private sanitizer: DomSanitizer
  ){
    if(this.tabService.currentTab == ''){
      this.tabService.setCurrentTab('result-tab');
    }
  }

  private imageChecklistLoadedSubject = new BehaviorSubject<boolean>(false);
  imageChecklistLoaded$ = this.imageChecklistLoadedSubject.asObservable();
  private imageCache: { [key: string]: {
    blob: Blob | null;
    objectUrl: string;
    safeUrl: SafeUrl | string;
    isLoading: boolean;
    hasError: boolean;
  } } = {};


  ngOnInit(){
    console.log("======================================= ngOnInit  RESULT");
    this.progressMessage = 'Procesando checklist...'; // mensaje inicial
    this.loadLogos();
    this.columnsConfig = [
      // { //REPORTE DE PARADAS Y MOVIMIENTOS
      //   num_rep: ['R001'],
      //   headers: ['estado', 'fecha_ini', 'hora_ini', 'fecha_fin', 'hora_fin', 'duracion', 'ubicacion', 'recorrido', 'maxima_velocidad', 'vel_max_can', 'pCercano', 'vel_promedio', 'vel_prom_can', 'referencia'],
      //   colDefs: [
      //     { orderData: [ 2, 3 ], targets: [2] }, //fecha
      //     { orderData: [ 3, 2 ], targets: [3] }, //hora
      //     { orderData: [ 4, 5 ], targets: [4] }, //fecha
      //     { orderData: [ 5, 4 ], targets: [5] }, //hora
      //   ],
      // },
      { //REPORTE DE EXCESOS DE VELOCIDAD
        num_rep: ['R002'],
        headers: ['nombre', 'fecha', 'hora', 'maxima_velocidad', 'ubicacion', 'fecha_ini', 'hora_ini', 'fecha_fin', 'hora_fin', 'duracion', 'cant_tramas', 'string_tramas', 'vel_min', 'vel_max', 'PC', 'ZC'],
        colDefs: [
          //Por definir después, dependiendo de si es por duracion o limte de velocidad
        ],
      },
      { //REPORTE DE ENTRADA Y SALIDA
        num_rep: ['R003'],
        headers: ['fecha_in', 'hora_in', 'fecha_out', 'hora_out', 'duracion', 'nombre_zona', 'ubicacion', 'PC'],
        colDefs: [
          { orderData: [ 1, 2 ], targets: [1] }, //fecha
          { orderData: [ 2, 1 ], targets: [2] }, //hora
          { orderData: [ 3, 4 ], targets: [3] }, //fecha
          { orderData: [ 4, 3 ], targets: [4] }, //hora
        ],
      },
      { //REPORTE DE COMBUSTIBLE
        num_rep: ['R004'],
        headers: ['fecha', 'hora', 'can_speed', 'fuel_level', 'fuel_used', 'can_HRFC', 'combusrestante', 'di4', 'can_dist', 'ubicacion', 'alerta', 'combustiblealerta', 'can_rpm', 'altitude'],
        colDefs: [
          { orderData: [ 1, 2 ], targets: [1] }, //fecha
          { orderData: [ 2, 1 ], targets: [2] }, //hora
        ],
      },
      { //REPORTE DE EXCESOS EN ZONA
        num_rep: ['R005'],
        headers: ['convoy', 'codigo', 'tracto', 'v0', 'velocidad', 'fecha_ini', 'hora_ini', 'fecha_fin', 'hora_fin', 'duracion', 'nombre_zona', 'referencia', 'ubicacion'],
        colDefs: [
          { orderData: [ 6, 7 ], targets: [6] }, //fecha
          { orderData: [ 7, 6 ], targets: [7] }, //hora
          { orderData: [ 8, 9 ], targets: [8] }, //fecha
          { orderData: [ 9, 8 ], targets: [9] }, //hora
        ],
      },
      { //REPORTE DE EVENTOS
        num_rep: ['R007'],
        headers: ['nombre_objeto', 'descripcion_evento', 'fecha', 'hora', 'velocidad', 'vel_can', 'nombre_zona', 'ubicacion', 'referencia'],
        colDefs: [
          { orderData: [ 3, 4 ], targets: [3] }, //fecha
          { orderData: [ 4, 3 ], targets: [4] }, //hora
        ],
      },
      { //REPORTE DE POSICION
        num_rep: ['R008'],
        headers: ['codigo', 'placa', 'fecha', 'hora', 'estado', 'conductor', 'velocidad', 'velocidad_can', 'odometro', 'ubicacion', 'referencia'],
        colDefs: [
          { orderData: [ 3, 4 ], targets: [3] }, //fecha
          { orderData: [ 4, 3 ], targets: [4] }, //hora
        ],
      },
      { //REPORTE DE FRENADA Y ACELERACIÓN BRUSCA (ECO DRIVE)
        num_rep: ['R011'],
        headers: ['fecha', 'hora', 'codigo', 'placa', 'tipo_unidad', 'idConductor', 'conductor', 'velGPS', 'vel_can', 'tipo_frenada', 'tramo', 'PC'],
        colDefs: [
          { orderData: [ 1, 2 ], targets: [1] }, //fecha
          { orderData: [ 2, 1 ], targets: [2] }, //hora
        ],
      },
      { //REPORTE DE DISTRACCIÓN Y POSIBLE FATIGA
        num_rep: ['R012'],
        headers: ['fecha', 'hora', 'codigo', 'placa', 'tipo_unidad', 'idConductor', 'conductor', 'velGPS', 'vel_can', 'descripcion', 'ai1x', 'tramo', 'PC', 'ubicacion'],
        colDefs: [
          { orderData: [ 1, 2 ], targets: [1] }, //fecha
          { orderData: [ 2, 1 ], targets: [2] }, //hora
        ],
      },
      { //REPORTE DE FATIGA EXTREMA
        num_rep: ['R014'],
        headers: ['fecha', 'hora', 'codigo', 'placa', 'tipo_unidad', 'idConductor', 'conductor', 'velGPS', 'vel_can',  'ai1x', 'tramo', 'PC', 'ubicacion'],
        colDefs: [
          { orderData: [ 1, 2 ], targets: [1] }, //fecha
          { orderData: [ 2, 1 ], targets: [2] }, //hora
        ],
      },
      {
        //REPORTE DE ANTICOLISIÓN FRONTAL
        //REPORTE DE COLISIÓN CON PEATONES
        //REPORTE DE DESVÍO DE CARRIL HACIA LA IZQUIERDA
        //REPORTE DE DESVÍO DE CARRIL HACIA LA DERECHA
        num_rep: ['R015', 'R016', 'R017', 'R018'],
        headers: ['fecha', 'hora', 'codigo', 'placa', 'tipo_unidad', 'idConductor', 'conductor', 'vel_gps_speed', 'vel_can', 'tramo', 'PC', 'ubicacion', 'sonidoEnCabina'],
        colDefs: [
          { orderData: [ 1, 2 ], targets: [1] }, //fecha
          { orderData: [ 2, 1 ], targets: [2] }, //hora
        ],
      },
      { //REPORTE DE BLOQUEO DE VISIÓN MOBILEYE
        num_rep: ['R019'],
        headers: ['fecha', 'hora', 'codigo', 'placa', 'tipo_unidad', 'idConductor', 'conductor', 'vel_gps_speed', 'vel_can', 'tramo', 'PC', 'ubicacion'],
        colDefs: [
          { orderData: [ 1, 2 ], targets: [1] }, //fecha
          { orderData: [ 2, 1 ], targets: [2] }, //hora
        ],
      },
    ];

    const isIndependentWindow = document.getElementById('vehicle_label') === null;
    if(isIndependentWindow){
      //Verificar si reporte es una ventana o componente
      var report_data = JSON.parse(localStorage.getItem('report_data')!);
      // console.log(report_data);

    }
    localStorage.removeItem('report_data');

    console.log('Iniciando result component');
    this.calculateRowHeights();

    if(!isIndependentWindow){
      this.reportService.showReport.subscribe(data_ => {
        this.showImages = true;
        const data = JSON.parse(JSON.stringify(data_));
        this.clearImageCache()
        console.log('Recibiendo data en result', data);

        this.dt_completed = 0;
        this.operators = data.operators; // PARA LISTA DE OPERADORES DE MONITOREO
        this.report_data.num_rep = data.numRep;
        this.report_data.rep_title = data.repTitle;
        this.report_data.rep_subtitle = data.repSubtitle;

      
        this.chkTableDropdown = data.chkTableDropdown;
        this.eC = data.eC;
        this.chkRiesgo = data.chkRiesgo;
        this.str_nombre_eventos = data.str_nombre_eventos;

        /* console.log('ES ARRAY?', data.data[0].constructor === Array);
        if(data.data[0].constructor === Array){
          console.log('MULTITABLA');
        } else {
          console.log('TABLA SINGULAR');
        } */

        this.data = data.data;
        if(this.report_data.num_rep === 'R053'){
          this.loadImageFromChecklist()
        }
        this.sortedData = JSON.parse(JSON.stringify(this.data));

        if(this.isSingleTableReport()){
          this.setDataTablesConfig(isIndependentWindow, 1);
        } else {
          this.setDataTablesConfig(isIndependentWindow, data.data.length);
        }

        this.chkDateHour = data.chkDateHour;
        this.chkFatigaSomnolencia = data.chkFatigaSomnolencia;
        this.chkFatigaDistraccion = data.chkFatigaDistraccion;
        this.chkFrenada = data.chkFrenada;
        this.chkAceleracion = data.chkAceleracion;
        this.chkDuracion = data.chkDuracion;
        this.chkOdomV = data.chkOdomV;
        this.repTitle = data.repTitle;
        this.period = data.period;
        this.params = data.params;
        if(this.chkTableDropdown && !this.isSingleTableReport()){
          this.prepareVehicleDropdown();
        }

        //Check if this is the first time loading
        if(this.dtElement !== undefined && "dtInstance" in this.dtElement){
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            dtInstance.destroy();
            this.dtRendered = false;
            this.dtTrigger = new Subject<any>();
          });
          console.log('saliendo del then');
        }
        setTimeout(() => {
          this.dtRendered = true;
        });
        console.log('dtRendered es ', this.dtRendered);

        console.log('antes de next');
        setTimeout(() => {
          this.dtTrigger.next();
        });

        console.log('despues de next');
        //this.table_hide = '';

        console.log('Proceso terminado a las: ', new Date());
        this.toggleImageColumn();
        this.reportService.reportFinished.emit(true);

      })
    } else {
      console.log('Se abrirá una nueva pestaña');
      localStorage.removeItem('report_data');

      this.report_data.num_rep = report_data.numRep;
      this.report_data.rep_title = report_data.repTitle;
      this.report_data.rep_subtitle = report_data.repSubtitle;

      this.chkTableDropdown = report_data.chkTableDropdown;
      this.eC = report_data.eC;
      this.chkRiesgo = report_data.chkRiesgo;
      this.str_nombre_eventos = report_data.str_nombre_eventos;

      this.data = report_data.data;
      this.sortedData = JSON.parse(JSON.stringify(this.data));

      if(this.isSingleTableReport()){
        this.setDataTablesConfig(isIndependentWindow, 1);
      } else {
        this.setDataTablesConfig(isIndependentWindow, report_data.data.length);
      }

      this.chkDateHour = report_data.chkDateHour;
      this.chkFatigaSomnolencia = report_data.chkFatigaSomnolencia;
      this.chkFatigaDistraccion = report_data.chkFatigaDistraccion;
      this.chkFrenada = report_data.chkFrenada;
      this.chkAceleracion = report_data.chkAceleracion;
      this.chkDuracion = report_data.chkDuracion;
      this.chkOdomV = report_data.chkOdomV;
      this.repTitle = report_data.repTitle;
      this.period = report_data.period;
      this.params = report_data.params;
      if(this.report_data.num_rep === 'R053'){
        this.loadImageFromChecklist()
      }

      if(this.chkTableDropdown && !this.isSingleTableReport()){
        this.prepareVehicleDropdown();
      }

      document.querySelector('body')!.style.backgroundColor = 'rgb(250,250,250)';
      document.querySelector('body')!.style.padding = '0.8rem';
      this.titleService.setTitle(this.report_data.rep_title);
      //this.dtTrigger.next();
      setTimeout(() => {
        this.dtTrigger.next();
      });

      //this.table_hide = '';

      console.log('Proceso terminado a las: ', new Date());
      this.reportService.reportFinished.emit(true);

    }

    if (this.isIOSChrome) {
      // is Google Chrome on IOS
      this.isChrome = true;
    } else if(
      this.isChromium !== null &&
      typeof this.isChromium !== "undefined" &&
      this.vendorName === "Google Inc." &&
      this.isOpera === false &&
      this.isIEedge === false
    ) {
        // is Google Chrome
        this.isChrome = true;
    } else {
        // not Google Chrome
        this.isChrome = false;
    }

    // console.log("========");
    // console.log(localStorage);
    this.user_id = Number(localStorage.getItem('user_id'));
    // console.log(this.user_id);


    this.reportService.currentShowImagesChecklist.subscribe(show => {
      this.showImages = show;
      this.toggleImageColumn();
    })
  }


  lineaUser():boolean{
    let id: number = this.userDataService.userData.id_usu??this.userDataService.userData.id
    return this.userLineaIDs.includes(id)
  }

  setDataTablesConfig(isIndependentWindow: boolean, numberOfTables: number){
    // console.log("=====================================>>>>>>>>>>>>>>>>>>>>>>>>>>> XDDDDD");
    // Reporte
    switch(this.report_data.num_rep) {
      case 'R045': //REPORTE DE BOLIVIA
        this.spinner.hide("reportSpinner");
        this.reportService.workingOnReport = false;
      break;
    }

    this.currentActiveTables = [];
    this.dtTableCurrentOrder = [[0, 'asc']];
    let columnsConfig = this.columnsConfig.filter((report: any) => { return report.num_rep.indexOf(this.report_data.num_rep) > -1; })[0];

    let reportExistInConfig = columnsConfig !== undefined;
    let headersExistInColumnsConfig = reportExistInConfig && columnsConfig.headers !== undefined;

    if(!isIndependentWindow){
      if(this.chkTableDropdown){
        this.dataTableStartingIndex = this.dataTableEndingIndex + 1;
        this.dataTableEndingIndex = this.dataTableStartingIndex;
      } else {
        this.dataTableStartingIndex = this.dataTableEndingIndex + 1;
        this.dataTableEndingIndex = this.dataTableStartingIndex + numberOfTables - 1;
      }
      console.log('datatble Starging Index ', this.dataTableStartingIndex);
      console.log('datatble Ending Index ', this.dataTableEndingIndex);
    } else {
      this.dataTableStartingIndex = 0;
      this.dataTableEndingIndex = this.dataTableStartingIndex + numberOfTables - 1;
      console.log('datatble Indexes reiniciados en nueva pestaña: ', [this.dataTableStartingIndex, this.dataTableEndingIndex]);
    }

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language:{
        url: '//cdn.datatables.net/plug-ins/1.11.5/i18n/es-ES.json'
      },
      dom: 'lfrtip',
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Todos"]],
      buttons: [{
        extend: 'excel',
        text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Exportar a Excel',
        className: 'btn btn-success'
      }],
      initComplete: ( oSettings: any ) => {
        console.log('Osetting->',oSettings);
        if(this.chkTableDropdown){
          console.log('InitComplete, with order: ', this.dtOptions.order);
        } else {
          console.log('InitComplete');
        }
        if(!this.chkTableDropdown && this.currentActiveTables.indexOf(oSettings.sTableId) < 0){
          console.log('Adding sTableId to the array', oSettings.sTableId);
          this.currentActiveTables.push(oSettings.sTableId);
        }
        this.dt_completed++;
        //console.log('Terminado de cargar y popular tabla ' + this.dt_completed);
        if(this.dt_completed == document.querySelectorAll('table[datatable]').length){
          this.wrapElements(document.querySelectorAll('table[datatable]'));
          this.table_hide = '';
          if(!isIndependentWindow){
            this.spinner.hide("reportSpinner");
            this.reportService.workingOnReport = false;
          }
        }
        // console.log("======================= AKI");

        // console.log(this.num_rep);

        // // if (this.num_rep == 19) {
        // if (this.num_rep == 'R020') {
        //     // this.runReportGerencial(1);
        //     setTimeout(() => {
        //       // this.runReportGerencial(1);
        //     }, 1000);
        // }
      },
      destroy: true,
      "orderMulti": false,
      /* "fnDrawCallback": ( oSettings: any ) => {
        if(this.chkTableDropdown){
          this.dtTableCurrentOrder = [[ oSettings.aaSorting[0]['0'], oSettings.aaSorting[0]['1']]];
          this.dtOptions.order = this.dtTableCurrentOrder;
        }
        const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
        if(   isIndependentWindow
          ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){
          let sortedDataTableIndex = -1;
          //console.log( 'DataTables has redrawn the table', oSettings );
          if(this.isSingleTableReport()){
            console.log( 'DataTables has redrawn (Single Table). Table info: ', {
              tableName: oSettings.sTableId,
              amountOfRows: this.sortedData.length,
              rowsOfSortedTable: this.sortedData,
            } );
          } else {
            sortedDataTableIndex = this.chkTableDropdown? this.reportTableVehicleSelected.index: dataTableIndex - this.dataTableStartingIndex;
            console.log( 'DataTables has redrawn. Table info: ', {
              tableName: oSettings.sTableId,
              indexOfDataTable: sortedDataTableIndex,
              amountOfRows: this.sortedData[sortedDataTableIndex][1].length,
              rowsOfSortedTable: this.sortedData[sortedDataTableIndex][1],
              dataOfSortedTable: this.sortedData[sortedDataTableIndex],
            } );
          }

          console.log( 'DataTables Sorting: ', {
            columnIndex: oSettings.aaSorting[0]['0'],
            strAscDesc: oSettings.aaSorting[0]['1'],
            intAscDesc: oSettings.aaSorting[0]['_idx'],
            object: oSettings.aaSorting,
          } );
          let sortingColIndex = oSettings.aaSorting[0]['0'];
          let sortingOrder = oSettings.aaSorting[0]['1'];

          if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
            let columnName: string;
            switch(this.report_data.num_rep){
              case 'R001': //REPORTE DE PARADAS Y MOVIMIENTOS
                let tableHeaders = [...columnsConfig.headers];
                if(this.sortedData[sortedDataTableIndex][2].Paradas && this.sortedData[sortedDataTableIndex][2].Movimientos){
                  //Dejamos los headers tal cual
                }
                //Solo Movimientos
                if(!this.sortedData[sortedDataTableIndex][2].Paradas && this.sortedData[sortedDataTableIndex][2].Movimientos){
                  console.log('Eliminar Solo Movimientos');
                  for(let i = 0; i < tableHeaders.length; i++){
                    if( tableHeaders[i] == 'ubicacion' ||
                        tableHeaders[i] == 'pCercano' ||
                        tableHeaders[i] == 'referencia'){
                      tableHeaders.splice(i, 1);
                      i--;
                    }
                  }
                }
                //Solo Paradas
                if(this.sortedData[sortedDataTableIndex][2].Paradas && !this.sortedData[sortedDataTableIndex][2].Movimientos){
                  console.log('Eliminar Solo Paradas');
                  for(let i = 0; i < tableHeaders.length; i++){
                    if( tableHeaders[i] == 'recorrido' ||
                        tableHeaders[i] == 'maxima_velocidad' ||
                        tableHeaders[i] == 'vel_max_can' ||
                        tableHeaders[i] == 'vel_promedio' ||
                        tableHeaders[i] == 'vel_prom_can'){
                      tableHeaders.splice(i, 1);
                      i--;
                    }
                  }
                }
                columnName = tableHeaders[sortingColIndex - 1];
                console.log('Headers List', tableHeaders);
                console.log('Sorting Column...', columnName);
                switch(columnName){
                  case 'fecha_ini':
                    if(this.chkTableDropdown){
                      for(let i = 0; i < numberOfTables; i++){
                        this.sortedData[i][1].sort((a: any, b: any) => {
                          return this.dateComparison(a['fecha'], b['fecha'], sortingOrder);
                        });
                      }
                    } else {
                      this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                        return this.dateComparison(a['fecha'], b['fecha'], sortingOrder);
                      });
                    }
                    break;
                  case 'hora_ini':
                    if(this.chkTableDropdown){
                      for(let i = 0; i < numberOfTables; i++){
                        this.sortedData[i][1].sort((a: any, b: any) => {
                          return this.dateComparison(a.fecha.split(' ')[1], b.fecha.split(' ')[1], sortingOrder);
                        });
                      }
                    } else {
                      this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha.split(' ')[1], b.fecha.split(' ')[1], sortingOrder);
                      });
                    }
                    break;
                  case 'fecha_fin':
                    if(this.chkTableDropdown){
                      for(let i = 0; i < numberOfTables; i++){
                        this.sortedData[i][1].sort((a: any, b: any) => {
                          return this.dateComparison(a['fechasig'], b['fechasig'], sortingOrder);
                        });
                      }
                    } else {
                      this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                        return this.dateComparison(a['fechasig'], b['fechasig'], sortingOrder);
                      });
                    }
                    break;
                  case 'hora_fin':
                    if(this.chkTableDropdown){
                      for(let i = 0; i < numberOfTables; i++){
                        this.sortedData[i][1].sort((a: any, b: any) => {
                          return this.dateComparison(a.fechasig.split(' ')[1], b.fechasig.split(' ')[1], sortingOrder);
                        });
                      }
                    } else {
                      this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fechasig.split(' ')[1], b.fechasig.split(' ')[1], sortingOrder);
                      });
                    }
                    break;
                  case 'duracion':
                    if(this.chkTableDropdown){
                      for(let i = 0; i < numberOfTables; i++){
                        this.sortedData[i][1].sort((a: any, b: any) => {
                          return this.numericComparison(this.intervalToSeconds(a[columnName]), this.intervalToSeconds(b[columnName]), sortingOrder);
                        });
                      }
                    } else {
                      this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                        return this.numericComparison(this.intervalToSeconds(a[columnName]), this.intervalToSeconds(b[columnName]), sortingOrder);
                      });
                    }
                    break;
                  case 'recorrido':
                  case 'maxima_velocidad':
                  case 'vel_max_can':
                  case 'vel_promedio':
                  case 'vel_prom_can':
                    if(this.chkTableDropdown){
                      for(let i = 0; i < numberOfTables; i++){
                        this.sortedData[i][1].sort((a: any, b: any) => {
                          let term1 = a.esInt == 0? -1: parseFloat(a[columnName].split(' ')[0]);
                          let term2 = b.esInt == 0? -1: parseFloat(b[columnName].split(' ')[0]);
                          return this.numericComparison(term1, term2, sortingOrder);
                        });
                      }
                    } else {
                      this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                        let term1 = a.esInt == 0? -1: parseFloat(a[columnName].split(' ')[0]);
                        let term2 = b.esInt == 0? -1: parseFloat(b[columnName].split(' ')[0]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                    break;
                  case 'pCercano':
                  case 'referencia':
                    if(this.chkTableDropdown){
                      for(let i = 0; i < numberOfTables; i++){
                        this.sortedData[i][1].sort((a: any, b: any) => {
                          let term1 = a.esInt == 1? '---': a[columnName];
                          let term2 = b.esInt == 1? '---': b[columnName];
                          console.log('refs', [term1, term2]);
                          console.log('refs result', this.textComparison(term1, term2, sortingOrder));
                          return this.textComparison(term1, term2, sortingOrder);
                        });
                      }
                    } else {
                      this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                        let term1 = a.esInt == 1? '---': a[columnName];
                        let term2 = b.esInt == 1? '---': b[columnName];
                        console.log('refs', [term1, term2]);
                        console.log('refs result', this.textComparison(term1, term2, sortingOrder));
                        return this.textComparison(term1, term2, sortingOrder);
                      });
                    }
                    break;
                  case 'ubicacion':
                    if(this.chkTableDropdown){
                      for(let i = 0; i < numberOfTables; i++){
                        this.sortedData[i][1].sort((a: any, b: any) => {
                          let term1 = a.esInt == 1? '---': `${a.latitud}, ${a.longitud}`;
                          let term2 = b.esInt == 1? '---': `${b.latitud}, ${b.longitud}`;
                          return this.textComparison(term1, term2, sortingOrder);
                        });
                      }
                    } else {
                      this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                        let term1 = a.esInt == 1? '---': `${a.latitud}, ${a.longitud}`;
                        let term2 = b.esInt == 1? '---': `${b.latitud}, ${b.longitud}`;
                        return this.textComparison(term1, term2, sortingOrder);
                      });
                    }
                    break;
                  default:
                    if(this.chkTableDropdown){
                      for(let i = 0; i < numberOfTables; i++){
                        this.sortedData[i][1].sort((a: any, b: any) => {
                          return this.textComparison(a[columnName], b[columnName], sortingOrder);
                        });
                      }
                    } else {
                      this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                        return this.textComparison(a[columnName], b[columnName], sortingOrder);
                      });
                    }
                    break;
                }
                console.log(this.sortedData[sortedDataTableIndex][1]);
                break;
              case 'R008': //REPORTE DE POSICION
                columnName = columnsConfig.headers[sortingColIndex - 1];
                if(columnName == 'fecha'){
                  this.sortedData.sort((a: any, b: any) => {
                    return this.dateComparison(a[columnName], b[columnName], sortingOrder);
                  });
                }
                if(columnName == 'hora'){
                  this.sortedData.sort((a: any, b: any) => {
                    return this.dateComparison(a.fecha.split(' ')[1], b.fecha.split(' ')[1], sortingOrder);
                  });
                }
                if(columnName == 'ubicacion'){
                  this.sortedData.sort((a: any, b: any) => {
                    return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                  });
                } else {
                  this.sortedData.sort((a: any, b: any) => {
                    return this.textComparison(a[columnName], b[columnName], sortingOrder);
                  });
                }
                console.log(this.sortedData);
                break;
              default:
                break;
            }
          }

          if(this.directSorting){
            this.directSorting = false;
            for(let i = 0; i < this.currentActiveTables.length; i++){
              if(this.currentActiveTables[i] != oSettings.sTableId){
                if(!this.chkTableDropdown){
                  console.log('Sorting other dataTables: ', this.currentActiveTables[i]);
                  $(`#${this.currentActiveTables[i]}`).DataTable().order([[sortingColIndex, sortingOrder]]).draw();
                }
              }
            }
            this.directSorting = true;
          }

        } else {
          console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          //console.log( 'DataTables has NOT BEEN redrawn. Table info: ', {
          //  tableName: oSettings.sTableId,
          //  tableNumber: dataTableIndex,
          //  indexOfDataTable: sortedDataTableIndex,
          //  amountOfRows: this.sortedData[sortedDataTableIndex][1].length,
          //  rowsOfSortedTable: this.sortedData[sortedDataTableIndex],
          //  dataOfSortedTable: this.sortedData[sortedDataTableIndex][1],
          //} );
        }

      }, */
    };

    //Config de drawCallback
    switch(this.report_data.num_rep){
      case 'R001': //REPORTE DE PARADAS Y MOVIMIENTOS
        this.dtOptions["fnDrawCallback"] = ( oSettings: any ) => {

          if(this.chkTableDropdown){
            this.dtTableCurrentOrder = [[ oSettings.aaSorting[0]['0'], oSettings.aaSorting[0]['1']]];
            this.dtOptions.order = this.dtTableCurrentOrder;
          }

          const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
          if(   isIndependentWindow
            ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){
            let sortedDataTableIndex = -1;
            //console.log( 'DataTables has redrawn the table', oSettings );
            sortedDataTableIndex = this.chkTableDropdown? this.reportTableVehicleSelected.index: dataTableIndex - this.dataTableStartingIndex;

            /* console.log( 'DataTables has redrawn. Table info: ', {
              tableName: oSettings.sTableId,
              indexOfDataTable: sortedDataTableIndex,
              amountOfRows: this.sortedData[sortedDataTableIndex][1].length,
              rowsOfSortedTable: this.sortedData[sortedDataTableIndex][1],
              dataOfSortedTable: this.sortedData[sortedDataTableIndex],
            } ); */
            /* console.log( 'DataTables Sorting: ', {
              columnIndex: oSettings.aaSorting[0]['0'],
              strAscDesc: oSettings.aaSorting[0]['1'],
              intAscDesc: oSettings.aaSorting[0]['_idx'],
              object: oSettings.aaSorting,
            } );  */

            let sortingColIndex = oSettings.aaSorting[0]['0'];
            let sortingOrder = oSettings.aaSorting[0]['1'];

            if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
              let columnName: string;
              let tableHeaders = [...columnsConfig.headers];

              if(this.sortedData[sortedDataTableIndex][2].Paradas && this.sortedData[sortedDataTableIndex][2].Movimientos){
                //Dejamos los headers tal cual
              }
              //Solo Movimientos
              if(!this.sortedData[sortedDataTableIndex][2].Paradas && this.sortedData[sortedDataTableIndex][2].Movimientos){
                //console.log('Eliminar Solo Movimientos');
                for(let i = 0; i < tableHeaders.length; i++){
                  if( tableHeaders[i] == 'ubicacion' ||
                      tableHeaders[i] == 'pCercano' ||
                      tableHeaders[i] == 'referencia'){
                    tableHeaders.splice(i, 1);
                    i--;
                  }
                }
              }
              //Solo Paradas
              if(this.sortedData[sortedDataTableIndex][2].Paradas && !this.sortedData[sortedDataTableIndex][2].Movimientos){
                //console.log('Eliminar Solo Paradas');
                for(let i = 0; i < tableHeaders.length; i++){
                  if( tableHeaders[i] == 'recorrido' ||
                      tableHeaders[i] == 'maxima_velocidad' ||
                      tableHeaders[i] == 'vel_max_can' ||
                      tableHeaders[i] == 'vel_promedio' ||
                      tableHeaders[i] == 'vel_prom_can'){
                    tableHeaders.splice(i, 1);
                    i--;
                  }
                }
              }

              columnName = tableHeaders[sortingColIndex - 1];
              //console.log('Headers List', tableHeaders);
              //console.log('Sorting Column...', columnName);

              switch(columnName){
                case 'fecha_ini':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                    });
                  }
                  break;
                case 'hora_ini':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                    });
                  }
                  break;
                case 'fecha_fin':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fechasig, b.fechasig, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fechasig, b.fechasig, sortingOrder);
                    });
                  }
                  break;
                case 'hora_fin':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fechasig, b.fechasig, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fechasig, b.fechasig, sortingOrder, true);
                    });
                  }
                  break;
                case 'duracion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.numericComparison(this.intervalToSeconds(a[columnName]), this.intervalToSeconds(b[columnName]), sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.numericComparison(this.intervalToSeconds(a[columnName]), this.intervalToSeconds(b[columnName]), sortingOrder);
                    });
                  }
                  break;
                case 'recorrido':
                case 'maxima_velocidad':
                case 'vel_max_can':
                case 'vel_promedio':
                case 'vel_prom_can':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = a.esInt == 0? -1: parseFloat(a[columnName].split(' ')[0]);
                        let term2 = b.esInt == 0? -1: parseFloat(b[columnName].split(' ')[0]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = a.esInt == 0? -1: parseFloat(a[columnName].split(' ')[0]);
                      let term2 = b.esInt == 0? -1: parseFloat(b[columnName].split(' ')[0]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'pCercano':
                case 'referencia':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = a.esInt == 1? '---': a[columnName];
                        let term2 = b.esInt == 1? '---': b[columnName];
                        console.log('refs', [term1, term2]);
                        console.log('refs result', this.textComparison(term1, term2, sortingOrder));
                        return this.textComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = a.esInt == 1? '---': a[columnName];
                      let term2 = b.esInt == 1? '---': b[columnName];
                      console.log('refs', [term1, term2]);
                      console.log('refs result', this.textComparison(term1, term2, sortingOrder));
                      return this.textComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'ubicacion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = a.esInt == 1? '---': `${a.latitud}, ${a.longitud}`;
                        let term2 = b.esInt == 1? '---': `${b.latitud}, ${b.longitud}`;
                        return this.textComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = a.esInt == 1? '---': `${a.latitud}, ${a.longitud}`;
                      let term2 = b.esInt == 1? '---': `${b.latitud}, ${b.longitud}`;
                      return this.textComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                default:
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(a[columnName], b[columnName], sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(a[columnName], b[columnName], sortingOrder);
                    });
                  }
                  break;
              }
              console.log(this.sortedData[sortedDataTableIndex][1]);

            }

            if(this.directSorting){
              this.directSorting = false;
              for(let i = 0; i < this.currentActiveTables.length; i++){
                if(this.currentActiveTables[i] != oSettings.sTableId){
                  if(!this.chkTableDropdown){
                    //console.log('Sorting other dataTables: ', this.currentActiveTables[i]);
                    $(`#${this.currentActiveTables[i]}`).DataTable().order([[sortingColIndex, sortingOrder]]).draw();
                  }
                }
              }
              this.directSorting = true;
            }

          } else {
            console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          }
        };
        break;
      case 'R002': //REPORTE DE EXCESOS DE VELOCIDAD
        this.dtOptions["fnDrawCallback"] = ( oSettings: any ) => {

          if(this.chkTableDropdown){
            this.dtTableCurrentOrder = [[ oSettings.aaSorting[0]['0'], oSettings.aaSorting[0]['1']]];
            this.dtOptions.order = this.dtTableCurrentOrder;
          }

          const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
          if(   isIndependentWindow
            ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){
            let sortedDataTableIndex = -1;

            sortedDataTableIndex = this.chkTableDropdown? this.reportTableVehicleSelected.index: dataTableIndex - this.dataTableStartingIndex;

            let sortingColIndex = oSettings.aaSorting[0]['0'];
            let sortingOrder = oSettings.aaSorting[0]['1'];

            if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
              let columnName: string;
              let tableHeaders = [...columnsConfig.headers];


              if(!this.chkDuracion){
                //Limite de velocidad
                for(let i = 0; i < tableHeaders.length; i++){
                  if( tableHeaders[i] == 'fecha_ini' ||
                      tableHeaders[i] == 'hora_ini' ||
                      tableHeaders[i] == 'fecha_fin' ||
                      tableHeaders[i] == 'hora_fin' ||
                      tableHeaders[i] == 'duracion' ||
                      tableHeaders[i] == 'cant_tramas' ||
                      tableHeaders[i] == 'string_tramas' ||
                      tableHeaders[i] == 'vel_min' ||
                      tableHeaders[i] == 'vel_max' ||
                      tableHeaders[i] == 'ZC'){
                    tableHeaders.splice(i, 1);
                    i--;
                  }
                }
              } else {
                //Duracion
                for(let i = 0; i < tableHeaders.length; i++){
                  if( tableHeaders[i] == 'nombre' ||
                      tableHeaders[i] == 'fecha' ||
                      tableHeaders[i] == 'hora' ||
                      tableHeaders[i] == 'maxima_velocidad'){
                    tableHeaders.splice(i, 1);
                    i--;
                  }
                }
              }

              columnName = tableHeaders[sortingColIndex - 1];
              //console.log('Headers List', tableHeaders);
              //console.log('Sorting Column...', columnName);

              switch(columnName){
                //LIMITE DE VELOCIDAD
                case 'fecha':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                    });
                  }
                  break;
                case 'hora':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                    });
                  }
                  break;
                case 'maxima_velocidad':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.numericComparison(parseFloat(a[columnName]), parseFloat(b[columnName]), sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.numericComparison(parseFloat(a[columnName]), parseFloat(b[columnName]), sortingOrder);
                    });
                  }
                  break;

                //DURACION
                case 'fecha_ini':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_inicial, b.fecha_inicial, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_inicial, b.fecha_inicial, sortingOrder);
                    });
                  }
                  break;
                case 'hora_ini':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_inicial, b.fecha_inicial, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_inicial, b.fecha_inicial, sortingOrder, true);
                    });
                  }
                  break;
                case 'fecha_fin':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder);
                    });
                  }
                  break;
                case 'hora_fin':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder, true);
                    });
                  }
                  break;
                case 'duracion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.numericComparison(this.intervalToSeconds(a[columnName]), this.intervalToSeconds(b[columnName]), sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.numericComparison(this.intervalToSeconds(a[columnName]), this.intervalToSeconds(b[columnName]), sortingOrder);
                    });
                  }
                  break;
                case 'cant_tramas':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.numericComparison(parseInt(a[columnName]), parseInt(b[columnName]), sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.numericComparison(parseInt(a[columnName]), parseInt(b[columnName]), sortingOrder);
                    });
                  }
                  break;
                case 'vel_min':
                case 'vel_max':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = parseFloat(a[columnName].split(' ')[0]);
                        let term2 = parseFloat(b[columnName].split(' ')[0]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = parseFloat(a[columnName].split(' ')[0]);
                      let term2 = parseFloat(b[columnName].split(' ')[0]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'vel_max_can':
                case 'vel_promedio':
                case 'vel_prom_can':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = a.esInt == 0? -1: parseFloat(a[columnName].split(' ')[0]);
                        let term2 = b.esInt == 0? -1: parseFloat(b[columnName].split(' ')[0]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = a.esInt == 0? -1: parseFloat(a[columnName].split(' ')[0]);
                      let term2 = b.esInt == 0? -1: parseFloat(b[columnName].split(' ')[0]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;

                case 'ubicacion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                    });
                  }
                  break;

                default:
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(a[columnName], b[columnName], sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(a[columnName], b[columnName], sortingOrder);
                    });
                  }
                  break;
              }
              console.log(this.sortedData[sortedDataTableIndex][1]);

            }

            if(this.directSorting){
              this.directSorting = false;
              for(let i = 0; i < this.currentActiveTables.length; i++){
                if(this.currentActiveTables[i] != oSettings.sTableId){
                  if(!this.chkTableDropdown){
                    console.log('Sorting other dataTables: ', this.currentActiveTables[i]);
                    $(`#${this.currentActiveTables[i]}`).DataTable().order([[sortingColIndex, sortingOrder]]).draw();
                  }
                }
              }
              this.directSorting = true;
            }

          } else {
            console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          }
        };
        break;
      case 'R003': //REPORTE DE ENTRADA Y SALIDA
        this.dtOptions["fnDrawCallback"] = ( oSettings: any ) => {

          if(this.chkTableDropdown){
            this.dtTableCurrentOrder = [[ oSettings.aaSorting[0]['0'], oSettings.aaSorting[0]['1']]];
            this.dtOptions.order = this.dtTableCurrentOrder;
          }

          const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
          if(   isIndependentWindow
            ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){
            let sortedDataTableIndex = -1;

            sortedDataTableIndex = this.chkTableDropdown? this.reportTableVehicleSelected.index: dataTableIndex - this.dataTableStartingIndex;

            let sortingColIndex = oSettings.aaSorting[0]['0'];
            let sortingOrder = oSettings.aaSorting[0]['1'];

            if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
              let columnName: string;
              let tableHeaders = [...columnsConfig.headers];

              columnName = tableHeaders[sortingColIndex - 1];
              //console.log('Headers List', tableHeaders);
              //console.log('Sorting Column...', columnName);

              switch(columnName){
                case 'fecha_in':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                    });
                  }
                  break;
                case 'hora_in':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                    });
                  }
                  break;
                case 'fecha_out':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = a.fecha_out == 'n/a'? '1970/01/01 00:00:00': a.fecha_out;
                        let term2 = b.fecha_out == 'n/a'? '1970/01/01 00:00:00': b.fecha_out;
                        return this.dateComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = a.fecha_out == 'n/a'? '1970/01/01 00:00:00': a.fecha_out;
                      let term2 = b.fecha_out == 'n/a'? '1970/01/01 00:00:00': b.fecha_out;
                      return this.dateComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'hora_out':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = a.fecha_out == 'n/a'? '1970/01/01 00:00:00': a.fecha_out;
                        let term2 = b.fecha_out == 'n/a'? '1970/01/01 00:00:00': b.fecha_out;
                        return this.dateComparison(term1, term2, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = a.fecha_out == 'n/a'? '1970/01/01 00:00:00': a.fecha_out;
                      let term2 = b.fecha_out == 'n/a'? '1970/01/01 00:00:00': b.fecha_out;
                      return this.dateComparison(term1, term2, sortingOrder, true);
                    });
                  }
                  break;
                case 'duracion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = a.duracion == 'n/a'? -1: this.intervalToSeconds(a.duracion);
                        let term2 = b.duracion == 'n/a'? -1: this.intervalToSeconds(b.duracion);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = a.duracion == 'n/a'? -1: this.intervalToSeconds(a.duracion);
                      let term2 = b.duracion == 'n/a'? -1: this.intervalToSeconds(b.duracion);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'ubicacion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                    });
                  }
                  break;
                default:
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(a[columnName], b[columnName], sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(a[columnName], b[columnName], sortingOrder);
                    });
                  }
                  break;
              }
              console.log(this.sortedData[sortedDataTableIndex][1]);

            }

            if(this.directSorting){
              this.directSorting = false;
              for(let i = 0; i < this.currentActiveTables.length; i++){
                if(this.currentActiveTables[i] != oSettings.sTableId){
                  if(!this.chkTableDropdown){
                    console.log('Sorting other dataTables: ', this.currentActiveTables[i]);
                    $(`#${this.currentActiveTables[i]}`).DataTable().order([[sortingColIndex, sortingOrder]]).draw();
                  }
                }
              }
              this.directSorting = true;
            }

          } else {
            console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          }
        };
        break;
      case 'R004': //REPORTE DE COMBUSTIBLE
        this.dtOptions["fnDrawCallback"] = ( oSettings: any ) => {

          if(this.chkTableDropdown){
            this.dtTableCurrentOrder = [[ oSettings.aaSorting[0]['0'], oSettings.aaSorting[0]['1']]];
            this.dtOptions.order = this.dtTableCurrentOrder;
          }

          const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
          if(   isIndependentWindow
            ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){
            let sortedDataTableIndex = -1;

            sortedDataTableIndex = this.chkTableDropdown? this.reportTableVehicleSelected.index: dataTableIndex - this.dataTableStartingIndex;

            let sortingColIndex = oSettings.aaSorting[0]['0'];
            let sortingOrder = oSettings.aaSorting[0]['1'];

            if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
              let columnName: string;
              let tableHeaders = [...columnsConfig.headers];

              columnName = tableHeaders[sortingColIndex - 1];
              //console.log('Headers List', tableHeaders);
              //console.log('Sorting Column...', columnName);

              switch(columnName){
                case 'fecha':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                    });
                  }
                  break;
                case 'hora':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                    });
                  }
                  break;
                case 'can_speed':
                case 'fuel_level':
                case 'fuel_used':
                case 'can_HRFC':
                case 'combusrestante':
                case 'combustiblealerta':
                case 'altitude':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.numericComparison(parseFloat(a[columnName]), parseFloat(b[columnName]), sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.numericComparison(parseFloat(a[columnName]), parseFloat(b[columnName]), sortingOrder);
                    });
                  }
                  break;
                case 'di4':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = a.di4 != 1 && a.di4 != 0? -1: this.Math.abs(a.di4 - 1); //1 es Abierto
                        let term2 = b.di4 != 1 && b.di4 != 0? -1: this.Math.abs(b.di4 - 1); //0 es cerrado
                        //Pero alfabeticamente hablando, 1 deberia ir antes del 0, entonces se les resta 1 y aplica abs
                        //para que 0 sea abierto y 1 cerrado, solo con fines de ordeniamiento
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = a.di4 != 1 && a.di4 != 0? -1: this.Math.abs(a.di4 - 1);
                      let term2 = b.di4 != 1 && b.di4 != 0? -1: this.Math.abs(b.di4 - 1);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break
                case 'can_dist':
                case 'can_rpm':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = isNaN(a[columnName])? -1: parseFloat(a[columnName].toFixed(2));
                        let term2 = isNaN(b[columnName])? -1: parseFloat(b[columnName].toFixed(2));
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = isNaN(a[columnName])? -1: parseFloat(a[columnName].toFixed(2));
                      let term2 = isNaN(b[columnName])? -1: parseFloat(b[columnName].toFixed(2));
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'ubicacion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                    });
                  }
                  break;
                case 'combusrestante':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.numericComparison(parseFloat(a[columnName]), parseFloat(b[columnName]), sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.numericComparison(parseFloat(a[columnName]), parseFloat(b[columnName]), sortingOrder);
                    });
                  }
                  break;
                default:
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(a[columnName], b[columnName], sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(a[columnName], b[columnName], sortingOrder);
                    });
                  }
                  break;
              }
              console.log(this.sortedData[sortedDataTableIndex][1]);

            }

            if(this.directSorting){
              this.directSorting = false;
              for(let i = 0; i < this.currentActiveTables.length; i++){
                if(this.currentActiveTables[i] != oSettings.sTableId){
                  if(!this.chkTableDropdown){
                    console.log('Sorting other dataTables: ', this.currentActiveTables[i]);
                    $(`#${this.currentActiveTables[i]}`).DataTable().order([[sortingColIndex, sortingOrder]]).draw();
                  }
                }
              }
              this.directSorting = true;
            }

          } else {
            console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          }
        };
        break;
      case 'R005': //REPORTE DE EXCESOS EN ZONA
        this.dtOptions["fnDrawCallback"] = ( oSettings: any ) => {

          if(this.chkTableDropdown){
            this.dtTableCurrentOrder = [[ oSettings.aaSorting[0]['0'], oSettings.aaSorting[0]['1']]];
            this.dtOptions.order = this.dtTableCurrentOrder;
          }

          const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
          if(   isIndependentWindow
            ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){
            let sortedDataTableIndex = -1;

            sortedDataTableIndex = this.chkTableDropdown? this.reportTableVehicleSelected.index: dataTableIndex - this.dataTableStartingIndex;

            let sortingColIndex = oSettings.aaSorting[0]['0'];
            let sortingOrder = oSettings.aaSorting[0]['1'];

            if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
              let columnName: string;
              let tableHeaders = [...columnsConfig.headers];

              columnName = tableHeaders[sortingColIndex - 1];
              //console.log('Headers List', tableHeaders);
              //console.log('Sorting Column...', columnName);

              switch(columnName){
                case 'codigo':
                case 'v0':
                case 'velocidad':
                case 'velocidad':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        this.sortedData[i][1].sort((a: any, b: any) => {
                          let term1 = isNaN(a[columnName])? -1: parseFloat(a[columnName]);
                          let term2 = isNaN(b[columnName])? -1: parseFloat(b[columnName]);
                          return this.numericComparison(term1, term2, sortingOrder);
                        });
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = isNaN(a[columnName])? -1: parseFloat(a[columnName]);
                      let term2 = isNaN(b[columnName])? -1: parseFloat(b[columnName]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'fecha_ini':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_inicio, b.fecha_inicio, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_inicio, b.fecha_inicio, sortingOrder);
                    });
                  }
                  break;
                case 'hora_ini':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_inicio, b.fecha_inicio, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_inicio, b.fecha_inicio, sortingOrder, true);
                    });
                  }
                  break;
                case 'fecha_fin':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder);
                    });
                  }
                  break;
                case 'hora_fin':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder, true);
                    });
                  }
                  break;
                case 'duracion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.numericComparison(this.intervalToSeconds(a[columnName]), this.intervalToSeconds(b[columnName]), sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.numericComparison(this.intervalToSeconds(a[columnName]), this.intervalToSeconds(b[columnName]), sortingOrder);
                    });
                  }
                  break;
                case 'ubicacion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                    });
                  }
                  break;
                default:
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(a[columnName], b[columnName], sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(a[columnName], b[columnName], sortingOrder);
                    });
                  }
                  break;
              }
              console.log(this.sortedData[sortedDataTableIndex][1]);

            }

            if(this.directSorting){
              this.directSorting = false;
              for(let i = 0; i < this.currentActiveTables.length; i++){
                if(this.currentActiveTables[i] != oSettings.sTableId){
                  if(!this.chkTableDropdown){
                    console.log('Sorting other dataTables: ', this.currentActiveTables[i]);
                    $(`#${this.currentActiveTables[i]}`).DataTable().order([[sortingColIndex, sortingOrder]]).draw();
                  }
                }
              }
              this.directSorting = true;
            }

          } else {
            console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          }
        };
        break;
      case 'R006': //REPORTE DE GENERAL
        break;
      case 'R007': //REPORTE DE EVENTOS
        this.dtOptions["fnDrawCallback"] = ( oSettings: any ) => {

          if(this.chkTableDropdown){
            this.dtTableCurrentOrder = [[ oSettings.aaSorting[0]['0'], oSettings.aaSorting[0]['1']]];
            this.dtOptions.order = this.dtTableCurrentOrder;
          }

          const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
          if(   isIndependentWindow
            ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){
            let sortedDataTableIndex = -1;

            sortedDataTableIndex = this.chkTableDropdown? this.reportTableVehicleSelected.index: dataTableIndex - this.dataTableStartingIndex;

            let sortingColIndex = oSettings.aaSorting[0]['0'];
            let sortingOrder = oSettings.aaSorting[0]['1'];

            if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
              let columnName: string;
              let tableHeaders = [...columnsConfig.headers];

              columnName = tableHeaders[sortingColIndex - 1];
              //console.log('Headers List', tableHeaders);
              //console.log('Sorting Column...', columnName);

              switch(columnName){
                case 'fecha':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_tracker, b.fecha_tracker, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_tracker, b.fecha_tracker, sortingOrder);
                    });
                  }
                  break;
                case 'hora':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_tracker, b.fecha_tracker, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_tracker, b.fecha_tracker, sortingOrder, true);
                    });
                  }
                  break;
                case 'velocidad':
                case 'vel_can':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = isNaN(a[columnName])? -1: parseFloat(a[columnName]);
                        let term2 = isNaN(b[columnName])? -1: parseFloat(b[columnName]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = isNaN(a[columnName])? -1: parseFloat(a[columnName]);
                      let term2 = isNaN(b[columnName])? -1: parseFloat(b[columnName]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'ubicacion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                    });
                  }
                  break;
                default:
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(a[columnName], b[columnName], sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(a[columnName], b[columnName], sortingOrder);
                    });
                  }
                  break;
              }
              console.log(this.sortedData[sortedDataTableIndex][1]);

            }

            if(this.directSorting){
              this.directSorting = false;
              for(let i = 0; i < this.currentActiveTables.length; i++){
                if(this.currentActiveTables[i] != oSettings.sTableId){
                  if(!this.chkTableDropdown){
                    console.log('Sorting other dataTables: ', this.currentActiveTables[i]);
                    $(`#${this.currentActiveTables[i]}`).DataTable().order([[sortingColIndex, sortingOrder]]).draw();
                  }
                }
              }
              this.directSorting = true;
            }

          } else {
            console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          }
        };
        break;
      case 'R008': //REPORTE DE POSICIÓN
        this.dtOptions["fnDrawCallback"] = ( oSettings: any ) => {
          const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
          if(   isIndependentWindow
            ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){

            let sortingColIndex = oSettings.aaSorting[0]['0'];
            let sortingOrder = oSettings.aaSorting[0]['1'];

            if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
              let columnName: string = columnsConfig.headers[sortingColIndex - 1];
              //console.log('Headers List', tableHeaders);
              //console.log('Sorting Column...', columnName);
              switch(columnName){
                case 'fecha':
                  this.sortedData.sort((a: any, b: any) => {
                    return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                  });
                  break;
                case 'hora':
                  this.sortedData.sort((a: any, b: any) => {
                    return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                  });
                  break;
                case 'velocidad':
                case 'velocidad_can':
                  this.sortedData.sort((a: any, b: any) => {
                    return this.numericComparison(parseFloat(a[columnName]), parseFloat(b[columnName]), sortingOrder);
                  });
                  break;
                case 'odometro':
                  this.sortedData.sort((a: any, b: any) => {
                    let term1 = a.odometro == '-'? -1: parseFloat(a.odometro);
                    let term2 = b.odometro == '-'? -1: parseFloat(b.odometro);
                    return this.numericComparison(term1, term2, sortingOrder);
                  });
                  break;
                case 'ubicacion':
                  this.sortedData.sort((a: any, b: any) => {
                    return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                  });
                  break;
                default:
                  this.sortedData.sort((a: any, b: any) => {
                    return this.textComparison(a[columnName], b[columnName], sortingOrder);
                  });
                  break;
              }
              console.log(this.sortedData);
            }
          } else {
            console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          }
        };
        break;
      case 'R009': //REPORTE DE EXCESOS Y TRANSGRESIONES
        break;
      case 'R010': //REPORTE DE COMBUSTIBLE ODÓMETRO VIRTUAL
        break;
      case 'R011': //REPORTE DE FRENADA Y ACELERACIÓN BRUSCA (ECO DRIVE)
        this.dtOptions["fnDrawCallback"] = ( oSettings: any ) => {

          if(this.chkTableDropdown){
            this.dtTableCurrentOrder = [[ oSettings.aaSorting[0]['0'], oSettings.aaSorting[0]['1']]];
            this.dtOptions.order = this.dtTableCurrentOrder;
          }

          const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
          if(   isIndependentWindow
            ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){
            let sortedDataTableIndex = -1;

            sortedDataTableIndex = this.chkTableDropdown? this.reportTableVehicleSelected.index: dataTableIndex - this.dataTableStartingIndex;

            let sortingColIndex = oSettings.aaSorting[0]['0'];
            let sortingOrder = oSettings.aaSorting[0]['1'];

            if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
              let columnName: string;
              let tableHeaders = [...columnsConfig.headers];

              columnName = tableHeaders[sortingColIndex - 1];
              //console.log('Headers List', tableHeaders);
              //console.log('Sorting Column...', columnName);

              switch(columnName){
                case 'fecha':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder);
                    });
                  }
                  break;
                case 'hora':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha_final, b.fecha_final, sortingOrder, true);
                    });
                  }
                  break;
                case 'idConductor':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = isNaN(a[columnName])? -1: parseInt(a[columnName]);
                        let term2 = isNaN(b[columnName])? -1: parseInt(b[columnName]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = isNaN(a[columnName])? -1: parseInt(a[columnName]);
                      let term2 = isNaN(b[columnName])? -1: parseInt(b[columnName]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'velGPS':
                case 'vel_can':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = isNaN(a[columnName].split(' ')[0])? -1: parseFloat(a[columnName].split(' ')[0]);
                        let term2 = isNaN(b[columnName].split(' ')[0])? -1: parseFloat(b[columnName].split(' ')[0]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = isNaN(a[columnName].split(' ')[0])? -1: parseFloat(a[columnName].split(' ')[0]);
                      let term2 = isNaN(b[columnName].split(' ')[0])? -1: parseFloat(b[columnName].split(' ')[0]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'ubicacion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                    });
                  }
                  break;
                default:
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(a[columnName], b[columnName], sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(a[columnName], b[columnName], sortingOrder);
                    });
                  }
                  break;
              }
              console.log(this.sortedData[sortedDataTableIndex][1]);

            }

            if(this.directSorting){
              this.directSorting = false;
              for(let i = 0; i < this.currentActiveTables.length; i++){
                if(this.currentActiveTables[i] != oSettings.sTableId){
                  if(!this.chkTableDropdown){
                    console.log('Sorting other dataTables: ', this.currentActiveTables[i]);
                    $(`#${this.currentActiveTables[i]}`).DataTable().order([[sortingColIndex, sortingOrder]]).draw();
                  }
                }
              }
              this.directSorting = true;
            }

          } else {
            console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          }
        };
        break;
      case 'R012': //REPORTE DE DISTRACCIÓN Y POSIBLE FATIGA
        this.dtOptions["fnDrawCallback"] = ( oSettings: any ) => {

          if(this.chkTableDropdown){
            this.dtTableCurrentOrder = [[ oSettings.aaSorting[0]['0'], oSettings.aaSorting[0]['1']]];
            this.dtOptions.order = this.dtTableCurrentOrder;
          }

          const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
          if(   isIndependentWindow
            ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){
            let sortedDataTableIndex = -1;

            sortedDataTableIndex = this.chkTableDropdown? this.reportTableVehicleSelected.index: dataTableIndex - this.dataTableStartingIndex;

            let sortingColIndex = oSettings.aaSorting[0]['0'];
            let sortingOrder = oSettings.aaSorting[0]['1'];

            if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
              let columnName: string;
              let tableHeaders = [...columnsConfig.headers];

              if(!this.chkFatigaSomnolencia || !this.chkFatigaDistraccion){
                for(let i = 0; i < tableHeaders.length; i++){
                  if(tableHeaders[i] == 'descripcion'){
                    tableHeaders.splice(i, 1);
                    break;
                  }
                }
              }

              columnName = tableHeaders[sortingColIndex - 1];
              //console.log('Headers List', tableHeaders);
              //console.log('Sorting Column...', columnName);

              switch(columnName){
                case 'fecha':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                    });
                  }
                  break;
                case 'hora':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                    });
                  }
                  break;
                case 'idConductor':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = isNaN(a[columnName])? -1: parseInt(a[columnName]);
                        let term2 = isNaN(b[columnName])? -1: parseInt(b[columnName]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = isNaN(a[columnName])? -1: parseInt(a[columnName]);
                      let term2 = isNaN(b[columnName])? -1: parseInt(b[columnName]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'velGPS':
                case 'vel_can':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = isNaN(a[columnName].split(' ')[0])? -1: parseFloat(a[columnName].split(' ')[0]);
                        let term2 = isNaN(b[columnName].split(' ')[0])? -1: parseFloat(b[columnName].split(' ')[0]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = isNaN(a[columnName].split(' ')[0])? -1: parseFloat(a[columnName].split(' ')[0]);
                      let term2 = isNaN(b[columnName].split(' ')[0])? -1: parseFloat(b[columnName].split(' ')[0]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'ai1x':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = a[columnName] > 1000? `Rostro detectado ${a[columnName]}`: `Rostro ausente ${a[columnName]}`;
                        let term2 = b[columnName] > 1000? `Rostro detectado ${b[columnName]}`: `Rostro ausente ${b[columnName]}`;
                        return this.textComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = a[columnName] > 1000? `Rostro detectado ${a[columnName]}`: `Rostro ausente ${a[columnName]}`;
                      let term2 = b[columnName] > 1000? `Rostro detectado ${b[columnName]}`: `Rostro ausente ${b[columnName]}`;
                      return this.textComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'ubicacion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                    });
                  }
                  break;
                default:
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(a[columnName], b[columnName], sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(a[columnName], b[columnName], sortingOrder);
                    });
                  }
                  break;
              }
              console.log(this.sortedData[sortedDataTableIndex][1]);

            }

            if(this.directSorting){
              this.directSorting = false;
              for(let i = 0; i < this.currentActiveTables.length; i++){
                if(this.currentActiveTables[i] != oSettings.sTableId){
                  if(!this.chkTableDropdown){
                    console.log('Sorting other dataTables: ', this.currentActiveTables[i]);
                    $(`#${this.currentActiveTables[i]}`).DataTable().order([[sortingColIndex, sortingOrder]]).draw();
                  }
                }
              }
              this.directSorting = true;
            }

          } else {
            console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          }
        };
        break;
      case 'R013': //REPORTE DE CALIFICACIÓN DE MANEJO
        break;
      case 'R014': //REPORTE DE FATIGA EXTREMA
        this.dtOptions["fnDrawCallback"] = ( oSettings: any ) => {

          if(this.chkTableDropdown){
            this.dtTableCurrentOrder = [[ oSettings.aaSorting[0]['0'], oSettings.aaSorting[0]['1']]];
            this.dtOptions.order = this.dtTableCurrentOrder;
          }

          const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
          if(   isIndependentWindow
            ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){
            let sortedDataTableIndex = -1;

            sortedDataTableIndex = this.chkTableDropdown? this.reportTableVehicleSelected.index: dataTableIndex - this.dataTableStartingIndex;

            let sortingColIndex = oSettings.aaSorting[0]['0'];
            let sortingOrder = oSettings.aaSorting[0]['1'];

            if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
              let columnName: string;
              let tableHeaders = [...columnsConfig.headers];

              columnName = tableHeaders[sortingColIndex - 1];
              //console.log('Headers List', tableHeaders);
              //console.log('Sorting Column...', columnName);

              switch(columnName){
                case 'fecha':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                    });
                  }
                  break;
                case 'hora':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                    });
                  }
                  break;
                case 'idConductor':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = isNaN(a[columnName])? -1: parseInt(a[columnName]);
                        let term2 = isNaN(b[columnName])? -1: parseInt(b[columnName]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = isNaN(a[columnName])? -1: parseInt(a[columnName]);
                      let term2 = isNaN(b[columnName])? -1: parseInt(b[columnName]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'velGPS':
                case 'vel_can':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = isNaN(a[columnName].split(' ')[0])? -1: parseFloat(a[columnName].split(' ')[0]);
                        let term2 = isNaN(b[columnName].split(' ')[0])? -1: parseFloat(b[columnName].split(' ')[0]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = isNaN(a[columnName].split(' ')[0])? -1: parseFloat(a[columnName].split(' ')[0]);
                      let term2 = isNaN(b[columnName].split(' ')[0])? -1: parseFloat(b[columnName].split(' ')[0]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'ai1x':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = a[columnName] > 1000? `Rostro detectado ${a[columnName]}`: `Rostro ausente ${a[columnName]}`;
                        let term2 = b[columnName] > 1000? `Rostro detectado ${b[columnName]}`: `Rostro ausente ${b[columnName]}`;
                        return this.textComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = a[columnName] > 1000? `Rostro detectado ${a[columnName]}`: `Rostro ausente ${a[columnName]}`;
                      let term2 = b[columnName] > 1000? `Rostro detectado ${b[columnName]}`: `Rostro ausente ${b[columnName]}`;
                      return this.textComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'ubicacion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                    });
                  }
                  break;
                default:
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(a[columnName], b[columnName], sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(a[columnName], b[columnName], sortingOrder);
                    });
                  }
                  break;
              }
              console.log(this.sortedData[sortedDataTableIndex][1]);

            }

            if(this.directSorting){
              this.directSorting = false;
              for(let i = 0; i < this.currentActiveTables.length; i++){
                if(this.currentActiveTables[i] != oSettings.sTableId){
                  if(!this.chkTableDropdown){
                    console.log('Sorting other dataTables: ', this.currentActiveTables[i]);
                    $(`#${this.currentActiveTables[i]}`).DataTable().order([[sortingColIndex, sortingOrder]]).draw();
                  }
                }
              }
              this.directSorting = true;
            }

          } else {
            console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          }
        };
        break;
      case 'R015': //REPORTE DE ANTICOLISIÓN FRONTAL
      case 'R016': //REPORTE DE COLISIÓN CON PEATONES
      case 'R017': //REPORTE DE DESVÍO DE CARRIL HACIA LA IZQUIERDA
      case 'R018': //REPORTE DE DESVÍO DE CARRIL HACIA LA DERECHA
      case 'R019': //REPORTE DE BLOQUEO DE VISIÓN MOBILEYE
        this.dtOptions["fnDrawCallback"] = ( oSettings: any ) => {

          if(this.chkTableDropdown){
            this.dtTableCurrentOrder = [[ oSettings.aaSorting[0]['0'], oSettings.aaSorting[0]['1']]];
            this.dtOptions.order = this.dtTableCurrentOrder;
          }

          const dataTableIndex = parseInt(oSettings.sTableId.split('_')[2]);
          if(   isIndependentWindow
            ||  (this.dataTableStartingIndex <= dataTableIndex && dataTableIndex <= this.dataTableEndingIndex)){
            let sortedDataTableIndex = -1;

            sortedDataTableIndex = this.chkTableDropdown? this.reportTableVehicleSelected.index: dataTableIndex - this.dataTableStartingIndex;

            let sortingColIndex = oSettings.aaSorting[0]['0'];
            let sortingOrder = oSettings.aaSorting[0]['1'];

            if(sortingColIndex > 0 && reportExistInConfig && headersExistInColumnsConfig){
              let columnName: string;
              let tableHeaders = [...columnsConfig.headers];

              columnName = tableHeaders[sortingColIndex - 1];
              //console.log('Headers List', tableHeaders);
              //console.log('Sorting Column...', columnName);

              switch(columnName){
                case 'fecha':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder);
                    });
                  }
                  break;
                case 'hora':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.dateComparison(a.fecha, b.fecha, sortingOrder, true);
                    });
                  }
                  break;
                case 'idConductor':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = isNaN(a[columnName])? -1: parseInt(a[columnName]);
                        let term2 = isNaN(b[columnName])? -1: parseInt(b[columnName]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = isNaN(a[columnName])? -1: parseInt(a[columnName]);
                      let term2 = isNaN(b[columnName])? -1: parseInt(b[columnName]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'vel_gps_speed':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.numericComparison(parseFloat(a[columnName]), parseFloat(b[columnName]), sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.numericComparison(parseFloat(a[columnName]), parseFloat(b[columnName]), sortingOrder);
                    });
                  }
                  break;
                case 'vel_can':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        let term1 = isNaN(a[columnName].split(' ')[0])? -1: parseFloat(a[columnName].split(' ')[0]);
                        let term2 = isNaN(b[columnName].split(' ')[0])? -1: parseFloat(b[columnName].split(' ')[0]);
                        return this.numericComparison(term1, term2, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      let term1 = isNaN(a[columnName].split(' ')[0])? -1: parseFloat(a[columnName].split(' ')[0]);
                      let term2 = isNaN(b[columnName].split(' ')[0])? -1: parseFloat(b[columnName].split(' ')[0]);
                      return this.numericComparison(term1, term2, sortingOrder);
                    });
                  }
                  break;
                case 'ubicacion':
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(`${a.latitud}, ${a.longitud}`, `${b.latitud}, ${b.longitud}`, sortingOrder);
                    });
                  }
                  break;
                default:
                  if(this.chkTableDropdown){
                    for(let i = 0; i < numberOfTables; i++){
                      this.sortedData[i][1].sort((a: any, b: any) => {
                        return this.textComparison(a[columnName], b[columnName], sortingOrder);
                      });
                    }
                  } else {
                    this.sortedData[sortedDataTableIndex][1].sort((a: any, b: any) => {
                      return this.textComparison(a[columnName], b[columnName], sortingOrder);
                    });
                  }
                  break;
              }
              console.log(this.sortedData[sortedDataTableIndex][1]);

            }

            if(this.directSorting){
              this.directSorting = false;
              for(let i = 0; i < this.currentActiveTables.length; i++){
                if(this.currentActiveTables[i] != oSettings.sTableId){
                  if(!this.chkTableDropdown){
                    console.log('Sorting other dataTables: ', this.currentActiveTables[i]);
                    $(`#${this.currentActiveTables[i]}`).DataTable().order([[sortingColIndex, sortingOrder]]).draw();
                  }
                }
              }
              this.directSorting = true;
            }

          } else {
            console.log('An fnDrawCallback has been fired by an old table', oSettings.sTableId);
          }
        };
        break;
    }

    if(this.chkTableDropdown){
      this.dtOptions.order = this.dtTableCurrentOrder;
    }

    console.log('Columns Config', columnsConfig);
    console.log('Columns Config', columnsConfig !== undefined);
    console.log('This Columns Config', this.columnsConfig);
    console.log('This Columns Config', this.columnsConfig.filter((report: any) => { return report.num_rep.indexOf(this.report_data.num_rep) > -1; })[0]);

    if(columnsConfig !== undefined && columnsConfig.colDefs !== undefined && columnsConfig.colDefs.length != 0){
      this.dtOptions.columnDefs = JSON.parse(JSON.stringify(columnsConfig.colDefs));

      //Custom renders para sorting de las dataTables
      switch(this.report_data.num_rep){
        case 'R001': //REPORTE DE PARADAS Y MOVIMIENTOS
          this.dtOptions.columnDefs.push(
            {
              targets: [6],
              "render": ( data: string, type: any, row: any, meta: any ) => {
                if(type === 'sort' || type === 'type'){
                  return this.intervalToSeconds(data);
                } else {
                  return data;
                }
              }
            },
          );
          console.log('this.data para revisar paradas y movimientos', this.data);
          //PARADAS Y MOVIMIENTOS
          if(this.data[0][2].Paradas && this.data[0][2].Movimientos){
            this.dtOptions.columnDefs.push(
              {
                targets: [8, 9, 10, 12, 13],
                "render": ( data: string, type: any, row: any, meta: any ) => {
                  if(type === 'sort' || type === 'type'){
                    return parseFloat(data.split(' ')[0]);
                  } else {
                    return data;
                  }
                }
              },
            );
          }
          //SOLO MOVIMIENTOS
          if(!this.data[0][2].Paradas && this.data[0][2].Movimientos){
            this.dtOptions.columnDefs.push(
              {
                targets: [7, 8, 9, 10, 11],
                "render": ( data: string, type: any, row: any, meta: any ) => {
                  if(type === 'sort' || type === 'type'){
                    return parseFloat(data.split(' ')[0]);
                  } else {
                    return data;
                  }
                }
              },
            );
          }
          break;
        case 'R002': //REPORTE DE EXCESOS DE VELOCIDAD
          if(!this.chkDuracion){ //Limite de velocidad
            this.dtOptions.columnDefs.push(
              { orderData: [ 2, 3 ], targets: [2] },
              { orderData: [ 3, 2 ], targets: [3] },
              {
                targets: [4], // Maxima velocidad
                "render": ( data: string, type: any, row: any, meta: any ) => {
                  if(type === 'sort' || type === 'type'){
                    return parseFloat(data);
                  } else {
                    return data;
                  }
                }
              },
            );
          } else {
            this.dtOptions.columnDefs.push(
              { orderData: [ 1, 2 ], targets: [1] },
              { orderData: [ 2, 1 ], targets: [2] },
              { orderData: [ 3, 4 ], targets: [3] },
              { orderData: [ 4, 3 ], targets: [4] },
              {
                targets: [5], // Duracion
                "render": ( data: string, type: any, row: any, meta: any ) => {
                  if(type === 'sort' || type === 'type'){
                    return this.intervalToSeconds(data);
                  } else {
                    return data;
                  }
                }
              },
              {
                targets: [8, 9], //Vel min y Vel max
                "render": ( data: string, type: any, row: any, meta: any ) => {
                  if(type === 'sort' || type === 'type'){
                    return parseFloat(data.split(' ')[0]);
                  } else {
                    return data;
                  }
                }
              },
            );
          }
          break;
        case 'R003': //REPORTE DE ENTRADA Y SALIDA
          this.dtOptions.columnDefs.push(
            {
              targets: [5], //Duracion
              "render": ( data: string, type: any, row: any, meta: any ) => {
                if(type === 'sort' || type === 'type'){
                  return this.intervalToSeconds(data);
                } else {
                  return data;
                }
              }
            },
          );
          break;
        case 'R004': //REPORTE DE COMBUSTIBLE
          //NADA ADICIONAL
          break;
        case 'R005': //REPORTE DE EXCESOS EN ZONA
          this.dtOptions.columnDefs.push(
            {
              targets: [6], //duracion
              "render": ( data: string, type: any, row: any, meta: any ) => {
                if(type === 'sort' || type === 'type'){
                  return this.intervalToSeconds(data);
                } else {
                  return data;
                }
              }
            },
          );
          break;
        case 'R006': //REPORTE GENERAL
          break;
        case 'R007': //REPORTE DE EVENTOS
          this.dtOptions.columnDefs.push(
            {
              targets: [5, 6], //velocidad gps  y velocidad_can
              "render": ( data: string, type: any, row: any, meta: any ) => {
                if(type === 'sort' || type === 'type'){
                  return isNaN(parseFloat(data.split(' ')[0]))? -1: parseFloat(data.split(' ')[0]);
                } else {
                  return data;
                }
              }
            },
          );
          break;
        case 'R008': //REPORTE DE POSICIÓN
          this.dtOptions.columnDefs.push(
            {
              targets: [7, 8], //velocidad  y velocidad_can
              "render": ( data: string, type: any, row: any, meta: any ) => {
                if(type === 'sort' || type === 'type'){
                  return parseFloat(data.split(' ')[0]);
                } else {
                  return data;
                }
              }
            },
          );
          this.dtOptions.columnDefs.push(
            {
              targets: [9], //odometro
              "render": ( data: string, type: any, row: any, meta: any ) => {
                if(type === 'sort' || type === 'type'){
                  return data == '-'? -1: parseFloat(data);
                } else {
                  return data;
                }
              }
            },
          );
          break;
        case 'R011': //REPORTE DE FRENADA Y ACELERACIÓN BRUSCA
        case 'R012': //REPORTE DE DISTRACCIÓN Y POSIBLE FATIGA

        case 'R014': //REPORTE DE FATIGA EXTREMA
        case 'R015': //REPORTE DE ANTICOLISIÓN FRONTAL
        case 'R016': //REPORTE DE COLISIÓN CON PEATONES
        case 'R017': //REPORTE DE DESVÍO DE CARRIL HACIA LA IZQUIERDA
        case 'R018': //REPORTE DE DESVÍO DE CARRIL HACIA LA DERECHA
        case 'R019': //REPORTE DE BLOQUEO DE VISIÓN DE MOBILEYE
          this.dtOptions.columnDefs.push(
            {
              targets: [8, 9], //velocidad gps  y velocidad can
              "render": ( data: string | number, type: any, row: any, meta: any ) => {
                if(type === 'sort' || type === 'type'){
                  let aux = -1;
                  if(typeof data == 'string'){ aux = parseFloat(data.split(' ')[0]); }
                  if(typeof data == 'number'){ aux = data; }
                  return isNaN(aux)? -1: aux;
                } else {
                  return data;
                }
              }
            },
          );
          break;
      }
    }

    this.dtOptions2 = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language:{
        url: '//cdn.datatables.net/plug-ins/1.11.5/i18n/es-ES.json'
      },
      dom: 'lfrtip',
      paging: false,
      searching: false,
      lengthChange: false,
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Todos"]],
      buttons: [{
        extend: 'excel',
        text: '<i class="fa fa-file-excel-o" aria-hidden="true"click></i> Exportar a Excel',
        className: 'btn btn-success'
      }],
      initComplete: () => {
        this.dt_completed++;
        //console.log('Terminado de cargar y popular tabla ' + this.dt_completed);
        if(this.dt_completed == document.querySelectorAll('table[datatable]').length){
          this.wrapElements(document.querySelectorAll('table[datatable]'));
          this.table_hide = '';
          if(!isIndependentWindow){
            this.spinner.hide("reportSpinner");
            this.reportService.workingOnReport = false;
          }
        }

      },
      destroy: true,
    };

    this.dtOptions3 = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language:{
        // url: '//cdn.datatables.net/plug-ins/1.11.5/i18n/es-ES.json',
        info: ''
      },
      dom: 'lfrtip',
      paging: false,
      searching: false,
      lengthChange: false,
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Todos"]],
      buttons: [{
        extend: 'excel',
        text: '<i class="fa fa-file-excel-o" aria-hidden="true"click></i> Exportar a Excel',
        className: 'btn btn-success'
      }],
      initComplete: () => {
        this.dt_completed++;
        //console.log('Terminado de cargar y popular tabla ' + this.dt_completed);
        if(this.dt_completed == document.querySelectorAll('table[datatable]').length){
          this.wrapElements(document.querySelectorAll('table[datatable]'));
          this.table_hide = '';
          if(!isIndependentWindow){
            this.spinner.hide("reportSpinner");
            this.reportService.workingOnReport = false;
          }
        }

      },
      destroy: true,
    };


    this.dtOptions4 = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language:{
        // url: '//cdn.datatables.net/plug-ins/1.11.5/i18n/es-ES.json',
        info: ''
      },
      dom: 'lfrtip',
      ordering: false,
      paging: false,
      searching: false,
      lengthChange: false,
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Todos"]],
      buttons: [{
        extend: 'excel',
        text: '<i class="fa fa-file-excel-o" aria-hidden="true"click></i> Exportar a Excel',
        className: 'btn btn-success'
      }],
      initComplete: () => {
        this.dt_completed++;
        //console.log('Terminado de cargar y popular tabla ' + this.dt_completed);
        if(this.dt_completed == document.querySelectorAll('table[datatable]').length){
          this.wrapElements(document.querySelectorAll('table[datatable]'));
          this.table_hide = '';
          if(!isIndependentWindow){
            this.spinner.hide("reportSpinner");
            this.reportService.workingOnReport = false;
          }
        }

      },
      destroy: true,
    };


    this.dtOptions5 = {
      pagingType: 'full_numbers',
      pageLength: -1,
      // processing: true,
      language:{
        // url: '//cdn.datatables.net/plug-ins/1.11.5/i18n/es-ES.json',
        info: ''
      },
      dom: 't',
      ordering: false,
      // paging: false,
      // searching: false,
      // lengthChange: false,
      // lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Todos"]],
      buttons: [{
        extend: 'excel',
        text: '<i class="fa fa-file-excel-o" aria-hidden="true"click></i> Exportar a Excel',
        className: 'btn btn-success'
      }],
      initComplete: () => {
        this.dt_completed++;

        // this.spinner.hide("reportSpinner");
        // this.reportService.workingOnReport = false;

        console.log('Terminado de cargar y popular tabla ' + this.dt_completed);
        if(this.dt_completed == document.querySelectorAll('table[datatable]').length){
          this.wrapElements(document.querySelectorAll('table[datatable]'));
          this.table_hide = '';
          if(!isIndependentWindow){
            this.spinner.hide("reportSpinner");
            this.reportService.workingOnReport = false;
          }
        }

      },
      destroy: true,
    };

  }


  prepareStringForComparison(str: string){
    return str.toLowerCase();
  }

  textComparison(a: string | null, b: string | null, order: string){
    //los acentos igual irand despues de la z, tal cual ordena datatables
    let str1 = a == null? '': this.prepareStringForComparison(a);
    let str2 = b == null? '': this.prepareStringForComparison(b);
    if(order == 'asc'){
      if(str1 < str2){ return -1; };
      if(str1 > str2){ return 1; };
      return 0;
    }
    if(order == 'desc'){
      if(str1 < str2){ return 1; };
      if(str1 > str2){ return -1; };
      return 0;
    }
    console.log(`Expecting order asc or desc (normal), got: `, order);
    return 0;
  }

  dateComparison(fecha1: string, fecha2: string, order: string, hourOnly?: boolean){
    let date1 = fecha1.split(' ')[0];
    let hour1 = fecha1.split(' ')[1];
    let date2 = fecha2.split(' ')[0];
    let hour2 = fecha2.split(' ')[1];
    if(hourOnly == undefined || !hourOnly){
      if(order == 'asc'){
        if(date1 < date2){ return -1; };
        if(date1 > date2){ return 1; };
        if(hour1 < hour2){ return -1; };
        if(hour1 > hour2){ return 1; };
        return 0;
      }
      if(order == 'desc'){
        if(date1 < date2){ return 1; };
        if(date1 > date2){ return -1; };
        if(hour1 < hour2){ return 1; };
        if(hour1 > hour2){ return -1; };
        return 0;
      }
    } else {
      if(order == 'asc'){
        if(hour1 < hour2){ return -1; };
        if(hour1 > hour2){ return 1; };
        if(date1 < date2){ return -1; };
        if(date1 > date2){ return 1; };
        return 0;
      }
      if(order == 'desc'){
        if(hour1 < hour2){ return 1; };
        if(hour1 > hour2){ return -1; };
        if(date1 < date2){ return 1; };
        if(date1 > date2){ return -1; };
        return 0;
      }
    }
    console.log(`Expecting order asc or desc (date), got: `, order);
    return 0;
  }

  intervalToSeconds(intervalStr: string){
    let intervalArr = intervalStr.trim().split(' ');
    let intervalValue = 0;
    for(let i = 0; i < intervalArr.length; i = i + 2){
      if(intervalArr[i + 1] == 'd'){ intervalValue = intervalValue + parseInt(intervalArr[i]) * 24 * 60 * 60 }
      if(intervalArr[i + 1] == 'h'){ intervalValue = intervalValue + parseInt(intervalArr[i]) * 60 * 60 }
      if(intervalArr[i + 1] == 'min'){ intervalValue = intervalValue + parseInt(intervalArr[i]) * 60 }
      if(intervalArr[i + 1] == 's'){ intervalValue = intervalValue + parseInt(intervalArr[i]) }
    }
    return intervalValue;
  }

  numericComparison(num1: number, num2: number, order: string){
    if(order == 'asc'){
      if(num1 < num2){ return -1; };
      if(num1 > num2){ return 1; };
      return 0;
    }
    if(order == 'desc'){
      if(num1 < num2){ return 1; };
      if(num1 > num2){ return -1; };
      return 0;
    }
    console.log(`Expecting order asc or desc (date), got: `, order);
    return 0;
  }

  coordinatesComparison(coord1: string, coord2: string, order: string){
    let lat1 = parseFloat(coord1.split(',')[0]);
    let long1 = parseFloat(coord1.split(',')[1]);
    let lat2 = parseFloat(coord2.split(',')[0]);
    let long2 = parseFloat(coord2.split(',')[1]);
    if(order == 'asc'){
      if(lat1 < lat2){ return -1; };
      if(lat1 > lat2){ return 1; };
      if(long1 < long2){ return -1; };
      if(long1 > long2){ return 1; };
      return 0;
    }
    if(order == 'desc'){
      if(lat1 < lat2){ return 1; };
      if(lat1 > lat2){ return -1; };
      if(long1 < long2){ return 1; };
      if(long1 > long2){ return -1; };
      return 0;
    }
    console.log(`Expecting order asc or desc (date), got: `, order);
    return 0;
  }

  isSingleTableReport(){
    return this.singleTableReportIDs.indexOf(this.report_data.num_rep) >= 0;
  }

  prepareVehicleDropdown(){
    this.reportTableVehicleDropdownOptions = [];
    for(let i = 0; i < this.data.length; i++){
      if( this.data[i][1].length == 0 ){
        //Si la tabla del vehiculo no tiene filas
        this.reportTableVehicleDropdownOptions.push({
          name: this.data[i][0][1],
          dataSize: ' (Sin registros)',
          index: i,
        });
      } else {
        //Si la tabla del vehiculo SÍ tiene filas
        this.reportTableVehicleDropdownOptions.push({
          name: this.data[i][0][1],
          dataSize: (this.data[i][1].length == 1? ' (1 registro)': (' (' + this.data[i][1].length +' registros)')),
          index: i,
        });
      }
    }
    if(this.reportTableVehicleDropdownOptions.length > 0){
      this.reportTableVehicleSelected = this.reportTableVehicleDropdownOptions[0];
      console.log(this.reportTableVehicleDropdownOptions);
      this.renderDataTable();
    } else {
      console.log('Sin resultados que mostrar');
    }
    console.log('Vehicle Dropdown Options Ready:', this.reportTableVehicleDropdownOptions);

  }

  renderDataTable(){
    if(this.reportTableVehicleSelected.index > -1){
      this.reportTableDropdownData = this.data[this.reportTableVehicleSelected.index];
      console.log(this.reportTableDropdownData);
      if(this.dtElement !== undefined && "dtInstance" in this.dtElement){
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          // Destroy the table first
          dtInstance.destroy();
          this.dtTrigger.next();
          this.wrapElements(document.querySelectorAll('table[datatable]'));
        });
      }
    }

    //this.dtRendered = true;
  }

  generateEmptyRowsForRowSpan(rowSpan: number, rowHeight: number){
    var arr=[];
    for(let i = 1; i < rowSpan; i++){
      arr.push({height: rowHeight});
    }
    return arr;
  }

  ngOnDestroy() {
    this.dtTrigger.unsubscribe();
    localStorage.removeItem('report_data');
  }

  calculateColWidth(noOfCharacters: number){
    return (this.char_to_px * noOfCharacters) + 5;
  }

  calculateRowHeights(){
    this.headerRowsHeight = this.headerRowsHeight * this.excelUnitstoPxRatio;
    this.subHeaderRepPosicionHeight = this.subHeaderRepPosicionHeight * this.excelUnitstoPxRatio;
    this.subHeaderHeight = this.subHeaderHeight * this.excelUnitstoPxRatio;
    this.colsHeaderHeight = this.colsHeaderHeight * this.excelUnitstoPxRatio;
    this.bodyRowsHeight = this.bodyRowsHeight * this.excelUnitstoPxRatio;
    this.overviewRowsHeight = this.overviewRowsHeight * this.excelUnitstoPxRatio;
    this.spaceBetweenTables = [
      {
        height: this.bodyRowsHeight
      },
      {
        height: this.bodyRowsHeight
      },
    ];
  }

  calculateSingleRowHeight(cellContent: string, defaultRowHeight: number){
    return (cellContent.split("\n").length) * defaultRowHeight;
  }

  breakParameterColValue(params: string){
    const paramsArr = params.split('|');
    var cellContent = '';
    var tempContent = '';
    for(let i = 0; i < paramsArr.length; i++){
      if( this.calculateColWidth((tempContent + '|' + paramsArr[i]).length) > 560 ){
        if(cellContent == ''){
          cellContent = tempContent;
        } else {
          cellContent = cellContent + "\n" + tempContent;
        }
        tempContent = '';
      }
      tempContent = tempContent + '|' + paramsArr[i];
    }
    cellContent = cellContent + tempContent;
    return cellContent.substring(1);
  }

  getChWidth(val1: string){
    var chWidth1 = val1.split("\n")[0].length;
    for( let i = 1; i < val1.split("\n").length; i++ ){
      if( chWidth1 < val1.split("\n")[i].length ){
        chWidth1 = val1.split("\n")[i].length;
      }
    }
    return chWidth1;
  }

  filterMovimientos(a: any[]): any[] {
    return a.filter((row: { esInt: number; }) => row.esInt == 1);
  }

  filterParadas(a: any[]): any[] {
    return a.filter((row: { esInt: number; }) => row.esInt == 0);
  }

  // Se ejecuta DESPUES de que todas las tablas hayan cargado
  wrapElements(elements: any){
    //console.log('Wrapping Elements...', elements);
    const htmlWrapper = `<div style="display: block; overflow: auto; width:100%;"></div>`;
    for(let element of elements){
      //console.log('Wrapping 1 element: ', element);
      let auxEl = document.createElement('div');
      auxEl.innerHTML = htmlWrapper.trim();
      let wrapperEl = auxEl.firstElementChild;
      let datatable_wrapper = element.parentNode;
      datatable_wrapper.insertBefore(wrapperEl, element);
      wrapperEl!.appendChild(element);
    }
  }

  isNumber(val: any):boolean{
    return (typeof val) == 'number';
  }

  isChe(date:any) {
    if (this.isChrome) {
      if (this.chkDateHour) {
        var fh = date.split(" ");
        return fh[0];
      } else {
        return date;
      }
    } else {
      return new Date(date);
    }
  }

  isChs(date:any) {
      if (this.isChrome) {
        if (this.chkDateHour) {
          var fh = date.split(" ");
          return fh[1];
        } else {
          return date; // never
        }
      } else {
        return new Date(date);
      }
  }


  showSelectExcel(fn_name: string){
    this.confirmationService.confirm({
      key: 'showSelectExcelConfirmation',
      //message: 'Are you sure that you want to perform this action?',
      reject: () => {
        console.log('Confirm Dialog rejected');
      },
      accept: () => {

        //Si es el usuario de Betsy : Quieres todo en una misma tabla

        // console.log("=====================");
        // console.log(this.user_id);
        // console.log(this.reportOption);
        // console.log(fn_name);
        // console.log(this.sortedData);

        // //Para la exportacion en una misma tabla
        // if (this.reportOption == 2) {
        //     this.exportOneTable = true;
        //     let arr = [JSON.parse(JSON.stringify(this.sortedData[0]))];
        //     // var arr = [];
        //     // arr.push([
        //     //     ['0000000','ABC-123'],
        //     //     [],
        //     //     ['-1', '-2', '-3', '-4', '-5', '-6', '-7', '-8', '-9']
        //     // ]);
        //     for (let index = 1; index < this.sortedData.length; index++) {
        //         //console.log(this.sortedData[index][1]);
        //         arr[0][1] = arr[0][1].concat(this.sortedData[index][1]);
        //         //console.log(arr[0][1]);
        //     }
        //     this.sortedDataOneTabla  = arr;

        //     // console.log("ordenar ====");
        //     this.sortedDataOneTabla[0][1].sort( this.compare );
        // }

        // console.log(this.sortedDataOneTabla );
        // console.log("_____________________________________");


        this[fn_name as keyof ResultComponent](this.reportOption);
        this.reportOption = 0;
      }
    });
  }


  exportFormat(fn_name: string, format: string){
      if (format == 'excel') {

        console.log("=====================  EXCEL ======================");

          this.confirmationService.confirm({
            key: 'showSelectExcelConfirmation',
            //message: 'Are you sure that you want to perform this action?',
            reject: () => {
              console.log('Confirm Dialog rejected');
            },
            accept: () => {
              console.log(fn_name);
              console.log(this[fn_name as keyof ResultComponent]);

              this[fn_name as keyof ResultComponent](this.reportOption ,format);
              this.reportOption = 0;
            }
          });

      } else if (format == 'html') {
        console.log("=====================  HTML ======================");
        console.log(fn_name);
        console.log(this[fn_name as keyof ResultComponent]);

        this[fn_name as keyof ResultComponent](2 ,format);
        this.reportOption = 0;

      }
  }

  showSelectPdf(fn_name: string) {
      //Si es el usuario de Betsy : Quieres todo en una misma tabla

      console.log("=====================");
      console.log(this.user_id);
      // console.log(this.reportOption);
      console.log(fn_name);
      // console.log(this.sortedData);

      // if (this.reportOption == 2) {
      //     this.exportOneTable = true;
      //     let arr = [JSON.parse(JSON.stringify(this.sortedData[0]))];
      //     // var arr = [];
      //     // arr.push([
      //     //     ['0000000','ABC-123'],
      //     //     [],
      //     //     ['-1', '-2', '-3', '-4', '-5', '-6', '-7', '-8', '-9']
      //     // ]);
      //     for (let index = 1; index < this.sortedData.length; index++) {
      //         //console.log(this.sortedData[index][1]);
      //         arr[0][1] = arr[0][1].concat(this.sortedData[index][1]);
      //         //console.log(arr[0][1]);
      //     }
      //     this.sortedDataOneTabla  = arr;

      //     // console.log("ordenar ====");
      //     this.sortedDataOneTabla[0][1].sort( this.compare );
      // }

      // // console.log(this.sortedDataOneTabla );
      // // console.log("_____________________________________");

      this[fn_name as keyof ResultComponent]();

  }




  configReporteSeparado(){
    console.log("Reporte de Excel por separado (hojas)");
    this.reportOption = 1;
  }

  configReporteUnido(){
    console.log("Reporte de Excel por separado (hojas)");
    this.reportOption = 2;
  }

  puntuacion(idx:number){
    // console.log("puntuacion---------------");

    // console.log(idx);
    // console.log(vm.datos[idx][1]);
    // console.log(vm.datos[idx][1][0]);
    // console.log(vm.datos[idx][1][0].C12);

    var item = this.data[idx][1][0];
    //console.log("retornar :: ");


    // console.log(item);
    // console.log(this.data);
    //console.log("100 - ( ("+item.C01+"*(50/100)) +("+item.C02+"*(40/100)) + ("+item.C03+"*(50/100)) + ("+item.C04+"*(30/100))+ ("+item.C05+"*(2000/100)) + ("+item.C06+"*(2500/100)) + ("+item.C07+"*(100/100)) + ("+item.C08+"*(50/100)) + ("+item.C09+"*(500/100)) + ("+item.C10+"*(50/100)) + ("+item.C11+"*(50/100)) + ("+item.C12+"*(2000/100)) )");

    //console.log(100 - ( (item.C01*(50/100)) + (item.C02*(40/100)) + (item.C03*(50/100)) + (item.C04*(30/100))+ (item.C05*(2000/100)) + (item.C06*(2500/100)) + (item.C07*(100/100)) + (item.C08*(50/100)) + (item.C09*(500/100)) + (item.C10*(50/100)) + (item.C11*(50/100)) + (item.C12*(2000/100)) ) );

    this.data[idx][1][0].puntuacion =(100 - ( (item.C01*(40/100)) + (item.C02*(50/100)) + (item.C03*(30/100))+ (item.C04*(2000/100)) + (item.C05*(2500/100)) + (item.C06*(100/100)) + (item.C07*(50/100)) + (item.C08*(500/100)) + (item.C09*(50/100)) + (item.C10*(50/100)) + (item.C11*(2000/100)) ) );

    // console.log(this.data[idx][1][0].puntuacion);

  };

  display: boolean = false;

  showDialog() {
    this.display = true;
  }

  showModal() {
    this.reportService.modalActive = true;
  }

  verTodos(periodo:any, imei:any, dateHour:any, vehiculo:any, dataParam:any) {
    console.log("===========================================");
    console.log(periodo);
    console.log(imei);
    console.log(dateHour);
    console.log(vehiculo);
    console.log(dataParam);


    this.spinner.show("reportSpinner");

    // var dataParam = this.reportService.getParams();
    dataParam['limit'] = false;
    dataParam['findImei'] = imei;
    // console.log(dataParam);

    // setTimeout(() => {
    //   /** spinner ends after 5 seconds */
    //   this.spinner.hide("reportSpinner");
    // }, 5000);

    this.http.post(environment.apiUrl + dataParam.url, dataParam).subscribe({
      next: data => {
        // console.log(this.selectedConvoy.length);
        // console.log(this.selectedGroup.length);
        // console.log(this.selectedVehicles.length);
        console.log(typeof data);
        console.log(data);
        // console.log("---> "+this.report_data.num_rep);

        this.reportService.modalActive = true;

        this.reportService.objGeneral.data = data;
        this.reportService.objGeneral.periodo = periodo;//this.period;
        this.reportService.objGeneral.vehiculo = vehiculo;//this.period;
        this.reportService.objGeneral.dateHour = dateHour;//this.period;
        this.reportService.objGeneral.numRep = this.report_data.num_rep;


        console.log(this.reportService.objGeneral);

        this.spinner.hide("reportSpinner");

        console.log("MODAL ACTIVATE");


        // var report_data = {
        //   data: data,
        //   numRep: param.numRep,
        //   repSubtitle: repSubtitle,
        //   chkDateHour: chkDateHour,
        //   chkDuracion: chkDuracion,
        //   chkOdomV: chkOdomV,
        //   repTitle: this.reports[param.numRep].value,
        //   period: M1 + ' - ' + M2_t,
        //   isVehicleReport: !cv,
        // }
        // if(new_tab === undefined || new_tab == true){
        //   //Report in the same tab
        //   this.reportService.showReport.emit(report_data);
        //   this.isFormFilled = true;
        // } else {
        //   //Report in new tab
        //   this.spinner.hide("fullScreenSpinner");
        //   this.isFormFilled = true;
        //   console.log('Se abrió una nueva pestaña');
        //   localStorage.setItem("report_data", JSON.stringify(report_data));
        //   var report_tab = window.open('/reports/result');
        //   if(report_tab == null){
        //     this.showBlockedTabDialog = true;
        //     /* this.toastr.error('', 'No se pudo reportar en nueva pestaña', {
        //       timeOut: 5000,
        //     }); */
        //   } else {
        //     this.toastr.success('', 'Reporte en nueva pestaña exitoso', {
        //       timeOut: 5000,
        //     });
        //   }
        // }
      }
    });




    // reportServices.setSpinnerValue(true);
    // dataParam =  reportServices.getParam();
    // dataParam['limit'] = false;
    // dataParam['findImei'] = imei;






    // reportServices.setSpinnerValue(true);
    // dataParam =  reportServices.getParam();
    // dataParam['limit'] = false;
    // dataParam['findImei'] = imei;

    // $q.all([
    //     api.post('informes/informes_general_uni',dataParam),
    //   ]).then(values => {



    //     var modalInstance = $uibModal.open({
    //       backdrop: false,
    //       component: 'reporteModalAll',
    //       resolve: {
    //       'datos'    : function() { return values[0]; },
    //       'periodo'  : function() { return periodo;},
    //       'vehiculo' : function() { return values[0][0][0][1];},
    //       'dateHour' : function() { return dateHour;},
    //       'lang'     : function() { return lang;}

    //     },
    //       size: 'lg'
    //     });
    //     reportServices.setSpinnerValue(false);
    //   });

  }


  exportExcelHtmlParadasMovimientos(vrs: number, format: string) {
    var exportFileEx = getFileExportParadasMovimientos(this, vrs);
    //********************************************* excel version 2 *********************************
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        //********************************************* excel version 2 *********************************
        if ( format == "excel" ) {
            var nom_inf_xls = "ReporteParadasMovimientos.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });

        } else if(format == "html") {
            var nom_inf_html = "ReporteParadasMovimientos.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }
    }
  }


  exportExcelHtmlExcesosVelocidad(vrs: number, format: string) {
    var exportFileEx = getFileExportExcesosVelocidad(this, vrs);
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        //********************************************* excel version 2 *********************************
        if ( format == "excel" ) {
            var nom_inf_xls = "ReporteExcesosVelocidad.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });
        } else if(format == "html") {
            var nom_inf_html = "ReporteExcesosVelocidad.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }

    }
  }


  exportExcelHtmlEntradaSalida(vrs: number, format: string) {
    var exportFileEx = getFileExportEntradaSalida(this, vrs);
    //******************************************************************************
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        if ( format == "excel" ) {
            var nom_inf_xls = "ReporteEntradaSalida.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });

        } else if(format == "html") {
            var nom_inf_html = "ReporteEntradaSalida.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }
    }

  }


  exportExcelHtmlCombustible(vrs: number, format: string) {
    var exportFileEx = getFileExportCombustible(this, vrs);
    //******************************************************************************
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        if ( format == "excel" ) {
            var nom_inf_xls = "ReporteCombustibleGeneral.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });

        } else if(format == "html") {
            var nom_inf_html = "ReporteCombustibleGeneral.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }
    }

  }


  exportExcelExcesosEnZona(vrs: number) {
    //vm.dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[] = [];

    var codigo_cell_ch_width = "Codigo".length;
    var placa_cell_ch_width = "Placa".length;
    var convoy_cell_ch_width = "Convoy".length;
    var vel_limite_comb_cell_ch_width = "vel. limite".length;
    var exceso_vel_max_litros_cell_ch_width = "vel. maxima".length;
    var duracion_cell_ch_width = "Duracion".length;
    // var geocerca_restante_cell_ch_width = "Geocerca ".length;
    var tramo_restante_cell_ch_width = "Tramo ".length;


    var referencia_motor_cell_ch_width = "Referencia".length;
    var ubicacion_cell_ch_width = "Ubicación".length;

    var table_width = 1 + (this.chkDateHour? 4:2) + 9;
    var vehiculo_width = (this.chkDateHour? 8:7);

    var allRows: AllRows[] = [
        {
          cells: [
            { value: "REPORTE DE EXCESOS EN ZONA", ...this.headerCellConfig, colSpan: 6 }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];

    this.sortedData.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        var rows:AllRows[] = [
          {
            cells: [
              { value: "REPORTE DE EXCESOS EN ZONA", ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              { value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderHeight
          },
          {
            cells: [
              { value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderContentHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];



          //=================CABECERA =================
          var cellsCampos :any = [];

          cellsCampos.push({ value: "Item", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Convoy", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Código", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Placa", ...this.colHeaderConfig });

          cellsCampos.push({ value: "Vel. Límite", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Exceso Vel. Maxima", ...this.colHeaderConfig, wrap: true });

          if(this.chkDateHour) {
              cellsCampos.push({ value: "Fecha de Inicio", ...this.colHeaderConfig });
              cellsCampos.push({ value: "Hora de Inicio", ...this.colHeaderConfig });
          } else {
              cellsCampos.push({ value: "Fecha/Hora Inicio", ...this.colHeaderConfig });
          }

          if(this.chkDateHour) {
            cellsCampos.push({ value: "Fecha Final", ...this.colHeaderConfig });
            cellsCampos.push({ value: "Hora Final", ...this.colHeaderConfig });
          } else {
              cellsCampos.push({ value: "Fecha/Hora Final", ...this.colHeaderConfig });
          }

          cellsCampos.push({ value: "Duración", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Tramo", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Referencia", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Ubicación", ...this.colHeaderConfig });

          rows.push({
              cells: cellsCampos,
              height: this.colsHeaderHeightTwoLine
          });

          //====================  CUERPO =============================

          data[1].forEach((item: { fecha: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; vel_gps_speed: any; vel_can: any; tramo: string; PC: any;
            convoy:any; tracto:any; v0:any; velocidad:any; fecha_inicio:any; fecha_final:any; duracion2:any; nombre_zona:any; referencia:any}, index: number) => {


            var ubicacion = item.latitud + "," + item.longitud;

            //=================CABECERA =================
            var cellsCuerpo :any = [];

            vel_limite_comb_cell_ch_width = Math.max(vel_limite_comb_cell_ch_width, (item.v0??'').toString().length);
            codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.tracto??'').toString().length);
            convoy_cell_ch_width = Math.max(convoy_cell_ch_width, (item.convoy??'').toString().length);
            exceso_vel_max_litros_cell_ch_width = Math.max(exceso_vel_max_litros_cell_ch_width, (item.velocidad??'').toString().length);
            duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion2??'').toString().length);
            tramo_restante_cell_ch_width = Math.max(tramo_restante_cell_ch_width, (item.nombre_zona??'').toString().length);
            referencia_motor_cell_ch_width = Math.max(referencia_motor_cell_ch_width, (item.referencia??'').toString().length);
            ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);


            cellsCuerpo.push({ value: index + 1, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.convoy, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.codigo, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.tracto, ...this.bodyRowsConfig });

            cellsCuerpo.push({ value: item.v0, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.velocidad, ...this.bodyRowsConfig });


            if(this.chkDateHour) {
              cellsCuerpo.push({ value: this.isChe(item.fecha_inicio), type: 'date', format: "yyyy/MM/dd", ...this.bodyRowsConfig });
              cellsCuerpo.push({ value: this.isChs(item.fecha_inicio), type: 'date', format: "hh:mm:ss", ...this.bodyRowsConfig });
            } else {
              cellsCuerpo.push({ value: this.isChe(item.fecha_inicio), type: 'date', format: "yyyy/MM/dd hh:mm:ss", ...this.bodyRowsConfig });
            }

            if(this.chkDateHour) {
                //var fh2 = item.fServidor.split(" ");
                cellsCuerpo.push({ value: this.isChe(item.fecha_final), type: 'date', format: "yyyy/MM/dd", ...this.bodyRowsConfig });
                cellsCuerpo.push({ value: this.isChs(item.fecha_final), type: 'date', format: "hh:mm:ss", ...this.bodyRowsConfig });
            } else {
                cellsCuerpo.push({ value: this.isChe(item.fecha_final), type: 'date', format: "yyyy/MM/dd hh:mm:ss", ...this.bodyRowsConfig });
            }

            cellsCuerpo.push({ value: item.duracion2, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.nombre_zona, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.referencia, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: ubicacion, ...this.bodyRowsConfig });

            rows.push({
              cells: cellsCuerpo,
              height: this.bodyRowsHeight
            });


          });

        // //********************************************* excel version 1 *********************************
    if (vrs == 1) {
      column_config = [
        { width: this.w_item },
        { width: this.calculateColWidth(convoy_cell_ch_width) },
        { width: this.calculateColWidth(codigo_cell_ch_width) },
        { width: this.calculateColWidth(placa_cell_ch_width) },
        { width: this.calculateColWidth(vel_limite_comb_cell_ch_width) },
        { width: this.calculateColWidth(exceso_vel_max_litros_cell_ch_width) },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date_ini_fin },
          { width: this.w_hour_ini_fin },
          { width: this.w_date_ini_fin },
          { width: this.w_hour_ini_fin },
        )
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
          { width: this.w_date_and_hour },
        )
      }
      column_config.push(
        { width: this.calculateColWidth(duracion_cell_ch_width) },
        { width: this.calculateColWidth(tramo_restante_cell_ch_width) },
        { width: this.calculateColWidth(referencia_motor_cell_ch_width) },
        { width: this.calculateColWidth(ubicacion_cell_ch_width) },
      );

      exportFileEx.push({
      freezePane: {
        rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2
        },
      columns: column_config,
      title: data[0][1],
      rows: rows
      });

      codigo_cell_ch_width = "Codigo".length;
      placa_cell_ch_width = "Placa".length;
      convoy_cell_ch_width = "Convoy".length;
      vel_limite_comb_cell_ch_width = "vel. limite".length;
      exceso_vel_max_litros_cell_ch_width = "vel maxima".length;
      duracion_cell_ch_width = "Duracion".length;
      tramo_restante_cell_ch_width = "Tramo".length;
      referencia_motor_cell_ch_width = "Referencia".length;
      ubicacion_cell_ch_width = "Ubicación".length;
    }
    // //********************************************* excel version 1 *********************************

    // //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      rows.splice(0, this.headerRowSpan);
      rows.push(...this.spaceBetweenTables);
      allRows = allRows.concat(rows);
    }
    // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: this.w_item },
        { width: this.calculateColWidth(convoy_cell_ch_width) },
        { width: this.calculateColWidth(codigo_cell_ch_width) },
        { width: this.calculateColWidth(placa_cell_ch_width) },
        { width: this.calculateColWidth(vel_limite_comb_cell_ch_width) },
        { width: this.calculateColWidth(exceso_vel_max_litros_cell_ch_width) },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date_ini_fin },
          { width: this.w_hour_ini_fin },
          { width: this.w_date_ini_fin },
          { width: this.w_hour_ini_fin },
        )
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
          { width: this.w_date_and_hour },
        )
      }
      column_config.push(
        { width: this.calculateColWidth(duracion_cell_ch_width) },
        { width: this.calculateColWidth(tramo_restante_cell_ch_width) },
        { width: this.calculateColWidth(referencia_motor_cell_ch_width) },
        { width: this.calculateColWidth(ubicacion_cell_ch_width) },
      );

      exportFileEx.push({
        freezePane: {
          rowSplit: this.headerRowSpan
        },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }
    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: "ReporteExcesosEnZona.xlsx"
      });

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }


  showModalExcesosEnZona(row:any) {
    // console.log(row);
    // console.log(row.detalle);

    this.modalDetalleRepExcesosEnZona = true;
    this.detalleExcesosEnZona = row;

    // console.log(this.detalleExcesosEnZona);

  }

  showModalNoRostro(row:any) {
    this.modalDetalleRepNoRostro = true;
    this.detalleNoRostro = row;
  }

  showModalFatigaExtrema(row:any) {
    console.log("----------- showModalFatigaExtrema -----");

    console.log(row);

    this.modalDetalleRepFatigaExtrema = true;
    this.detalleFatigaExtrema = row;
  }

  exportExcelHtmlGeneral(vrs: number, format: string) {
    var exportFileEx = getFileExportGeneral(this, vrs);
    //********************************************* excel version 2 *********************************
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        //********************************************* excel version 2 *********************************
        if ( format == "excel" ) {
            var nom_inf_xls = "Reporte_General.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });

        } else if(format == "html") {
            var nom_inf_html = "Reporte_General.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }
    }
  }

  exportExcelEventos(vrs: number) {
    // dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config = [];

    var table_width = 8 + (this.chkDateHour? 2: 1) + 1;
    var vehiculo_width = (this.chkDateHour? 5: 4) + 1;

    // var unidad_cell_ch_width = "unidad".length;
    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;

    var evento_cell_ch_width = "evento".length;
    var vel_gps_speed_cell_ch_width = "Velocidad GPS".length;
    var vel_can_cell_ch_width = "Velocidad CAN".length;
    // var geocerca_cell_ch_width = "Geocerca".length;
    var tramo_cell_ch_width = "Tramo".length;

    var ubicacion_cell_ch_width = "ubicacion".length;
    var referencia_cell_ch_width = "referencia".length;

    // var allRows = [
    var allRows: AllRows[] = [
        {
          cells: [
            { value: "REPORTE DE EVENTOS", ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];


    //this.data.forEach((table_data: any) => {

    this.sortedData.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        // var rows = [
        var rows:AllRows[] = [
          {
            cells: [
              { value: "REPORTE DE EVENTOS", ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              { value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderHeight
          },
          {
            cells: [
              { value:  data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderContentHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];


        if(this.chkDateHour) {


          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },
              // { value: "Unidad", ...this.colHeaderConfig },
              { value: "Código", ...this.colHeaderConfig },
              { value: "Placa", ...this.colHeaderConfig },

              { value: "Evento", ...this.colHeaderConfig },
              { value: "Fecha", ...this.colHeaderConfig },
              { value: "Hora", ...this.colHeaderConfig },

              { value: "Velocidad GPS", ...this.colHeaderConfig },
              { value: "Velocidad CAN", ...this.colHeaderConfig },

              { value: "Tramo", ...this.colHeaderConfig },
              { value: "Ubicación", ...this.colHeaderConfig },
              { value: "Referencia", ...this.colHeaderConfig }
            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){

          data[1].forEach((item: { fecha: number;  latitud: number; longitud: number; nombre_objeto: any; codigo: any; placa_con_guion: any; descripcion_evento: any; fecha_tracker: any; velocidad: any; vel_can: any; nombre_zona: any; referencia: any;}, index: number) => {

            var ubicacion = item.latitud + "," + item.longitud;

            // unidad_cell_ch_width = Math.max(unidad_cell_ch_width, (item.nombre_objeto??'').toString().length);
            codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.nombre_objeto??'').toString().length);
            placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.nombre_objeto??'').toString().length);

            evento_cell_ch_width = Math.max(evento_cell_ch_width, (item.descripcion_evento??'').toString().length);
            vel_gps_speed_cell_ch_width = Math.max(vel_gps_speed_cell_ch_width, (item.velocidad??'').toString().length);
            vel_can_cell_ch_width = Math.max(vel_can_cell_ch_width, (item.vel_can??'').toString().length);
            tramo_cell_ch_width = Math.max(tramo_cell_ch_width, (item.nombre_zona??'').toString().length);
            ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);
            referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);

            rows.push({
              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },
                // { value: item.nombre_objeto, ...this.bodyRowsConfig },
                { value: item.codigo, ...this.bodyRowsConfig },
                { value: item.placa_con_guion, ...this.bodyRowsConfig },

                { value: item.descripcion_evento, ...this.bodyRowsConfig },

                { value: this.isChe(item.fecha_tracker), format: "yyyy/mm/dd", ...this.bodyRowsConfig },
                { value: this.isChs(item.fecha_tracker), format: "hh:mm:ss", ...this.bodyRowsConfig },

                { value: item.velocidad, ...this.bodyRowsConfig },
                { value: item.vel_can, ...this.bodyRowsConfig },
                { value: item.nombre_zona, ...this.bodyRowsConfig },

                { value: ubicacion, ...this.bodyRowsConfig },
                { value: item.referencia, ...this.bodyRowsConfig },
              ],
              height: this.bodyRowsHeight
            });
          });




        } else {

          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },
              // { value: "Unidad", ...this.colHeaderConfig },
              { value: "Código", ...this.colHeaderConfig },
              { value: "Placa", ...this.colHeaderConfig },

              { value: "Evento", ...this.colHeaderConfig },
              { value: "Fecha/Hora", ...this.colHeaderConfig },

              { value: "Velocidad GPS", ...this.colHeaderConfig },
              { value: "Velocidad CAN", ...this.colHeaderConfig },

              { value: "Tramo", ...this.colHeaderConfig },
              { value: "Ubicación", ...this.colHeaderConfig },
              { value: "Referencia", ...this.colHeaderConfig }

            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){
            data[1].forEach((item: { fecha: number;  latitud: number; longitud: number; nombre_objeto: any; codigo: any; placa: any; descripcion_evento: any; fecha_tracker: any; velocidad: any; vel_can: any; nombre_zona: any; referencia: any;}, index: number) => {

            var ubicacion = item.latitud + "," + item.longitud;

            // unidad_cell_ch_width = Math.max(unidad_cell_ch_width, (item.nombre_objeto??'').toString().length);
            codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.nombre_objeto??'').toString().length);
            placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.nombre_objeto??'').toString().length);

            evento_cell_ch_width = Math.max(evento_cell_ch_width, (item.descripcion_evento??'').toString().length);
            vel_gps_speed_cell_ch_width = Math.max(vel_gps_speed_cell_ch_width, (item.velocidad??'').toString().length);
            vel_can_cell_ch_width = Math.max(vel_can_cell_ch_width, (item.vel_can??'').toString().length);
            tramo_cell_ch_width = Math.max(tramo_cell_ch_width, (item.nombre_zona??'').toString().length);
            ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);
            referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);

            rows.push({

              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },
                // { value: item.nombre_objeto, ...this.bodyRowsConfig },
                { value: item.codigo, ...this.bodyRowsConfig },
                { value: item.placa, ...this.bodyRowsConfig },

                { value: item.descripcion_evento, ...this.bodyRowsConfig },
                { value: this.isChe(item.fecha_tracker), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig },

                { value: item.velocidad, ...this.bodyRowsConfig },
                { value: item.vel_can, ...this.bodyRowsConfig },

                { value: item.nombre_zona, ...this.bodyRowsConfig },
                { value: ubicacion, ...this.bodyRowsConfig },
                { value: item.referencia, ...this.bodyRowsConfig }
              ],
              height: this.bodyRowsHeight
            });
          });

        }

        // //********************************************* excel version 1 *********************************
        if (vrs == 1) {
          column_config = [
            { width: this.w_item },
            // { width: this.calculateColWidth(unidad_cell_ch_width) },
            { width: this.calculateColWidth(codigo_cell_ch_width) },
            { width: this.calculateColWidth(placa_cell_ch_width) },

            { width: this.calculateColWidth(evento_cell_ch_width) },
          ];
          if(this.chkDateHour){
            column_config.push(
              { width: this.w_date },
              { width: this.w_hour },
            );
          } else {
            column_config.push(
              { width: this.w_date_and_hour },
            );
          }
          column_config.push(
            { width: this.calculateColWidth(vel_gps_speed_cell_ch_width) },
            { width: this.calculateColWidth(vel_can_cell_ch_width) },
            { width: this.calculateColWidth(tramo_cell_ch_width) },
            { width: this.calculateColWidth(ubicacion_cell_ch_width) },
            { width: this.calculateColWidth(referencia_cell_ch_width) },
          );

          exportFileEx.push({
            freezePane: {
                rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2
              },
            columns: column_config,
            title: data[0][1],
            rows: rows
          });

          // unidad_cell_ch_width = "unidad".length;
          codigo_cell_ch_width = "codigo".length;
          placa_cell_ch_width = "placa".length;

          evento_cell_ch_width = "evento".length;
          vel_gps_speed_cell_ch_width = "Velocidad GPS".length;
          vel_can_cell_ch_width = "Velocidad CAN".length;
          tramo_cell_ch_width = "Tramo".length;
          ubicacion_cell_ch_width = "ubicacion".length;
          referencia_cell_ch_width = "referencia".length;
        }
        // //********************************************* excel version 1 *********************************

        // //********************************************* excel version 2 *********************************
        if (vrs == 2) {
           rows.splice(0, this.headerRowSpan);
           rows.push(...this.spaceBetweenTables);
           allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: this.w_item },
        // { width: this.calculateColWidth(unidad_cell_ch_width) },
        { width: this.calculateColWidth(codigo_cell_ch_width) },
        { width: this.calculateColWidth(placa_cell_ch_width) },

        { width: this.calculateColWidth(evento_cell_ch_width) },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date },
          { width: this.w_hour },
        );
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
        );
      }
      column_config.push(
        { width: this.calculateColWidth(vel_gps_speed_cell_ch_width) },
        { width: this.calculateColWidth(vel_can_cell_ch_width) },
        { width: this.calculateColWidth(tramo_cell_ch_width) },
        { width: this.calculateColWidth(ubicacion_cell_ch_width) },
        { width: this.calculateColWidth(referencia_cell_ch_width) },
      );

      exportFileEx.push({
        freezePane: {
            rowSplit: this.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }
    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: "ReporteEventos.xlsx"
      });

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }



  exportExcelHtmlPosicion(vrs: number, format: string) {
    var exportFileEx = getFileExportPosicion(this, vrs);
    //******************************************************************************
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        if ( format == "excel" ) {
            var nom_inf_xls = "ReportePosicion.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });

        } else if(format == "html") {
            var nom_inf_html = "ReportePosicion.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }
    }

  }


  exportExcelEncendidoMotor(vrs: number) {
    // dateHour();
    // var nom_excel: string = 'ReporteEncendidoMotor.xlsx';
    var nom_excel: string = 'ReporteRelenti.xlsx';

    var exportFileEx = [];
    var bol_datos_ex = false;

    var column_config:Columns[];
    var table_width = 5 + (this.chkDateHour? 2: 0);
    var vehiculo_width = (this.chkDateHour? 5: 3);

    var duracion_cell_ch_width = "duracion".length;
    var referencia_cell_ch_width = "referencia".length;

    // var codigo_cell_ch_width = "codigo".length;
    // var placa_cell_ch_width = "placa".length;
    // var tipo_unidad_cell_ch_width = "Tipo de Unidad".length;
    // var tipo_mantenimiento_cell_ch_width = "Tipo Mantenimiento".length;
    // var id_conductor_cell_ch_width = "ID conductor".length;
    // var conductor_cell_ch_width = "conductor".length;

    // var vel_gps_cell_ch_width = "Vel. GPS".length;
    // var vel_can_cell_ch_width = "Vel. CAN".length;

    // var tramo_cell_ch_width = "tramo".length;
    // var pc_cell_ch_width = "Punto Cercano".length;
    // var ubicacion_cell_ch_width = "Ubicacion".length;


    // var allRows = [
    var allRows: AllRows[] = [
        {
          cells: [
            { value: this.repTitle, ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];


    //this.data.forEach((table_data: any) => {

    this.data.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        // var rows = [
        var rows:AllRows[] = [
          {
            cells: [
              { value: this.repTitle, ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              { value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderHeight
          },
          {
            cells: [
              { value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderContentHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];


        if(this.chkDateHour) {

          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },

              { value: "Fecha Inicio", ...this.colHeaderConfig },
              { value: "Hora Inicio", ...this.colHeaderConfig },
              { value: "Fecha Fin", ...this.colHeaderConfig },
              { value: "Hora Fin", ...this.colHeaderConfig },

              { value: "Duración", ...this.colHeaderConfig },
              { value: "Referencia", ...this.colHeaderConfig },

              // { value: "Convoy", ...this.colHeaderConfig },
              // { value: "Codigo", ...this.colHeaderConfig },
              // { value: "Placa", ...this.colHeaderConfig },
              // { value: "Tipo de Unidad", ...this.colHeaderConfig },
              //{ value: "Placa", ...this.colHeaderConfig },
              // { value: "Id Conductor", ...this.colHeaderConfig },
              // { value: "Conductor", ...this.colHeaderConfig },
            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){

          data[1].forEach((item: { fecha: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; vel_gps_speed: any; vel_can: any; descripcion: string; ai1x: number; tramo: string; PC: any; tipo_mantenimiento: any; campoResumen: any; GPS_speed: any; velGPS: any; convoy: any; fecha_ini:any; fecha_fin:any; duracion:any; referencia:any; duracion2:any}, index: number) => {

            //var ubicacion = item.latitud + "," + item.longitud;

            referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);
            duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion2??'').toString().length);
            // id_conductor_cell_ch_width = Math.max(id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
            // conductor_cell_ch_width = Math.max(conductor_cell_ch_width, (item.conductor??'').toString().length);
            // gps_speed_cell_ch_width = Math.max(gps_speed_cell_ch_width, (item.GPS_speed??'').toString().length);
            // ai1_cell_ch_width = Math.max(ai1_cell_ch_width, (item.ai1x??'').toString().length);
            // resumen_cell_ch_width = Math.max(resumen_cell_ch_width, (item.campoResumen??'').toString().length);
            // ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);
            // pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.PC??'').toString().length);

            rows.push({
              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },

                { value: this.isChe(item.fecha_ini), format: "yyyy/mm/dd", ...this.bodyRowsConfig },
                { value: this.isChs(item.fecha_ini), format: "hh:mm:ss", ...this.bodyRowsConfig },
                { value: this.isChe(item.fecha_fin), format: "yyyy/mm/dd", ...this.bodyRowsConfig },
                { value: this.isChs(item.fecha_fin), format: "hh:mm:ss", ...this.bodyRowsConfig },

                { value: item.duracion2, ...this.bodyRowsConfig },
                { value: item.referencia, ...this.bodyRowsConfig },
              ],
              height: this.bodyRowsHeight
            });
          });


        } else {

          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },

              { value: "Fecha Inicio", ...this.colHeaderConfig },
              { value: "Fecha Fin", ...this.colHeaderConfig },

              { value: "Duración", ...this.colHeaderConfig },
              { value: "Referencia", ...this.colHeaderConfig },
            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){
            data[1].forEach((item: { fecha: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; vel_gps_speed: any; vel_can: any; descripcion: string; ai1x: number; tramo: string; PC: any; tipo_mantenimiento: any; campoResumen: any; GPS_speed: any; velGPS: any; convoy: any; fecha_ini:any; fecha_fin:any; referencia:any;duracion:any;  duracion2:any}, index: number) => {

            referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);
            duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion2??'').toString().length);

            rows.push({

              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },

                { value: this.isChe(item.fecha_ini), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig },
                { value: this.isChe(item.fecha_fin), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig },

                { value: item.duracion2, ...this.bodyRowsConfig },
                { value: item.referencia, ...this.bodyRowsConfig },

              ],
              height: this.bodyRowsHeight

            });
          });

        }

        /*****************************RESUMEN */
        rows.push(
            ...this.spaceBetweenTables,
            {
              cells: [
                { value: "Duración Total : ", ...this.overviewLeftConfig },
                { value: data[2][1], ...this.overviewRightConfig }
              ],
              height: this.overviewRowsHeight
            }
        );


        // //********************************************* excel version 1 *********************************
        if (vrs == 1) {
          column_config = [
            { width: this.w_item },
          ];

          if(this.chkDateHour){
            column_config.push(
              { width: this.w_date },
              { width: this.w_hour },
              { width: this.w_date },
              { width: this.w_hour },
            );
          } else {
            column_config.push(
              { width: this.w_date_and_hour },
              { width: this.w_date_and_hour },

            );
          }

          column_config.push(
            { width: this.calculateColWidth(duracion_cell_ch_width) },
            { width: this.calculateColWidth(referencia_cell_ch_width) },
          );

          exportFileEx.push({
            freezePane: {
                rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2
              },
            columns: column_config,
            title: data[0][1],
            rows: rows
          });

          duracion_cell_ch_width = "duracion".length;
          referencia_cell_ch_width = "referencia".length;

        }
        // //********************************************* excel version 1 *********************************

        // //********************************************* excel version 2 *********************************
        if (vrs == 2) {
           rows.splice(0, this.headerRowSpan);
           rows.push(...this.spaceBetweenTables);
           allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: this.w_item },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date },
          { width: this.w_hour },
          { width: this.w_date },
          { width: this.w_hour },
        );
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
          { width: this.w_date_and_hour },

        );
      }
      column_config.push(
        { width: this.calculateColWidth(duracion_cell_ch_width) },
        { width: this.calculateColWidth(referencia_cell_ch_width) }
      );

      exportFileEx.push({
        freezePane: {
            rowSplit: this.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }

    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: nom_excel
      });

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }


  exportExcelLlaveIbutton(vrs: number) {
    // dateHour();
    var nom_excel: string = 'ReporteLlaveIbutton.xlsx';

    var exportFileEx = [];
    var bol_datos_ex = false;

    var column_config:Columns[];
    var table_width = 8 + (this.chkDateHour? 2: 1);
    var vehiculo_width = (this.chkDateHour? 5: 4);


    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;
    var tipo_unidad_cell_ch_width = "Tipo de Unidad".length;
    // var tipo_mantenimiento_cell_ch_width = "Tipo Mantenimiento".length;

    var id_conductor_cell_ch_width = "ID conductor".length;
    var conductor_cell_ch_width = "conductor".length;

    // var vel_gps_cell_ch_width = "Vel. GPS".length;
    // var vel_can_cell_ch_width = "Vel. CAN".length;

    var tramo_cell_ch_width = "tramo".length;
    // var pc_cell_ch_width = "Punto Cercano".length;
    var ubicacion_cell_ch_width = "Ubicacion".length;


    // var allRows = [
    var allRows: AllRows[] = [
        {
          cells: [
            { value: this.repTitle, ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];


    //this.data.forEach((table_data: any) => {

    this.data.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        // var rows = [
        var rows:AllRows[] = [
          {
            cells: [
              { value: this.repTitle, ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              { value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderHeight
          },
          {
            cells: [
              { value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderContentHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];


        if(this.chkDateHour) {

          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },

              { value: "Fecha", ...this.colHeaderConfig },
              { value: "Hora", ...this.colHeaderConfig },

              // { value: "Convoy", ...this.colHeaderConfig },
              { value: "Codigo", ...this.colHeaderConfig },
              { value: "Placa", ...this.colHeaderConfig },
              { value: "Tipo de Unidad", ...this.colHeaderConfig },
              //{ value: "Placa", ...this.colHeaderConfig },
              { value: "Id Conductor", ...this.colHeaderConfig },
              { value: "Conductor", ...this.colHeaderConfig },
              { value: "Tramo", ...this.colHeaderConfig },
              { value: "Ubicación", ...this.colHeaderConfig },
            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){

          data[1].forEach((item: { fecha: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; vel_gps_speed: any; vel_can: any; descripcion: string; ai1x: number; tramo: string; PC: any; tipo_mantenimiento: any; campoResumen: any; GPS_speed: any; velGPS: any; convoy: any; notificacion:any;}, index: number) => {

            var ubicacion = item.latitud + "," + item.longitud;

            codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
            tipo_unidad_cell_ch_width = Math.max(tipo_unidad_cell_ch_width, (item.tipo_unidad??'').toString().length);
            id_conductor_cell_ch_width = Math.max(id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
            conductor_cell_ch_width = Math.max(conductor_cell_ch_width, (item.notificacion??'').toString().length);
            tramo_cell_ch_width = Math.max(tramo_cell_ch_width, (item.tramo??'').toString().length);
            ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);


            rows.push({
              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },

                { value: this.isChe(item.fecha), format: "yyyy/mm/dd", ...this.bodyRowsConfig },
                { value: this.isChs(item.fecha), format: "hh:mm:ss", ...this.bodyRowsConfig },

                { value: item.codigo, ...this.bodyRowsConfig },
                { value: item.placa, ...this.bodyRowsConfig },
                { value: item.tipo_unidad, ...this.bodyRowsConfig },

                { value: item.idConductor, ...this.bodyRowsConfig },
                { value: item.notificacion, ...this.bodyRowsConfig },
                { value: item.tramo, ...this.bodyRowsConfig },
                { value: ubicacion, ...this.bodyRowsConfig },

              ],
              height: this.bodyRowsHeight
            });
          });


        } else {

          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },
              { value: "Fecha", ...this.colHeaderConfig },

              // { value: "Convoy", ...this.colHeaderConfig },
              { value: "Codigo", ...this.colHeaderConfig },
              { value: "Placa", ...this.colHeaderConfig },
              { value: "Tipo de Unidad", ...this.colHeaderConfig },
              //{ value: "Placa", ...this.colHeaderConfig },
              { value: "Id Conductor", ...this.colHeaderConfig },
              { value: "Conductor", ...this.colHeaderConfig },
              { value: "Tramo", ...this.colHeaderConfig },
              { value: "Ubicación", ...this.colHeaderConfig },

            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){
            data[1].forEach((item: { fecha: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; vel_gps_speed: any; vel_can: any; descripcion: string; ai1x: number; tramo: string; PC: any; tipo_mantenimiento: any; campoResumen: any; GPS_speed: any; velGPS: any; convoy: any; notificacion: any;}, index: number) => {

            var ubicacion = item.latitud + "," + item.longitud;

            codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
            tipo_unidad_cell_ch_width = Math.max(tipo_unidad_cell_ch_width, (item.tipo_unidad??'').toString().length);
            id_conductor_cell_ch_width = Math.max(id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
            conductor_cell_ch_width = Math.max(conductor_cell_ch_width, (item.notificacion??'').toString().length);
            tramo_cell_ch_width = Math.max(tramo_cell_ch_width, (item.tramo??'').toString().length);
            ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);


            rows.push({

              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },

                { value: this.isChe(item.fecha), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig },
                { value: item.codigo, ...this.bodyRowsConfig },
                { value: item.placa, ...this.bodyRowsConfig },
                { value: item.tipo_unidad, ...this.bodyRowsConfig },

                { value: item.idConductor, ...this.bodyRowsConfig },
                { value: item.notificacion, ...this.bodyRowsConfig },
                { value: item.tramo, ...this.bodyRowsConfig },
                { value: ubicacion, ...this.bodyRowsConfig },

              ],
              height: this.bodyRowsHeight

            });
          });

        }


        // //********************************************* excel version 1 *********************************
        if (vrs == 1) {
          column_config = [
            { width: this.w_item },
          ];

          if(this.chkDateHour){
            column_config.push(
              { width: this.w_date },
              { width: this.w_hour },
            );
          } else {
            column_config.push(
              { width: this.w_date_and_hour },
            );
          }

          column_config.push(
            { width: this.calculateColWidth(codigo_cell_ch_width) },
            { width: this.calculateColWidth(placa_cell_ch_width) },
            { width: this.calculateColWidth(tipo_unidad_cell_ch_width) },
            { width: this.calculateColWidth(id_conductor_cell_ch_width) },
            { width: this.calculateColWidth(conductor_cell_ch_width) },
            { width: this.calculateColWidth(tramo_cell_ch_width) },
            { width: this.calculateColWidth(ubicacion_cell_ch_width) },

          );

          exportFileEx.push({
            freezePane: {
                rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2
              },
            columns: column_config,
            title: data[0][1],
            rows: rows
          });

          codigo_cell_ch_width = "codigo".length;
          placa_cell_ch_width = "placa".length;
          tipo_unidad_cell_ch_width = "Tipo de Unidad".length;
          id_conductor_cell_ch_width = "ID conductor".length;
          conductor_cell_ch_width = "conductor".length;
          tramo_cell_ch_width = "tramo".length;
          ubicacion_cell_ch_width = "Ubicacion".length;

        }
        // //********************************************* excel version 1 *********************************

        // //********************************************* excel version 2 *********************************
        if (vrs == 2) {
           rows.splice(0, this.headerRowSpan);
           rows.push(...this.spaceBetweenTables);
           allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: this.w_item },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date },
          { width: this.w_hour },
        );
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
        );
      }
      column_config.push(
        { width: this.calculateColWidth(codigo_cell_ch_width) },
        { width: this.calculateColWidth(placa_cell_ch_width) },
        { width: this.calculateColWidth(tipo_unidad_cell_ch_width) },
        { width: this.calculateColWidth(id_conductor_cell_ch_width) },
        { width: this.calculateColWidth(conductor_cell_ch_width) },
        { width: this.calculateColWidth(tramo_cell_ch_width) },
        { width: this.calculateColWidth(ubicacion_cell_ch_width) },

      );

      exportFileEx.push({
        freezePane: {
            rowSplit: this.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }

    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: nom_excel
      });

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }


  exportExcelAlcotester(vrs: number) {
    // dateHour();
    var nom_excel: string = 'ReporteAlcotester.xlsx';

    var exportFileEx = [];
    var bol_datos_ex = false;

    var column_config:Columns[];
    var table_width = 8 + (this.chkDateHour? 2: 1);
    var vehiculo_width = (this.chkDateHour? 5: 4);


    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;
    var tipo_unidad_cell_ch_width = "Tipo de Unidad".length;
    var resultados_cell_ch_width = "Resultados".length;

    // var tipo_mantenimiento_cell_ch_width = "Tipo Mantenimiento".length;
    // var id_conductor_cell_ch_width = "ID conductor".length;
    // var conductor_cell_ch_width = "conductor".length;
    // var vel_gps_cell_ch_width = "Vel. GPS".length;
    // var vel_can_cell_ch_width = "Vel. CAN".length;

    var tramo_cell_ch_width = "Tramo".length;
    var referencia_cell_ch_width = "Referencia".length;
    var ubicacion_cell_ch_width = "Ubicacion".length;


    // var allRows = [
    var allRows: AllRows[] = [
        {
          cells: [
            { value: this.repTitle, ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];


    //this.data.forEach((table_data: any) => {

    this.data.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        // var rows = [
        var rows:AllRows[] = [
          {
            cells: [
              { value: this.repTitle, ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              //{ value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width },
            ],
            height: this.subHeaderHeight
          },
          {
            cells: [
              //{ value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width },
            ],
            height: this.subHeaderContentHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];


        if(this.chkDateHour) {

          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },

              { value: "Fecha", ...this.colHeaderConfig },
              { value: "Hora", ...this.colHeaderConfig },

              // { value: "Convoy", ...this.colHeaderConfig },
              { value: "Codigo", ...this.colHeaderConfig },
              { value: "Placa", ...this.colHeaderConfig },

              { value: "Tipo de Unidad", ...this.colHeaderConfig },
              { value: "Resultados", ...this.colHeaderConfig },

              { value: "Tramo", ...this.colHeaderConfig },
              { value: "Referencia", ...this.colHeaderConfig },
              { value: "Ubicación", ...this.colHeaderConfig },

            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){

          data[1].forEach((item: { fecha: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; vel_gps_speed: any; vel_can: any; descripcion: string; ai1x: number; tramo: string; PC: any; tipo_mantenimiento: any; campoResumen: any; GPS_speed: any; velGPS: any; convoy: any; notificacion:any; resultados:any; referencia:any}, index: number) => {

            var ubicacion = item.latitud + "," + item.longitud;

            codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
            tipo_unidad_cell_ch_width = Math.max(tipo_unidad_cell_ch_width, (item.tipo_unidad??'').toString().length);
            resultados_cell_ch_width = Math.max(resultados_cell_ch_width, (item.resultados??'').toString().length);

            tramo_cell_ch_width = Math.max(tramo_cell_ch_width, (item.tramo??'').toString().length);
            referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);
            ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);


            rows.push({
              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },

                { value: this.isChe(item.fecha), format: "yyyy/mm/dd", ...this.bodyRowsConfig },
                { value: this.isChs(item.fecha), format: "hh:mm:ss", ...this.bodyRowsConfig },

                { value: item.codigo, ...this.bodyRowsConfig },
                { value: item.placa, ...this.bodyRowsConfig },
                { value: item.tipo_unidad, ...this.bodyRowsConfig },
                { value: item.resultados, ...this.bodyRowsConfig },

                { value: item.tramo, ...this.bodyRowsConfig },
                { value: item.referencia, ...this.bodyRowsConfig },
                { value: ubicacion, ...this.bodyRowsConfig },

              ],
              height: this.bodyRowsHeight
            });
          });


        } else {

          rows.push({
            cells: [

              { value: "Item", ...this.colHeaderConfig },
              { value: "Fecha", ...this.colHeaderConfig },
              { value: "Hora", ...this.colHeaderConfig },

              { value: "Codigo", ...this.colHeaderConfig },
              { value: "Placa", ...this.colHeaderConfig },
              { value: "Tipo de Unidad", ...this.colHeaderConfig },
              { value: "Resultados", ...this.colHeaderConfig },

              { value: "Tramo", ...this.colHeaderConfig },
              { value: "Referencia", ...this.colHeaderConfig },
              { value: "Ubicación", ...this.colHeaderConfig },

            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){
            data[1].forEach((item: { fecha: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; vel_gps_speed: any; vel_can: any; descripcion: string; ai1x: number; tramo: string; PC: any; tipo_mantenimiento: any; campoResumen: any; GPS_speed: any; velGPS: any; convoy: any; notificacion: any; resultados:any; referencia:any}, index: number) => {

            var ubicacion = item.latitud + "," + item.longitud;

            codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
            tipo_unidad_cell_ch_width = Math.max(tipo_unidad_cell_ch_width, (item.tipo_unidad??'').toString().length);
            resultados_cell_ch_width = Math.max(resultados_cell_ch_width, (item.resultados??'').toString().length);

            tramo_cell_ch_width = Math.max(tramo_cell_ch_width, (item.tramo??'').toString().length);
            referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);
            ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);


            rows.push({

              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },

                { value: this.isChe(item.fecha), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig },
                { value: item.codigo, ...this.bodyRowsConfig },
                { value: item.placa, ...this.bodyRowsConfig },
                { value: item.tipo_unidad, ...this.bodyRowsConfig },
                { value: item.resultados, ...this.bodyRowsConfig },

                { value: item.tramo, ...this.bodyRowsConfig },
                { value: item.referencia, ...this.bodyRowsConfig },
                { value: ubicacion, ...this.bodyRowsConfig },

              ],
              height: this.bodyRowsHeight

            });
          });

        }


        // //********************************************* excel version 1 *********************************
        if (vrs == 1) {
          column_config = [
            { width: this.w_item },
          ];

          if(this.chkDateHour){
            column_config.push(
              { width: this.w_date },
              { width: this.w_hour },
            );
          } else {
            column_config.push(
              { width: this.w_date_and_hour },
            );
          }

          column_config.push(
            { width: this.calculateColWidth(codigo_cell_ch_width) },
            { width: this.calculateColWidth(placa_cell_ch_width) },
            { width: this.calculateColWidth(tipo_unidad_cell_ch_width) },
            { width: this.calculateColWidth(resultados_cell_ch_width) },

            { width: this.calculateColWidth(tramo_cell_ch_width) },
            { width: this.calculateColWidth(referencia_cell_ch_width) },
            { width: this.calculateColWidth(ubicacion_cell_ch_width) },

          );

          exportFileEx.push({
            freezePane: {
                rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2
              },
            columns: column_config,
            title: data[0][1],
            rows: rows
          });

          codigo_cell_ch_width = "codigo".length;
          placa_cell_ch_width = "placa".length;
          tipo_unidad_cell_ch_width = "Tipo de Unidad".length;
          resultados_cell_ch_width = "Resultados".length;

          tramo_cell_ch_width = "Tramo".length;
          referencia_cell_ch_width = "Referencia".length;
          ubicacion_cell_ch_width = "Ubicacion".length;

        }
        // //********************************************* excel version 1 *********************************

        // //********************************************* excel version 2 *********************************
        if (vrs == 2) {
           rows.splice(0, this.headerRowSpan);
           rows.push(...this.spaceBetweenTables);
           allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: this.w_item },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date },
          { width: this.w_hour },
        );
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
        );
      }
      column_config.push(
        { width: this.calculateColWidth(codigo_cell_ch_width) },
        { width: this.calculateColWidth(placa_cell_ch_width) },
        { width: this.calculateColWidth(tipo_unidad_cell_ch_width) },
        { width: this.calculateColWidth(resultados_cell_ch_width) },

        { width: this.calculateColWidth(tramo_cell_ch_width) },
        { width: this.calculateColWidth(referencia_cell_ch_width) },
        { width: this.calculateColWidth(ubicacion_cell_ch_width) },

      );

      exportFileEx.push({
        freezePane: {
            rowSplit: this.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }

    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: nom_excel
      });

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }



  exportExcelFatigaExtremaFormatoBetsy_1(vrs: number) {
    var nom_excel: string = 'ReportePosibleFatiga2.xlsx';
    // console.log(this.repTitle);
    // if (this.report_data.num_rep == 'R012') {
    //   if (this.chkFatigaSomnolencia && this.chkFatigaDistraccion) {
    //     nom_excel = "ReporteDistraccionPosibleFatiga.xlsx";
    //   } else {
    //     if (this.chkFatigaSomnolencia) {
    //       nom_excel = "ReportePosibleFatiga.xlsx";
    //     }
    //     if (this.chkFatigaDistraccion) {
    //       nom_excel = "ReporteDistraccion.xlsx";
    //     }
    //   }
    // } else if (this.report_data.num_rep == 'R022') {
    //    if (this.chkFatigaSomnolencia && this.chkFatigaDistraccion) {
    //     nom_excel = "ReporteSomnolenciaDistraccionProloint.xlsx";
    //   } else {
    //     if (this.chkFatigaSomnolencia) {
    //       nom_excel = "ReportePosibleFatigaProloin.xlsx";
    //     }
    //     if (this.chkFatigaDistraccion) {
    //       nom_excel = "ReporteDistraccionProloin.xlsx";
    //     }
    //   }
    // }


    var exportFileEx = [];
    var bol_datos_ex = false;

    var column_config:Columns[];
    var table_width = 15 + (this.chkDateHour? 2: 1) + ((this.chkFatigaSomnolencia && this.chkFatigaDistraccion)? 0: -1);
    var vehiculo_width = (this.chkDateHour? 5: 4) + ((this.chkFatigaSomnolencia && this.chkFatigaDistraccion)? 0: -1);

    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;
    var tipo_unidad_cell_ch_width = "Tipo unidad".length;
    var id_conductor_cell_ch_width = "ID conductor".length;
    var conductor_cell_ch_width = "conductor".length;

    var fecha_evaluacion_cell_ch_width = "Fecha de Evaluacion".length;
    var criterio_evaluacion_cell_ch_width = "Criterio de Evaluacion".length;
    var observacion_evaluacion_cell_ch_width = "Observacion".length;

    var vel_gps_cell_ch_width = "Vel. GPS".length;
    var vel_can_cell_ch_width = "Vel. CAN".length;
    // var descripcion_cell_ch_width = "descripcion".length;
    // var reconocimiento_facial_cell_ch_width = "reconocimiento facial (alix)".length;
    var tramo_cell_ch_width = "tramo".length;
    var pc_cell_ch_width = "Punto Cercano".length;
    var ubicacion_cell_ch_width = "Ubicacion".length;

    var operador_monitoreo_cell_ch_width = "Operador de Monitoreo".length;


    // var allRows = [
    var allRows: AllRows[] = [
        {
          cells: [
            { value: this.repTitle, ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];


      // //this.data.forEach((table_data: any) => {
			// var TEM = [[[],this.tablaFormatoBetsy_1]]

			// //vm.datos.forEach( (data,idx) => {
      //   console.log("DATA =======");
			// 	console.log(data);
			// TEM.forEach( (data,idx) => {
			// 	console.log("DATA =======");
			// 	console.log(data);
			// 	if(data[1].length > 0){
			// 		bol_datos_ex = true;






    var TEM = [[[], this.tablaFormatoBetsy_1]]

    //this.sortedData.forEach((data: any,idx:any) => {
    TEM.forEach((data: any,idx:any) => {

      console.log("DATA =======");
      console.log(data);

      if(data[1].length > 0){
        bol_datos_ex = true;

        // var rows = [
        var rows:AllRows[] = [
          {
            cells: [
              { value: this.repTitle, ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              //{ value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width },
            ],
            height: this.subHeaderHeight
          },
          {
            cells: [
              //{ value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width },
            ],
            height: this.subHeaderContentHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];


        if(this.chkDateHour) {


          // rows.push({
          //   cells: [
          //     { value: "Item", ...this.colHeaderConfig },
          //     { value: "Fecha", ...this.colHeaderConfig },
          //     { value: "Hora", ...this.colHeaderConfig },
          //     { value: "Código", ...this.colHeaderConfig },
          //     { value: "Placa", ...this.colHeaderConfig },
          //     { value: "Tipo de Unidad", ...this.colHeaderConfig },

          //     { value: "Id Conductor", ...this.colHeaderConfig },
          //     { value: "Conductor", ...this.colHeaderConfig },
          //     { value: "Vel.GPS", ...this.colHeaderConfig },
          //     { value: "Vel.CAN", ...this.colHeaderConfig },
          //     { value: "Descripción", ...this.colHeaderConfig },

          //     { value: "Reconocimiento Facial (ai1x)", ...this.colHeaderConfig },
          //     { value: "Tramo", ...this.colHeaderConfig },
          //     { value: "Punto Cercano", ...this.colHeaderConfig },
          //     { value: "Ubicación", ...this.colHeaderConfig },
          //   ],
          //   height: this.colsHeaderHeight
          // });


          var cellsCabecera = [];

          cellsCabecera.push({ value: "Item", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Fecha", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Hora", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Código", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Placa", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Tipo de Unidad", ...this.colHeaderConfig });

          cellsCabecera.push({ value: "Id Conductor", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Conductor", ...this.colHeaderConfig });

          cellsCabecera.push({ value: "Fecha de Evaluación", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Criterio de Evaluación", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Observación", ...this.colHeaderConfig });

          cellsCabecera.push({ value: "Vel.GPS", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Vel.CAN", ...this.colHeaderConfig });
          // if (this.chkFatigaSomnolencia && this.chkFatigaDistraccion){ cellsCabecera.push({ value: "Descripción", ...this.colHeaderConfig }); };

          // cellsCabecera.push({ value: "Reconocimiento Facial (ai1x)", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Tramo", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Punto Cercano", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Ubicación", ...this.colHeaderConfig });

          cellsCabecera.push({ value: "Operador de Monitoreo", ...this.colHeaderConfig });


          rows.push({
            cells: cellsCabecera,
            height: this.colsHeaderHeight
          });


          // data[1].forEach(function(item:any, index:any){


          data[1].forEach((item: { fecha: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; velGPS: any; vel_can: any; descripcion: string; ai1x: number; tramo: string; PC: any; fecha_evaluacion : any; criterio_evaluacion:any; observacion_evaluacion:any; operador_monitoreo: any }, index: number) => {

            var ubicacion = item.latitud + "," + item.longitud;

            // if (item.ai1x > 1000) {
            //     var rec_facial = "Rostro detectado (" + item.ai1x + ")";
            // } else {
            //     var rec_facial = "Rostro ausente (" + item.ai1x + ")";
            // }

            codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
            tipo_unidad_cell_ch_width = Math.max(tipo_unidad_cell_ch_width, (item.tipo_unidad??'').toString().length);
            id_conductor_cell_ch_width = Math.max(id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
            conductor_cell_ch_width = Math.max(conductor_cell_ch_width, (item.conductor??'').toString().length);

            fecha_evaluacion_cell_ch_width = Math.max(fecha_evaluacion_cell_ch_width, (item.fecha_evaluacion??'').toString().length);
            criterio_evaluacion_cell_ch_width = Math.max(criterio_evaluacion_cell_ch_width, (item.criterio_evaluacion??'').toString().length);
            observacion_evaluacion_cell_ch_width = Math.max(observacion_evaluacion_cell_ch_width, (item.observacion_evaluacion??'').toString().length);

            vel_gps_cell_ch_width = Math.max(vel_gps_cell_ch_width, (item.velGPS??'').toString().length);
            vel_can_cell_ch_width = Math.max(vel_can_cell_ch_width, (item.vel_can??'').toString().length);
            // descripcion_cell_ch_width = Math.max(descripcion_cell_ch_width, (item.descripcion??'').toString().length);
            // reconocimiento_facial_cell_ch_width = Math.max(reconocimiento_facial_cell_ch_width, (rec_facial??'').toString().length);
            tramo_cell_ch_width = Math.max(tramo_cell_ch_width, (item.tramo??'').toString().length);
            pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.PC??'').toString().length);
            ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);

            operador_monitoreo_cell_ch_width = Math.max(operador_monitoreo_cell_ch_width, (item.operador_monitoreo??'').toString().length);


            var cellsCuerpo = [];

            cellsCuerpo.push({ value: (index + 1), ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: this.isChe(item.fecha), format: "yyyy/mm/dd", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: this.isChs(item.fecha), format: "hh:mm:ss", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.codigo, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.placa, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.tipo_unidad, ...this.bodyRowsConfig });

            cellsCuerpo.push({ value: item.idConductor, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.conductor, ...this.bodyRowsConfig });

            cellsCuerpo.push({ value: item.fecha_evaluacion, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.criterio_evaluacion, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.observacion_evaluacion, ...this.bodyRowsConfig });

            cellsCuerpo.push({ value: item.velGPS+" Km/h", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.vel_can+" Km/h", ...this.bodyRowsConfig });
            // if (this.chkFatigaSomnolencia && this.chkFatigaDistraccion){ cellsCuerpo.push({ value: item.descripcion, ...this.bodyRowsConfig }); };

            // cellsCuerpo.push({ value: rec_facial, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.tramo, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.PC, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: ubicacion, ...this.bodyRowsConfig });

            cellsCuerpo.push({ value: item.operador_monitoreo, ...this.bodyRowsConfig });

            rows.push({
              cells: cellsCuerpo,
              height: this.bodyRowsHeight
            });


          });


        } else {

          var cellsCabecera = [];

          cellsCabecera.push({ value: "Item", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Fecha", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Código", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Placa", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Tipo de Unidad", ...this.colHeaderConfig });

          cellsCabecera.push( { value: "Id Conductor", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Conductor", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Vel.GPS", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Vel.CAN", ...this.colHeaderConfig });
          // if (this.chkFatigaSomnolencia && this.chkFatigaDistraccion){ cellsCabecera.push({ value: "Descripción", ...this.colHeaderConfig }); };

          // cellsCabecera.push({ value: "Reconocimiento Facial (ai1x)", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Tramo", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Punto Cercano", ...this.colHeaderConfig });
          cellsCabecera.push({ value: "Ubicación", ...this.colHeaderConfig });

          rows.push({
            cells: cellsCabecera,
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){
            data[1].forEach((item: { fecha: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; velGPS: any; vel_can: any; descripcion: string; ai1x: number; tramo: string; PC: any; fecha_evaluacion:any; criterio_evaluacion:any; observacion_evaluacion:any; operador_monitoreo:any}, index: number) => {

            var ubicacion = item.latitud + "," + item.longitud;
            // if (item.ai1x > 1000) {
            //     var rec_facial = "Rostro detectado (" + item.ai1x + ")";
            // } else {
            //     var rec_facial = "Rostro ausente (" + item.ai1x + ")";
            // }

            codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
            tipo_unidad_cell_ch_width = Math.max(tipo_unidad_cell_ch_width, (item.tipo_unidad??'').toString().length);
            id_conductor_cell_ch_width = Math.max(id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
            conductor_cell_ch_width = Math.max(conductor_cell_ch_width, (item.conductor??'').toString().length);

            fecha_evaluacion_cell_ch_width = Math.max(fecha_evaluacion_cell_ch_width, (item.fecha_evaluacion??'').toString().length);
            criterio_evaluacion_cell_ch_width = Math.max(criterio_evaluacion_cell_ch_width, (item.criterio_evaluacion??'').toString().length);
            observacion_evaluacion_cell_ch_width = Math.max(observacion_evaluacion_cell_ch_width, (item.observacion_evaluacion??'').toString().length);


            vel_gps_cell_ch_width = Math.max(vel_gps_cell_ch_width, (item.velGPS??'').toString().length);
            vel_can_cell_ch_width = Math.max(vel_can_cell_ch_width, (item.vel_can??'').toString().length);
            // descripcion_cell_ch_width = Math.max(descripcion_cell_ch_width, (item.descripcion??'').toString().length);
            // reconocimiento_facial_cell_ch_width = Math.max(reconocimiento_facial_cell_ch_width, (rec_facial??'').toString().length);
            tramo_cell_ch_width = Math.max(tramo_cell_ch_width, (item.tramo??'').toString().length);
            pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.PC??'').toString().length);
            ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);

            operador_monitoreo_cell_ch_width = Math.max(operador_monitoreo_cell_ch_width, (item.operador_monitoreo??'').toString().length);


            var cellsCuerpo = [];

            cellsCuerpo.push({ value: (index + 1), ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: this.isChe(item.fecha), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.codigo, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.placa, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.tipo_unidad, ...this.bodyRowsConfig });

            cellsCuerpo.push({ value: item.idConductor, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.conductor, ...this.bodyRowsConfig });

            cellsCuerpo.push({ value: item.fecha_evaluacion, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.criterio_evaluacion, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.observacion_evaluacion, ...this.bodyRowsConfig });

            cellsCuerpo.push({ value: item.velGPS+" Km/h", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.vel_can+" Km/h", ...this.bodyRowsConfig });
            // if (this.chkFatigaSomnolencia && this.chkFatigaDistraccion){ cellsCuerpo.push({ value: item.descripcion, ...this.bodyRowsConfig }); };

            // cellsCuerpo.push({ value: rec_facial, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.tramo, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: item.PC, ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: ubicacion, ...this.bodyRowsConfig });

            cellsCuerpo.push({ value: item.operador_monitoreo, ...this.bodyRowsConfig });

            rows.push({
              cells: cellsCuerpo,
              height: this.bodyRowsHeight
            });

          });

        }


        // //********************************************* excel version 1 *********************************
        if (vrs == 1) {
          column_config = [
            { width: this.w_item },
          ];
          if(this.chkDateHour){
            column_config.push(
              { width: this.w_date },
              { width: this.w_hour },
            );
          } else {
            column_config.push(
              { width: this.w_date_and_hour },
            );
          }
          column_config.push(
            { width: this.calculateColWidth(codigo_cell_ch_width) },
            { width: this.calculateColWidth(placa_cell_ch_width) },
            { width: this.calculateColWidth(tipo_unidad_cell_ch_width) },
            { width: this.calculateColWidth(id_conductor_cell_ch_width) },
            { width: this.calculateColWidth(conductor_cell_ch_width) },

            { width: this.calculateColWidth(fecha_evaluacion_cell_ch_width) },
            { width: this.calculateColWidth(criterio_evaluacion_cell_ch_width) },
            { width: this.calculateColWidth(observacion_evaluacion_cell_ch_width) },

            { width: this.calculateColWidth(vel_gps_cell_ch_width) },
            { width: this.calculateColWidth(vel_can_cell_ch_width) },
          );

          // if (this.chkFatigaSomnolencia && this.chkFatigaDistraccion){
          //   column_config.push(
          //     { width: this.calculateColWidth(descripcion_cell_ch_width) }
          //   );
          // };

          column_config.push(
            // { width: this.calculateColWidth(reconocimiento_facial_cell_ch_width) },
            { width: this.calculateColWidth(tramo_cell_ch_width) },
            { width: this.calculateColWidth(pc_cell_ch_width) },
            { width: this.calculateColWidth(ubicacion_cell_ch_width) },
            { width: this.calculateColWidth(operador_monitoreo_cell_ch_width) },

          );



          exportFileEx.push({
            freezePane: {
                rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2
              },
            columns: column_config,
            title: data[0][1],
            rows: rows
          });

          codigo_cell_ch_width = "codigo".length;
          placa_cell_ch_width = "placa".length;
          tipo_unidad_cell_ch_width = "Tipo unidad".length;
          id_conductor_cell_ch_width = "ID conductor".length;
          conductor_cell_ch_width = "conductor".length;

          fecha_evaluacion_cell_ch_width = "Fecha de Evaluacion".length;
          criterio_evaluacion_cell_ch_width = "Criterio de Evaluacion".length;
          observacion_evaluacion_cell_ch_width = "Observacion".length;

          vel_gps_cell_ch_width = "Vel. GPS".length;
          vel_can_cell_ch_width = "Vel. CAN".length;
          // descripcion_cell_ch_width = "descripcion".length;
          // reconocimiento_facial_cell_ch_width = "reconocimiento facial (alix)".length;
          tramo_cell_ch_width = "tramo".length;
          pc_cell_ch_width = "Punto Cercano".length;
          ubicacion_cell_ch_width = "Ubicacion".length;

          operador_monitoreo_cell_ch_width = "Operador de Monitoreo".length;

        }
        // //********************************************* excel version 1 *********************************

        // //********************************************* excel version 2 *********************************
        if (vrs == 2) {
           rows.splice(0, this.headerRowSpan);
           rows.push(...this.spaceBetweenTables);
           allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: this.w_item },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date },
          { width: this.w_hour },
        );
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
        );
      }
      column_config.push(
        { width: this.calculateColWidth(codigo_cell_ch_width) },
        { width: this.calculateColWidth(placa_cell_ch_width) },
        { width: this.calculateColWidth(tipo_unidad_cell_ch_width) },
        { width: this.calculateColWidth(id_conductor_cell_ch_width) },
        { width: this.calculateColWidth(conductor_cell_ch_width) },

        { width: this.calculateColWidth(fecha_evaluacion_cell_ch_width) },
        { width: this.calculateColWidth(criterio_evaluacion_cell_ch_width) },
        { width: this.calculateColWidth(observacion_evaluacion_cell_ch_width) },

        { width: this.calculateColWidth(vel_gps_cell_ch_width) },
        { width: this.calculateColWidth(vel_can_cell_ch_width) },
      );

      // if (this.chkFatigaSomnolencia && this.chkFatigaDistraccion){
      //   column_config.push(
      //     { width: this.calculateColWidth(descripcion_cell_ch_width) }
      //   );
      // };

      column_config.push(
        // { width: this.calculateColWidth(reconocimiento_facial_cell_ch_width) },
        { width: this.calculateColWidth(tramo_cell_ch_width) },
        { width: this.calculateColWidth(pc_cell_ch_width) },
        { width: this.calculateColWidth(ubicacion_cell_ch_width) },
        { width: this.calculateColWidth(operador_monitoreo_cell_ch_width) },

      );

      exportFileEx.push({
        freezePane: {
            rowSplit: this.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }
    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: nom_excel
      });

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }


  exportExcelHtmlEventosEvaluacionCIPIA(vrs: number, format: string) {
    var exportFileEx = getFileExportEventosEvaluacionCIPIA(this, vrs);
    //******************************************************************************
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        if ( format == "excel" ) {
            var nom_inf_xls = "ReporteAtencionEventos.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });

        } else if(format == "html") {
            var nom_inf_html = "ReporteAtencionEventos.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }
    }

  }


  exportExcelHtmlEventosCIPIA(vrs: number, format: string) {
    var exportFileEx = getFileExportEventosCIPIA(this, vrs);
    //******************************************************************************
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        if ( format == "excel" ) {

            var nom_inf_xls = '';
            if (this.report_data.num_rep == 'R040') {
                nom_inf_xls = "ReporteEventosInternos.xlsx"; //'REPORTE DE EVENTOS INTERNO';
            } else if(this.report_data.num_rep == 'R037') {
                nom_inf_xls = "ReporteEventos.xlsx"; //'REPORTE DE EVENTOS';
            }

            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });

        } else if(format == "html") {

            var nom_inf_html = '';
            if (this.report_data.num_rep == 'R040') {
                nom_inf_html = "ReporteEventosInternos.html"; //'REPORTE DE EVENTOS INTERNO';
            } else if(this.report_data.num_rep == 'R037') {
                nom_inf_html = "ReporteEventos.html"; //'REPORTE DE EVENTOS';
            }

            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }
    }

  }

  exportExcelExcesosVelocidadNuevoFormato(vrs: number) {
    //vm.dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;

    var table_width = 10 + (this.chkDateHour? 2: 1);
    var vehiculo_width = 4 + (this.chkDateHour? 2: 1);
    var column_config = [];

    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;
    var tipo_unidad_cell_ch_width = "Tipo unidad".length;
    var id_conductor_cell_ch_width = "ID conductor".length;
    var conductor_cell_ch_width = "conductor".length;
    var tramo_cell_ch_width = "tramo".length;
    var limite_velocidad_cell_ch_width = "Limite de".length;
    var exceso_velocidad_cell_ch_width = "Exceso de".length;
    var ubicacion_cell_ch_width = "Ubicacion".length;

    var header_two_lines = true;

    var allRows: AllRows[] = [
        {
          cells: [
            { value: "REPORTE DE EXCESOS DE VELOCIDAD (NUEVO FORMATO)", ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];


    this.data.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        var rows:AllRows[] = [
          {
            cells: [
              { value: "REPORTE DE EXCESOS DE VELOCIDAD (NUEVO FORMATO)", ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              // { value: "VEHÍCULO : " + data[0][1], color: "#FFF", background: "#000", vAlign: "center", hAlign: "center", fontSize: this.t2, colSpan: 2 },
              { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width },
            ],
            height: this.subHeaderHeight
          },
          {
            cells: [
              //{ value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width },
            ],
            height: this.subHeaderContentHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];

        if(this.chkDateHour) {
          rows.push({
            cells: [

              { value: "Item", ...this.colHeaderConfig },
              { value: "Fecha", ...this.colHeaderConfig },
              { value: "Hora", ...this.colHeaderConfig },
              { value: "Código", ...this.colHeaderConfig },
              { value: "Placa", ...this.colHeaderConfig },
              { value: "Tipo de Unidad", ...this.colHeaderConfig },

              { value: "Id Conductor", ...this.colHeaderConfig },
              { value: "Conductor", ...this.colHeaderConfig },

              { value: "Tramo", ...this.colHeaderConfig },
              { value: "Límite de Velocidad", ...this.colHeaderConfig },
              { value: "Exceso de Velocidad", ...this.colHeaderConfig },
              { value: "Ubicación", ...this.colHeaderConfig },

            ],
            height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
          });



          data[1].forEach((item: { fecha_inicio: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; nombre_zona: any; v0: any; velocidad: any;}, index: number) => {

            //var fh = item.fecha.split(" ");
            var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

            codigo_cell_ch_width = Math.max( codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max( placa_cell_ch_width, (item.placa??'').toString().length);
            tipo_unidad_cell_ch_width = Math.max( tipo_unidad_cell_ch_width, (item.tipo_unidad??'').toString().length);
            id_conductor_cell_ch_width = Math.max( id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
            conductor_cell_ch_width = Math.max( conductor_cell_ch_width, (item.conductor??'').toString().length);
            tramo_cell_ch_width = Math.max( tramo_cell_ch_width, (item.nombre_zona??'').toString().length);
            limite_velocidad_cell_ch_width = Math.max( limite_velocidad_cell_ch_width, (item.v0??'').toString().length);
            exceso_velocidad_cell_ch_width = Math.max( exceso_velocidad_cell_ch_width, (item.velocidad??'').toString().length);
            ubicacion_cell_ch_width = Math.max( ubicacion_cell_ch_width, (ubicacion??'').toString().length);

            rows.push({
              cells: [

                { value: (index + 1), ...this.bodyRowsConfig },
                { value: this.isChe(item.fecha_inicio), format: "yyyy/mm/dd", ...this.bodyRowsConfig },
                { value: this.isChs(item.fecha_inicio), format: "hh:mm:ss", ...this.bodyRowsConfig },
                { value: item.codigo, ...this.bodyRowsConfig },
                { value: item.placa, ...this.bodyRowsConfig },
                { value: item.tipo_unidad, ...this.bodyRowsConfig },

                { value: item.idConductor, ...this.bodyRowsConfig },
                { value: item.conductor, ...this.bodyRowsConfig },

                { value: item.nombre_zona, ...this.bodyRowsConfig },
                { value: item.v0+" Km/h", ...this.bodyRowsConfig },
                { value: item.velocidad+" Km/h", ...this.bodyRowsConfig },
                //{ value: ubicacion, ...this.bodyRowsConfig },
                { formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...this.bodyRowsConfig },

              ],
              height: this.bodyRowsHeight
            });
          });

        } else {

          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },
              { value: "Fecha", ...this.colHeaderConfig },
              { value: "Código", ...this.colHeaderConfig },
              { value: "Placa", ...this.colHeaderConfig },
              { value: "Tipo de Unidad", ...this.colHeaderConfig },

              { value: "Id Conductor", ...this.colHeaderConfig },
              { value: "Conductor", ...this.colHeaderConfig },

              { value: "Tramo", ...this.colHeaderConfig },
              { value: "Límite de Velocidad", ...this.colHeaderConfig },
              { value: "Exceso de Velocidad", ...this.colHeaderConfig },
              { value: "Ubicación", ...this.colHeaderConfig },

            ],
            height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
          });


          data[1].forEach((item: { fecha_inicio: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; nombre_zona: any; v0: any; velocidad: any;}, index: number) => {

            var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

            codigo_cell_ch_width = Math.max( codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max( placa_cell_ch_width, (item.placa??'').toString().length);
            tipo_unidad_cell_ch_width = Math.max( tipo_unidad_cell_ch_width, (item.tipo_unidad??'').toString().length);
            id_conductor_cell_ch_width = Math.max( id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
            conductor_cell_ch_width = Math.max( conductor_cell_ch_width, (item.conductor??'').toString().length);
            tramo_cell_ch_width = Math.max( tramo_cell_ch_width, (item.nombre_zona??'').toString().length);
            limite_velocidad_cell_ch_width = Math.max( limite_velocidad_cell_ch_width, (item.v0??'').toString().length);
            exceso_velocidad_cell_ch_width = Math.max( exceso_velocidad_cell_ch_width, (item.velocidad??'').toString().length);
            ubicacion_cell_ch_width = Math.max( ubicacion_cell_ch_width, (ubicacion??'').toString().length);

            rows.push({

              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },
                { value: this.isChe(item.fecha_inicio), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig },
                { value: item.codigo, ...this.bodyRowsConfig },
                { value: item.placa, ...this.bodyRowsConfig },
                { value: item.tipo_unidad, ...this.bodyRowsConfig },

                { value: item.idConductor, ...this.bodyRowsConfig },
                { value: item.conductor, ...this.bodyRowsConfig },

                { value: item.nombre_zona, ...this.bodyRowsConfig },
                { value: item.v0+" Km/h", ...this.bodyRowsConfig },
                { value: item.velocidad+" Km/h", ...this.bodyRowsConfig },

                //{ value: ubicacion, ...this.bodyRowsConfig },
                { formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...this.bodyRowsConfig },


              ],
              height: this.bodyRowsHeight,
            });
          });

        }

        // //********************************************* excel version 1 *********************************
    if (vrs == 1) {
      column_config = [
        { width: this.w_item },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date },
          { width: this.w_hour },
        );
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
        );
      }
      column_config.push(
        { width: this.calculateColWidth(codigo_cell_ch_width) },
        { width: this.calculateColWidth(placa_cell_ch_width) },
        { width: this.calculateColWidth(tipo_unidad_cell_ch_width) },
        { width: this.calculateColWidth(id_conductor_cell_ch_width) },
        { width: this.calculateColWidth(conductor_cell_ch_width) },
        { width: this.calculateColWidth(tramo_cell_ch_width) },
        { width: this.calculateColWidth(limite_velocidad_cell_ch_width) },
        { width: this.calculateColWidth(exceso_velocidad_cell_ch_width) },
        { width: this.calculateColWidth(ubicacion_cell_ch_width) },
      );

      exportFileEx.push({
      freezePane: {
        rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2
        },
      columns: column_config,
      title: "Resultado",//data[0][1],
      rows: rows
      });

      codigo_cell_ch_width = "codigo".length;
      placa_cell_ch_width = "placa".length;
      tipo_unidad_cell_ch_width = "Tipo unidad".length;
      id_conductor_cell_ch_width = "ID conductor".length;
      conductor_cell_ch_width = "conductor".length;
      tramo_cell_ch_width = "tramo".length;
      limite_velocidad_cell_ch_width = "Limite de".length;
      exceso_velocidad_cell_ch_width = "Exceso de".length;
      ubicacion_cell_ch_width = "Ubicacion".length;
    }
    // //********************************************* excel version 1 *********************************

    // //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      rows.splice(0, this.headerRowSpan);
      rows.push(...this.spaceBetweenTables);
      allRows = allRows.concat(rows);
    }
    // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: this.w_item },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date },
          { width: this.w_hour },
        );
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
        );
      }
      column_config.push(
        { width: this.calculateColWidth(codigo_cell_ch_width) },
        { width: this.calculateColWidth(placa_cell_ch_width) },
        { width: this.calculateColWidth(tipo_unidad_cell_ch_width) },
        { width: this.calculateColWidth(id_conductor_cell_ch_width) },
        { width: this.calculateColWidth(conductor_cell_ch_width) },
        { width: this.calculateColWidth(tramo_cell_ch_width) },
        { width: this.calculateColWidth(limite_velocidad_cell_ch_width) },
        { width: this.calculateColWidth(exceso_velocidad_cell_ch_width) },
        { width: this.calculateColWidth(ubicacion_cell_ch_width) },
      );

      exportFileEx.push({
        freezePane: {
          rowSplit: this.headerRowSpan
        },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }
    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: "ReporteExcesosVelocidadFormatoExtendido.xlsx"
      });

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }


  exportHtmlExcesosVelocidadNuevoFormato(vrs: number=2) {
    //vm.dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;

    var table_width = 10 + (this.chkDateHour? 2: 1);
    var vehiculo_width = 4 + (this.chkDateHour? 2: 1);
    var column_config = [];

    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;
    var tipo_unidad_cell_ch_width = "Tipo unidad".length;
    var id_conductor_cell_ch_width = "ID conductor".length;
    var conductor_cell_ch_width = "conductor".length;
    var tramo_cell_ch_width = "tramo".length;
    var limite_velocidad_cell_ch_width = "Limite de".length;
    var exceso_velocidad_cell_ch_width = "Exceso de".length;
    var ubicacion_cell_ch_width = "Ubicacion".length;

    var header_two_lines = true;

    var allRows: AllRows[] = [
        {
          cells: [
            { value: "REPORTE DE EXCESOS DE VELOCIDAD (NUEVO FORMATO)", ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];


    this.data.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        var rows:AllRows[] = [
          {
            cells: [
              { value: "REPORTE DE EXCESOS DE VELOCIDAD (NUEVO FORMATO)", ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              // { value: "VEHÍCULO : " + data[0][1], color: "#FFF", background: "#000", vAlign: "center", hAlign: "center", fontSize: this.t2, colSpan: 2 },
              { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width },
            ],
            height: this.subHeaderHeight
          },
          {
            cells: [
              //{ value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width },
            ],
            height: this.subHeaderContentHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];

        if(this.chkDateHour) {
          rows.push({
            cells: [

              { value: "Item", ...this.colHeaderConfig },
              { value: "Fecha", ...this.colHeaderConfig },
              { value: "Hora", ...this.colHeaderConfig },
              { value: "Código", ...this.colHeaderConfig },
              { value: "Placa", ...this.colHeaderConfig },
              { value: "Tipo de Unidad", ...this.colHeaderConfig },

              { value: "Id Conductor", ...this.colHeaderConfig },
              { value: "Conductor", ...this.colHeaderConfig },

              { value: "Tramo", ...this.colHeaderConfig },
              { value: "Límite de Velocidad", ...this.colHeaderConfig },
              { value: "Exceso de Velocidad", ...this.colHeaderConfig },
              { value: "Ubicación", ...this.colHeaderConfig },

            ],
            height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
          });



          data[1].forEach((item: { fecha_inicio: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; nombre_zona: any; v0: any; velocidad: any;}, index: number) => {

            //var fh = item.fecha.split(" ");
            var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

            codigo_cell_ch_width = Math.max( codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max( placa_cell_ch_width, (item.placa??'').toString().length);
            tipo_unidad_cell_ch_width = Math.max( tipo_unidad_cell_ch_width, (item.tipo_unidad??'').toString().length);
            id_conductor_cell_ch_width = Math.max( id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
            conductor_cell_ch_width = Math.max( conductor_cell_ch_width, (item.conductor??'').toString().length);
            tramo_cell_ch_width = Math.max( tramo_cell_ch_width, (item.nombre_zona??'').toString().length);
            limite_velocidad_cell_ch_width = Math.max( limite_velocidad_cell_ch_width, (item.v0??'').toString().length);
            exceso_velocidad_cell_ch_width = Math.max( exceso_velocidad_cell_ch_width, (item.velocidad??'').toString().length);
            ubicacion_cell_ch_width = Math.max( ubicacion_cell_ch_width, (ubicacion??'').toString().length);

            rows.push({
              cells: [

                { value: (index + 1), ...this.bodyRowsConfig },
                { value: this.isChe(item.fecha_inicio), format: "yyyy/mm/dd", ...this.bodyRowsConfig },
                { value: this.isChs(item.fecha_inicio), format: "hh:mm:ss", ...this.bodyRowsConfig },
                { value: item.codigo, ...this.bodyRowsConfig },
                { value: item.placa, ...this.bodyRowsConfig },
                { value: item.tipo_unidad, ...this.bodyRowsConfig },

                { value: item.idConductor, ...this.bodyRowsConfig },
                { value: item.conductor, ...this.bodyRowsConfig },

                { value: item.nombre_zona, ...this.bodyRowsConfig },
                { value: item.v0+" Km/h", ...this.bodyRowsConfig },
                { value: item.velocidad+" Km/h", ...this.bodyRowsConfig },
                //{ value: ubicacion, ...this.bodyRowsConfig },
                { formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...this.bodyRowsConfig },

              ],
              height: this.bodyRowsHeight
            });
          });

        } else {

          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },
              { value: "Fecha", ...this.colHeaderConfig },
              { value: "Código", ...this.colHeaderConfig },
              { value: "Placa", ...this.colHeaderConfig },
              { value: "Tipo de Unidad", ...this.colHeaderConfig },

              { value: "Id Conductor", ...this.colHeaderConfig },
              { value: "Conductor", ...this.colHeaderConfig },

              { value: "Tramo", ...this.colHeaderConfig },
              { value: "Límite de Velocidad", ...this.colHeaderConfig },
              { value: "Exceso de Velocidad", ...this.colHeaderConfig },
              { value: "Ubicación", ...this.colHeaderConfig },

            ],
            height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
          });


          data[1].forEach((item: { fecha_inicio: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; nombre_zona: any; v0: any; velocidad: any;}, index: number) => {

            var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

            codigo_cell_ch_width = Math.max( codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max( placa_cell_ch_width, (item.placa??'').toString().length);
            tipo_unidad_cell_ch_width = Math.max( tipo_unidad_cell_ch_width, (item.tipo_unidad??'').toString().length);
            id_conductor_cell_ch_width = Math.max( id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
            conductor_cell_ch_width = Math.max( conductor_cell_ch_width, (item.conductor??'').toString().length);
            tramo_cell_ch_width = Math.max( tramo_cell_ch_width, (item.nombre_zona??'').toString().length);
            limite_velocidad_cell_ch_width = Math.max( limite_velocidad_cell_ch_width, (item.v0??'').toString().length);
            exceso_velocidad_cell_ch_width = Math.max( exceso_velocidad_cell_ch_width, (item.velocidad??'').toString().length);
            ubicacion_cell_ch_width = Math.max( ubicacion_cell_ch_width, (ubicacion??'').toString().length);

            rows.push({

              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },
                { value: this.isChe(item.fecha_inicio), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig },
                { value: item.codigo, ...this.bodyRowsConfig },
                { value: item.placa, ...this.bodyRowsConfig },
                { value: item.tipo_unidad, ...this.bodyRowsConfig },

                { value: item.idConductor, ...this.bodyRowsConfig },
                { value: item.conductor, ...this.bodyRowsConfig },

                { value: item.nombre_zona, ...this.bodyRowsConfig },
                { value: item.v0+" Km/h", ...this.bodyRowsConfig },
                { value: item.velocidad+" Km/h", ...this.bodyRowsConfig },

                //{ value: ubicacion, ...this.bodyRowsConfig },
                { formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...this.bodyRowsConfig },


              ],
              height: this.bodyRowsHeight,
            });
          });

        }

        // //********************************************* excel version 1 *********************************
    // //********************************************* excel version 1 *********************************

    // //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      rows.splice(0, this.headerRowSpan);
      rows.push(...this.spaceBetweenTables);
      allRows = allRows.concat(rows);
    }
    // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: this.w_item },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date },
          { width: this.w_hour },
        );
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
        );
      }
      column_config.push(
        { width: this.calculateColWidth(codigo_cell_ch_width) },
        { width: this.calculateColWidth(placa_cell_ch_width) },
        { width: this.calculateColWidth(tipo_unidad_cell_ch_width) },
        { width: this.calculateColWidth(id_conductor_cell_ch_width) },
        { width: this.calculateColWidth(conductor_cell_ch_width) },
        { width: this.calculateColWidth(tramo_cell_ch_width) },
        { width: this.calculateColWidth(limite_velocidad_cell_ch_width) },
        { width: this.calculateColWidth(exceso_velocidad_cell_ch_width) },
        { width: this.calculateColWidth(ubicacion_cell_ch_width) },
      );

      exportFileEx.push({
        freezePane: {
          rowSplit: this.headerRowSpan
        },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }
    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    // if(bol_datos_ex){
    //   var workbook = new kendo.ooxml.Workbook({
    //     sheets: exportFileEx
    //   });
    //   kendo.saveAs({
    //     dataURI: workbook.toDataURL(),
    //     fileName: "ReporteExcesosVelocidadFormatoExtendido.xlsx"
    //   });
    // } else {
    //   alert('No se han encontrado datos para exportar');
    // }

    var aFileParts = '<html><head> <style> *{font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";}</style></head><table style="width:100%;border: 0px solid black;" >';

    for (let index = 0; index < exportFileEx[0].rows.length; index++) {
      const row = exportFileEx[0].rows[index];

      var height_celda:any = row.height;

      // console.log(row.height+" ___ "+row.hasOwnProperty('cells'));
      // console.log(element.cells);
      // console.log(element.hasOwnProperty('cells'));
      aFileParts += '<tr '+
                  'style="height:'+ height_celda *(3/4) +'pt;"'+
                  '>';

      if (row.hasOwnProperty('cells')) {

        // console.log(row['cells']);
        // console.log(row.cells);
        var celdas: any = row.cells;

        for (let j = 0; j < celdas.length; j++) {

          var font_weight = 'normal';
          if ( celdas[j].bold ) {
            font_weight = 'bold';
          }

          aFileParts += '<td '+
                        'colspan="'+celdas[j].colSpan+'" '+
                        'rowspan="'+celdas[j].rowSpan+'" '+
                        'style="font-size:'+ celdas[j].fontSize+
                            '; color:'+ celdas[j].color+
                            '; font-weight:'+ font_weight+
                            '; background-color:'+ celdas[j].background+
                            '; vertical-align: middle;text-align: center;"'+
                            '>';

          if (celdas[j].hasOwnProperty('formula')) {
            var aux = celdas[j].formula.split("maps?q=")[1];
            aux = aux.split("&amp;t=m")[0]; //-16.480746,-71.618448
            //   "HYPERLINK("http://maps.google.com/maps?q=-16.480746,-71.618448&amp;t=m","-16.480746,-71.618448")"
            aFileParts += '<a style="text-decoration: none;" href="http://maps.google.com/maps?q='+aux+'&amp;t=m" target="_blank">'+aux+'</a>'
          } else {
              // const element = array[j];
              aFileParts += celdas[j].value;
          }

          aFileParts += '</td>';

        }
      }
      aFileParts += '</tr>';
    }

    aFileParts += '</table></a></html>';

    var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
    var nom_inf_html = "ReporteExcesosVelocidadFormatoExtendido.html";


    if(bol_datos_ex){
      // var workbook = new kendo.ooxml.Workbook({
      //   sheets: exportFileEx
      // });
      // kendo.saveAs({
      //   dataURI: workbook.toDataURL(),
      //   fileName: nom_inf_xls
      // });
      kendo.saveAs({
        dataURI: oMyBlob,
        fileName: nom_inf_html
      });

    } else {
      this.toastr.error("No se han encontrado datos para exportar");
      /* alert('No se han encontrado datos para exportar'); */
    }


  }


  onChangeOperadorMonitoreo(row:any) {
    console.log("----- onChangeOperadorMonitoreo");
    // console.log(row.FechaEvaluacion);
    if (row.fecha_evaluacion == "" || row.fecha_evaluacion == null) {
      row.fecha_evaluacion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss"); //actualizar = true;
    }
    row.editado = 'si';
  }
  onChangeCriterioEvaluacion(event : any,row:any) {
    if(!event.value){
      this.resetEvaluation(row)
    }else{
      const evaluationCriteria = this.evaluationCriteriaService.getById(event.value)
      if(!evaluationCriteria){return}
      this.assignCriteriaToEvaluation(evaluationCriteria, row)
    }
  }
  private assignCriteriaToEvaluation(evaluationCriteria : EvaluationCriteria, evaluation : any){
    evaluation.criterion_id = evaluationCriteria.id;
    evaluation.criterio_evaluacion = evaluationCriteria.name;
    evaluation.is_confirmed = this.evaluationCriteriaService.isCriteriaConfirmed(evaluationCriteria.id);
    evaluation.senales_posible_fatiga = this.evaluationCriteriaService.isPosibleFatiga(evaluationCriteria.id)

    // permanece
    if (evaluation.fecha_evaluacion == "" || evaluation.fecha_evaluacion == null) {
      evaluation.fecha_evaluacion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss"); //actualizar = true;
    }
    evaluation.es_antiguo_criterio = false;
    evaluation.editado = 'si';
  }

  private resetEvaluation(evaluation : any){
    evaluation.criterion_id = null;
    evaluation.criterio_evaluacion = "";
    evaluation.is_confirmed = false;
    evaluation.senales_posible_fatiga = false;
  }


  onChangeCriterioEvaluacion2(row:any) {
      console.log("------onChangeCriterioEvaluacion");
      if (row.fecha_evaluacion == "" || row.fecha_evaluacion == null) {
        row.fecha_evaluacion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss"); //actualizar = true;
      }
      console.log(row);
      console.log(row.criterio_evaluacion);

      row.es_antiguo_criterio = false;

      if (row.criterio_evaluacion == "INCLINACIÓN DE LA CABEZA HACIA ADELANTE Y/O HACIA ATRÁS"  ||
        row.criterio_evaluacion == "PARPADEO INVOLUNTARIO"  ||
        row.criterio_evaluacion == "GESTOS O MOVIMIENTOS A MANERA DE AUTOGESTIÓN"  ||
        row.criterio_evaluacion == "BOSTEZO CONTINUO (>=3 EN 30 SEG.)" ||
        row.criterio_evaluacion == "MANO CON ACCIÓN DE FROTACIÓN EN LOS OJOS"
      ) {
        row.senales_posible_fatiga = true;
      } else {
        row.senales_posible_fatiga = false;
      }

      row.editado = 'si';

  }

  onChangeObservacion(row:any) {
    console.log("------onChangeObservacion");
    console.log(row);
    if (row.fecha_evaluacion == "" || row.fecha_evaluacion == null) {
      row.fecha_evaluacion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss"); //actualizar = true;
    }
    row.editado = 'si';
  }


  guardarEvaluacionEventos() {
      console.log("------guardarEvaluacionEventos");
      this.spinner.show("reportSpinner");
      var arr_params = [];
      console.log(this.sortedData[0][1]);
      console.log(this.data);

      for (let index = 0; index < this.data[0][1].length; index++) {
          // console.log(this.data[0][1][index].fecha +"  -   "+ this.data[0][1][index].criterio_evaluacion +"  -  " + this.data[0][1][index].editado);

          if (this.data[0][1][index].editado) {
              this.data[0][1][index].imei = this.data[0][1][index].tracker_imei;
              this.data[0][1][index].event_id = this.data[0][1][index].evento_id;


              arr_params.push( this.data[0][1][index] );
          }

      }



      //var dataParams = {array_items:arr_params, user_id:this.reportService.getUserId()};
      const tzCustom = this.momentService.tzCustom;
      const tzPHP = this.momentService.tzPHP;
      var dataParams = {array_items:arr_params, user_id:this.user_id, tzCustom:tzCustom,tzPHP:tzPHP };

      this.http.post(environment.apiUrl + "/api/saveEventUserEvaluacion", dataParams).subscribe({
        next: datos => {

          console.log("========== values");
          console.log(datos);
          this.spinner.hide("reportSpinner");
        }
      });



    // this.sortedData.forEach((data: any,idx:any) => {

    //   if(data[1].length > 0){


    // var dataParams = {array_items:arr_params, user_id:vm.optionUser()};
    // console.log("====== PARAMETROS =====0=");
    // console.log(dataParams);
    // reportServices.setSpinnerValue(true);
    // $q.all([
    //   api.post("saveEventUserEvaluacion", dataParams)
    // ]).then(values => {
    //   console.log("=== EVENTO EVALUADO =====================================");
    //   console.log(values);
    //   reportServices.setSpinnerValue(false);
    // });



  }


  actualizarEvaluacionEventos() {

    console.log("===================================actualizarEvaluacionEventos");
    // console.log(vm.datos);
    // console.log(contador);

    // console.log("===== this.data =====");
    // console.log(this.data);
    // console.log(this.arr_evaluacion2);


    // var tipoR = vm.optionR();
    // var rutaUrl = "X";
    // if (tipoR == 101) {
    // 	rutaUrl = "informes/informes_fatigas_SF";
    // } else if (tipoR == 102) {
    // 	rutaUrl = "informes/informes_fatiga_extrema";
    // }

    var dataParams:any = this.params;// this.reportService.getParams();



    dataParams['fecha_hasta2'] = dataParams['fecha_hasta'];
    dataParams['fecha_hasta'] = moment(new Date()).format("YYYY-MM-DD") + 'T' + moment(new Date()).format("HH:mm:ss") + '-05:00';

    console.log(dataParams);

    this.spinner.show("reportSpinner");
    this.http.post(environment.apiUrl + dataParams.url, dataParams).subscribe({
      next: datos => {
        // console.log("========== values");
        // console.log(typeof datos);
        // console.log(datos);
        var values:any = datos;
        // console.log(values[0]);
        // console.log("===== this.data");
        // console.log(this.data);


        for (let i = 0; i < this.data.length; i++) {

          // console.log("-------------- nuevas tramas "+i);
          // console.log(this.data);

          console.log(values[i][1]);
          this.data[i][0] = values[i][0];
          this.data[i][1] = values[i][1];


          // for (let j = 0; j < this.data[i][1].length; j++) {
          //     var row = this.data[i][1][j];

          //     for (let i2 = 0; i2 < this.arr_evaluacion2.length; i2++) {
          //         const element = this.arr_evaluacion2[i2];
          //         if (row.fecha == this.arr_evaluacion2[i2][4] && row.nombre == this.arr_evaluacion2[i2][5]) {
          //             // row.criterio_evaluacion		  = this.arr_evaluacion2[i2][0];
          //             // row.observacion_evaluacion  = this.arr_evaluacion2[i2][1];
          //             // row.fecha_evaluacion		    = this.arr_evaluacion2[i2][2];
          //             // row.operador_monitoreo		  = this.arr_evaluacion2[i2][3];
          //         }

          //     }

          // }

        }

        // console.log("==========  this.data :");
        // console.log(this.data);
        // console.log("==========  this.arr_evaluacion 2 :");
        // console.log(vm.arr_evaluacion);
        // console.log(this.arr_evaluacion2);
        // this.arr_evaluacion = undefined;
        // this.arr_evaluacion2 = undefined;
        // console.log(vm.arr_evaluacion);
        // console.log(this.arr_evaluacion2);
        this.spinner.hide("reportSpinner");


        // this.fatigaExtremaNewFormato();

        // this.reportService.modalActive = true;
        // this.reportService.objGeneral.data = data;
        // this.reportService.objGeneral.periodo = periodo;//this.period;
        // this.reportService.objGeneral.vehiculo = vehiculo;//this.period;
        // this.reportService.objGeneral.dateHour = dateHour;//this.period;
        // console.log(this.reportService.objGeneral);
        // this.spinner.hide("reportSpinner");
        // console.log("MODAL ACTIVATE");
      }
    });



    // reportServices.setSpinnerValue(true);
    // $q.all([
    //   	api.post(rutaUrl, dataParams),
    //   ]).then(values => {
    // 	console.log("========== values");
    // 	console.log(values);
    // 	console.log(values[0]);
    // 	// vm.datos = values[0];

    // 	for (let i = 0; i < vm.datos.length; i++) {
    // 		//const lista_eventos = vm.datos[i][1];
    // 		console.log("-------------- nuevas tramas");
    // 		console.log(values[0][i][1]);
    // 		vm.datos[i][0] = values[0][i][0];
    // 		vm.datos[i][1] = values[0][i][1];

    // 		for (let j = 0; j < vm.datos[i][1].length; j++) {
    // 			var row = vm.datos[i][1][j];
    // 			for (let i2 = 0; i2 < vm.arr_evaluacion2.length; i2++) {
    // 				const element = vm.arr_evaluacion2[i2];
    // 				if (row.fecha == vm.arr_evaluacion2[i2][4] && row.nombre == vm.arr_evaluacion2[i2][5]) {
    // 					row.criterio_evaluacion		= vm.arr_evaluacion2[i2][0];
    // 					row.observacion_evaluacion  = vm.arr_evaluacion2[i2][1];
    // 					row.fecha_evaluacion		= vm.arr_evaluacion2[i2][2];
    // 					row.operador_monitoreo		= vm.arr_evaluacion2[i2][3];
    // 				}
    // 			}
    // 		}
    // 	}
    // 	console.log("==========  vm.datos :");
    // 	console.log(vm.datos);
    // 	console.log("==========  vm.arr_evaluacion 2 :");

    // 	// console.log(vm.arr_evaluacion);
    // 	console.log(vm.arr_evaluacion2);
    // 	vm.arr_evaluacion = undefined;
    // 	vm.arr_evaluacion2 = undefined;
    // 	// console.log(vm.arr_evaluacion);
    // 	console.log(vm.arr_evaluacion2);
    // 	reportServices.setSpinnerValue(false);

    // });

    // console.log("============= 2 ============");
    // console.log(vm.datos);


}

  exportExcelExcesosVelocidadDuracionToleranciaRiesgo(vrs: number) {

    var rs = this.eC; //this.reportService.eC;
    var table_width = 6;


    if (rs.Fecha) { table_width++; }
    if (rs.Hora) { table_width++;  };
    if (rs.Codigo) {  table_width++;  };
    if (rs.Placa) {  table_width++;  };
    if (rs.Zona) {  table_width++; };
    if (!this.chkRiesgo) {  table_width++;};
    if (this.chkRiesgo) {  table_width = table_width + 3;};
    if (rs.IdConductor) {  table_width++; };
    if (rs.Conductor) {  table_width++; };
    if (rs.VelMobileye) {  table_width++; };
    if (rs.VelGPSspeed) {  table_width++; };
    if (rs.VelCAN) {  table_width++; };
    if (rs.Satelite) {  table_width++; };
    if (rs.Ubicacion) {  table_width++; };

    console.log("cont = "+ table_width);

    //vm.dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[];
    //var table_width = 12 + (this.chkDateHour? 2: 1) +1 + (this.user_id == 923? -2: 0);
    //var table_width = cont;

    var vehiculo_width = 0;//(this.chkDateHour? 5: 4) +1 + (this.user_id == 923? -2: 0);


    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;
    var zona_cell_ch_width = "zona".length;

    var limite_velocidad_cell_ch_width = "Límite de Velocidad".length;

    var leve_cell_ch_width = "Leve(1,2)".length;
    var grave_cell_ch_width = "Grave(3,5)".length;
    var muy_grave_cell_ch_width = "Muy Grave(>=6)".length;

    //---
    var duracion_cell_ch_width = "Duracion".length;

    var id_conductor_cell_ch_width = "Id Conductor".length;
    var conductor_cell_ch_width = "Conductor".length;

    var vel_mobileye_cell_ch_width = "Vel.ADAS".length;
    var vel_gps_speed_cell_ch_width = "Vel.GPS".length;
    var vel_can_cell_ch_width = "Vel.GPS".length;
    var satelite_cell_ch_width = "Satélite".length;
    var ubicacion_cell_ch_width = "Ubicación".length;

    var nom_xlsx: string = '';
    if (this.report_data.num_rep == 'R041') {
      nom_xlsx = "ReporteExcesosVelocidad.xlsx";
    } else  if (this.report_data.num_rep == 'R044') {
      nom_xlsx = "ReporteExcesosVelocidadDireccion.xlsx";
    } else  if (this.report_data.num_rep == 'R047') {
      nom_xlsx = "ReporteExcesosVelocidadPorNivel.xlsx";
    }


    // var allRows = [
    var allRows: AllRows[] = [
        {
          cells: [
            { value: this.repTitle, ...this.headerCellConfig, colSpan: table_width }
            // { value: "REPORTE DE EXCESOS DE VELOCIDAD", ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];

    this.sortedData.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        var rows:AllRows[] = [
          {
            cells: [
              { value: this.repTitle, ...this.headerCellConfig, colSpan: table_width }
              // { value: "REPORTE DE EXCESOS DE VELOCIDAD.", ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              // { value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderHeight
          },
          {
            cells: [
              // { value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderContentHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];

        //if(this.chkDateHour) {

          var array_campos_cabecera = [];

          array_campos_cabecera.push({ value: "Item", ...this.colHeaderConfig });

          if (rs.Fecha) { array_campos_cabecera.push({ value: "Fecha", ...this.colHeaderConfig }); }
          if (rs.Hora) {  array_campos_cabecera.push({ value: "Hora", ...this.colHeaderConfig }); };
          if (rs.Codigo) {  array_campos_cabecera.push({ value: "Unidad", ...this.colHeaderConfig }); };
          if (rs.Placa) {  array_campos_cabecera.push({ value: "Placa", ...this.colHeaderConfig }); };
          if (rs.Zona) {  array_campos_cabecera.push({ value: "Zona", ...this.colHeaderConfig }); };
          array_campos_cabecera.push({ value: "Límite de Velocidad de Zona", ...this.colHeaderConfig });
          if (!this.chkRiesgo) {  array_campos_cabecera.push({ value: "Exceso de Velocidad", ...this.colHeaderConfig }); };

          if (this.report_data.num_rep == 'R047') {
            if (this.chkRiesgo) {  array_campos_cabecera.push({ value: "Nivel I", ...this.colHeaderConfig }); };
            if (this.chkRiesgo) {  array_campos_cabecera.push({ value: "Nivel II", ...this.colHeaderConfig }); };
            if (this.chkRiesgo) {  array_campos_cabecera.push({ value: "Nivel III", ...this.colHeaderConfig }); };
          } else {
            if (this.chkRiesgo) {  array_campos_cabecera.push({ value: "Leve(1,2)", ...this.colHeaderConfig }); };
            if (this.chkRiesgo) {  array_campos_cabecera.push({ value: "Grave(3,5)", ...this.colHeaderConfig }); };
            if (this.chkRiesgo) {  array_campos_cabecera.push({ value: "Muy Grave(>=6)", ...this.colHeaderConfig }); };
          }



          array_campos_cabecera.push({ value: "Inicio del Exceso", ...this.colHeaderConfig });
          array_campos_cabecera.push({ value: "Hora del Exceso", ...this.colHeaderConfig });
          array_campos_cabecera.push({ value: "Fin del Exceso", ...this.colHeaderConfig });
          array_campos_cabecera.push({ value: "Duración", ...this.colHeaderConfig });

          if (rs.IdConductor) { array_campos_cabecera.push({ value: "ID Conductor", ...this.colHeaderConfig }); };
          if (rs.Conductor) { array_campos_cabecera.push({ value: "Conductor", ...this.colHeaderConfig }); };

          if (rs.VelMobileye) { array_campos_cabecera.push({ value: "Vel.ADAS", ...this.colHeaderConfig }); };
          if (rs.VelGPSspeed) { array_campos_cabecera.push({ value: "Vel.GPS", ...this.colHeaderConfig }); };
          if (rs.VelCAN) { array_campos_cabecera.push({ value: "Vel.CAN", ...this.colHeaderConfig }); };
          if (rs.Satelite) { array_campos_cabecera.push({ value: "Satélite", ...this.colHeaderConfig }); };
          if (rs.Ubicacion) { array_campos_cabecera.push({ value: "Ubicación", ...this.colHeaderConfig }); };




          rows.push({
            cells: array_campos_cabecera ,height: this.colsHeaderHeight
          });


          data[1].forEach((item: { col1:any, es_resumen:any, vel_leve:any, vel_grave:any, vel_muy_grave:any, hora_exceso:any, fin_exceso:any, duracion2:any, velMobileye_ME460:any, GPS_speed:any, can_speed:any, sat:any, v0:any, velocidad:any,nombre_zona:any, fecha_inicio:any, parametros:any, vel_eco:any, vel_gps_speed:any, vel_mobileye:any, referencia:any, enlaceVideoCIPIA:any, enlaceImageCIPIA:any, descripcion_evento:any; fecha_tracker: number; fecha_servidor: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; vel_gps: any; vel_can: any; tramo: string; PC: any; sonidoEnCabina: any;}, index: number) => {

              //var fh = item.fecha.split(" ");
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6);

              codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
              placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
              zona_cell_ch_width = Math.max(zona_cell_ch_width, (item.nombre_zona??'').toString().length);
              limite_velocidad_cell_ch_width = Math.max(limite_velocidad_cell_ch_width, (item.v0??'').toString().length);

              leve_cell_ch_width = Math.max(leve_cell_ch_width, (item.vel_leve??'').toString().length);
              grave_cell_ch_width = Math.max(grave_cell_ch_width, (item.vel_grave??'').toString().length);
              muy_grave_cell_ch_width = Math.max(muy_grave_cell_ch_width, (item.vel_muy_grave??'').toString().length);

              //==
              duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion2??'').toString().length);

              id_conductor_cell_ch_width = Math.max(id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
              conductor_cell_ch_width = Math.max(conductor_cell_ch_width, (item.conductor??'').toString().length);

              vel_mobileye_cell_ch_width = Math.max(vel_mobileye_cell_ch_width, (item.vel_mobileye??'').toString().length);
              vel_gps_speed_cell_ch_width = Math.max(vel_gps_speed_cell_ch_width, (item.vel_gps_speed??'').toString().length);
              vel_can_cell_ch_width = Math.max(vel_can_cell_ch_width, (item.vel_can??'').toString().length);

              satelite_cell_ch_width = Math.max(satelite_cell_ch_width, (item.vel_eco??'').toString().length);
              ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);



              var color = "";
              if (item.es_resumen) {
                color = "#E5E3D9";
                ubicacion = "";
              }

              var array_campos_cuerpo= [];

              // array_campos_cuerpo.push({ value: (index + 1), background: color, ...this.bodyRowsConfig });
              array_campos_cuerpo.push({ value: item.col1, background: color, ...this.bodyRowsConfig });

              if (rs.Fecha) { array_campos_cuerpo.push({ value: this.isChe(item.fecha_inicio), background: color, format: "yyyy/mm/dd", ...this.bodyRowsConfig }); };
              if (rs.Hora) { array_campos_cuerpo.push({ value: this.isChs(item.fecha_inicio), background: color, format: "hh:mm:ss", ...this.bodyRowsConfig }); };

              if (rs.Codigo) { array_campos_cuerpo.push({ value: item.codigo, background: color, ...this.bodyRowsConfig }); };
              if (rs.Placa) { array_campos_cuerpo.push({ value: item.placa, background: color, ...this.bodyRowsConfig }); };
              if (rs.Zona) { array_campos_cuerpo.push({ value: item.nombre_zona, background: color, ...this.bodyRowsConfig }); };

              array_campos_cuerpo.push({ value: item.v0, background: color, ...this.bodyRowsConfig });
              if (!this.chkRiesgo) { array_campos_cuerpo.push({ value: item.velocidad, background: color, ...this.bodyRowsConfig }); };

              if (this.chkRiesgo) { array_campos_cuerpo.push({ value: item.vel_leve, background: color, ...this.bodyRowsConfig }); };
              if (this.chkRiesgo) { array_campos_cuerpo.push({ value: item.vel_grave, background: color, ...this.bodyRowsConfig }); };
              if (this.chkRiesgo) { array_campos_cuerpo.push({ value: item.vel_muy_grave, background: color, ...this.bodyRowsConfig }); };

              array_campos_cuerpo.push({ value: this.isChs(item.fecha_inicio), format: "hh:mm:ss", background: color, ...this.bodyRowsConfig });
              array_campos_cuerpo.push({ value: this.isChs(item.hora_exceso), format: "hh:mm:ss", background: color, ...this.bodyRowsConfig });
              array_campos_cuerpo.push({ value: this.isChs(item.fin_exceso), format: "hh:mm:ss", background: color, ...this.bodyRowsConfig });
              array_campos_cuerpo.push({ value: item.duracion2, background: color, ...this.bodyRowsConfig });

              if (rs.IdConductor) { array_campos_cuerpo.push({ value: item.idConductor, background: color, ...this.bodyRowsConfig }); };
              if (rs.Conductor) { array_campos_cuerpo.push({ value: item.conductor, background: color, ...this.bodyRowsConfig }); };

              if (rs.VelMobileye) { array_campos_cuerpo.push({ value: item.velMobileye_ME460, background: color, ...this.bodyRowsConfig }); };
              if (rs.VelGPSspeed) { array_campos_cuerpo.push({ value: item.GPS_speed, background: color, ...this.bodyRowsConfig }); };
              if (rs.VelCAN) { array_campos_cuerpo.push({ value: item.can_speed, background: color, ...this.bodyRowsConfig }); };
              if (rs.Satelite) { array_campos_cuerpo.push({ value: item.sat, background: color, ...this.bodyRowsConfig }); };
              if (rs.Ubicacion) { array_campos_cuerpo.push({ formula: 'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', background: color, color:'#0000FF', ...this.bodyRowsConfig}); };

              rows.push({
                cells: array_campos_cuerpo, height: this.bodyRowsHeight
              });

          });

        //}

        // //********************************************* excel version 1 *********************************
    if (vrs == 1) {

      column_config = [ { width: this.w_item }  ];

      if (rs.Fecha) { column_config.push( { width: this.w_date } );  }
      if (rs.Hora) { column_config.push( { width: this.w_hour } );  }
      if (rs.Codigo) {  column_config.push( { width: this.calculateColWidth(codigo_cell_ch_width) }  );  };
      if (rs.Placa)  {  column_config.push( { width: this.calculateColWidth(placa_cell_ch_width) }  );  };
      if (rs.Zona) { column_config.push( { width: this.calculateColWidth(zona_cell_ch_width) }  );  };

      column_config.push( { width: this.calculateColWidth(limite_velocidad_cell_ch_width) }  );

      if (!this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(limite_velocidad_cell_ch_width) }  );  };

      if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(leve_cell_ch_width) }  );  };
      if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(grave_cell_ch_width) }  );  };
      if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(muy_grave_cell_ch_width) }  );  };

      column_config.push( { width: this.w_hour });
      column_config.push( { width: this.w_hour });
      column_config.push( { width: this.w_hour });
      column_config.push( { width: this.calculateColWidth(duracion_cell_ch_width) }  );

      if (rs.IdConductor) { column_config.push( { width: this.calculateColWidth(id_conductor_cell_ch_width) }  );  };
      if (rs.Conductor) { column_config.push( { width: this.calculateColWidth(conductor_cell_ch_width) }  );  };

      if (rs.VelMobileye) { column_config.push( { width: this.calculateColWidth(vel_mobileye_cell_ch_width) }  );  };
      if (rs.VelGPSspeed) { column_config.push( { width: this.calculateColWidth(vel_gps_speed_cell_ch_width) }  );  };
      if (rs.VelCAN) { column_config.push( { width: this.calculateColWidth(vel_can_cell_ch_width) }  );  };
      if (rs.Satelite) { column_config.push( { width: this.calculateColWidth(satelite_cell_ch_width) }  );  };
      if (rs.Ubicacion) { column_config.push( { width: this.calculateColWidth(ubicacion_cell_ch_width) }  );  };



      exportFileEx.push({
      freezePane: {
        rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2
        },
      columns: column_config,
      title: data[0][1],
      rows: rows
      });


      codigo_cell_ch_width = "codigo".length;
      placa_cell_ch_width = "placa".length;
      zona_cell_ch_width = "zona".length;

      limite_velocidad_cell_ch_width = "Límite de Velocidad de Zona".length;

      leve_cell_ch_width = "Leve(1,2)".length;
      grave_cell_ch_width = "Grave(3,5)".length;
      muy_grave_cell_ch_width = "Muy Grave(>=6)".length;
      //---
      duracion_cell_ch_width = "Duracion".length;

      id_conductor_cell_ch_width = "Id Conductor".length;
      conductor_cell_ch_width = "Conductor".length;

      vel_mobileye_cell_ch_width = "Vel.ADAS".length;
      vel_gps_speed_cell_ch_width = "Vel.GPS".length;
      vel_can_cell_ch_width = "Vel.GPS".length;
      satelite_cell_ch_width = "Satélite".length;
      ubicacion_cell_ch_width = "Ubicación".length;

    }
    // //********************************************* excel version 1 *********************************

    // //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      rows.splice(0, this.headerRowSpan);
      rows.push(...this.spaceBetweenTables);
      allRows = allRows.concat(rows);
    }
    // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
        allRows[0].cells![0].colSpan = table_width;

        column_config = [ { width: this.w_item }  ];

        if (rs.Fecha) { column_config.push( { width: this.w_date } );  }
        if (rs.Hora) { column_config.push( { width: this.w_hour } );  }
        if (rs.Codigo) {  column_config.push( { width: this.calculateColWidth(codigo_cell_ch_width) }  );  };
        if (rs.Placa)  {  column_config.push( { width: this.calculateColWidth(placa_cell_ch_width) }  );  };
        if (rs.Zona) { column_config.push( { width: this.calculateColWidth(zona_cell_ch_width) }  );  };

        column_config.push( { width: this.calculateColWidth(limite_velocidad_cell_ch_width) }  );

        if (!this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(limite_velocidad_cell_ch_width) }  );  };

        if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(leve_cell_ch_width) }  );  };
        if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(grave_cell_ch_width) }  );  };
        if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(muy_grave_cell_ch_width) }  );  };

        column_config.push( { width: this.w_hour });
        column_config.push( { width: this.w_hour });
        column_config.push( { width: this.w_hour });
        column_config.push( { width: this.calculateColWidth(duracion_cell_ch_width) }  );

        if (rs.IdConductor) { column_config.push( { width: this.calculateColWidth(id_conductor_cell_ch_width) }  );  };
        if (rs.Conductor) { column_config.push( { width: this.calculateColWidth(conductor_cell_ch_width) }  );  };

        if (rs.VelMobileye) { column_config.push( { width: this.calculateColWidth(vel_mobileye_cell_ch_width) }  );  };
        if (rs.VelGPSspeed) { column_config.push( { width: this.calculateColWidth(vel_gps_speed_cell_ch_width) }  );  };
        if (rs.VelCAN) { column_config.push( { width: this.calculateColWidth(vel_can_cell_ch_width) }  );  };
        if (rs.Satelite) { column_config.push( { width: this.calculateColWidth(satelite_cell_ch_width) }  );  };
        if (rs.Ubicacion) { column_config.push( { width: this.calculateColWidth(ubicacion_cell_ch_width) }  );  };




      exportFileEx.push({
        freezePane: {
          rowSplit: this.headerRowSpan
        },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }
    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: nom_xlsx //"ReporteExcesosVelocidad.xlsx"
      });

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }


  exportHtmlExcesosVelocidadDuracionToleranciaRiesgo(vrs: number=2) {

    var rs = this.eC; //this.reportService.eC;
    var table_width = 6;


    if (rs.Fecha) { table_width++; }
    if (rs.Hora) { table_width++;  };
    if (rs.Codigo) {  table_width++;  };
    if (rs.Placa) {  table_width++;  };
    if (rs.Zona) {  table_width++; };
    if (!this.chkRiesgo) {  table_width++;};
    if (this.chkRiesgo) {  table_width = table_width + 3;};
    if (rs.IdConductor) {  table_width++; };
    if (rs.Conductor) {  table_width++; };
    if (rs.VelMobileye) {  table_width++; };
    if (rs.VelGPSspeed) {  table_width++; };
    if (rs.VelCAN) {  table_width++; };
    if (rs.Satelite) {  table_width++; };
    if (rs.Ubicacion) {  table_width++; };

    console.log("cont = "+ table_width);

    //vm.dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[];
    //var table_width = 12 + (this.chkDateHour? 2: 1) +1 + (this.user_id == 923? -2: 0);
    //var table_width = cont;

    var vehiculo_width = 0;//(this.chkDateHour? 5: 4) +1 + (this.user_id == 923? -2: 0);


    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;
    var zona_cell_ch_width = "zona".length;

    var limite_velocidad_cell_ch_width = "Límite de Velocidad".length;

    var leve_cell_ch_width = "Leve(1,2)".length;
    var grave_cell_ch_width = "Grave(3,5)".length;
    var muy_grave_cell_ch_width = "Muy Grave(>=6)".length;

    //---
    var duracion_cell_ch_width = "Duracion".length;

    var id_conductor_cell_ch_width = "Id Conductor".length;
    var conductor_cell_ch_width = "Conductor".length;

    var vel_mobileye_cell_ch_width = "Vel.ADAS".length;
    var vel_gps_speed_cell_ch_width = "Vel.GPS".length;
    var vel_can_cell_ch_width = "Vel.GPS".length;
    var satelite_cell_ch_width = "Satélite".length;
    var ubicacion_cell_ch_width = "Ubicación".length;

    var nom_inf_html: string = '';
    if (this.report_data.num_rep == 'R041') {
        nom_inf_html = "ReporteExcesosVelocidad.html";
    } else  if (this.report_data.num_rep == 'R044') {
        nom_inf_html = "ReporteExcesosVelocidadDireccion.html";
    }

    // var allRows = [
    var allRows: AllRows[] = [
        {
          cells: [
            // { value: "REPORTE DE EXCESOS DE VELOCIDAD", ...this.headerCellConfig, colSpan: table_width }
            { value: this.repTitle, ...this.headerCellConfig, colSpan: table_width }

          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];

    this.sortedData.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        var rows:AllRows[] = [
          {
            cells: [
              { value: "REPORTE DE EXCESOS DE VELOCIDAD.", ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              // { value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderHeight
          },
          {
            cells: [
              // { value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderContentHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];

        //if(this.chkDateHour) {

          var array_campos_cabecera = [];

          array_campos_cabecera.push({ value: "Item", ...this.colHeaderConfig });

          if (rs.Fecha) { array_campos_cabecera.push({ value: "Fecha", ...this.colHeaderConfig }); }
          if (rs.Hora) {  array_campos_cabecera.push({ value: "Hora", ...this.colHeaderConfig }); };
          if (rs.Codigo) {  array_campos_cabecera.push({ value: "Unidad", ...this.colHeaderConfig }); };
          if (rs.Placa) {  array_campos_cabecera.push({ value: "Placa", ...this.colHeaderConfig }); };
          if (rs.Zona) {  array_campos_cabecera.push({ value: "Zona", ...this.colHeaderConfig }); };
          array_campos_cabecera.push({ value: "Límite de Velocidad de Zona", ...this.colHeaderConfig });
          if (!this.chkRiesgo) {  array_campos_cabecera.push({ value: "Exceso de Velocidad", ...this.colHeaderConfig }); };

          if (this.chkRiesgo) {  array_campos_cabecera.push({ value: "Leve(1,2)", ...this.colHeaderConfig }); };
          if (this.chkRiesgo) {  array_campos_cabecera.push({ value: "Grave(3,5)", ...this.colHeaderConfig }); };
          if (this.chkRiesgo) {  array_campos_cabecera.push({ value: "Muy Grave(>=6)", ...this.colHeaderConfig }); };

          array_campos_cabecera.push({ value: "Inicio del Exceso", ...this.colHeaderConfig });
          array_campos_cabecera.push({ value: "Hora del Exceso", ...this.colHeaderConfig });
          array_campos_cabecera.push({ value: "Fin del Exceso", ...this.colHeaderConfig });
          array_campos_cabecera.push({ value: "Duración", ...this.colHeaderConfig });

          if (rs.IdConductor) { array_campos_cabecera.push({ value: "ID Conductor", ...this.colHeaderConfig }); };
          if (rs.Conductor) { array_campos_cabecera.push({ value: "Conductor", ...this.colHeaderConfig }); };

          if (rs.VelMobileye) { array_campos_cabecera.push({ value: "Vel.ADAS", ...this.colHeaderConfig }); };
          if (rs.VelGPSspeed) { array_campos_cabecera.push({ value: "Vel.GPS", ...this.colHeaderConfig }); };
          if (rs.VelCAN) { array_campos_cabecera.push({ value: "Vel.CAN", ...this.colHeaderConfig }); };
          if (rs.Satelite) { array_campos_cabecera.push({ value: "Satélite", ...this.colHeaderConfig }); };
          if (rs.Ubicacion) { array_campos_cabecera.push({ value: "Ubicación", ...this.colHeaderConfig }); };




          rows.push({
            cells: array_campos_cabecera ,height: this.colsHeaderHeight
          });


          data[1].forEach((item: { col1:any, es_resumen:any, vel_leve:any, vel_grave:any, vel_muy_grave:any, hora_exceso:any, fin_exceso:any, duracion2:any, velMobileye_ME460:any, GPS_speed:any, can_speed:any, sat:any, v0:any, velocidad:any,nombre_zona:any, fecha_inicio:any, parametros:any, vel_eco:any, vel_gps_speed:any, vel_mobileye:any, referencia:any, enlaceVideoCIPIA:any, enlaceImageCIPIA:any, descripcion_evento:any; fecha_tracker: number; fecha_servidor: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; vel_gps: any; vel_can: any; tramo: string; PC: any; sonidoEnCabina: any;}, index: number) => {

              //var fh = item.fecha.split(" ");
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6);

              codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
              placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
              zona_cell_ch_width = Math.max(zona_cell_ch_width, (item.nombre_zona??'').toString().length);
              limite_velocidad_cell_ch_width = Math.max(limite_velocidad_cell_ch_width, (item.v0??'').toString().length);

              leve_cell_ch_width = Math.max(leve_cell_ch_width, (item.vel_leve??'').toString().length);
              grave_cell_ch_width = Math.max(grave_cell_ch_width, (item.vel_grave??'').toString().length);
              muy_grave_cell_ch_width = Math.max(muy_grave_cell_ch_width, (item.vel_muy_grave??'').toString().length);

              //==
              duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion2??'').toString().length);

              id_conductor_cell_ch_width = Math.max(id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
              conductor_cell_ch_width = Math.max(conductor_cell_ch_width, (item.conductor??'').toString().length);

              vel_mobileye_cell_ch_width = Math.max(vel_mobileye_cell_ch_width, (item.vel_mobileye??'').toString().length);
              vel_gps_speed_cell_ch_width = Math.max(vel_gps_speed_cell_ch_width, (item.vel_gps_speed??'').toString().length);
              vel_can_cell_ch_width = Math.max(vel_can_cell_ch_width, (item.vel_can??'').toString().length);

              satelite_cell_ch_width = Math.max(satelite_cell_ch_width, (item.vel_eco??'').toString().length);
              ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);



              var color = "";
              if (item.es_resumen) {
                color = "#E5E3D9";
                ubicacion = "";
              }

              var array_campos_cuerpo= [];

              // array_campos_cuerpo.push({ value: (index + 1), background: color, ...this.bodyRowsConfig });
              array_campos_cuerpo.push({ value: item.col1, background: color, ...this.bodyRowsConfig });

              if (rs.Fecha) { array_campos_cuerpo.push({ value: this.isChe(item.fecha_inicio), background: color, format: "yyyy/mm/dd", ...this.bodyRowsConfig }); };
              if (rs.Hora) { array_campos_cuerpo.push({ value: this.isChs(item.fecha_inicio), background: color, format: "hh:mm:ss", ...this.bodyRowsConfig }); };

              if (rs.Codigo) { array_campos_cuerpo.push({ value: item.codigo, background: color, ...this.bodyRowsConfig }); };
              if (rs.Placa) { array_campos_cuerpo.push({ value: item.placa, background: color, ...this.bodyRowsConfig }); };
              if (rs.Zona) { array_campos_cuerpo.push({ value: item.nombre_zona, background: color, ...this.bodyRowsConfig }); };

              array_campos_cuerpo.push({ value: item.v0, background: color, ...this.bodyRowsConfig });
              if (!this.chkRiesgo) { array_campos_cuerpo.push({ value: item.velocidad, background: color, ...this.bodyRowsConfig }); };

              if (this.chkRiesgo) { array_campos_cuerpo.push({ value: item.vel_leve, background: color, ...this.bodyRowsConfig }); };
              if (this.chkRiesgo) { array_campos_cuerpo.push({ value: item.vel_grave, background: color, ...this.bodyRowsConfig }); };
              if (this.chkRiesgo) { array_campos_cuerpo.push({ value: item.vel_muy_grave, background: color, ...this.bodyRowsConfig }); };

              array_campos_cuerpo.push({ value: this.isChs(item.fecha_inicio), format: "hh:mm:ss", background: color, ...this.bodyRowsConfig });
              array_campos_cuerpo.push({ value: this.isChs(item.hora_exceso), format: "hh:mm:ss", background: color, ...this.bodyRowsConfig });
              array_campos_cuerpo.push({ value: this.isChs(item.fin_exceso), format: "hh:mm:ss", background: color, ...this.bodyRowsConfig });
              array_campos_cuerpo.push({ value: item.duracion2, background: color, ...this.bodyRowsConfig });

              if (rs.IdConductor) { array_campos_cuerpo.push({ value: item.idConductor, background: color, ...this.bodyRowsConfig }); };
              if (rs.Conductor) { array_campos_cuerpo.push({ value: item.conductor, background: color, ...this.bodyRowsConfig }); };

              if (rs.VelMobileye) { array_campos_cuerpo.push({ value: item.velMobileye_ME460, background: color, ...this.bodyRowsConfig }); };
              if (rs.VelGPSspeed) { array_campos_cuerpo.push({ value: item.GPS_speed, background: color, ...this.bodyRowsConfig }); };
              if (rs.VelCAN) { array_campos_cuerpo.push({ value: item.can_speed, background: color, ...this.bodyRowsConfig }); };
              if (rs.Satelite) { array_campos_cuerpo.push({ value: item.sat, background: color, ...this.bodyRowsConfig }); };
              if (rs.Ubicacion) { array_campos_cuerpo.push({ formula: 'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', background: color, color:'#0000FF', ...this.bodyRowsConfig}); };

              rows.push({
                cells: array_campos_cuerpo, height: this.bodyRowsHeight
              });

          });

        //}

        // //********************************************* excel version 1 *********************************
    if (vrs == 1) {

      column_config = [ { width: this.w_item }  ];

      if (rs.Fecha) { column_config.push( { width: this.w_date } );  }
      if (rs.Hora) { column_config.push( { width: this.w_hour } );  }
      if (rs.Codigo) {  column_config.push( { width: this.calculateColWidth(codigo_cell_ch_width) }  );  };
      if (rs.Placa)  {  column_config.push( { width: this.calculateColWidth(placa_cell_ch_width) }  );  };
      if (rs.Zona) { column_config.push( { width: this.calculateColWidth(zona_cell_ch_width) }  );  };

      column_config.push( { width: this.calculateColWidth(limite_velocidad_cell_ch_width) }  );

      if (!this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(limite_velocidad_cell_ch_width) }  );  };

      if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(leve_cell_ch_width) }  );  };
      if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(grave_cell_ch_width) }  );  };
      if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(muy_grave_cell_ch_width) }  );  };

      column_config.push( { width: this.w_hour });
      column_config.push( { width: this.w_hour });
      column_config.push( { width: this.w_hour });
      column_config.push( { width: this.calculateColWidth(duracion_cell_ch_width) }  );

      if (rs.IdConductor) { column_config.push( { width: this.calculateColWidth(id_conductor_cell_ch_width) }  );  };
      if (rs.Conductor) { column_config.push( { width: this.calculateColWidth(conductor_cell_ch_width) }  );  };

      if (rs.VelMobileye) { column_config.push( { width: this.calculateColWidth(vel_mobileye_cell_ch_width) }  );  };
      if (rs.VelGPSspeed) { column_config.push( { width: this.calculateColWidth(vel_gps_speed_cell_ch_width) }  );  };
      if (rs.VelCAN) { column_config.push( { width: this.calculateColWidth(vel_can_cell_ch_width) }  );  };
      if (rs.Satelite) { column_config.push( { width: this.calculateColWidth(satelite_cell_ch_width) }  );  };
      if (rs.Ubicacion) { column_config.push( { width: this.calculateColWidth(ubicacion_cell_ch_width) }  );  };



      exportFileEx.push({
      freezePane: {
        rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2
        },
      columns: column_config,
      title: data[0][1],
      rows: rows
      });


      codigo_cell_ch_width = "codigo".length;
      placa_cell_ch_width = "placa".length;
      zona_cell_ch_width = "zona".length;

      limite_velocidad_cell_ch_width = "Límite de Velocidad de Zona".length;

      leve_cell_ch_width = "Leve(1,2)".length;
      grave_cell_ch_width = "Grave(3,5)".length;
      muy_grave_cell_ch_width = "Muy Grave(>=6)".length;
      //---
      duracion_cell_ch_width = "Duracion".length;

      id_conductor_cell_ch_width = "Id Conductor".length;
      conductor_cell_ch_width = "Conductor".length;

      vel_mobileye_cell_ch_width = "Vel.ADAS".length;
      vel_gps_speed_cell_ch_width = "Vel.GPS".length;
      vel_can_cell_ch_width = "Vel.GPS".length;
      satelite_cell_ch_width = "Satélite".length;
      ubicacion_cell_ch_width = "Ubicación".length;

    }
    // //********************************************* excel version 1 *********************************

    // //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      rows.splice(0, this.headerRowSpan);
      rows.push(...this.spaceBetweenTables);
      allRows = allRows.concat(rows);
    }
    // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
        allRows[0].cells![0].colSpan = table_width;

        column_config = [ { width: this.w_item }  ];

        if (rs.Fecha) { column_config.push( { width: this.w_date } );  }
        if (rs.Hora) { column_config.push( { width: this.w_hour } );  }
        if (rs.Codigo) {  column_config.push( { width: this.calculateColWidth(codigo_cell_ch_width) }  );  };
        if (rs.Placa)  {  column_config.push( { width: this.calculateColWidth(placa_cell_ch_width) }  );  };
        if (rs.Zona) { column_config.push( { width: this.calculateColWidth(zona_cell_ch_width) }  );  };

        column_config.push( { width: this.calculateColWidth(limite_velocidad_cell_ch_width) }  );

        if (!this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(limite_velocidad_cell_ch_width) }  );  };

        if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(leve_cell_ch_width) }  );  };
        if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(grave_cell_ch_width) }  );  };
        if (this.chkRiesgo) { column_config.push( { width: this.calculateColWidth(muy_grave_cell_ch_width) }  );  };

        column_config.push( { width: this.w_hour });
        column_config.push( { width: this.w_hour });
        column_config.push( { width: this.w_hour });
        column_config.push( { width: this.calculateColWidth(duracion_cell_ch_width) }  );

        if (rs.IdConductor) { column_config.push( { width: this.calculateColWidth(id_conductor_cell_ch_width) }  );  };
        if (rs.Conductor) { column_config.push( { width: this.calculateColWidth(conductor_cell_ch_width) }  );  };

        if (rs.VelMobileye) { column_config.push( { width: this.calculateColWidth(vel_mobileye_cell_ch_width) }  );  };
        if (rs.VelGPSspeed) { column_config.push( { width: this.calculateColWidth(vel_gps_speed_cell_ch_width) }  );  };
        if (rs.VelCAN) { column_config.push( { width: this.calculateColWidth(vel_can_cell_ch_width) }  );  };
        if (rs.Satelite) { column_config.push( { width: this.calculateColWidth(satelite_cell_ch_width) }  );  };
        if (rs.Ubicacion) { column_config.push( { width: this.calculateColWidth(ubicacion_cell_ch_width) }  );  };




      exportFileEx.push({
        freezePane: {
          rowSplit: this.headerRowSpan
        },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }
    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

      // if(bol_datos_ex){
      //   var workbook = new kendo.ooxml.Workbook({
      //     sheets: exportFileEx
      //   });

      //   kendo.saveAs({
      //     dataURI: workbook.toDataURL(),
      //     fileName: "ReporteExcesosVelocidad.xlsx"
      //   });

      // } else {
      //   alert('No se han encontrado datos para exportar');
      // }

      var aFileParts = '<html><head> <style> *{font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";}</style></head><table style="width:100%;border: 0px solid black;" >';

      for (let index = 0; index < exportFileEx[0].rows.length; index++) {
        const row = exportFileEx[0].rows[index];

        var height_celda:any = row.height;

        // console.log(row.height+" ___ "+row.hasOwnProperty('cells'));
        // console.log(element.cells);
        // console.log(element.hasOwnProperty('cells'));
        aFileParts += '<tr '+
                    'style="height:'+ height_celda *(3/4) +'pt;"'+
                    '>';

        if (row.hasOwnProperty('cells')) {

          // console.log(row['cells']);
          // console.log(row.cells);
          var celdas: any = row.cells;

          for (let j = 0; j < celdas.length; j++) {

            var font_weight = 'normal';
            if ( celdas[j].bold ) {
              font_weight = 'bold';
            }

            aFileParts += '<td '+
                          'colspan="'+celdas[j].colSpan+'" '+
                          'rowspan="'+celdas[j].rowSpan+'" '+
                          'style="font-size:'+ celdas[j].fontSize+
                              '; color:'+ celdas[j].color+
                              '; font-weight:'+ font_weight+
                              '; background-color:'+ celdas[j].background+
                              '; vertical-align: middle;text-align: center;"'+
                              '>';

            if (celdas[j].hasOwnProperty('formula')) {
              var aux = celdas[j].formula.split("maps?q=")[1];
              aux = aux.split("&amp;t=m")[0]; //-16.480746,-71.618448
              //   "HYPERLINK("http://maps.google.com/maps?q=-16.480746,-71.618448&amp;t=m","-16.480746,-71.618448")"
              aFileParts += '<a style="text-decoration: none;" href="http://maps.google.com/maps?q='+aux+'&amp;t=m" target="_blank">'+aux+'</a>'
            } else {
                // const element = array[j];

                if(celdas[j].value === undefined){
                  console.log("--------es indefinido");
                  aFileParts += "";
                } else {
                  aFileParts += celdas[j].value;
                }
            }

            aFileParts += '</td>';

          }
        }
        aFileParts += '</tr>';
      }

      aFileParts += '</table></a></html>';

      var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
      // var nom_inf_html = "ReporteExcesosVelocidad.html";

      if(bol_datos_ex) {

        kendo.saveAs({
          dataURI: oMyBlob,
          fileName: nom_inf_html
        });

      } else {
        this.toastr.error("No se han encontrado datos para exportar");
        /* alert('No se han encontrado datos para exportar'); */
      }


  }

  exportExcelHtmlCombustibleResumen(vrs: number, format: string) {
    var exportFileEx = getFileExportCombustibleResumen(this, vrs);
    //******************************************************************************
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        if ( format == "excel" ) {
            var nom_inf_xls = "ReporteCombustibleResumen.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });

        } else if(format == "html") {
            var nom_inf_html = "ReporteCombustibleResumen.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }
    }

  }

  exportExcelHtmlCombustibleResumenDash(vrs: number, format: string) {
    var exportFileEx = getFileExportCombustibleResumenDash(this, vrs);
    //******************************************************************************
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        if ( format == "excel" ) {
            var nom_inf_xls = "ReporteResumenDash.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });

        } else if(format == "html") {
            var nom_inf_html = "ReporteResumenDash.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }
    }

  }

  showImages: boolean = true; // por defecto activado

  toggleImageColumn() {
    const columnIndex = 10; // índice de la columna Previsualizacion (0-based)
    const table = this.dtElement?.dtInstance; // dtInstance es Promise<DataTables.Api>
    if(table){
      table.then((dt: any) => {
        const col = dt.column(columnIndex);
        col.visible(this.showImages);
      });
    }
  }
  getImage(fecha: string): SafeUrl | undefined {
    return this.imageCache[fecha]?.safeUrl;
  }
  async loadImageFromChecklist(batchSize: number = 5) {
    this.imageChecklistLoadedSubject.next(false); // empezamos en "no cargado"
    const rows = this.data.data[0];
    const total = rows.length;
    let processed = 0;
    let index = 0;

    while (index < total) {
      const batch = rows.slice(index, index + batchSize);

      await Promise.all(
        batch.map((row: any) => {
          // if (row.linkImage && row.linkImage.length >= 4) {
          // }
          return this.loadImageToCache(row.linkImage, row.date_event).then(() => {
            processed++;
            this.progressMessage = `Procesando imágenes... ${processed}/${total}`;
          });
          // processed++;
          // this.progressMessage = `Procesando imágenes... ${processed}/${total}`;
          // return Promise.resolve();
        })
      );

      index += batchSize;
    }

    this.progressMessage = `Completado (${processed}/${total})`;
    this.imageChecklistLoadedSubject.next(true); // ✅ listo
  }

  async loadImageToCache(url: string, fecha: string): Promise<void> {
    // Inicializamos el estado como "cargando"
    this.imageCache[fecha] = {
      blob: null,
      objectUrl: '',
      safeUrl: '',
      isLoading: true,
      hasError: false
    };

    if(url && url.length <= 4){
      this.imageCache[fecha] = {
        blob: null,
        objectUrl: '',
        safeUrl: '',
        isLoading: false,
        hasError: true
      };
      return;
    }
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();

      // Crear un solo Blob URL temporal
      const blobUrl = URL.createObjectURL(blob);

      // Guardar en caché como éxito
      this.imageCache[fecha] = {
        blob: blob,
        objectUrl: blobUrl,
        safeUrl: this.sanitizer.bypassSecurityTrustUrl(blobUrl),
        isLoading: false,
        hasError: false
      };

    } catch (error) {
      console.error(`Error cargando imagen de ${url}`, error);

      // Guardar en caché como error
      this.imageCache[fecha] = {
        blob: null,
        objectUrl: '',
        safeUrl: '',
        isLoading: false,
        hasError: true
      };
    }
  }

  // Función para liberar memoria
  revokeImage(fecha: string) {
    const cacheEntry = this.imageCache[fecha];
    if (cacheEntry?.objectUrl) {
      URL.revokeObjectURL(cacheEntry.objectUrl);
    }
    delete this.imageCache[fecha];
  }

  // Función para limpiar toda la cache
  clearImageCache() {
    for (const fecha of Object.keys(this.imageCache)) {
      this.revokeImage(fecha);
    }
  }
  private async blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async getImageBase64(fecha: string): Promise<string | null> {
    const entry = this.imageCache[fecha];
    
    // Validar si existe y está lista
    if (!entry || entry.isLoading || entry.hasError || !entry.blob) {
      return null; // no disponible
    }

    // Convertir a base64
    const base64 = await this.blobToBase64(entry.blob);

    // devolver solo el string sin el prefijo data:image/png;base64,
    return base64.split(",")[1];
  }
  async addImageFromCache(
    workbook: ExcelJS.Workbook,
    sheet: ExcelJS.Worksheet,
    fecha: string,
    row: number,
    col: number,
    maxWidth = 50,
    maxHeight = 50
  ) {
    const entry = this.imageCache[fecha];
    if (!entry || entry.isLoading || entry.hasError || !entry.blob) {
      console.warn(`Imagen no disponible para ${fecha}`);
      return;
    }

    // Convertir Blob a base64
    const base64 = await this.getImageBase64(fecha);
    if (!base64) return;

    // Intentar detectar extensión a partir del mimeType del blob
    const mime = entry.blob.type; // ej. "image/png"
    let extension: 'png' | 'jpeg' | 'gif' = 'png';
    if (mime.includes('jpeg') || mime.includes('jpg')) extension = 'jpeg';
    if (mime.includes('gif')) extension = 'gif';

    const imageId = workbook.addImage({ base64, extension });

    // Obtener altura actual de la fila
    const rowObj = sheet.getRow(row);
    const rowHeight = rowObj.height || 15;

    // Ajustar altura de la fila si la imagen es más alta
    const factor = 0.75; // conversión px -> puntos
    const imageHeightInPoints = maxHeight * factor;

    if (imageHeightInPoints > rowHeight) {
      rowObj.height = imageHeightInPoints;
    }

    // Escalar imagen si la fila es más pequeña que la altura deseada
    const finalHeight = rowObj.height / factor;
    const scaleFactor = finalHeight / maxHeight;

    sheet.addImage(imageId, {
      tl: { col: col - 1, row: row - 1 },
      ext: { width: maxWidth * scaleFactor, height: maxHeight * scaleFactor }
    });
  }

  progressMessage = 'Procesando checklist...'; // mensaje inicial

  async exportChecklistExcelBrowserWithImage(data: any[]) {
    this.spinner.show("exportReponnerSpinner")
    if (!this.imageChecklistLoadedSubject.getValue()) {
      // esperar hasta que sea true
      await this.imageChecklistLoaded$
        .pipe(
          filter(loaded => loaded),
          take(1)
        )
        .toPromise();
    }

    this.progressMessage = "Generando Excel...";

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Export');

    // TITULO DEL REPORTE
    const cellTitle = sheet.getCell('A1'); // solo la celda fusionada
    cellTitle.value = 'REPORTE DE CHECKLIST';
    cellTitle.font = { size: 16, bold: true, color: { argb: '003366' } };
    cellTitle.alignment = { horizontal: 'center', vertical: 'middle' };
    sheet.mergeCells('A1:N1');
    // Simular "padding" vertical
    sheet.getRow(1).height = 30; // ajusta el valor según necesites


    // SUBTITULO PERIODO
    sheet.addRow(['Periodo']); // Fila 2
    sheet.mergeCells('A2:N2');
    const cellPeriodo = sheet.getCell('A2'); // la celda superior izquierda de la fusión
    cellPeriodo.font = { size: 12, color: { argb: 'FFFFFFFF' } };
    cellPeriodo.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'A6A6A6' } };
    cellPeriodo.alignment = { horizontal: 'center', vertical: 'middle' };
    sheet.getRow(2).height = 20; // ajusta el valor según necesites

    // MOSTRAR RANGO / PERIODO
    sheet.addRow([`${this.period}`]); // Fila 3
    sheet.mergeCells('A3:N3');
    sheet.getRow(3).height = 20; // ajusta el valor según necesites

    const cell = sheet.getCell('A3'); // celda superior izquierda de la fusión
    cell.font = { size: 12 };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EEECE1' } };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };


    // --- Header de tabla (fila 5 y 6) ---
    const headers = [
      { label: 'Item', span: 1 },
      { label: 'Código Interno', span: 1 },
      { label: 'Placa', span: 1 },
      { label: 'Datos del evento', span: 4, children: ['Duración', 'Evento', 'Fecha', 'Conductor'] },
      { label: 'Datos del checklist', span: 5, children: ['Fecha','Hora', 'Tiempo de diferencia', 'Código Conductor', 'Conductor'] },
      { label: 'Previsualización', span: 1 },
      { label: 'Imagen (Link)', span: 1 },
      { label: 'Video (Link)', span: 1 },
    ];

    // Generar dinámicamente las filas 5 y 6
    
    let colIndex = 1;
    headers.forEach(h => {
      if (h.span > 1 && h.children) {
        // Merge fila 5
        sheet.mergeCells(5, colIndex, 5, colIndex + h.span - 1);
        const parentCell = sheet.getCell(5, colIndex);
        parentCell.value = h.label;

        // Subcolumnas fila 6
        h.children.forEach((child, i) => {
          const childCell = sheet.getCell(6, colIndex + i);
          childCell.value = child;

          // 🎨 Estilo diferente solo para subcolumnas
          childCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '003366' } }; // azul claro
          childCell.font = { bold: false, color: { argb: 'FFFFFF' } };
          childCell.alignment = { 
            horizontal: 'center', 
            vertical: 'middle' 
          };
          childCell.border = {
            top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
            left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
            bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
            right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
          };
        });

        // 🎨 Estilo diferente para el padre
        parentCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '003366' } }; // morado
        parentCell.font = { bold: true, color: { argb: 'FFFFFF' } };
        parentCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        parentCell.border = {
          top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
        };

      } else {
        // Columnas normales
        sheet.mergeCells(5, colIndex, 6, colIndex);
        const cell = sheet.getCell(5, colIndex);
        cell.value = h.label;
      }
      colIndex += h.span;
    });

    // Estilo general para todas las cabeceras fila 5 y 6
    [5, 6].forEach(rn => {
      sheet.getRow(rn).eachCell(cell => {
        if (!cell.fill) { // solo si no tiene estilo propio
          cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '003366' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
          cell.border = {
            top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
            left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
            bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
            right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
          };
        }
      });
    });

    // --- Filas de datos (sin merges de columnas generales) ---
    for (let i = 0; i < data.length; i++) {
      const row = data[i];

      const countChecklist = row.arrayChecklist?.length || 1;

      for (let j = 0; j < countChecklist; j++) {
        const checklistItem = row.arrayChecklist?.[j] || {};

        let fecha = "-";
        let hora = "-";
        let tiempo = "-";
        let codigo = "-";
        let conductor = "-";

        if (checklistItem.date_checklist) {
          const partes = checklistItem.date_checklist.split(" ");
          fecha = partes[0];
          hora = partes[1] || "-";
        }
        tiempo = checklistItem.string_timing || "-";
        codigo = checklistItem.cod_driver || "-";
        conductor = checklistItem.name_driver || "-";

        const dataRow = sheet.addRow([
          i + 1,           // Item
          row.cod_interno, // Código interno
          row.var_plate,   // Placa

          // Detalles del evento
          row.duration,
          row.name_event,
          row.date_event,
          row.conductorEvent,

          // Detalles del checklist
          fecha,
          hora,
          tiempo,
          codigo,
          conductor,

          // Previsualización
          'No se pudo cargar la imagen',

          // Links
          row.linkImage && row.linkImage !== '-' ? { text: 'Imagen', hyperlink: row.linkImage } : 'Sin medios disponibles',
          row.linkVideo && row.linkVideo !== '-' ? { text: 'Video', hyperlink: row.linkVideo } : 'Sin medios disponibles',
        ]);

        // Resaltar si conductor coincide
        if (conductor != "-" && conductor === row.conductorEvent) {
          for (let col = 8; col <= 12; col++) {
            const cell = dataRow.getCell(col);
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD5F5D5' } };
            cell.font = { bold: true, color: { argb: 'FF000000' } };
            cell.border = {
              top: { style: 'thin', color: { argb: 'FFBFBFBF' } },
              left: { style: 'thin', color: { argb: 'FFBFBFBF' } },
              bottom: { style: 'thin', color: { argb: 'FFBFBFBF' } },
              right: { style: 'thin', color: { argb: 'FFBFBFBF' } }
            };
          }
        }

        // Alineación general
        dataRow.eachCell(cell => {
          cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        });

        // Imagen para cada fila si existe
        if (row.linkImage && row.linkImage !== '-') {
          await this.addImageFromCache(workbook, sheet, row.date_event, dataRow.number, 13, 180, 180);
        }
      }
    }



    // --- Ajustar ancho de columnas ---
    const columnWidths = [
      8,   // Código
      15,  // Placa
      15,  // Duración
      30,  // Evento
      22,  // Fecha evento
      25,  // Conductor evento
      20,  // Hora checklist
      25,  // Tiempo diferencia
      18,  // Código conductor checklist
      25,  // Conductor checklist
      30,  // Previsualización (imagen)
      22,  // Imagen (link descarga)
      22   // Video (link descarga)
    ];

    sheet.columns.forEach((col, i) => {
      col.width = columnWidths[i] || 15;
    });

    // --- Descargar archivo ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'ReporteChecklist_'+this.period+'.xlsx');
    this.spinner.hide("exportReponnerSpinner");
  }

  async exportChecklistExcelBrowser(data: any[]) {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Export');

    const cellTitle = sheet.getCell('A1'); // solo la celda fusionada
    cellTitle.value = 'REPORTE DE CHECKLIST';
    cellTitle.font = { size: 16, bold: true, color: { argb: '003366' } };
    cellTitle.alignment = { horizontal: 'center', vertical: 'middle' };
    sheet.mergeCells('A1:L1');
    // Simular "padding" vertical
    sheet.getRow(1).height = 30; // ajusta el valor según necesites


    sheet.addRow(['Periodo']); // Fila 2
    sheet.mergeCells('A2:L2');
    const cellPeriodo = sheet.getCell('A2'); // la celda superior izquierda de la fusión
    cellPeriodo.font = { size: 12, color: { argb: 'FFFFFFFF' } };
    cellPeriodo.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'A6A6A6' } };
    cellPeriodo.alignment = { horizontal: 'center', vertical: 'middle' };
    sheet.getRow(2).height = 20; // ajusta el valor según necesites

    sheet.addRow([`${this.period}`]); // Fila 3
    sheet.mergeCells('A3:L3');
    sheet.getRow(3).height = 20; // ajusta el valor según necesites

    const cell = sheet.getCell('A3'); // celda superior izquierda de la fusión
    cell.font = { size: 12 };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EEECE1' } };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };


    // --- Encabezado de la tabla (Fila 5) ---
    const headerRowIndex = 5;
    const headerRow = sheet.addRow([
      'Item', 'Código Interno', 'Placa', 'Evento', 'Fecha del Evento', 'Conductor del Evento',
      'Fecha Checklist', 'Código Conductor', 'Conductor', 'Checklist', 'Imagen', 'Video'
    ]);

    headerRow.eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '003366' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } }
      };
    });

    // --- Filas de datos ---
    data.forEach((row, i) => {
      const dataRow = sheet.addRow([
        i + 1,
        row.cod_interno,
        row.var_plate,
        row.name_event,
        row.date_event,
        row.conductorEvent,
        row.date_checklist,
        row.cod_driver,
        row.name_driver,
        row.checklist === 'COMPLETADO'
          ? `COMPLETADO (${row.relative_timing === 'BEFORE' ? 'ANTES' : row.relative_timing === 'AFTER' ? 'DESPUÉS' : 'EN EL MOMENTO'})`
          : 'NO COMPLETADO',
        row.linkImage && row.linkImage !== '-' 
          ? { text: 'Imagen', hyperlink: row.linkImage } 
          : '',
        row.linkVideo && row.linkVideo !== '-' 
          ? { text: 'Video', hyperlink: row.linkVideo } 
          : ''
      ]);
      dataRow.eachCell(cell => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    });

    // --- Ajustar ancho de columnas ---
    const columnWidths = [6, 15, 12, 40, 38, 35, 25, 20, 40, 22, 25, 25];
    sheet.columns.forEach((col, i) => {
      col.width = columnWidths[i] || 15;
    });

    // --- Descargar archivo ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'ReporteChecklist.xlsx');
  }
  exportChecklistPDF() {
    

  }
  exportChecklistExcel(){
    this.exportChecklistExcelBrowser(this.data.data[0]);
  }
  exportChecklistExcelWithImages(){
    this.exportChecklistExcelBrowserWithImage(this.data.data[0]);
  }

  exportExcelHtmlOperatividadEquipos(vrs: number, format: string) {
    var exportFileEx = getFileExportOperatividadEquipos(this, vrs);
    //******************************************************************************
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        if ( format == "excel" ) {
            var nom_inf_xls = "ReporteOperatividadEquipos.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });

        } else if(format == "html") {
            var nom_inf_html = "ReporteOperatividadEquipos.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }
    }

  }

  exportExcelEstadoTransmision(vrs: number) {
    /* vm.dateHour() y datee; //Obtiene el chkDateHour para separar las columnas de fecha y hora*/

    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[] = [];

    var estado_cell_ch_width = "Estado".length;

    var duracion_cell_ch_width = "Duracion".length;
    var pc_cell_ch_width = "Punto cercano".length;
    var geocerca_cell_ch_width = "Referencia".length;
    var referencia_cell_ch_width = "Referencia".length;
    var ubicacion_cell_ch_width = "Referencia".length;


    var table_width = this.chkDuracion? (1 + (this.chkDateHour? 4:2) + 8): (2 + (this.chkDateHour? 2:1) + 4);
    var vehiculo_width = this.chkDuracion? ((this.chkDateHour? 6:4)): (this.chkDateHour? 4:3);

    var nom_inf = this.report_data.rep_title; //"REPORTE DE EXCESOS DE VELOCIDAD";

    var allRows: AllRows[] = [
        {
          cells: [
            { value: nom_inf, ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight,
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];



    this.sortedData.forEach((table_data: any) => {
      if(table_data[1].length > 0){
        column_config = [];
        var p_cercano_width = 155;
        var z_cercana_width = 165;

        bol_datos_ex = true;

        var nom_vehi = table_data[0][1];
        /* if (vm.optionR() == 28) {
            vm.period = data[3][10];
            ruta  = "RUTA : " + data[3][11];

            if (vrs == 1) {
                cc = cc + 1;
                nom_vehi = nom_vehi + " - " +cc;
            }
        } */

        /* Table Header */

        var rows: AllRows[] = [
          {
            cells: [
              { value: nom_inf, ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight,
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              { value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO",  ...this.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderHeight,
          },
          {
            cells: [
              { value: table_data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width, rowSpan: this.subHeaderContentRowSpan },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width, rowSpan: this.subHeaderContentRowSpan },
            ],
            height: this.subHeaderContentHeight,
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];

        /* Table Body */

        var cellsCampos = [];

        //----------- CABECERA ------------
          cellsCampos.push({ value: "Ítem", ...this.colHeaderConfig });
          if (this.chkDateHour) {
            cellsCampos.push({ value: "Fecha Inicio", ...this.colHeaderConfig });
            cellsCampos.push({ value: "Hora Inicio", ...this.colHeaderConfig });
            cellsCampos.push({ value: "Fecha Fin", ...this.colHeaderConfig });
            cellsCampos.push({ value: "Hora Fin", ...this.colHeaderConfig });
          } else {
            cellsCampos.push({ value: "Fecha/Hora de Inicio", ...this.colHeaderConfig });
            cellsCampos.push({ value: "Fecha/Hora de Fin", ...this.colHeaderConfig });
          }

          cellsCampos.push({ value: "Duración", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Punto Cercano", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Geocerca", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Referencia", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Ubicación", ...this.colHeaderConfig });


        rows.push({
          cells: cellsCampos,
          height: this.colsHeaderHeight,
        });

        //----------- CONTENIDO / FILAS ------------


        table_data[1].forEach((item: { latitud: number; longitud: number; nombre: any; fecha_ini: any; fecha_fin: any; punto_cercano: any; estado: any; zona: any; reference: any; duracion: string; }, index: number) => {
          var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
          var cellsCuerpo = [];

          estado_cell_ch_width = Math.max(estado_cell_ch_width, (item.estado??'').toString().length);
          duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion??'').toString().length);
          pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.punto_cercano??'').toString().length);
          geocerca_cell_ch_width = Math.max(geocerca_cell_ch_width, (item.zona??'').toString().length);
          referencia_cell_ch_width = Math.max(geocerca_cell_ch_width, (item.reference??'').toString().length);
          ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);




          cellsCuerpo.push({ value: index + 1, ...this.bodyRowsConfig });
          cellsCuerpo.push({ value: item.estado, ...this.bodyRowsConfig });

          if (this.chkDateHour) {
            cellsCuerpo.push({ value: this.isChe(item.fecha_ini), format: "yyyy/mm/dd", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: this.isChs(item.fecha_ini), format: "hh:mm:ss", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: this.isChe(item.fecha_fin), format: "yyyy/mm/dd", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: this.isChs(item.fecha_fin), format: "hh:mm:ss", ...this.bodyRowsConfig });
          } else {
            cellsCuerpo.push({ value: this.isChe(item.fecha_ini), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: this.isChe(item.fecha_fin), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig });
          }
          cellsCuerpo.push({ value: item.duracion, ...this.bodyRowsConfig });
          cellsCuerpo.push({ value: item.punto_cercano, ...this.bodyRowsConfig });
          cellsCuerpo.push({ value: item.zona, ...this.bodyRowsConfig });
          cellsCuerpo.push({ value: item.reference, ...this.bodyRowsConfig });
          // cellsCuerpo.push({ value: ubicacion, ...this.bodyRowsConfig });
          cellsCuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...this.bodyRowsConfig });


          rows.push({
            cells:cellsCuerpo,
            height: this.bodyRowsHeight,
          });
        });



        // //********************************************* excel version 2 *********************************
        if ( vrs == 2 ) {
          rows.splice(0, this.headerRowSpan);
          rows.push(...this.spaceBetweenTables);
          allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************

        // //********************************************* excel version 1 *********************************

        if( vrs == 1 ){

            column_config = [
              { width: this.w_item },
              { width: this.calculateColWidth(estado_cell_ch_width) },

            ];
            if(this.chkDateHour){
              column_config.push(
                { width: this.w_date_ini_fin },
                { width: this.w_hour_ini_fin },
                { width: this.w_date_ini_fin },
                { width: this.w_hour_ini_fin },
              )
            } else {
              column_config.push(
                { width: this.w_date_and_hour },
                { width: this.w_date_and_hour },
              )
            }
            column_config.push(
              { width: this.calculateColWidth(duracion_cell_ch_width) },
              { width: this.calculateColWidth(pc_cell_ch_width) },
              { width: this.calculateColWidth(geocerca_cell_ch_width) },
              { width: this.calculateColWidth(referencia_cell_ch_width) },
              { width: this.calculateColWidth(ubicacion_cell_ch_width) },
            )
          /* Fin Ancho de Columnas */

          exportFileEx.push({
            freezePane: {
                rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2
              },
            columns: column_config,
            title: nom_vehi,
            rows: rows
          });

          estado_cell_ch_width = "Estado".length;

          duracion_cell_ch_width = "Duracion".length;
          pc_cell_ch_width = "Punto cercano".length;
          geocerca_cell_ch_width = "Referencia".length;
          referencia_cell_ch_width = "Referencia".length;
          ubicacion_cell_ch_width = "Referencia".length;

        }
        // //********************************************* excel version 1 *********************************

      } // if si hay datos del vehiculo
    });

    //NOTA: width * 1.28 (aprox) = Ancho de columna en excel

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;


      column_config = [
        { width: this.w_item },
        { width: this.calculateColWidth(estado_cell_ch_width) },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date_ini_fin },
          { width: this.w_hour_ini_fin },
          { width: this.w_date_ini_fin },
          { width: this.w_hour_ini_fin },
        )
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
          { width: this.w_date_and_hour },
        )
      }
      column_config.push(
        { width: this.calculateColWidth(duracion_cell_ch_width) },
        { width: this.calculateColWidth(pc_cell_ch_width) },
        { width: this.calculateColWidth(geocerca_cell_ch_width) },
        { width: this.calculateColWidth(referencia_cell_ch_width) },
        { width: this.calculateColWidth(ubicacion_cell_ch_width) },
      )


      exportFileEx.push({
        freezePane: {
            rowSplit: this.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });

    }
    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    var nom_inf_xls = "ReporteEstadoTransmision.xlsx";
    /* if (vm.optionUser() == 445 ) {
      var nom_inf_xls = "ReporteLuminarias.xlsx";
    } */

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: nom_inf_xls
      });

    } else {
      this.toastr.error("No se han encontrado datos para exportar");
      /* alert('No se han encontrado datos para exportar'); */
    }
  }



  exportExcelHtmlEstadoTransmisionEventos(vrs: number, format: string) {
    var exportFileEx = getFileExportEstadoTransmisionEventos(this, vrs);
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        //********************************************* excel version 2 *********************************
        if ( format == "excel" ) {
            var nom_inf_xls = "ReporteEstadoTransmisionEventos.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });
        } else if(format == "html") {
            var nom_inf_html = "ReporteEstadoTransmisionEventos.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }

    }
  }

  exportHtmlEstadoTransmision(vrs: number=2) {
    /* vm.dateHour() y datee; //Obtiene el chkDateHour para separar las columnas de fecha y hora*/

    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[] = [];

    var estado_cell_ch_width = "Estado".length;

    var duracion_cell_ch_width = "Duracion".length;
    var pc_cell_ch_width = "Punto cercano".length;
    var geocerca_cell_ch_width = "Referencia".length;
    var referencia_cell_ch_width = "Referencia".length;
    var ubicacion_cell_ch_width = "Referencia".length;


    var table_width = this.chkDuracion? (1 + (this.chkDateHour? 4:2) + 8): (2 + (this.chkDateHour? 2:1) + 4);
    var vehiculo_width = this.chkDuracion? ((this.chkDateHour? 6:4)): (this.chkDateHour? 4:3);

    var nom_inf = this.report_data.rep_title; //"REPORTE DE EXCESOS DE VELOCIDAD";

    var allRows: AllRows[] = [
        {
          cells: [
            { value: nom_inf, ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight,
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];

    this.sortedData.forEach((table_data: any) => {
      if(table_data[1].length > 0){
        column_config = [];
        var p_cercano_width = 155;
        var z_cercana_width = 165;

        bol_datos_ex = true;

        var nom_vehi = table_data[0][1];
        /* if (vm.optionR() == 28) {
            vm.period = data[3][10];
            ruta  = "RUTA : " + data[3][11];

            if (vrs == 1) {
                cc = cc + 1;
                nom_vehi = nom_vehi + " - " +cc;
            }
        } */

        /* Table Header */

        var rows: AllRows[] = [
          {
            cells: [
              { value: nom_inf, ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight,
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              { value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO",  ...this.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: this.subHeaderHeight,
          },
          {
            cells: [
              { value: table_data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width, rowSpan: this.subHeaderContentRowSpan },
              { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width, rowSpan: this.subHeaderContentRowSpan },
            ],
            height: this.subHeaderContentHeight,
          },
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];

        /* Table Body */

        var cellsCampos = [];

        //----------- CABECERA ------------
          cellsCampos.push({ value: "Ítem", ...this.colHeaderConfig });
          if (this.chkDateHour) {
            cellsCampos.push({ value: "Fecha Inicio", ...this.colHeaderConfig });
            cellsCampos.push({ value: "Hora Inicio", ...this.colHeaderConfig });
            cellsCampos.push({ value: "Fecha Fin", ...this.colHeaderConfig });
            cellsCampos.push({ value: "Hora Fin", ...this.colHeaderConfig });
          } else {
            cellsCampos.push({ value: "Fecha/Hora de Inicio", ...this.colHeaderConfig });
            cellsCampos.push({ value: "Fecha/Hora de Fin", ...this.colHeaderConfig });
          }

          cellsCampos.push({ value: "Duración", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Punto Cercano", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Geocerca", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Referencia", ...this.colHeaderConfig });
          cellsCampos.push({ value: "Ubicación", ...this.colHeaderConfig });


        rows.push({
          cells: cellsCampos,
          height: this.colsHeaderHeight,
        });

        //----------- CONTENIDO / FILAS ------------


        table_data[1].forEach((item: { latitud: number; longitud: number; nombre: any; fecha_ini: any; fecha_fin: any; punto_cercano: any; estado: any; zona: any; reference: any; duracion: string; }, index: number) => {
          var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
          var cellsCuerpo = [];

          estado_cell_ch_width = Math.max(estado_cell_ch_width, (item.estado??'').toString().length);
          duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion??'').toString().length);
          pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.punto_cercano??'').toString().length);
          geocerca_cell_ch_width = Math.max(geocerca_cell_ch_width, (item.zona??'').toString().length);
          referencia_cell_ch_width = Math.max(geocerca_cell_ch_width, (item.reference??'').toString().length);
          ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);


          cellsCuerpo.push({ value: index + 1, ...this.bodyRowsConfig });
          cellsCuerpo.push({ value: item.estado, ...this.bodyRowsConfig });

          if (this.chkDateHour) {
            cellsCuerpo.push({ value: this.isChe(item.fecha_ini), format: "yyyy/mm/dd", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: this.isChs(item.fecha_ini), format: "hh:mm:ss", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: this.isChe(item.fecha_fin), format: "yyyy/mm/dd", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: this.isChs(item.fecha_fin), format: "hh:mm:ss", ...this.bodyRowsConfig });
          } else {
            cellsCuerpo.push({ value: this.isChe(item.fecha_ini), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig });
            cellsCuerpo.push({ value: this.isChe(item.fecha_fin), format: "yyyy/mm/dd hh:mm:ss", ...this.bodyRowsConfig });
          }
          cellsCuerpo.push({ value: item.duracion, ...this.bodyRowsConfig });
          cellsCuerpo.push({ value: item.punto_cercano, ...this.bodyRowsConfig });
          cellsCuerpo.push({ value: item.zona, ...this.bodyRowsConfig });
          cellsCuerpo.push({ value: item.reference, ...this.bodyRowsConfig });
          // cellsCuerpo.push({ value: ubicacion, ...this.bodyRowsConfig });
          cellsCuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...this.bodyRowsConfig });

          rows.push({
            cells:cellsCuerpo,
            height: this.bodyRowsHeight,
          });
        });

        // //********************************************* excel version 2 *********************************
        if ( vrs == 2 ) {
          rows.splice(0, this.headerRowSpan);
          rows.push(...this.spaceBetweenTables);
          allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************

        // //********************************************* excel version 1 *********************************

        if( vrs == 1 ){

            column_config = [
              { width: this.w_item },
              { width: this.calculateColWidth(estado_cell_ch_width) },

            ];
            if(this.chkDateHour){
              column_config.push(
                { width: this.w_date_ini_fin },
                { width: this.w_hour_ini_fin },
                { width: this.w_date_ini_fin },
                { width: this.w_hour_ini_fin },
              )
            } else {
              column_config.push(
                { width: this.w_date_and_hour },
                { width: this.w_date_and_hour },
              )
            }
            column_config.push(
              { width: this.calculateColWidth(duracion_cell_ch_width) },
              { width: this.calculateColWidth(pc_cell_ch_width) },
              { width: this.calculateColWidth(geocerca_cell_ch_width) },
              { width: this.calculateColWidth(referencia_cell_ch_width) },
              { width: this.calculateColWidth(ubicacion_cell_ch_width) },
            )
          /* Fin Ancho de Columnas */

          exportFileEx.push({
            freezePane: {
                rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2
              },
            columns: column_config,
            title: nom_vehi,
            rows: rows
          });

          estado_cell_ch_width = "Estado".length;

          duracion_cell_ch_width = "Duracion".length;
          pc_cell_ch_width = "Punto cercano".length;
          geocerca_cell_ch_width = "Referencia".length;
          referencia_cell_ch_width = "Referencia".length;
          ubicacion_cell_ch_width = "Referencia".length;

        }
        // //********************************************* excel version 1 *********************************

      } // if si hay datos del vehiculo
    });

    //NOTA: width * 1.28 (aprox) = Ancho de columna en excel

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;


      column_config = [
        { width: this.w_item },
        { width: this.calculateColWidth(estado_cell_ch_width) },
      ];
      if(this.chkDateHour){
        column_config.push(
          { width: this.w_date_ini_fin },
          { width: this.w_hour_ini_fin },
          { width: this.w_date_ini_fin },
          { width: this.w_hour_ini_fin },
        )
      } else {
        column_config.push(
          { width: this.w_date_and_hour },
          { width: this.w_date_and_hour },
        )
      }
      column_config.push(
        { width: this.calculateColWidth(duracion_cell_ch_width) },
        { width: this.calculateColWidth(pc_cell_ch_width) },
        { width: this.calculateColWidth(geocerca_cell_ch_width) },
        { width: this.calculateColWidth(referencia_cell_ch_width) },
        { width: this.calculateColWidth(ubicacion_cell_ch_width) },
      )


      exportFileEx.push({
        freezePane: {
            rowSplit: this.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });

    }
    //********************************************* excel version 2 *********************************

    // console.log(exportFileEx);

    // var nom_inf_xls = "ReporteEstadoTransmision.xlsx";
    // /* if (vm.optionUser() == 445 ) {
    //   var nom_inf_xls = "ReporteLuminarias.xlsx";
    // } */

    // if(bol_datos_ex){
    //   var workbook = new kendo.ooxml.Workbook({
    //     sheets: exportFileEx
    //   });

    //   kendo.saveAs({
    //     dataURI: workbook.toDataURL(),
    //     fileName: nom_inf_xls
    //   });

    // } else {
    //   this.toastr.error("No se han encontrado datos para exportar");
    //   /* alert('No se han encontrado datos para exportar'); */
    // }


    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);


    var aFileParts = '<html><head> <style> *{font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";}</style></head><table style="width:100%;border: 0px solid black;" >';

    for (let index = 0; index < exportFileEx[0].rows.length; index++) {
      const row = exportFileEx[0].rows[index];

      var height_celda:any = row.height;

      // console.log(row.height+" ___ "+row.hasOwnProperty('cells'));
      // console.log(element.cells);
      // console.log(element.hasOwnProperty('cells'));
      aFileParts += '<tr '+
                  'style="height:'+ height_celda *(3/4) +'pt;"'+
                  '>';

      if (row.hasOwnProperty('cells')) {

        // console.log(row['cells']);
        // console.log(row.cells);
        var celdas: any = row.cells;

        for (let j = 0; j < celdas.length; j++) {

          var font_weight = 'normal';
          if ( celdas[j].bold ) {
            font_weight = 'bold';
          }

          aFileParts += '<td '+
                        'colspan="'+celdas[j].colSpan+'" '+
                        'rowspan="'+celdas[j].rowSpan+'" '+
                        'style="font-size:'+ celdas[j].fontSize+
                            '; color:'+ celdas[j].color+
                            '; font-weight:'+ font_weight+
                            '; background-color:'+ celdas[j].background+
                            '; vertical-align: middle;text-align: center;"'+
                            '>';

          if (celdas[j].hasOwnProperty('formula')) {
            var aux = celdas[j].formula.split("maps?q=")[1];
            aux = aux.split("&amp;t=m")[0]; //-16.480746,-71.618448
            //   "HYPERLINK("http://maps.google.com/maps?q=-16.480746,-71.618448&amp;t=m","-16.480746,-71.618448")"
            aFileParts += '<a style="text-decoration: none;" href="http://maps.google.com/maps?q='+aux+'&amp;t=m" target="_blank">'+aux+'</a>'
          } else {
              // const element = array[j];
              aFileParts += celdas[j].value;
          }

          aFileParts += '</td>';

        }
      }
      aFileParts += '</tr>';
    }

    aFileParts += '</table></a></html>';

    var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
    var nom_inf_html = "ReporteEstadoTransmision.html";


    if(bol_datos_ex){
      // var workbook = new kendo.ooxml.Workbook({
      //   sheets: exportFileEx
      // });

      // kendo.saveAs({
      //   dataURI: workbook.toDataURL(),
      //   fileName: nom_inf_xls
      // });

      kendo.saveAs({
        dataURI: oMyBlob,
        fileName: nom_inf_html
      });


    } else {
      this.toastr.error("No se han encontrado datos para exportar");
      /* alert('No se han encontrado datos para exportar'); */
    }
  }


  exportExcelHtmlReporteResumenPorDia(vrs: number, format: string) {
    var exportFileEx = getFileExportResumenPorDia(this, vrs);
    //********************************************* excel version 2 *********************************
    if (exportFileEx.length == 0) {
        this.toastr.error("No se han encontrado datos para exportar");
    } else {
        //********************************************* excel version 2 *********************************
        if ( format == "excel" ) {
            var nom_inf_xls = "ReporteResumenPorDia.xlsx";
            console.log(nom_inf_xls);
            console.log("export -> Excel");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var workbook = new kendo.ooxml.Workbook({
              sheets: exportFileEx
            });
            kendo.saveAs({
              dataURI: workbook.toDataURL(),
              fileName: nom_inf_xls
            });

        } else if(format == "html") {
            var nom_inf_html = "ReporteResumenPorDia.html";
            console.log(nom_inf_html);
            console.log("export -> Html");
            console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
            console.log(exportFileEx);

            var aFileParts = getReportTextHtml(exportFileEx);
            var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
            kendo.saveAs({
              dataURI: oMyBlob,
              fileName: nom_inf_html
            });
        }
    }
  }

  
  exportExcelHtmlReporteMonitoreoCantidadEventosUnidad(vrs: number, format: string) {
      var exportFileEx = getFileExportMonitoreoCantidadEventosUnidad(this, vrs);
      //********************************************* excel version 2 *********************************
      if (exportFileEx.length == 0) {
          this.toastr.error("No se han encontrado datos para exportar");
      } else {
          //********************************************* excel version 2 *********************************
          if ( format == "excel" ) {
              var nom_inf_xls = "ReporteCantidadDeEventos.xlsx";
              console.log(nom_inf_xls);
              console.log("export -> Excel");
              console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
              console.log(exportFileEx);

              var workbook = new kendo.ooxml.Workbook({
                sheets: exportFileEx
              });
              kendo.saveAs({
                dataURI: workbook.toDataURL(),
                fileName: nom_inf_xls
              });

          } else if(format == "html") {
              var nom_inf_html = "ReporteCantidadDeEventos.html";
              console.log(nom_inf_html);
              console.log("export -> Html");
              console.log(vrs == 1 ? "export SEPARADO" : "export UNIDO") ;
              console.log(exportFileEx);

              var aFileParts = getReportTextHtml(exportFileEx);
              var oMyBlob = new Blob([aFileParts], { type: "text/html;charset=utf-8" });
              kendo.saveAs({
                dataURI: oMyBlob,
                fileName: nom_inf_html
              });
          }
      }
  }



  exportExcelBOLIVIA(vrs: number) {
    //vm.dateHour();
    console.log("----------------exportExcelBOLIVIA");
    //======================== CONFIGURACION ========================
    var ratio = 4/3;

    var ratioH = 100/86;

    // var colorH = {
    //   color: '#000', //this.colsHeaderTextColor,
    //   background: '#ffff00', //this.colsHeaderBackground,
    // };

    var arrColor = [
        {color: '#000', background: '#008000'}, //verde
        {color: '#000', background: '#ffff00'}, //amarillo
        {color: '#000', background: '#ff0000'}, //rojo
        {color: '', background: ''}, {color: '', background: ''},
        {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''},
        {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''},
        {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''},
        {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''},
        {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''},
        {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''}, {color: '', background: ''},
        {color: '#FFF', background: '#000080'}, //azul
        {color: '#000', background: '#CCFFFF'}, //agua verde
      ];

    var headerCellConfig = {
      bold: true, //this.headerBold,
      color: 'FFF',//this.headerTextColor,
      background: '#000080', //this.headerBackground,
      vAlign: "center",
      hAlign: "center",
      fontSize: 12,//this.t1,
      rowSpan: 1, //this.headerRowSpan,
      wrap: true,
      fontFamily: "Arial",
    };

    var subHeaderPeriodHeaderConfig = {
      bold: true, //this.periodHeaderBold,
      color: '#000',//this.periodHeaderTextColor,
      background: '#FFF', //this.periodHeaderBackground,
      vAlign: "center",
      hAlign: "center",
      fontSize: 12, //this.t2,
      fontFamily: "Arial",
      // borderRight: {
      //   color: this.headersBorderColor,
      //   size: this.headersBorderSize
      // },
      // borderLeft: {
      //   color: this.headersBorderColor,
      //   size: this.headersBorderSize
      // },
      // borderTop: {
      //   color: this.headersBorderColor,
      //   size: this.headersBorderSize
      // },
    };

    var subHeaderPeriodContentConfig = {
      bold: true, //this.periodContentBold,
      color: '#FFF',//this.periodContentTextColor,
      background: '#000080', //this.periodContentBackground,
      vAlign: "center",
      hAlign: "center",
      fontSize: 12, //this.t2,
      rowSpan: 1, //this.subHeaderContentRowSpan,
      fontFamily: "Arial",
      // borderRight: {
      //   color: this.headersBorderColor,
      //   size: this.headersBorderSize
      // },
      // borderLeft: {
      //   color: this.headersBorderColor,
      //   size: this.headersBorderSize
      // },
      // borderTop: {
      //   color: this.headersBorderColor,
      //   size: this.headersBorderSize
      // },
    };

    var colHeaderConfig = {
      bold: true, //this.colsHeaderBold,
      color: '#FFF', //this.colsHeaderTextColor,
      background: '#000080', //this.colsHeaderBackground,
      vAlign: "center",
      hAlign: "center",
      fontSize: 8, //this.t3,
      fontFamily: "Arial",
      wrap: true,
      // borderRight: {
      //   color: this.headersBorderColor,
      //   size: this.headersBorderSize
      // },
      // borderLeft: {
      //   color: this.headersBorderColor,
      //   size: this.headersBorderSize
      // },
      // borderTop: {
      //   color: this.headersBorderColor,
      //   size: this.headersBorderSize
      // },
    };

    var bodyRowsConfig = {
      vAlign: "center",
      hAlign: "center",
      fontSize: 8, //this.c1,
      // color: 'blue',
      background: '#008000',
      fontFamily: "Arial",
    };

    console.log("=================================");
    console.log(this.period);
    var arrayDeCadenas = this.period.split(" - ");
    var f1 = moment(arrayDeCadenas[0]).format("DD/MM/YYYY HH:mm:ss"); //actualizar = true;
    var f2 = moment(arrayDeCadenas[1]).format("DD/MM/YYYY HH:mm:ss"); //actualizar = true;
    console.log(f1);
    console.log(f2);
    var periodo_string = "del "+f1+" AL "+f2;
    console.log(periodo_string);

    // azul : 000080
    // verde : 008000
    // amarillo : ffff00
    // rojo : ff0000
    // blanco ffffff
    // negro : 000


    // overviewRightConfig = {
    //   bold: this.overviewTotalRightBold,
    //   color: this.overviewTotalRightTextColor,
    //   background: this.overviewTotalRightBackground,
    //   vAlign: "center",
    //   hAlign: "center",
    //   fontSize: this.r1,
    //   colSpan: 2,
    // }

    var exportFileEx:any = [];
    var bol_datos_ex = false;

    var table_width = 10 + (this.chkDateHour? 2: 1);
    var vehiculo_width = 4 + (this.chkDateHour? 2: 1);

    var column_config = [];

    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;
    var tipo_unidad_cell_ch_width = "Tipo unidad".length;
    var id_conductor_cell_ch_width = "ID conductor".length;
    var conductor_cell_ch_width = "conductor".length;
    var tramo_cell_ch_width = "tramo".length;
    var limite_velocidad_cell_ch_width = "Limite de".length;
    var exceso_velocidad_cell_ch_width = "Exceso de".length;
    var ubicacion_cell_ch_width = "Ubicacion".length;

    var header_two_lines = true;

    var color_intervalo = [['VERDE', '0.00 - 1.1'],['AMARILLO', '1.1 - 1.7'],['ROJO', '1.7 - 1000']]

    var allRows: AllRows[] = [
        {
          cells: [
            { value: "exportExcelBOLIVIA", ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];

    var titulos_paginas = [
                    '1.INDICES POR GRUPO',
                    '2.DETALLE INDICES GRUPO',
                    '3.INDICES POR CONDUCTOR',
                    '4.FALTAS POR CONDUCTOR',
                    '5.DETALLE INDICES POR CONDUCTOR',

                    '6.CALIFICACION CONDUCTORES',
                    '7.RESUMEN POR CONDUCTOR',
                    '8.INDICES POR VEHICULO',
                    '9.FALTAS POR VEHICULO',
                    '10.DET. INDICES VEHICULO DIA',

                    '11.CONDUCCION NOCTURNA',
                    '12.CONDUCCION PROLONGADA',
                    '13.FRENADA BRUSCA',
                    '14.ACELERACION BRUSCA',
                    '15.CONDUCCION CABLE EMERGENCIA',

                    '16.ENCENDIDO Y APAGADO',
                    '17.LISTA DE VEHICULOS',
                    '18.LISTA DE CONDUCTORES'
                  ];

    var titulos_tablas = [
                    'INDICES POR DIVISION',
                    'DETALLE DE INDICES POR DIVISION',
                    'INDICES POR CONDUCTOR',
                    'FALTAS  POR CONDUCTOR',
                    'DETALLE DE INDICES  POR CONDUCTOR',

                    'REPORTE DE CALIFICACION DE CONDUCTORES',
                    'RESUMEN DE INDICES  POR CONDUCTOR',
                    'INDICES  POR VEHICULO',
                    'FALTAS  POR VEHICULO',
                    'DETALLE DE INDICES  POR VEHICULO',

                    'CONDUCCION FUERA DE HORARIO',
                    'CONDUCCION PROLONGADA',
                    'FRENADA BRUSCA',
                    'ACELERACION BRUSCA',
                    'CONDUCCION CABLE EMERGENCIA',

                    'REPORTE DE PRIMER ENCENDIDO Y ULTIMO APAGADO',
                    'LISTADO DE VEHICULOS',
                    'LISTADO DE CONDUCTORES'
                  ];

    var tables_widths = [
                    16,
                    18,
                    19,
                    14,
                    21, //5
                    15,
                    20,
                    19,
                    14,
                    20, //10

                    10,
                    12,
                    12,
                    12,
                    12,

                    11, //16
                    20,
                    10
                ];

    // var column_config_arr = [
    //   [{width:30*ratioH},{width:108*ratioH},{width:60*ratioH},{width:60*ratioH},{width:60*ratioH},{width:60*ratioH},{width:60*ratioH},{width:60*ratioH}],
    //   [{width:30*ratioH},{width:240*ratioH},{width:72*ratioH},{width:108*ratioH},{width:60*ratioH},{width:60*ratioH},{width:60*ratioH},{width:60*ratioH},{width:60*ratioH},{width:60*ratioH}],
    // ];

    var column_config_nros = [
      [30,108,        60,60,60,60,60,60],
      [30,240,72,108, 60,60,60,60,60,60],
      [30,240,72,180, 60,60,60,60,60,60, 42,42,42,42,42,42,42,42, 84],
      [30,240,72,108, 60,60,60,60,60,60],
      [48,240,72,180, 72,60,60,60,60,60], // 5

      [30,240,72,108, 72,72,72,72,72,72, 72,72,72,72,72], //6
      [72,240,72,180, 90,60,60,60,60,60], // 7
      [30,90,240,180, 60,60,60,60,60,60, 42,42,42,42,42,42,42,42, 84], // 8
      [30,90,240,180, 60,60,60,60,60,60], // 9
      [72,90,180,72, 180,60,60,60,60,60,60], // 10

      [90,180,72,150,150,108,108,72,72,72],
      [48,48,210,72,180,72,210,90,60,150,180,60],
      [48,48,210,72,180,72,210,90,60,150,180,60],
      [48,48,210,72,180,72,210,90,60,150,180,60],
      [48,48,210,72,180,72,210,90,60,150,180,60],

      [71,180,72,90,300,180,72,90,300,60,60],
      [30,72,72,90,90,90,72,72,90,90,72,72,90,90,90,72,72,180,150,72],
      [30,60,72,120,120,120,180,180,60,132]

    ]


    var column_config_arr:any = [];
    column_config_nros.forEach((arrNros: any, id:any) => {
        column_config_arr.push([]);
        arrNros.forEach((nros: any) => {
            column_config_arr[id].push({ width: nros * ratioH });
        });
    });


    console.log("================ DATA ================== : ");
    console.log(this.data);

    this.data.forEach((dataArr: any,idx:any) => {

      // titulos_tablas.forEach((data: any,idx:any) => {
      // if(data[1].length > 0){
      //   bol_datos_ex = true;

        var data_grupos:any;
        // table_width = 16

        var rows:AllRows[] = [
          {
            cells: [
              { value: titulos_tablas[idx] , ...headerCellConfig, colSpan: tables_widths[idx] }
            ],
            height: 15 * this.excelUnitstoPxRatio, //this.headerRowsHeight
          },
          // ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          {
            cells: [
              // { value: "VEHÍCULO : " + data[0][1], color: "#FFF", background: "#000", vAlign: "center", hAlign: "center", fontSize: this.t2, colSpan: 2 },
              { value: "EQUIPETROL S.A", ...subHeaderPeriodHeaderConfig, colSpan: tables_widths[idx] },
            ],
            height: 15 * this.excelUnitstoPxRatio, //this.subHeaderHeight
          },
          {
            cells: [
              // { value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              // { value: this.period, ...subHeaderPeriodContentConfig, colSpan: table_width },
              { value: periodo_string, ...subHeaderPeriodContentConfig, colSpan: tables_widths[idx] },
            ],
            height: 15 * this.excelUnitstoPxRatio, //this.subHeaderContentHeight
          },
          // ...this.generateEmptyRowsForRowSpan(1, 13),
          ...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, 13 * this.excelUnitstoPxRatio),

        ];

            data_grupos = dataArr[1];

            if (idx==0) {

              rows.push({
                cells: [

                  { value: "Nro", ...colHeaderConfig },
                  { value: "Grupo", ...colHeaderConfig },

                  { value: "Km Recorridos", ...colHeaderConfig },
                  { value: "Horas Trabajadas", ...colHeaderConfig },
                  { value: "Horas Movimiento", ...colHeaderConfig },
                  { value: "% Movimiento", ...colHeaderConfig },
                  { value: "Horas Ralenti", ...colHeaderConfig },
                  { value: "% Ralenti", ...colHeaderConfig },
                  { value: "Faltas Vel>60", ...colHeaderConfig },
                  { value: "Faltas Vel>80", ...colHeaderConfig },
                  { value: "Faltas FB", ...colHeaderConfig },
                  { value: "Total Faltas", ...colHeaderConfig },
                  { value: "Indice Vel>60", ...colHeaderConfig },
                  { value: "Indice Vel>80", ...colHeaderConfig },
                  { value: "Indice FB", ...colHeaderConfig },
                  { value: "Indice Total", ...colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: 25 * this.excelUnitstoPxRatio,
              });

                  // this.data.forEach((data: any,idx:any) => {
                  // data[1].forEach((item: { fecha_inicio: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; nombre_zona: any; v0: any; velocidad: any;}, index: number) => {

              data_grupos.forEach((item: { nombre_grupo:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any }, index: number) => {

                rows.push({
                  cells: [
                    { value:  ( index + 1 == data_grupos.length ) ? "": (index + 1), ...bodyRowsConfig, ...arrColor[item.background]},
                    { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background] },
                    { value: item.km_recorridos, ...bodyRowsConfig, ...arrColor[item.background] },
                    { value: item.horas_trabajadas, ...bodyRowsConfig, ...arrColor[item.background] },
                    { value: item.horas_movimiento, ...bodyRowsConfig, ...arrColor[item.background] },
                    { value: item.porcentaje_movimiento, ...bodyRowsConfig, ...arrColor[item.background] },

                    { value: item.horas_ralenti, ...bodyRowsConfig, ...arrColor[item.background] },
                    { value: item.porcentaje_ralenti, ...bodyRowsConfig, ...arrColor[item.background] },

                    { value: item.faltas_60, ...bodyRowsConfig, ...arrColor[item.background] },
                    { value: item.faltas_80, ...bodyRowsConfig, ...arrColor[item.background] },
                    { value: item.faltas_fb, ...bodyRowsConfig, ...arrColor[item.background] },
                    { value: item.total_faltas, ...bodyRowsConfig, ...arrColor[item.background] },

                    { value: item.indice_60, ...bodyRowsConfig, ...arrColor[item.background] },
                    { value: item.indice_80, ...bodyRowsConfig, ...arrColor[item.background] },
                    { value: item.indice_fb, ...bodyRowsConfig, ...arrColor[item.background] },
                    { value: item.indice_total, ...bodyRowsConfig, ...arrColor[item.background] },
                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });

              // rows.push({
              //   cells: [
              //     { value: '', ...this.bodyRowsConfig },
              //     { value: 'TOTAL', ...this.bodyRowsConfig },
              //     { value: '0010', ...this.bodyRowsConfig },
              //     { value: '0010', ...this.bodyRowsConfig },
              //     { value: '0010', ...this.bodyRowsConfig },
              //     { value: '0010', ...this.bodyRowsConfig },
              //     { value: '0020', ...this.bodyRowsConfig },
              //     { value: '0020', ...this.bodyRowsConfig },
              //     { value: '0020', ...this.bodyRowsConfig },
              //     { value: '0030', ...this.bodyRowsConfig },
              //     { value: '0030', ...this.bodyRowsConfig },
              //     { value: '0040', ...this.bodyRowsConfig },
              //     { value: '0040', ...this.bodyRowsConfig },
              //     { value: '0040', ...this.bodyRowsConfig },
              //     { value: '0040', ...this.bodyRowsConfig },
              //     { value: vrs, ...this.bodyRowsConfig },
              //   ],
              //   height: this.bodyRowsHeight
              // });

            } else if(idx==1) {

              // data_grupos = dataArr[1];

              dataArr.forEach((data_grupos:any, index: number) => {

                if (index === 0) {
                  return;
                }

                rows.push({
                  cells: [

                    { value: "Nro", ...colHeaderConfig },
                    { value: "Conductor", ...colHeaderConfig },
                    { value: "Ibutton", ...colHeaderConfig },
                    { value: "Grupo", ...colHeaderConfig },

                    { value: "Km Recorridos", ...colHeaderConfig },
                    { value: "Horas Trabajadas", ...colHeaderConfig },
                    { value: "Horas Movimiento", ...colHeaderConfig },
                    { value: "% Movimiento", ...colHeaderConfig },
                    { value: "Horas Ralenti", ...colHeaderConfig },
                    { value: "% Ralenti", ...colHeaderConfig },
                    { value: "Faltas Vel>60", ...colHeaderConfig },
                    { value: "Faltas Vel>80", ...colHeaderConfig },
                    { value: "Faltas FB", ...colHeaderConfig },
                    { value: "Total Faltas", ...colHeaderConfig },
                    { value: "Indice Vel>60", ...colHeaderConfig },
                    { value: "Indice Vel>80", ...colHeaderConfig },
                    { value: "Indice FB", ...colHeaderConfig },
                    { value: "Indice Total", ...colHeaderConfig },

                  ],
                  height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
                });

                data_grupos.forEach((item: { ibutton:any; conductor:any; nombre_grupo:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any }, index: number) => {

                  rows.push({
                    cells: [
                      { value:  ( index + 1 == data_grupos.length ) ? "": (index + 1), ...bodyRowsConfig, ...arrColor[item.background]},
                      { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.ibutton, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background] },

                      { value: item.km_recorridos, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.horas_trabajadas, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.horas_movimiento, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.porcentaje_movimiento, ...bodyRowsConfig, ...arrColor[item.background] },

                      { value: item.horas_ralenti, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.porcentaje_ralenti, ...bodyRowsConfig, ...arrColor[item.background] },

                      { value: item.faltas_60, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.faltas_80, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.faltas_fb, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.total_faltas, ...bodyRowsConfig, ...arrColor[item.background] },

                      { value: item.indice_60, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.indice_80, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.indice_fb, ...bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.indice_total, ...bodyRowsConfig, ...arrColor[item.background] },
                    ],
                    height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                  });

                });

                rows.push({});

              });



            } else if(idx==2) {

              dataArr.forEach((data_grupos:any, index: number) => {

                if (index === 0) {
                  return;
                }

                rows.push({
                  cells: [

                    { value: "Nro", ...colHeaderConfig },
                    { value: "Conductor", ...colHeaderConfig },
                    { value: "Ibutton", ...colHeaderConfig },
                    { value: "Grupo", ...colHeaderConfig },

                    { value: "Km Recorridos", ...colHeaderConfig },
                    { value: "Horas Trabajadas", ...colHeaderConfig },
                    { value: "Horas Movimiento", ...colHeaderConfig },
                    { value: "% Movimiento", ...colHeaderConfig },

                    { value: "Horas Ralenti", ...colHeaderConfig },
                    { value: "% Ralenti", ...colHeaderConfig },
                    { value: "Faltas Vel>60", ...colHeaderConfig },
                    { value: "Faltas Vel>80", ...colHeaderConfig },
                    { value: "Faltas FB", ...colHeaderConfig },
                    { value: "Total Faltas", ...colHeaderConfig },

                    { value: "Indice Vel>60", ...colHeaderConfig },
                    { value: "Indice Vel>80", ...colHeaderConfig },
                    { value: "Indice FB", ...colHeaderConfig },
                    { value: "Indice Total", ...colHeaderConfig },

                    { value: "Velocidad Total", ...colHeaderConfig },
                  ],
                  height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
                });

                data_grupos.forEach((item: { ibutton:any; conductor:any; nombre_grupo:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; background2:any; velocidad_total:any  }, index: number) => {

                  rows.push({
                    cells: [
                      { value:  ( index + 1 == data_grupos.length ) ? "": (index + 1), ...bodyRowsConfig, ...arrColor[item.background2]},
                      { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.ibutton, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },

                      { value: item.km_recorridos, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.horas_trabajadas, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.horas_movimiento, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.porcentaje_movimiento, ...bodyRowsConfig, ...arrColor[item.background2] },

                      { value: item.horas_ralenti, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.porcentaje_ralenti, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.faltas_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.faltas_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.faltas_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.total_faltas, ...bodyRowsConfig, ...arrColor[item.background2] },

                      { value: item.indice_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.indice_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.indice_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.indice_total, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.velocidad_total, ...bodyRowsConfig, ...arrColor[item.background2] },

                    ],
                    height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                  });

                });

                rows.push({});

              });



            } else if(idx==3) {

              rows.push({
                cells: [

                  { value: "Nro", ...colHeaderConfig },
                  { value: "Conductor", ...colHeaderConfig },
                  { value: "Ibutton", ...colHeaderConfig },
                  { value: "Grupo", ...colHeaderConfig },

                  { value: "Km", ...colHeaderConfig },

                  { value: "Horas Trabajadas", ...colHeaderConfig },
                  { value: "Horas Movimiento", ...colHeaderConfig },
                  { value: "% Movimiento", ...colHeaderConfig },
                  { value: "Horas Ralenti", ...colHeaderConfig },
                  { value: "% Ralenti", ...colHeaderConfig },

                  { value: "Faltas Vel>60", ...colHeaderConfig },
                  { value: "Faltas Vel>80", ...colHeaderConfig },
                  { value: "Faltas FB", ...colHeaderConfig },
                  { value: "Total Faltas", ...colHeaderConfig },

                  // { value: "Indice Vel>60", ...this.colHeaderConfig },
                  // { value: "Indice Vel>80", ...this.colHeaderConfig },
                  // { value: "Indice FB", ...this.colHeaderConfig },
                  // { value: "Indice Total", ...this.colHeaderConfig },

                  // { value: "Velocidad Total", ...this.colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });

              data_grupos.forEach((item: { ibutton:any; conductor:any; nombre_grupo:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; background2:any; velocidad_total:any  }, index: number) => {

                rows.push({
                  cells: [
                    { value:  ( index + 1 == data_grupos.length ) ? "": (index + 1), ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.ibutton, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.km_recorridos, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.horas_trabajadas, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.horas_movimiento, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.porcentaje_movimiento, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.horas_ralenti, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.porcentaje_ralenti, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.faltas_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.faltas_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.faltas_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.total_faltas, ...bodyRowsConfig, ...arrColor[item.background2] },

                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });

              rows.push({ });
              rows.push({ });

              rows.push({
                cells: [
                  { value: '' },
                  { value: "Conductor", ...colHeaderConfig },
                  { value: "Total Faltas", ...colHeaderConfig },
                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });

              data_grupos.forEach((item: { ibutton:any; conductor:any; nombre_grupo:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; background2:any; velocidad_total:any  }, index: number) => {

                rows.push({
                  cells: [
                    { value: '' },
                    { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.total_faltas, ...bodyRowsConfig, ...arrColor[item.background2] },
                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });



            } else if(idx==4) {
                rows.push({
                  cells: [
                    { value: "Fecha", ...colHeaderConfig },
                    { value: "Conductor", ...colHeaderConfig },
                    { value: "Ibutton", ...colHeaderConfig },
                    { value: "Grupo", ...colHeaderConfig },

                    { value: "Placa", ...colHeaderConfig },

                    { value: "Km Recorridos", ...colHeaderConfig },
                    { value: "Horas Trabajadas", ...colHeaderConfig },
                    { value: "Horas Movimiento", ...colHeaderConfig },
                    { value: "% Movimiento", ...colHeaderConfig },
                    { value: "Horas Ralenti", ...colHeaderConfig },
                    { value: "% Ralenti", ...colHeaderConfig },
                    { value: "Faltas Vel>60", ...colHeaderConfig },
                    { value: "Faltas Vel>80", ...colHeaderConfig },
                    { value: "Faltas FB", ...colHeaderConfig },
                    { value: "Total Faltas", ...colHeaderConfig },

                    { value: "Indice Vel>60", ...colHeaderConfig },
                    { value: "Indice Vel>80", ...colHeaderConfig },
                    { value: "Indice FB", ...colHeaderConfig },
                    { value: "Indice Total", ...colHeaderConfig },

                    { value: "Velocidad Maxima", ...colHeaderConfig },
                    { value: "Recorrido", ...colHeaderConfig },

                  ],
                  height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
                });

                data_grupos.forEach((item: { rango_fecha:any; placa:any; ibutton:any; conductor:any; nombre_grupo:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; background2:any; velocidad_total:any  }, index: number) => {

                  rows.push({
                    cells: [
                      { value: item.rango_fecha, ...bodyRowsConfig, ...arrColor[item.background2]},
                      { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.ibutton, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.placa, ...bodyRowsConfig, ...arrColor[item.background2] },


                      { value: item.km_recorridos, ...bodyRowsConfig, ...arrColor[item.background2] },

                      { value: item.horas_trabajadas, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.horas_movimiento, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.porcentaje_movimiento, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.horas_ralenti, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.porcentaje_ralenti, ...bodyRowsConfig, ...arrColor[item.background2] },

                      { value: item.faltas_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.faltas_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.faltas_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.total_faltas, ...bodyRowsConfig, ...arrColor[item.background2] },

                      { value: item.indice_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.indice_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.indice_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.indice_total, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: item.velocidad_total, ...bodyRowsConfig, ...arrColor[item.background2] },
                      { value: "", ...bodyRowsConfig, ...arrColor[item.background2] },

                    ],
                    height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                  });

                });

            } else if(idx==5) {

              rows.push({
                cells: [

                  { value: "Nro", ...colHeaderConfig },
                  { value: "Conductor", ...colHeaderConfig },
                  { value: "Ibutton", ...colHeaderConfig },
                  { value: "Grupo", ...colHeaderConfig },

                  { value: "Km. Recorridos", ...colHeaderConfig },

                  { value: "Cant. Aceleraciones", ...colHeaderConfig },
                  { value: "Prom. Aceleraciones", ...colHeaderConfig },
                  { value: "Cant. Frenadas Bruscas", ...colHeaderConfig },
                  { value: "Prom. Frenadas Bruscas", ...colHeaderConfig },
                  { value: "Cant. Excesos", ...colHeaderConfig },
                  { value: "Prom. Excesos", ...colHeaderConfig },

                  { value: "Calif. Aceleraciones", ...colHeaderConfig },
                  { value: "Calif. Frenadas Bruscas", ...colHeaderConfig },
                  { value: "Calif. Excesos", ...colHeaderConfig },
                  { value: "Puntaje Final", ...colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });


              data_grupos.forEach((item: { ibutton:any; conductor:any; nombre_grupo:any; km_recorridos:number; cant_aceleracion:any; prom_aceleracion:any; cant_frenada_brusca:any; prom_frenada_brusca:any; cant_excesos:any; prom_excesos:any; calif_aceleracion:any; calif_frenada_brusca:any; calif_excesos:any; puntaje_final:any; background2:any; }, index: number) => {

                rows.push({
                  cells: [
                    { value:  ( index + 1 == data_grupos.length ) ? "": (index + 1), ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.ibutton, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.km_recorridos, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.cant_aceleracion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.prom_aceleracion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.cant_frenada_brusca, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.prom_frenada_brusca, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.cant_excesos, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.prom_excesos, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.calif_aceleracion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.calif_frenada_brusca, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.calif_excesos, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.puntaje_final, ...bodyRowsConfig, ...arrColor[item.background2] },

                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });


            } else if(idx==6) {

              rows.push({
                cells: [

                  { value: "Id Cond.", ...colHeaderConfig },
                  { value: "Conductor", ...colHeaderConfig },
                  { value: "Ibutton", ...colHeaderConfig },
                  { value: "Grupo", ...colHeaderConfig },

                  { value: "Placa", ...colHeaderConfig },

                  { value: "Km Recorridos", ...colHeaderConfig },
                  { value: "Horas Trabajadas", ...colHeaderConfig },
                  { value: "Horas Movimiento", ...colHeaderConfig },
                  { value: "% Movimiento", ...colHeaderConfig },
                  { value: "Horas Ralenti", ...colHeaderConfig },
                  { value: "% Ralenti", ...colHeaderConfig },
                  { value: "Faltas Vel>60", ...colHeaderConfig },
                  { value: "Faltas Vel>80", ...colHeaderConfig },
                  { value: "Faltas FB", ...colHeaderConfig },
                  { value: "Total Faltas", ...colHeaderConfig },

                  { value: "Indice Vel>60", ...colHeaderConfig },
                  { value: "Indice Vel>80", ...colHeaderConfig },
                  { value: "Indice FB", ...colHeaderConfig },
                  { value: "Indice Total", ...colHeaderConfig },

                  { value: "Velocidad Maxima", ...colHeaderConfig },
                  // { value: "Recorrido", ...this.colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });


              data_grupos.forEach((item: { id_conductor:any; placa:any; ibutton:any; conductor:any; nombre_grupo:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; background2:any; velocidad_total:any  }, index: number) => {

                rows.push({
                  cells: [
                    { value: item.id_conductor, ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.ibutton, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.placa, ...bodyRowsConfig, ...arrColor[item.background2] },


                    { value: item.km_recorridos, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.horas_trabajadas, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.horas_movimiento, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.porcentaje_movimiento, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.horas_ralenti, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.porcentaje_ralenti, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.faltas_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.faltas_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.faltas_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.total_faltas, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.indice_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.indice_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.indice_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.indice_total, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.velocidad_total, ...bodyRowsConfig, ...arrColor[item.background2] },

                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });






            } else if(idx==7) {

              rows.push({
                cells: [

                  { value: "Nro", ...colHeaderConfig },
                  { value: "Placa", ...colHeaderConfig },
                  { value: "Descripción", ...colHeaderConfig },
                  { value: "Grupo", ...colHeaderConfig },

                  { value: "Km Recorridos", ...colHeaderConfig },
                  { value: "Horas Trabajadas", ...colHeaderConfig },
                  { value: "Horas Movimiento", ...colHeaderConfig },
                  { value: "% Movimiento", ...colHeaderConfig },
                  { value: "Horas Ralenti", ...colHeaderConfig },
                  { value: "% Ralenti", ...colHeaderConfig },
                  { value: "Faltas Vel>60", ...colHeaderConfig },
                  { value: "Faltas Vel>80", ...colHeaderConfig },
                  { value: "Faltas FB", ...colHeaderConfig },
                  { value: "Total Faltas", ...colHeaderConfig },

                  { value: "Indice Vel>60", ...colHeaderConfig },
                  { value: "Indice Vel>80", ...colHeaderConfig },
                  { value: "Indice FB", ...colHeaderConfig },
                  { value: "Indice Total", ...colHeaderConfig },

                  { value: "Velocidad Maxima", ...colHeaderConfig },
                  // { value: "Recorrido", ...this.colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });


              data_grupos.forEach((item: { rango_fecha:any; placa:any; descripcion:any; ibutton:any; conductor:any; nombre_grupo:any; km_recorridos_str:number; horas_trabajadas_str:any; horas_movimiento_str:any; porcentaje_movimiento_str:any; horas_ralenti_str:any; porcentaje_ralenti_str:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; background2:any; velocidad_maxima_str:any  }, index: number) => {

                rows.push({
                  cells: [
                    { value:  ( index + 1 == data_grupos.length ) ? "": (index + 1), ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.placa, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.descripcion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.km_recorridos_str, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.horas_trabajadas_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.horas_movimiento_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.porcentaje_movimiento_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.horas_ralenti_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.porcentaje_ralenti_str, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.faltas_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.faltas_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.faltas_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.total_faltas, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.indice_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.indice_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.indice_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.indice_total, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.velocidad_maxima_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    // { value: "", ...bodyRowsConfig, ...arrColor[item.background2] },

                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });


            } else if(idx==8) {

              rows.push({
                cells: [

                  { value: "Nro", ...colHeaderConfig },
                  { value: "Placa", ...colHeaderConfig },
                  { value: "Descripción", ...colHeaderConfig },
                  { value: "Grupo", ...colHeaderConfig },

                  { value: "Km Recorridos", ...colHeaderConfig },

                  { value: "Horas Trabajadas", ...colHeaderConfig },
                  { value: "Horas Movimiento", ...colHeaderConfig },
                  { value: "% Movimiento", ...colHeaderConfig },
                  { value: "Horas Ralenti", ...colHeaderConfig },
                  { value: "% Ralenti", ...colHeaderConfig },
                  { value: "Faltas Vel>60", ...colHeaderConfig },
                  { value: "Faltas Vel>80", ...colHeaderConfig },
                  { value: "Faltas FB", ...colHeaderConfig },
                  { value: "Total Faltas", ...colHeaderConfig },

                  // { value: "Indice Vel>60", ...this.colHeaderConfig },
                  // { value: "Indice Vel>80", ...this.colHeaderConfig },
                  // { value: "Indice FB", ...this.colHeaderConfig },
                  // { value: "Indice Total", ...this.colHeaderConfig },

                  // { value: "Velocidad Total", ...this.colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });



              data_grupos.forEach((item: { ibutton:any; placa:any; descripcion:any; conductor:any; nombre_grupo:any; km_recorridos_str:number; horas_trabajadas_str:any; horas_movimiento_str:any; porcentaje_movimiento_str:any; horas_ralenti_str:any; porcentaje_ralenti_str:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; background2:any; velocidad_total:any  }, index: number) => {

                rows.push({
                  cells: [
                    { value:  ( index + 1 == data_grupos.length ) ? "": (index + 1), ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.placa, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.descripcion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.km_recorridos_str, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.horas_trabajadas_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.horas_movimiento_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.porcentaje_movimiento_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.horas_ralenti_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.porcentaje_ralenti_str, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.faltas_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.faltas_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.faltas_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.total_faltas, ...bodyRowsConfig, ...arrColor[item.background2] },

                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });

              rows.push({ });
              rows.push({ });

              rows.push({
                cells: [
                  { value: '' },
                  { value: "Conductor", ...colHeaderConfig },
                  { value: "Total Faltas", ...colHeaderConfig },
                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });

              data_grupos.forEach((item: { ibutton:any; conductor:any; nombre_grupo:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; background2:any; velocidad_total:any  }, index: number) => {

                rows.push({
                  cells: [
                    { value: '' },
                    { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.total_faltas, ...bodyRowsConfig, ...arrColor[item.background2] },
                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });



            } else if(idx==9) {

              rows.push({
                cells: [

                  { value: "Fecha", ...colHeaderConfig },
                  { value: "Placa", ...colHeaderConfig },
                  { value: "Division", ...colHeaderConfig },
                  { value: "Ibutton", ...colHeaderConfig },
                  { value: "Conductor", ...colHeaderConfig },

                  { value: "Km Recorridos", ...colHeaderConfig },
                  { value: "Horas Trabajadas", ...colHeaderConfig },
                  { value: "Horas Movimiento", ...colHeaderConfig },
                  { value: "% Movimiento", ...colHeaderConfig },
                  { value: "Horas Ralenti", ...colHeaderConfig },
                  { value: "% Ralenti", ...colHeaderConfig },
                  { value: "Faltas Vel>60", ...colHeaderConfig },
                  { value: "Faltas Vel>80", ...colHeaderConfig },
                  { value: "Faltas FB", ...colHeaderConfig },
                  { value: "Total Faltas", ...colHeaderConfig },

                  { value: "Indice Vel>60", ...colHeaderConfig },
                  { value: "Indice Vel>80", ...colHeaderConfig },
                  { value: "Indice FB", ...colHeaderConfig },
                  { value: "Indice Total", ...colHeaderConfig },

                  { value: "Velocidad Maxima", ...colHeaderConfig },
                  { value: "Recorrido", ...colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });

              data_grupos.forEach((item: { rango_fecha:any; placa:any; ibutton:any; conductor:any; nombre_grupo:any; km_recorridos_str:number; horas_trabajadas_str:any; horas_movimiento_str:any; porcentaje_movimiento_str:any; horas_ralenti_str:any; porcentaje_ralenti_str:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; background2:any; velocidad_maxima_str:any  }, index: number) => {

                rows.push({
                  cells: [
                    { value: item.rango_fecha, ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.placa, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.ibutton, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.km_recorridos_str, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.horas_trabajadas_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.horas_movimiento_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.porcentaje_movimiento_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.horas_ralenti_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.porcentaje_ralenti_str, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.faltas_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.faltas_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.faltas_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.total_faltas, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.indice_60, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.indice_80, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.indice_fb, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.indice_total, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.velocidad_maxima_str, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: "", ...bodyRowsConfig, ...arrColor[item.background2] },

                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });

            } else if(idx==10) {

              rows.push({
                cells: [

                  { value: "Fecha", ...colHeaderConfig },
                  { value: "Descripcion", ...colHeaderConfig },
                  { value: "Ibutton", ...colHeaderConfig },
                  { value: "Conductor", ...colHeaderConfig },

                  { value: "Grupo", ...colHeaderConfig },
                  { value: "Fecha Inicio", ...colHeaderConfig },
                  { value: "Fecha Fin", ...colHeaderConfig },
                  { value: "Km Recorridos", ...colHeaderConfig },
                  { value: "Tiempo", ...colHeaderConfig },
                  { value: "Url Recorrido", ...colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });

            } else if(idx==11) {
              //HOJA 12 conduccion prolongada
              rows.push({
                cells: [

                  { value: "Item", ...colHeaderConfig },
                  { value: "Cod Cond", ...colHeaderConfig },
                  { value: "Conductor", ...colHeaderConfig },
                  { value: "Ibutton", ...colHeaderConfig },

                  { value: "Grupo Cond", ...colHeaderConfig },
                  { value: "Placa", ...colHeaderConfig },
                  { value: "Descripcion", ...colHeaderConfig },
                  { value: "Fecha evento", ...colHeaderConfig },
                  { value: "Velocidad", ...colHeaderConfig },
                  { value: "Lat;Long", ...colHeaderConfig },
                  { value: "Direccion", ...colHeaderConfig },
                  { value: "Ubicacion", ...colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });

              data_grupos.forEach((item: { rango_fecha:any; placa:any; ibutton:any; cod_conductor:any; conductor:any; nombre_grupo:any; descripcion:any; fecha_evento:any; velocidad:any; latitud:any; longitud:any; direccion:any; ubicacion:any; background:any; background2:any; }, index: number) => {
                var ubicacion_1 = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

                rows.push({
                  cells: [
                    { value: (index + 1), ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.cod_conductor, ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.ibutton, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.placa, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.descripcion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.fecha_evento, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.velocidad, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.latitud+';'+item.longitud, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.direccion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion_1+'&amp;t=m","ubicacion")', ...bodyRowsConfig, ...arrColor[item.background2], color:'#0000FF' },
                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });

            } else if(idx==12) {
              //HOJA 13 frenada
              rows.push({
                cells: [

                  { value: "Item", ...colHeaderConfig },
                  { value: "Cod Cond", ...colHeaderConfig },
                  { value: "Conductor", ...colHeaderConfig },
                  { value: "Ibutton", ...colHeaderConfig },

                  { value: "Grupo Cond", ...colHeaderConfig },
                  { value: "Placa", ...colHeaderConfig },
                  { value: "Descripcion", ...colHeaderConfig },
                  { value: "Fecha evento", ...colHeaderConfig },
                  { value: "Velocidad", ...colHeaderConfig },
                  { value: "Lat;Long", ...colHeaderConfig },
                  { value: "Direccion", ...colHeaderConfig },
                  { value: "Ubicacion", ...colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });

              data_grupos.forEach((item: { rango_fecha:any; placa:any; ibutton:any; cod_conductor:any; conductor:any; nombre_grupo:any; descripcion:any; fecha_evento:any; velocidad:any; latitud:any; longitud:any; direccion:any; ubicacion:any; background:any; background2:any; }, index: number) => {
                var ubicacion_1 = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

                rows.push({
                  cells: [
                    { value: (index + 1), ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.cod_conductor, ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.ibutton, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.placa, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.descripcion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.fecha_evento, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.velocidad, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.latitud+';'+item.longitud, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.direccion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion_1+'&amp;t=m","ubicacion")', ...bodyRowsConfig, ...arrColor[item.background2], color:'#0000FF' },
                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });


            } else if(idx==13) {
              //HOJA 14 aceleracion
              rows.push({
                cells: [

                  { value: "Item", ...colHeaderConfig },
                  { value: "Cod Cond", ...colHeaderConfig },
                  { value: "Conductor", ...colHeaderConfig },
                  { value: "Ibutton", ...colHeaderConfig },

                  { value: "Grupo Cond", ...colHeaderConfig },
                  { value: "Placa", ...colHeaderConfig },
                  { value: "Descripcion", ...colHeaderConfig },
                  { value: "Fecha evento", ...colHeaderConfig },
                  { value: "Velocidad", ...colHeaderConfig },
                  { value: "Lat;Long", ...colHeaderConfig },
                  { value: "Direccion", ...colHeaderConfig },
                  { value: "Ubicacion", ...colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });


              data_grupos.forEach((item: { rango_fecha:any; placa:any; ibutton:any; cod_conductor:any; conductor:any; nombre_grupo:any; descripcion:any; fecha_evento:any; velocidad:any; latitud:any; longitud:any; direccion:any; ubicacion:any; background:any; background2:any; }, index: number) => {
                var ubicacion_1 = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

                rows.push({
                  cells: [
                    { value: (index + 1), ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.cod_conductor, ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.ibutton, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.placa, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.descripcion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.fecha_evento, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.velocidad, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.latitud+';'+item.longitud, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.direccion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion_1+'&amp;t=m","ubicacion")', ...bodyRowsConfig, ...arrColor[item.background2], color:'#0000FF' },
                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });

            } else if(idx==14) {
              //HOJA 15 Conduccion Cable Emergencia
              rows.push({
                cells: [

                  { value: "Item", ...colHeaderConfig },
                  { value: "Cod Cond", ...colHeaderConfig },
                  { value: "Conductor", ...colHeaderConfig },
                  { value: "Ibutton", ...colHeaderConfig },

                  { value: "Grupo Cond", ...colHeaderConfig },
                  { value: "Placa", ...colHeaderConfig },
                  { value: "Descripcion", ...colHeaderConfig },
                  { value: "Fecha evento", ...colHeaderConfig },
                  { value: "Velocidad", ...colHeaderConfig },
                  { value: "Lat;Long", ...colHeaderConfig },
                  { value: "Direccion", ...colHeaderConfig },
                  { value: "Ubicacion", ...colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });

              data_grupos.forEach((item: { rango_fecha:any; placa:any; ibutton:any; cod_conductor:any; conductor:any; nombre_grupo:any; descripcion:any; fecha_evento:any; velocidad:any; latitud:any; longitud:any; direccion:any; ubicacion:any; background:any; background2:any; }, index: number) => {
                var ubicacion_1 = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

                rows.push({
                  cells: [
                    { value: (index + 1), ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.cod_conductor, ...bodyRowsConfig, ...arrColor[item.background2]},
                    { value: item.conductor, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.ibutton, ...bodyRowsConfig, ...arrColor[item.background2] },

                    { value: item.nombre_grupo, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.placa, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.descripcion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.fecha_evento, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.velocidad, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.latitud+';'+item.longitud, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { value: item.direccion, ...bodyRowsConfig, ...arrColor[item.background2] },
                    { formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion_1+'&amp;t=m","ubicacion")', ...bodyRowsConfig, ...arrColor[item.background2], color:'#0000FF' },
                  ],
                  height: 13 * this.excelUnitstoPxRatio //this.bodyRowsHeight
                });

              });

            } else if(idx==15) {
              //HOJA 16 Primer Encedido y Ultimo Apagado
              rows.push({
                cells: [

                  { value: "Placa", ...colHeaderConfig },

                  { value: "Conductor 1er. Encendido", ...colHeaderConfig },
                  { value: "IButton 1er. Encendido", ...colHeaderConfig },
                  { value: "Hora 1er. Encendido", ...colHeaderConfig },
                  { value: "Referencia Encendido", ...colHeaderConfig },

                  { value: "Conductor Ult. Apagado", ...colHeaderConfig },
                  { value: "IButton Ult. Apagado", ...colHeaderConfig },
                  { value: "Hora Ult. Apagado", ...colHeaderConfig },
                  { value: "Referencia Ult. Apagado", ...colHeaderConfig },

                  { value: "Ubicacion Encendido", ...colHeaderConfig },
                  { value: "Ubicacion Apagado", ...colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });

              data_grupos.forEach((item: { placa:any; conductor_encendido:any; ibutton_encendido:any; primer_encendido:any; referencia_encendido:any; conductor_apagado:number; ibutton_apagado:any; ultimo_apagado:any; referencia_apagado:any; background:any; background2:any; lat_encendido:any; lng_encendido:any; lat_apagado:any; lng_apagado:any; }, index: number) => {

                  var array_campos_cuerpo= [];

                  array_campos_cuerpo.push({ value: item.placa, ...bodyRowsConfig, ...arrColor[item.background2] });

                  array_campos_cuerpo.push({ value: item.conductor_encendido, ...bodyRowsConfig, ...arrColor[item.background2] });
                  array_campos_cuerpo.push({ value: item.ibutton_encendido, ...bodyRowsConfig, ...arrColor[item.background2] });
                  array_campos_cuerpo.push({ value: item.primer_encendido, ...bodyRowsConfig, ...arrColor[item.background2] });
                  array_campos_cuerpo.push({ value: item.referencia_encendido, ...bodyRowsConfig, ...arrColor[item.background2] });

                  array_campos_cuerpo.push({ value: item.conductor_apagado, ...bodyRowsConfig, ...arrColor[item.background2] });
                  array_campos_cuerpo.push({ value: item.ibutton_apagado, ...bodyRowsConfig, ...arrColor[item.background2] });
                  array_campos_cuerpo.push({ value: item.ultimo_apagado, ...bodyRowsConfig, ...arrColor[item.background2] });
                  array_campos_cuerpo.push({ value: item.referencia_apagado, ...bodyRowsConfig, ...arrColor[item.background2] });

                  if (item.lat_encendido === undefined) {
                    array_campos_cuerpo.push({ value: "", ...bodyRowsConfig, ...arrColor[item.background2], color:'#0000FF' });
                    array_campos_cuerpo.push({ value: "", ...bodyRowsConfig, ...arrColor[item.background2], color:'#0000FF' });
                  } else {
                    console.log("---------------");
                    console.log(item.lat_encendido);
                    console.log(item.lng_encendido);
                    console.log(item.lat_apagado);
                    console.log(item.lng_apagado);

                    var ubicacion_1 = item.lat_encendido.toFixed(6) + "," + item.lng_encendido.toFixed(6) + "";
                    var ubicacion_2 = item.lat_apagado.toFixed(6) + "," + item.lng_apagado.toFixed(6) + "";

                    array_campos_cuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion_1+'&amp;t=m","ubicacion")', ...bodyRowsConfig, ...arrColor[item.background2], color:'#0000FF' });
                    array_campos_cuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion_2+'&amp;t=m","ubicacion")', ...bodyRowsConfig, ...arrColor[item.background2], color:'#0000FF' });
                  }

                  rows.push({
                    cells: array_campos_cuerpo, height: 13 * this.excelUnitstoPxRatio
                  });

              });

            }  else if(idx==16) {

              rows.push({
                cells: [

                  { value: "Nro", ...colHeaderConfig },
                  { value: "Placa", ...colHeaderConfig },
                  { value: "Nombre", ...colHeaderConfig },
                  { value: "Tipo", ...colHeaderConfig },
                  { value: "Marca", ...colHeaderConfig },

                  { value: "Modelo", ...colHeaderConfig },
                  { value: "Version", ...colHeaderConfig },
                  { value: "Color", ...colHeaderConfig },
                  { value: "Nro Chasis", ...colHeaderConfig },
                  { value: "Nro Motor", ...colHeaderConfig },

                  { value: "Cap Carga", ...colHeaderConfig },
                  { value: "Cilindrada", ...colHeaderConfig },
                  { value: "Voltaje Bateria", ...colHeaderConfig },
                  { value: "Tipo Traccion", ...colHeaderConfig },
                  { value: "Tipo Comubustible", ...colHeaderConfig },

                  { value: "Capacidad Tanque", ...colHeaderConfig },
                  { value: "Rendimiento Km/L", ...colHeaderConfig },
                  { value: "Grupo", ...colHeaderConfig },
                  { value: "Sub Grupo", ...colHeaderConfig },
                  { value: "Kilometros Recorridos", ...colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });

            } else if(idx==17) {

              rows.push({
                cells: [

                  { value: "Nro", ...colHeaderConfig },
                  { value: "Id Conductor", ...colHeaderConfig },
                  { value: "Ibutton", ...colHeaderConfig },
                  { value: "Nombre", ...colHeaderConfig },
                  { value: "Paterno", ...colHeaderConfig },

                  { value: "Materno", ...colHeaderConfig },
                  { value: "Grupo", ...colHeaderConfig },
                  { value: "SubGrupo", ...colHeaderConfig },
                  { value: "Brevet", ...colHeaderConfig },
                  { value: "Fecha Expiracion", ...colHeaderConfig },

                ],
                height: header_two_lines? this.colsHeaderHeightTwoLine: this.colsHeaderHeight,
              });

            }



            rows.push({ });
            rows.push({ });


            if (titulos_paginas[idx].includes(".INDICES POR ")) {

                var clave_head = "";
                var valor_body = "";
                if(idx==0) {
                  // 1.INDICES POR GRUPO
                  // Grupo
                  clave_head = "Grupo";
                } else if (idx==2) {
                  // 3.INDICES POR CONDUCTOR
                  // Conductor
                  clave_head = "Conductor";
                } else if (idx==7) {
                  // 8.INDICES POR VEHICULO
                  // Placa
                  clave_head = "Placa";
                }

                rows.push({
                  cells: [
                    { value: '',  },
                    { value: clave_head, ...colHeaderConfig },
                    { value: 'Indice Vel>60', ...colHeaderConfig },
                    { value: 'Indice Vel>80', ...colHeaderConfig },
                    { value: 'Indice FB', ...colHeaderConfig },
                    { value: 'Indice Total', ...colHeaderConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: 'COLOR', ...colHeaderConfig },
                    { value: 'INTERVALO', ...colHeaderConfig },
                  ],
                  height: 24 * this.excelUnitstoPxRatio, //this.bodyRowsHeight
                });


                var index2 = 0;
                data_grupos.forEach((item: { nombre_grupo:any; conductor:any; placa:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; }, idnex: number) => {

                  if (idx==0) {
                    valor_body = item.nombre_grupo;
                  } else if (idx==2) {
                    valor_body = item.conductor;
                  } else if (idx==7) {
                    valor_body = item.placa;
                  }

                  rows.push({
                    cells: [
                      { value: '', ...this.bodyRowsConfig },
                      { value: valor_body, ...this.bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.indice_60, ...this.bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.indice_80, ...this.bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.indice_fb, ...this.bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.indice_total, ...this.bodyRowsConfig, ...arrColor[item.background] },

                      { value: '', ...this.bodyRowsConfig },
                      { value: (idnex > 2) ? '': color_intervalo[idnex][0], ...this.bodyRowsConfig, ...arrColor[idnex]},
                      { value: (idnex > 2) ? '': color_intervalo[idnex][1], ...this.bodyRowsConfig, ...arrColor[idnex]},
                    ],
                    height: this.bodyRowsHeight
                  });
                  index2 = idnex;

                });

                index2++;
                if (index2 <= 2) {
                    // for (let index = index2; index < color_intervalo.length; index++) {
                    for (let index = index2; index < 3; index++) {

                        rows.push({
                          cells: [
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },

                            { value: '', ...this.bodyRowsConfig },
                            { value: color_intervalo[index][0], ...this.bodyRowsConfig, ...arrColor[index2] },
                            { value: color_intervalo[index][1], ...this.bodyRowsConfig, ...arrColor[index2] },
                          ],
                          height: this.bodyRowsHeight
                        });
                    }
                }

                rows.push({ });
                rows.push({ });

                rows.push({
                  cells: [
                    { },
                    { value: clave_head, ...colHeaderConfig },
                    { value: 'Indice Vel>60', ...colHeaderConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: 'COLOR', ...colHeaderConfig },
                    { value: 'INTERVALO', ...colHeaderConfig },
                  ],
                  height: 24 * this.excelUnitstoPxRatio, //this.bodyRowsHeight
                });


                var index2 = 0;
                data_grupos.forEach((item: { nombre_grupo:any; conductor:any; placa:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; }, idnex: number) => {

                  if (idx==0) {
                    valor_body = item.nombre_grupo;
                  } else if (idx==2) {
                    valor_body = item.conductor;
                  } else if (idx==7) {
                    valor_body = item.placa;
                  }

                  rows.push({
                    cells: [
                      { },
                      { value: valor_body, ...this.bodyRowsConfig, ...arrColor[item.background]  },
                      { value: item.indice_60, ...this.bodyRowsConfig, ...arrColor[item.background]  },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },

                      { value: (idnex > 2) ? '': color_intervalo[idnex][0], ...this.bodyRowsConfig, ...arrColor[idnex] },
                      { value: (idnex > 2) ? '': color_intervalo[idnex][1], ...this.bodyRowsConfig, ...arrColor[idnex] },
                    ],
                    height: this.bodyRowsHeight
                  });
                  index2 = idnex;

                });

                index2++;
                if (index2 <= 2) {
                    for (let index = index2; index < 3; index++) {
                        rows.push({
                          cells: [
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },

                            { value: '', ...this.bodyRowsConfig },
                            { value: color_intervalo[index][0], ...this.bodyRowsConfig, ...arrColor[index]  },
                            { value: color_intervalo[index][1], ...this.bodyRowsConfig, ...arrColor[index]  },
                          ],
                          height: this.bodyRowsHeight
                        });
                    }
                }

                rows.push({ });
                rows.push({ });

                rows.push({
                  cells: [
                    { },
                    { value: clave_head, ...colHeaderConfig },
                    { value: 'Indice Vel>80', ...colHeaderConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: 'COLOR', ...colHeaderConfig },
                    { value: 'INTERVALO', ...colHeaderConfig },
                  ],
                  height: 24 * this.excelUnitstoPxRatio, // this.bodyRowsHeight
                });


                var index2 = 0;
                data_grupos.forEach((item: { nombre_grupo:any; conductor:any; placa:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; }, idnex: number) => {

                  if (idx==0) {
                    valor_body = item.nombre_grupo;
                  } else if (idx==2) {
                    valor_body = item.conductor;
                  } else if (idx==7) {
                    valor_body = item.placa;
                  }

                  rows.push({
                    cells: [
                      { },
                      { value: valor_body, ...this.bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.indice_80, ...this.bodyRowsConfig, ...arrColor[item.background] },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },

                      { value: (idnex > 2) ? '': color_intervalo[idnex][0], ...this.bodyRowsConfig, ...arrColor[idnex]   },
                      { value: (idnex > 2) ? '': color_intervalo[idnex][1], ...this.bodyRowsConfig, ...arrColor[idnex]   },
                    ],
                    height: this.bodyRowsHeight
                  });
                  index2 = idnex;

                });

                index2++;
                if (index2 <= 2) {
                    for (let index = index2; index < color_intervalo.length; index++) {
                        rows.push({
                          cells: [
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },

                            { value: '', ...this.bodyRowsConfig },
                            { value: color_intervalo[index][0], ...this.bodyRowsConfig, ...arrColor[index]   },
                            { value: color_intervalo[index][1], ...this.bodyRowsConfig, ...arrColor[index]   },
                          ],
                          height: this.bodyRowsHeight
                        });
                    }
                }


                rows.push({ });
                rows.push({ });

                rows.push({
                  cells: [
                    { },
                    { value: clave_head, ...colHeaderConfig },
                    { value: 'Indice FB', ...colHeaderConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: 'COLOR', ...colHeaderConfig },
                    { value: 'INTERVALO', ...colHeaderConfig },
                  ],
                  height: 24 * this.excelUnitstoPxRatio, //this.bodyRowsHeight
                });

                var index2 = 0;
                data_grupos.forEach((item: { nombre_grupo:any; conductor:any; placa:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; }, idnex: number) => {

                  if (idx==0) {
                    valor_body = item.nombre_grupo;
                  } else if (idx==2) {
                    valor_body = item.conductor;
                  } else if (idx==7) {
                    valor_body = item.placa;
                  }

                  rows.push({
                    cells: [
                      { },
                      { value: valor_body, ...this.bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.indice_fb, ...this.bodyRowsConfig, ...arrColor[item.background] },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },

                      { value: (idnex > 2) ? '': color_intervalo[idnex][0], ...this.bodyRowsConfig, ...arrColor[idnex]  },
                      { value: (idnex > 2) ? '': color_intervalo[idnex][1], ...this.bodyRowsConfig, ...arrColor[idnex]  },
                    ],
                    height: this.bodyRowsHeight
                  });
                  index2 = idnex;

                });

                index2++;
                if (index2 <= 2) {
                    for (let index = index2; index < color_intervalo.length; index++) {
                        rows.push({
                          cells: [
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },

                            { value: '', ...this.bodyRowsConfig },
                            { value: color_intervalo[index][0], ...this.bodyRowsConfig, ...arrColor[index]  },
                            { value: color_intervalo[index][1], ...this.bodyRowsConfig, ...arrColor[index]  },
                          ],
                          height: this.bodyRowsHeight
                        });
                    }
                }


                rows.push({ });
                rows.push({ });

                rows.push({
                  cells: [
                    { },
                    { value: clave_head, ...colHeaderConfig },
                    { value: 'Indice Total', ...colHeaderConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: '', ...this.bodyRowsConfig },
                    { value: 'COLOR', ...colHeaderConfig },
                    { value: 'INTERVALO', ...colHeaderConfig },
                  ],
                  height: 24 * this.excelUnitstoPxRatio,// this.bodyRowsHeight
                });


                var index2 = 0;
                data_grupos.forEach((item: { nombre_grupo:any; conductor:any; placa:any; km_recorridos:number; horas_trabajadas:any; horas_movimiento:any; porcentaje_movimiento:any; horas_ralenti:any; porcentaje_ralenti:any; faltas_60:any; faltas_80:any; faltas_fb:any; total_faltas:any; indice_60:any; indice_80:any; indice_fb:any; indice_total:any; cont:any; background:any; }, idnex: number) => {

                  if (idx==0) {
                    valor_body = item.nombre_grupo;
                  } else if (idx==2) {
                    valor_body = item.conductor;
                  } else if (idx==7) {
                    valor_body = item.placa;
                  }

                  rows.push({
                    cells: [
                      { },
                      { value: valor_body, ...this.bodyRowsConfig, ...arrColor[item.background] },
                      { value: item.indice_total, ...this.bodyRowsConfig, ...arrColor[item.background] },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },
                      { value: '', ...this.bodyRowsConfig },

                      { value: (idnex > 2) ? '': color_intervalo[idnex][0], ...this.bodyRowsConfig, ...arrColor[idnex]  },
                      { value: (idnex > 2) ? '': color_intervalo[idnex][1], ...this.bodyRowsConfig, ...arrColor[idnex]  },
                    ],
                    height: this.bodyRowsHeight
                  });
                  index2 = idnex;

                });

                index2++;
                if (index2 <= 2) {
                    for (let index = index2; index < color_intervalo.length; index++) {
                        rows.push({
                          cells: [
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },
                            { value: '', ...this.bodyRowsConfig },

                            { value: '', ...this.bodyRowsConfig },
                            { value: color_intervalo[index][0], ...this.bodyRowsConfig, ...arrColor[index]  },
                            { value: color_intervalo[index][1], ...this.bodyRowsConfig, ...arrColor[index]  },
                          ],
                          height: this.bodyRowsHeight
                        });
                    }
                }


            }
        // });




        // //********************************************* excel version 1 *********************************
        if (vrs == 1) {
            // column_config = [
            //   { width: this.w_item },
            // ];

            // if(this.chkDateHour){
            //   column_config.push(
            //     { width: this.w_date },
            //     { width: this.w_hour },
            //   );
            // } else {
            //   column_config.push(
            //     { width: this.w_date_and_hour },
            //   );
            // }

            // column_config.push(
            //   { width: this.calculateColWidth(codigo_cell_ch_width) },
            //   { width: this.calculateColWidth(placa_cell_ch_width) },
            //   { width: this.calculateColWidth(tipo_unidad_cell_ch_width) },
            //   { width: this.calculateColWidth(id_conductor_cell_ch_width) },
            //   { width: this.calculateColWidth(conductor_cell_ch_width) },
            //   { width: this.calculateColWidth(tramo_cell_ch_width) },
            //   { width: this.calculateColWidth(limite_velocidad_cell_ch_width) },
            //   { width: this.calculateColWidth(exceso_velocidad_cell_ch_width) },
            //   { width: this.calculateColWidth(ubicacion_cell_ch_width) },
            // );

            // column_config = [{width:30*ratio},{width:108*ratio},{width:60*ratio},{width:60*ratio},
            //                   {width:60*ratio},{width:60*ratio},{width:60*ratio},{width:60*ratio}];

            column_config = column_config_arr[idx];


            exportFileEx.push({
              // freezePane: {
              //   rowSplit: 0//this.headerRowSpan + this.subHeaderContentRowSpan + 2
              //   },
              columns: column_config,
              // columns: [ { autoWidth: true } ],
              title: titulos_paginas[idx], //"Resultado01"+idx,//data[0][1],
              rows: rows
            });

            codigo_cell_ch_width = "codigo".length;
            placa_cell_ch_width = "placa".length;
            tipo_unidad_cell_ch_width = "Tipo unidad".length;
            id_conductor_cell_ch_width = "ID conductor".length;
            conductor_cell_ch_width = "conductor".length;
            tramo_cell_ch_width = "tramo".length;
            limite_velocidad_cell_ch_width = "Limite de".length;
            exceso_velocidad_cell_ch_width = "Exceso de".length;
            ubicacion_cell_ch_width = "Ubicacion".length;
        }
        // //********************************************* excel version 1 *********************************

        // //********************************************* excel version 2 *********************************

      // }
    });

    //********************************************* excel version 2 *********************************

    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    // if(bol_datos_ex){

      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: "REPORTE PETROLERO FULL BOLTRACK.xlsx"
      });

    // } else {
    //   alert('No se han encontrado datos para exportar');
    // }
  }


  exportExcelCoordenadasGeocercas(vrs: number) {
    // dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config: Columns[];
    var table_width = 10;// + (this.chkDateHour? 2: 1) -1;
    // var vehiculo_width = (this.chkDateHour? 5: 4) -1;

    var nro_geocerca_cell_ch_width = "Nº Geo".length;
    var nombre_geocerca_cell_ch_width = "Nombre Geocerca".length;
    var latitud_cell_ch_width = "Latitud".length;
    var longitud_cell_ch_width = "Longitud".length;

    var velocidad_cell_ch_width = "Velocidad".length;
    var vel_muy_grave_cell_ch_width = "Vel.Muy Grave".length;
    var vel_grave_cell_ch_width = "Vel.Grave".length;
    var vel_tolerable_cell_ch_width = "Vel.Tolerable".length;
    var zona_color_cell_ch_width = "Zona Color".length;


    // var allRows = [
    var allRows: AllRows[] = [
        {
          cells: [
            { value: "REPORTE COORDENADAS DE GEOCERCAS", ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];


    //this.data.forEach((table_data: any) => {

    this.sortedData.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        // var rows = [
        var rows:AllRows[] = [
          {
            cells: [
              { value: "REPORTE DE COORDENADAS DE GEOCERCAS", ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          // {
          //   cells: [
          //     { value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
          //     { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
          //   ],
          //   height: this.subHeaderHeight
          // },
          // {
          //   cells: [
          //     { value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
          //     { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
          //   ],
          //   height: this.subHeaderContentHeight
          // },
          //...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];


        if(this.chkDateHour) {


          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },
              { value: "Nº Geo", ...this.colHeaderConfig },
              { value: "Nombre Geocerca", ...this.colHeaderConfig },
              { value: "Latitud", ...this.colHeaderConfig },
              { value: "Longitud", ...this.colHeaderConfig },

              { value: "Velocidad", ...this.colHeaderConfig },
              { value: "Vel.Muy Grave", ...this.colHeaderConfig },
              { value: "Vel.Grave", ...this.colHeaderConfig },
              { value: "Vel.Tolerable", ...this.colHeaderConfig },
              { value: "Zona Color", ...this.colHeaderConfig },
            ],
            height: this.colsHeaderHeight
          });


          // data[1].forEach(function(item:any, index:any){


          data[1].forEach((item: { fecha: number;  lat: number; lng: number; nro: any; zone_name: any; vel_max: any; vel3_zona: any; vel2_zona: any; vel_zona: any; zone_color: any;}, index: number) => {


            nro_geocerca_cell_ch_width = Math.max(nro_geocerca_cell_ch_width, (item.nro??'').toString().length);
            nombre_geocerca_cell_ch_width = Math.max(nombre_geocerca_cell_ch_width, (item.zone_name??'').toString().length);
            latitud_cell_ch_width = Math.max(latitud_cell_ch_width, (item.lat??'').toString().length);
            longitud_cell_ch_width = Math.max(longitud_cell_ch_width, (item.lng??'').toString().length);

            velocidad_cell_ch_width = Math.max(velocidad_cell_ch_width, (item.vel_max??'').toString().length);
            vel_muy_grave_cell_ch_width = Math.max(vel_muy_grave_cell_ch_width, (item.vel3_zona??'').toString().length);
            vel_grave_cell_ch_width = Math.max(vel_grave_cell_ch_width, (item.vel2_zona??'').toString().length);
            vel_tolerable_cell_ch_width = Math.max(vel_tolerable_cell_ch_width, (item.vel_zona??'').toString().length);
            zona_color_cell_ch_width = Math.max(zona_color_cell_ch_width, (item.zone_color??'').toString().length);



            rows.push({
              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },

                { value: item.nro, ...this.bodyRowsConfig },
                { value: item.zone_name, ...this.bodyRowsConfig },
                { value: item.lat, ...this.bodyRowsConfig },
                { value: item.lng, ...this.bodyRowsConfig },

                { value: item.vel_max, ...this.bodyRowsConfig },
                { value: item.vel3_zona, ...this.bodyRowsConfig },
                { value: item.vel2_zona, ...this.bodyRowsConfig },
                { value: item.vel_zona, ...this.bodyRowsConfig },
                { value: item.zone_color, ...this.bodyRowsConfig },
              ],
              height: this.bodyRowsHeight
            });
          });



        } else {

          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },
              { value: "Nº Geo", ...this.colHeaderConfig },
              { value: "Nombre Geocerca", ...this.colHeaderConfig },
              { value: "Latitud", ...this.colHeaderConfig },
              { value: "Longitud", ...this.colHeaderConfig },

              { value: "Velocidad", ...this.colHeaderConfig },
              { value: "Vel.Muy Grave", ...this.colHeaderConfig },
              { value: "Vel.Grave", ...this.colHeaderConfig },
              { value: "Vel.Tolerable", ...this.colHeaderConfig },
              { value: "Zona Color", ...this.colHeaderConfig },
            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){
            data[1].forEach((item: { fecha: number;  lat: number; lng: number; nro: any; zone_name: any; vel_max: any; vel3_zona: any; vel2_zona: any; vel_zona: any; zone_color: any;}, index: number) => {

              nro_geocerca_cell_ch_width = Math.max(nro_geocerca_cell_ch_width, (item.nro??'').toString().length);
              nombre_geocerca_cell_ch_width = Math.max(nombre_geocerca_cell_ch_width, (item.zone_name??'').toString().length);
              latitud_cell_ch_width = Math.max(latitud_cell_ch_width, (item.lat??'').toString().length);
              longitud_cell_ch_width = Math.max(longitud_cell_ch_width, (item.lng??'').toString().length);

              velocidad_cell_ch_width = Math.max(velocidad_cell_ch_width, (item.vel_max??'').toString().length);
              vel_muy_grave_cell_ch_width = Math.max(vel_muy_grave_cell_ch_width, (item.vel3_zona??'').toString().length);
              vel_grave_cell_ch_width = Math.max(vel_grave_cell_ch_width, (item.vel2_zona??'').toString().length);
              vel_tolerable_cell_ch_width = Math.max(vel_tolerable_cell_ch_width, (item.vel_zona??'').toString().length);
              zona_color_cell_ch_width = Math.max(zona_color_cell_ch_width, (item.zone_color??'').toString().length);


            rows.push({

              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },

                { value: item.nro, ...this.bodyRowsConfig },
                { value: item.zone_name, ...this.bodyRowsConfig },
                { value: item.lat, ...this.bodyRowsConfig },
                { value: item.lng, ...this.bodyRowsConfig },

                { value: item.vel_max, ...this.bodyRowsConfig },
                { value: item.vel3_zona, ...this.bodyRowsConfig },
                { value: item.vel2_zona, ...this.bodyRowsConfig },
                { value: item.vel_zona, ...this.bodyRowsConfig },
                { value: item.zone_color, ...this.bodyRowsConfig },
              ],
              height: this.bodyRowsHeight

            });
          });

        }

        // //********************************************* excel version 1 *********************************
        if (vrs == 1) { // HOJAS SEPARADAS
            column_config = [
              { width: this.w_item },
            ];

            column_config.push(
              { width: this.calculateColWidth(nro_geocerca_cell_ch_width) },
              { width: this.calculateColWidth(nombre_geocerca_cell_ch_width) },
              { width: this.calculateColWidth(latitud_cell_ch_width) },
              { width: this.calculateColWidth(longitud_cell_ch_width) },

              { width: this.calculateColWidth(velocidad_cell_ch_width) },
              { width: this.calculateColWidth(vel_muy_grave_cell_ch_width) },
              { width: this.calculateColWidth(vel_grave_cell_ch_width) },
              { width: this.calculateColWidth(vel_tolerable_cell_ch_width) },
              { width: this.calculateColWidth(zona_color_cell_ch_width) },

            );

            exportFileEx.push({
              freezePane: {
                  rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2 - 3,
                },
              columns: column_config,
              title: "Resultado1", //data[0][1],
              rows: rows
            });


            nro_geocerca_cell_ch_width = "Nº Geo".length;
            nombre_geocerca_cell_ch_width = "Nombre Geocerca".length;
            latitud_cell_ch_width = "Latitud".length;
            longitud_cell_ch_width = "Longitud".length;

            velocidad_cell_ch_width = "Velocidad".length;
            vel_muy_grave_cell_ch_width = "Vel.Muy Grave".length;
            vel_grave_cell_ch_width = "Vel.Grave".length;
            vel_tolerable_cell_ch_width = "Vel.Tolerable".length;
            zona_color_cell_ch_width = "Zona Color".length;




        }
        // //********************************************* excel version 1 *********************************

        // //********************************************* excel version 2 *********************************
        if (vrs == 2) {
           rows.splice(0, this.headerRowSpan);
           rows.push(...this.spaceBetweenTables);
           allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) { // TODO JUNTO
        allRows[0].cells![0].colSpan = table_width;

        column_config = [
          { width: this.w_item },
        ];

        column_config.push(
          { width: this.calculateColWidth(nro_geocerca_cell_ch_width) },
          { width: this.calculateColWidth(nombre_geocerca_cell_ch_width) },
          { width: this.calculateColWidth(latitud_cell_ch_width) },
          { width: this.calculateColWidth(longitud_cell_ch_width) },

          { width: this.calculateColWidth(velocidad_cell_ch_width) },
          { width: this.calculateColWidth(vel_muy_grave_cell_ch_width) },
          { width: this.calculateColWidth(vel_grave_cell_ch_width) },
          { width: this.calculateColWidth(vel_tolerable_cell_ch_width) },
          { width: this.calculateColWidth(zona_color_cell_ch_width) },

        );

        exportFileEx.push({
          freezePane: {
              rowSplit: this.headerRowSpan + 1 ,
            },
          columns: column_config,
          title: "Resultado2",//data[0][1],
          rows: allRows
        });
    }
    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: "ReporteCoordenadasGeocercas.xlsx"
      });

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }

  exportExcelCoordenadasGeopuntos(vrs: number) {
    // dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config: Columns[];
    var table_width = 10;// + (this.chkDateHour? 2: 1) -1;
    // var vehiculo_width = (this.chkDateHour? 5: 4) -1;

    var nro_punto_cell_ch_width = "Nº Punto".length;
    var nombre_punto_cell_ch_width = "Nombre Punto".length;
    var latitud_cell_ch_width = "Latitud".length;
    var longitud_cell_ch_width = "Longitud".length;
    var color_cell_ch_width = "Color".length;

    var visibilidad_punto_cell_ch_width = "Visibilidad Punto".length;
    var visibilidad_nombre_cell_ch_width = "Visibilidad Nombre".length;
    var latitud2_cell_ch_width = "Latitud 2".length;
    var longitud2_cell_ch_width = "Longitud 2".length;


    // var allRows = [
    var allRows: AllRows[] = [
        {
          cells: [
            { value: "REPORTE COORDENADAS DE GEOPUNTOS", ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];


    //this.data.forEach((table_data: any) => {

    this.sortedData.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        // var rows = [
        var rows:AllRows[] = [
          {
            cells: [
              { value: "REPORTE DE COORDENADAS DE GEOPUNTOS", ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          // {
          //   cells: [
          //     { value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
          //     { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
          //   ],
          //   height: this.subHeaderHeight
          // },
          // {
          //   cells: [
          //     { value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
          //     { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
          //   ],
          //   height: this.subHeaderContentHeight
          // },
          //...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];


        if(this.chkDateHour) {


          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },
              { value: "Nº Punto", ...this.colHeaderConfig },
              { value: "Nombre Punto", ...this.colHeaderConfig },
              { value: "Latitud", ...this.colHeaderConfig },
              { value: "Longitud", ...this.colHeaderConfig },
              { value: "Color", ...this.colHeaderConfig },

              { value: "Visibilidad Punto", ...this.colHeaderConfig },
              { value: "Visibilidad Nombre", ...this.colHeaderConfig },
              { value: "Latitud 2", ...this.colHeaderConfig },
              { value: "Longitud 2", ...this.colHeaderConfig },
            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){

          data[1].forEach((item: { lat: number; lng: number; nro: any; geopunto_name: any; geopunto_color: any; geopunto_visible: any; geopunto_nombre_visible: any; lat_1: any; lng_1: any;}, index: number) => {


            nro_punto_cell_ch_width = Math.max(nro_punto_cell_ch_width, (item.nro??'').toString().length);
            nombre_punto_cell_ch_width = Math.max(nombre_punto_cell_ch_width, (item.geopunto_name??'').toString().length);
            latitud_cell_ch_width = Math.max(latitud_cell_ch_width, (item.lat??'').toString().length);
            longitud_cell_ch_width = Math.max(longitud_cell_ch_width, (item.lng??'').toString().length);
            color_cell_ch_width = Math.max(color_cell_ch_width, (item.geopunto_color??'').toString().length);

            visibilidad_punto_cell_ch_width = Math.max(visibilidad_punto_cell_ch_width, (item.geopunto_visible??'').toString().length);
            visibilidad_nombre_cell_ch_width = Math.max(visibilidad_nombre_cell_ch_width, (item.geopunto_nombre_visible??'').toString().length);
            latitud2_cell_ch_width = Math.max(latitud2_cell_ch_width, (item.lat_1??'').toString().length);
            longitud2_cell_ch_width = Math.max(longitud2_cell_ch_width, (item.lng_1??'').toString().length);


            rows.push({
              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },
                { value: item.nro, ...this.bodyRowsConfig },
                { value: item.geopunto_name, ...this.bodyRowsConfig },
                { value: item.lat, ...this.bodyRowsConfig },
                { value: item.lng, ...this.bodyRowsConfig },
                { value: item.geopunto_color, ...this.bodyRowsConfig },

                { value: item.geopunto_visible, ...this.bodyRowsConfig },
                { value: item.geopunto_nombre_visible, ...this.bodyRowsConfig },
                { value: item.lat_1, ...this.bodyRowsConfig },
                { value: item.lng_1, ...this.bodyRowsConfig },
              ],
              height: this.bodyRowsHeight
            });
          });


        } else {

          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },
              { value: "Nº Punto", ...this.colHeaderConfig },
              { value: "Nombre Punto", ...this.colHeaderConfig },
              { value: "Latitud", ...this.colHeaderConfig },
              { value: "Longitud", ...this.colHeaderConfig },
              { value: "Color", ...this.colHeaderConfig },

              { value: "Visibilidad Punto", ...this.colHeaderConfig },
              { value: "Visibilidad Nombre", ...this.colHeaderConfig },
              { value: "Latitud 2", ...this.colHeaderConfig },
              { value: "Longitud 2", ...this.colHeaderConfig },
            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){
          data[1].forEach((item: { lat: number; lng: number; nro: any; geopunto_name: any; geopunto_color: any; geopunto_visible: any; geopunto_nombre_visible: any; lat_1: any; lng_1: any;}, index: number) => {

            nro_punto_cell_ch_width = Math.max(nro_punto_cell_ch_width, (item.nro??'').toString().length);
            nombre_punto_cell_ch_width = Math.max(nombre_punto_cell_ch_width, (item.geopunto_name??'').toString().length);
            latitud_cell_ch_width = Math.max(latitud_cell_ch_width, (item.lat??'').toString().length);
            longitud_cell_ch_width = Math.max(longitud_cell_ch_width, (item.lng??'').toString().length);
            color_cell_ch_width = Math.max(color_cell_ch_width, (item.geopunto_color??'').toString().length);

            visibilidad_punto_cell_ch_width = Math.max(visibilidad_punto_cell_ch_width, (item.geopunto_visible??'').toString().length);
            visibilidad_nombre_cell_ch_width = Math.max(visibilidad_nombre_cell_ch_width, (item.geopunto_nombre_visible??'').toString().length);
            latitud2_cell_ch_width = Math.max(latitud2_cell_ch_width, (item.lat_1??'').toString().length);
            longitud2_cell_ch_width = Math.max(longitud2_cell_ch_width, (item.lng_1??'').toString().length);

            rows.push({

              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },
                { value: item.nro, ...this.bodyRowsConfig },
                { value: item.geopunto_name, ...this.bodyRowsConfig },
                { value: item.lat, ...this.bodyRowsConfig },
                { value: item.lng, ...this.bodyRowsConfig },
                { value: item.geopunto_color, ...this.bodyRowsConfig },

                { value: item.geopunto_visible, ...this.bodyRowsConfig },
                { value: item.geopunto_nombre_visible, ...this.bodyRowsConfig },
                { value: item.lat_1, ...this.bodyRowsConfig },
                { value: item.lng_1, ...this.bodyRowsConfig },
              ],
              height: this.bodyRowsHeight

            });
          });

        }

        // //********************************************* excel version 1 *********************************
        if (vrs == 1) { // HOJAS SEPARADAS
            column_config = [
              { width: this.w_item },
            ];

            column_config.push(
              { width: this.calculateColWidth(nro_punto_cell_ch_width) },
              { width: this.calculateColWidth(nombre_punto_cell_ch_width) },
              { width: this.calculateColWidth(latitud_cell_ch_width) },
              { width: this.calculateColWidth(longitud_cell_ch_width) },
              { width: this.calculateColWidth(color_cell_ch_width) },

              { width: this.calculateColWidth(visibilidad_punto_cell_ch_width) },
              { width: this.calculateColWidth(visibilidad_nombre_cell_ch_width) },
              { width: this.calculateColWidth(latitud2_cell_ch_width) },
              { width: this.calculateColWidth(longitud2_cell_ch_width) },

            );

            exportFileEx.push({
              freezePane: {
                  rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2 - 3,
                },
              columns: column_config,
              title: "Resultado1", //data[0][1],
              rows: rows
            });

            nro_punto_cell_ch_width = "Nº Punto".length;
            nombre_punto_cell_ch_width = "Nombre Punto".length;
            latitud_cell_ch_width = "Latitud".length;
            longitud_cell_ch_width = "Longitud".length;
            color_cell_ch_width = "Color".length;

            visibilidad_punto_cell_ch_width = "Visibilidad Punto".length;
            visibilidad_nombre_cell_ch_width = "Visibilidad Nombre".length;
            latitud2_cell_ch_width = "Latitud 2".length;
            longitud2_cell_ch_width = "Longitud 2".length;


        }
        // //********************************************* excel version 1 *********************************

        // //********************************************* excel version 2 *********************************
        if (vrs == 2) {
           rows.splice(0, this.headerRowSpan);
           rows.push(...this.spaceBetweenTables);
           allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) { // TODO JUNTO
        allRows[0].cells![0].colSpan = table_width;

        column_config = [
          { width: this.w_item },
        ];

        column_config.push(
          { width: this.calculateColWidth(nro_punto_cell_ch_width) },
          { width: this.calculateColWidth(nombre_punto_cell_ch_width) },
          { width: this.calculateColWidth(latitud_cell_ch_width) },
          { width: this.calculateColWidth(longitud_cell_ch_width) },
          { width: this.calculateColWidth(color_cell_ch_width) },

          { width: this.calculateColWidth(visibilidad_punto_cell_ch_width) },
          { width: this.calculateColWidth(visibilidad_nombre_cell_ch_width) },
          { width: this.calculateColWidth(latitud2_cell_ch_width) },
          { width: this.calculateColWidth(longitud2_cell_ch_width) },

        );

        exportFileEx.push({
          freezePane: {
              rowSplit: this.headerRowSpan + 1 ,
            },
          columns: column_config,
          title: "Resultado2",//data[0][1],
          rows: allRows
        });
    }
    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: "ReporteCoordenadasGeopuntos.xlsx"
      });

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }

  exportExcelCoordenadasGeocercasCirculares(vrs: number) {
    // dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config: Columns[];
    var table_width = 12;// + (this.chkDateHour? 2: 1) -1;
    // var vehiculo_width = (this.chkDateHour? 5: 4) -1;

    var nro_geocerca_cell_ch_width = "Nº Geo".length;
    var nombre_geocerca_cell_ch_width = "Nombre Geocerca".length;
    var latitud_cell_ch_width = "Latitud".length;
    var longitud_cell_ch_width = "Longitud".length;
    var radio_cell_ch_width = "radio".length;
    var diametro_cell_ch_width = "diametro".length;

    var velocidad_cell_ch_width = "Velocidad".length;
    var vel_muy_grave_cell_ch_width = "Vel.Muy Grave".length;
    var vel_grave_cell_ch_width = "Vel.Grave".length;
    var vel_tolerable_cell_ch_width = "Vel.Tolerable".length;
    var zona_color_cell_ch_width = "Zona Color".length;


    // var allRows = [
    var allRows: AllRows[] = [
        {
          cells: [
            { value: "REPORTE COORDENADAS DE GEOCERCAS CIRCULARES", ...this.headerCellConfig, colSpan: table_width }
          ],
          height: this.headerRowsHeight
        },
        ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
    ];


    //this.data.forEach((table_data: any) => {

    this.sortedData.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        // var rows = [
        var rows:AllRows[] = [
          {
            cells: [
              { value: "REPORTE DE COORDENADAS DE GEOCERCAS CIRCULARES", ...this.headerCellConfig, colSpan: table_width }
            ],
            height: this.headerRowsHeight
          },
          ...this.generateEmptyRowsForRowSpan(this.headerRowSpan, this.headerRowsHeight),
          // {
          //   cells: [
          //     { value: "VEHÍCULO", ...this.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
          //     { value: "PERIODO", ...this.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
          //   ],
          //   height: this.subHeaderHeight
          // },
          // {
          //   cells: [
          //     { value: data[0][1], ...this.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
          //     { value: this.period, ...this.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
          //   ],
          //   height: this.subHeaderContentHeight
          // },
          //...this.generateEmptyRowsForRowSpan(this.subHeaderContentRowSpan, this.subHeaderContentHeight),
        ];


        if(this.chkDateHour) {


          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },
              { value: "Nº Geo", ...this.colHeaderConfig },
              { value: "Nombre Geocerca", ...this.colHeaderConfig },
              { value: "Latitud", ...this.colHeaderConfig },
              { value: "Longitud", ...this.colHeaderConfig },
              { value: "radio", ...this.colHeaderConfig },
              { value: "diametro", ...this.colHeaderConfig },

              { value: "Velocidad", ...this.colHeaderConfig },
              { value: "Vel.Muy Grave", ...this.colHeaderConfig },
              { value: "Vel.Grave", ...this.colHeaderConfig },
              { value: "Vel.Tolerable", ...this.colHeaderConfig },
              { value: "Zona Color", ...this.colHeaderConfig },
            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){


          data[1].forEach((item: { fecha: number;  lat: number; lng: number; radio:number; diametro:number; nro: any; geocerca_name: any; v0: any; v3: any; v2: any; v1: any; geocerca_color: any;}, index: number) => {


            nro_geocerca_cell_ch_width = Math.max(nro_geocerca_cell_ch_width, (item.nro??'').toString().length);
            nombre_geocerca_cell_ch_width = Math.max(nombre_geocerca_cell_ch_width, (item.geocerca_name??'').toString().length);
            latitud_cell_ch_width = Math.max(latitud_cell_ch_width, (item.lat??'').toString().length);
            longitud_cell_ch_width = Math.max(longitud_cell_ch_width, (item.lng??'').toString().length);
            radio_cell_ch_width = Math.max(radio_cell_ch_width, (item.radio??'').toString().length);
            diametro_cell_ch_width = Math.max(diametro_cell_ch_width, (item.diametro??'').toString().length);

            velocidad_cell_ch_width = Math.max(velocidad_cell_ch_width, (item.v0??'').toString().length);
            vel_muy_grave_cell_ch_width = Math.max(vel_muy_grave_cell_ch_width, (item.v3??'').toString().length);
            vel_grave_cell_ch_width = Math.max(vel_grave_cell_ch_width, (item.v2??'').toString().length);
            vel_tolerable_cell_ch_width = Math.max(vel_tolerable_cell_ch_width, (item.v1??'').toString().length);
            zona_color_cell_ch_width = Math.max(zona_color_cell_ch_width, (item.geocerca_color??'').toString().length);

            rows.push({
              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },

                { value: item.nro, ...this.bodyRowsConfig },
                { value: item.geocerca_name, ...this.bodyRowsConfig },
                { value: item.lat, ...this.bodyRowsConfig },
                { value: item.lng, ...this.bodyRowsConfig },
                { value: item.radio, ...this.bodyRowsConfig },
                { value: item.diametro, ...this.bodyRowsConfig },

                { value: item.v0, ...this.bodyRowsConfig },
                { value: item.v3, ...this.bodyRowsConfig },
                { value: item.v2, ...this.bodyRowsConfig },
                { value: item.v1, ...this.bodyRowsConfig },
                { value: item.geocerca_color, ...this.bodyRowsConfig },
              ],
              height: this.bodyRowsHeight
            });
          });


        } else {

          rows.push({
            cells: [
              { value: "Item", ...this.colHeaderConfig },
              { value: "Nº Geo", ...this.colHeaderConfig },
              { value: "Nombre Geocerca", ...this.colHeaderConfig },
              { value: "Latitud", ...this.colHeaderConfig },
              { value: "Longitud", ...this.colHeaderConfig },
              { value: "radio", ...this.colHeaderConfig },
              { value: "diametro", ...this.colHeaderConfig },

              { value: "Velocidad", ...this.colHeaderConfig },
              { value: "Vel.Muy Grave", ...this.colHeaderConfig },
              { value: "Vel.Grave", ...this.colHeaderConfig },
              { value: "Vel.Tolerable", ...this.colHeaderConfig },
              { value: "Zona Color", ...this.colHeaderConfig },
            ],
            height: this.colsHeaderHeight
          });

          // data[1].forEach(function(item:any, index:any){
          data[1].forEach((item: { fecha: number;  lat: number; lng: number; radio:number; diametro:number; nro: any; geocerca_name: any; v0: any; v3: any; v2: any; v1: any; geocerca_color: any;}, index: number) => {

              nro_geocerca_cell_ch_width = Math.max(nro_geocerca_cell_ch_width, (item.nro??'').toString().length);
              nombre_geocerca_cell_ch_width = Math.max(nombre_geocerca_cell_ch_width, (item.geocerca_name??'').toString().length);
              latitud_cell_ch_width = Math.max(latitud_cell_ch_width, (item.lat??'').toString().length);
              longitud_cell_ch_width = Math.max(longitud_cell_ch_width, (item.lng??'').toString().length);
              radio_cell_ch_width = Math.max(radio_cell_ch_width, (item.radio??'').toString().length);
              diametro_cell_ch_width = Math.max(diametro_cell_ch_width, (item.diametro??'').toString().length);

              velocidad_cell_ch_width = Math.max(velocidad_cell_ch_width, (item.v0??'').toString().length);
              vel_muy_grave_cell_ch_width = Math.max(vel_muy_grave_cell_ch_width, (item.v3??'').toString().length);
              vel_grave_cell_ch_width = Math.max(vel_grave_cell_ch_width, (item.v2??'').toString().length);
              vel_tolerable_cell_ch_width = Math.max(vel_tolerable_cell_ch_width, (item.v1??'').toString().length);
              zona_color_cell_ch_width = Math.max(zona_color_cell_ch_width, (item.geocerca_color??'').toString().length);


            rows.push({

              cells: [
                { value: (index + 1), ...this.bodyRowsConfig },

                { value: item.nro, ...this.bodyRowsConfig },
                { value: item.geocerca_name, ...this.bodyRowsConfig },
                { value: item.lat, ...this.bodyRowsConfig },
                { value: item.lng, ...this.bodyRowsConfig },
                { value: item.radio, ...this.bodyRowsConfig },
                { value: item.diametro, ...this.bodyRowsConfig },

                { value: item.v0, ...this.bodyRowsConfig },
                { value: item.v3, ...this.bodyRowsConfig },
                { value: item.v2, ...this.bodyRowsConfig },
                { value: item.v1, ...this.bodyRowsConfig },
                { value: item.geocerca_color, ...this.bodyRowsConfig },
              ],
              height: this.bodyRowsHeight

            });
          });

        }

        // //********************************************* excel version 1 *********************************
        if (vrs == 1) { // HOJAS SEPARADAS
            column_config = [
              { width: this.w_item },
            ];

            column_config.push(
              { width: this.calculateColWidth(nro_geocerca_cell_ch_width) },
              { width: this.calculateColWidth(nombre_geocerca_cell_ch_width) },
              { width: this.calculateColWidth(latitud_cell_ch_width) },
              { width: this.calculateColWidth(longitud_cell_ch_width) },
              { width: this.calculateColWidth(radio_cell_ch_width) },
              { width: this.calculateColWidth(diametro_cell_ch_width) },

              { width: this.calculateColWidth(velocidad_cell_ch_width) },
              { width: this.calculateColWidth(vel_muy_grave_cell_ch_width) },
              { width: this.calculateColWidth(vel_grave_cell_ch_width) },
              { width: this.calculateColWidth(vel_tolerable_cell_ch_width) },
              { width: this.calculateColWidth(zona_color_cell_ch_width) },

            );

            exportFileEx.push({
              freezePane: {
                  rowSplit: this.headerRowSpan + this.subHeaderContentRowSpan + 2 - 3,
                },
              columns: column_config,
              title: "Resultado1", //data[0][1],
              rows: rows
            });


            nro_geocerca_cell_ch_width = "Nº Geo".length;
            nombre_geocerca_cell_ch_width = "Nombre Geocerca".length;
            latitud_cell_ch_width = "Latitud".length;
            longitud_cell_ch_width = "Longitud".length;
            radio_cell_ch_width = "radio".length;
            diametro_cell_ch_width = "diametro".length;

            velocidad_cell_ch_width = "Velocidad".length;
            vel_muy_grave_cell_ch_width = "Vel.Muy Grave".length;
            vel_grave_cell_ch_width = "Vel.Grave".length;
            vel_tolerable_cell_ch_width = "Vel.Tolerable".length;
            zona_color_cell_ch_width = "Zona Color".length;




        }
        // //********************************************* excel version 1 *********************************

        // //********************************************* excel version 2 *********************************
        if (vrs == 2) {
           rows.splice(0, this.headerRowSpan);
           rows.push(...this.spaceBetweenTables);
           allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) { // TODO JUNTO
        allRows[0].cells![0].colSpan = table_width;

        column_config = [
          { width: this.w_item },
        ];

        column_config.push(
          { width: this.calculateColWidth(nro_geocerca_cell_ch_width) },
          { width: this.calculateColWidth(nombre_geocerca_cell_ch_width) },
          { width: this.calculateColWidth(latitud_cell_ch_width) },
          { width: this.calculateColWidth(longitud_cell_ch_width) },
          { width: this.calculateColWidth(radio_cell_ch_width) },
          { width: this.calculateColWidth(diametro_cell_ch_width) },

          { width: this.calculateColWidth(velocidad_cell_ch_width) },
          { width: this.calculateColWidth(vel_muy_grave_cell_ch_width) },
          { width: this.calculateColWidth(vel_grave_cell_ch_width) },
          { width: this.calculateColWidth(vel_tolerable_cell_ch_width) },
          { width: this.calculateColWidth(zona_color_cell_ch_width) },

        );

        exportFileEx.push({
          freezePane: {
              rowSplit: this.headerRowSpan + 1 ,
            },
          columns: column_config,
          title: "Resultado2",//data[0][1],
          rows: allRows
        });
    }
    //********************************************* excel version 2 *********************************

    console.log(exportFileEx);

    if(bol_datos_ex){
      var workbook = new kendo.ooxml.Workbook({
        sheets: exportFileEx
      });

      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: "ReporteCoordenadasGeocercasCirculares.xlsx"
      });

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }



  // EXPORTACION DE PDF

  fileLogoRoot = "./assets/logos/"
  logo_cruzdelsurUrl = this.fileLogoRoot + "CruzDelSur.png";
  logo_gltrackerUrl = this.fileLogoRoot + "GltrackerLogo.jpg";
  logo_gltracker2Url = this.fileLogoRoot + "GltrackerLogo.png";

  logo_cruzdelsur: string  = "";
  logo_gltracker: string  = "";
  logo_gltracker2: string = "";

  async loadLogos() {
    this.logo_cruzdelsur = await this.getCodigoLogo(this.logo_cruzdelsurUrl);
    this.logo_gltracker = await this.getCodigoLogo(this.logo_gltrackerUrl);
    this.logo_gltracker2 = await this.getCodigoLogo(this.logo_gltracker2Url);
  }
  async getCodigoLogo(url: string): Promise<string> {
    const response = await fetch(url);
    const blob = await response.blob();
    const reader = new FileReader();
  
    return new Promise<string>((resolve, reject) => {
      reader.onloadend = () => {
        resolve(reader.result as string); // Devuelve una cadena Base64
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob); // Convierte la imagen a Base64
    });
  }

  // arrDataGrafico  = [false,false,false,false,false,false,false,false,false,false,false,false];
  arrDataGrafico  = [true,true,true,true,true,true,true,true,true,true,true,true];

  arrDataPlot  = ['','','','','','','','','','','',''];

  arrDataTabla  = {
        distraccion:0,
        posible_fatiga:0,
        fatiga_extrema:0
      };

  contador = 1;//reportServices.getNroGenReport();

  //================== Datos reporte formato Betsy =====================

  //  tablaFormatoBetsy_1: any = [];
   rep_contReport : any;
   arr_evaluacion2:any;

   arr_evaluacion :any;
   arr_evaluacion_ini :any;



  //================ Datos reporte formato Betsy FIN ===================

  fatigaExtremaNewFormato (){

    //console.log("_______________fatigaExtremaNewFormato");
    // var id = parseInt(reportServices.getuserD());
    // console.log(id);
    // console.log(vm.datos);
    // console.log(vm.arr_evaluacion2);
    // var mostrar = false; // ocultar por defecto

    var contReport = this.reportService.contReport;
    // console.log(this.reportService.contReport);
    // console.log(contReport +" - "+this.rep_contReport);


    if (contReport == this.rep_contReport) {
      //console.log("contReport hasta igual .... misma consulta");
    } else {
      //console.log("contReport hasta diferente .... nueva consulta");
      //this.arr_evaluacion = undefined;
      this.arr_evaluacion2 = undefined;
    }


    if (this.arr_evaluacion2 === undefined) {
      // console.log('undefined == this.arr_evaluacion2');
      // console.log(this.arr_evaluacion2);

      //this.arr_evaluacion = [];
      this.arr_evaluacion2 = [];
      this.arr_evaluacion_ini = [];
      this.tablaFormatoBetsy_1 = [];

      this.rep_contReport = contReport;
      //console.log(this.data);

      for (let i = 0; i < this.data.length; i++) {
        const lista_eventos = this.data[i][1];

        //var arr_elements = [];
        for (let j = 0; j < lista_eventos.length; j++) {
          // arr_elements.push([ lista_eventos[j].criterio_evaluacion, lista_eventos[j].observacion_evaluacion, lista_eventos[j].fecha_evaluacion, lista_eventos[j].operador_monitoreo ]);
          //======================= formato 2 ===========================
          this.tablaFormatoBetsy_1.push(lista_eventos[j]);

        }
        // console.log(arr_elements);
        //vm.arr_evaluacion.push(arr_elements);
      }
      this.tablaFormatoBetsy_1.sort( this.compare );
      // cons

      for (let i = 0; i < this.tablaFormatoBetsy_1.length; i++) {
        this.arr_evaluacion2.push([ this.tablaFormatoBetsy_1[i].criterio_evaluacion, this.tablaFormatoBetsy_1[i].observacion_evaluacion, this.tablaFormatoBetsy_1[i].fecha_evaluacion, this.tablaFormatoBetsy_1[i].operador_monitoreo, this.tablaFormatoBetsy_1[i].fecha, this.tablaFormatoBetsy_1[i].nombre, i]);

        this.arr_evaluacion_ini.push([ this.tablaFormatoBetsy_1[i].criterio_evaluacion, this.tablaFormatoBetsy_1[i].observacion_evaluacion, this.tablaFormatoBetsy_1[i].fecha_evaluacion, this.tablaFormatoBetsy_1[i].operador_monitoreo, this.tablaFormatoBetsy_1[i].fecha, this.tablaFormatoBetsy_1[i].nombre, i]);
      }

      // console.log(' ============  this.tablaFormatoBetsy_1  =========== ');

      // console.log(this.tablaFormatoBetsy_1);
      // console.log(this.arr_evaluacion2);
      // console.log(this.arr_evaluacion_ini);




    } else {
      // console.log('undefined != this.arr_evaluacion2');
      // console.log(this.arr_evaluacion2);
      // console.log(this.tablaFormatoBetsy_1);

      for (let i = 0; i < this.tablaFormatoBetsy_1.length; i++) {

        this.arr_evaluacion2[i][3] = this.tablaFormatoBetsy_1[i].operador_monitoreo;


          if (this.tablaFormatoBetsy_1[i].criterio_evaluacion == this.arr_evaluacion2[i][0] && this.tablaFormatoBetsy_1[i].observacion_evaluacion == this.arr_evaluacion2[i][1] ) {
          } else {
            // console.log("========valor diferente al anterior ::::::: "+i);
            // console.log(this.tablaFormatoBetsy_1[i].criterio_evaluacion+" - "+this.arr_evaluacion2[i][0]+" - "+this.tablaFormatoBetsy_1[i].observacion_evaluacion+" - "+this.arr_evaluacion2[i][1]);





            //FUNCION PARA GUARDAR

            this.arr_evaluacion2[i][0] = this.tablaFormatoBetsy_1[i].criterio_evaluacion;
            this.arr_evaluacion2[i][1] = this.tablaFormatoBetsy_1[i].observacion_evaluacion;



            if ( (this.tablaFormatoBetsy_1[i].criterio_evaluacion != '' || this.tablaFormatoBetsy_1[i].observacion_evaluacion != '') && this.tablaFormatoBetsy_1[i].fecha_evaluacion == '') {
              this.tablaFormatoBetsy_1[i].fecha_evaluacion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss"); //actualizar = true;
              this.arr_evaluacion2[i][2] = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
            }

            // if ( (vm.arr_evaluacion2[i][0] == '' || vm.arr_evaluacion2[i][0] === undefined) && (vm.arr_evaluacion2[i][1] == '' || vm.arr_evaluacion2[i][1] === undefined) ) {
            // 	vm.tablaFormatoBetsy_1[i].fecha_evaluacion = ''; //actualizar = true;
            // 	vm.arr_evaluacion2[i][2] = 'S';
            // } else {
            // 	vm.tablaFormatoBetsy_1[i].fecha_evaluacion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss"); //actualizar = true;
            // 	vm.arr_evaluacion2[i][2] = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
            // }


          }

      }
    }


    // // var dataParams =  reportServices.getParam();

    // var contReport =  reportServices.getNroGenReport();


    // // console.log(dataParams);
    // // console.log(dataParams['fecha_hasta'] +" - "+vm.rep_fecha_fin);
    // // console.log(dataParams['fecha_hasta'] +" - "+vm.rep_fecha_fin);
    // // console.log(dataParams['vehiculos']   +" - "+vm.rep_vehiculos);
    // // if (dataParams['fecha_desde'] == vm.rep_fecha_ini &&
    // // 	dataParams['fecha_hasta'] == vm.rep_fecha_fin &&
    // // 	dataParams['vehiculos']   == vm.rep_vehiculos ) {
    // // 	console.log("fecha hasta igual .... misma consulta");
    // // } else {
    // // 	console.log("fecha hasta diferente .... nueva consulta");
    // // 	vm.arr_evaluacion = undefined;
    // // }

    // console.log(contReport +" - "+vm.rep_contReport);
    // if (contReport == vm.rep_contReport) {
    //   console.log("contReport hasta igual .... misma consulta");
    // } else {
    //   console.log("contReport hasta diferente .... nueva consulta");
    //   vm.arr_evaluacion = undefined;
    //   vm.arr_evaluacion2 = undefined;
    // }


    // // if (vm.arr_evaluacion === undefined) {
    // if (vm.arr_evaluacion2 === undefined) {
    //   vm.arr_evaluacion = [];
    //   vm.arr_evaluacion2 = [];
    //   vm.arr_evaluacion_ini = [];
    //   vm.tablaFormatoBetsy_1 = [];
    //   // vm.rep_fecha_ini = dataParams['fecha_desde'];
    //   // vm.rep_fecha_fin = dataParams['fecha_hasta'];
    //   // vm.rep_vehiculos = dataParams['vehiculos'];
    //   vm.rep_contReport = contReport;

    //   console.log(vm.datos);
    //   for (let i = 0; i < vm.datos.length; i++) {
    //     const lista_eventos = vm.datos[i][1];

    //     var arr_elements = [];
    //     for (let j = 0; j < lista_eventos.length; j++) {
    //       // arr_elements.push([ lista_eventos[j].criterio_evaluacion, lista_eventos[j].observacion_evaluacion, lista_eventos[j].fecha_evaluacion, lista_eventos[j].operador_monitoreo ]);
    //       //======================= formato 2 ===========================
    //       vm.tablaFormatoBetsy_1.push(lista_eventos[j]);

    //     }
    //     // console.log(arr_elements);
    //     //vm.arr_evaluacion.push(arr_elements);
    //   }

    //   // console.log("vacia a llena ========");
    //   // console.log(vm.datos);
    //   // console.log(vm.arr_evaluacion);
    //   console.log("LLENAR TABLA FORMATO BETSY");
    //   console.log(vm.tablaFormatoBetsy_1);


    //   vm.tablaFormatoBetsy_1.sort( compare );
    //   for (let i = 0; i < vm.tablaFormatoBetsy_1.length; i++) {
    //     vm.arr_evaluacion2.push([ vm.tablaFormatoBetsy_1[i].criterio_evaluacion, vm.tablaFormatoBetsy_1[i].observacion_evaluacion, vm.tablaFormatoBetsy_1[i].fecha_evaluacion, vm.tablaFormatoBetsy_1[i].operador_monitoreo, vm.tablaFormatoBetsy_1[i].fecha, vm.tablaFormatoBetsy_1[i].nombre, i]);

    //     vm.arr_evaluacion_ini.push([ vm.tablaFormatoBetsy_1[i].criterio_evaluacion, vm.tablaFormatoBetsy_1[i].observacion_evaluacion, vm.tablaFormatoBetsy_1[i].fecha_evaluacion, vm.tablaFormatoBetsy_1[i].operador_monitoreo, vm.tablaFormatoBetsy_1[i].fecha, vm.tablaFormatoBetsy_1[i].nombre, i]);
    //   }
    //   console.log(vm.arr_evaluacion2);
    //     // vm.tablaFormatoBetsy_1[i].criterio_evaluacion, 0
    //     // vm.tablaFormatoBetsy_1[i].observacion_evaluacion, 1
    //     // vm.tablaFormatoBetsy_1[i].fecha_evaluacion, 2
    //     // vm.tablaFormatoBetsy_1[i].operador_monitoreo,3
    //     // vm.tablaFormatoBetsy_1[i].fecha, 4
    //     // vm.tablaFormatoBetsy_1[i].nombre 5


    // } else {
    //   console.log("=====================W");
    //   // console.log(vm.datos);
    //   // console.log(vm.arr_evaluacion);
    //   // for (let i = 0; i < vm.datos.length; i++) {
    //   // 	const lista_eventos = vm.datos[i][1];
    //   // 	for (let j = 0; j < lista_eventos.length; j++) {
    //   // 		// var actualizar = false;

    //   // 		vm.arr_evaluacion[i][j][3] = lista_eventos[j].operador_monitoreo;

    //   // 		if (lista_eventos[j].criterio_evaluacion == vm.arr_evaluacion[i][j][0] && lista_eventos[j].observacion_evaluacion == vm.arr_evaluacion[i][j][1] ) {
    //   // 		} else {
    //   // 			console.log(lista_eventos[j].criterio_evaluacion+" - "+vm.arr_evaluacion[i][j][0]+" - "+lista_eventos[j].observacion_evaluacion+" - "+vm.arr_evaluacion[i][j][1]);

    //   // 			vm.arr_evaluacion[i][j][0] = lista_eventos[j].criterio_evaluacion;
    //   // 			vm.arr_evaluacion[i][j][1] = lista_eventos[j].observacion_evaluacion;

    //   // 			// if (vm.arr_evaluacion[i][j][0] === undefined) {
    //   // 			// 	console.log("es undefined");
    //   // 			// } else {
    //   // 			// 	console.log("no es undefined");
    //   // 			// }
    //   // 			// if (vm.arr_evaluacion[i][j][1] === undefined) {
    //   // 			// 	console.log("es undefined");
    //   // 			// } else {
    //   // 			// 	console.log("no es undefined");
    //   // 			// }

    //   // 			if ( (vm.arr_evaluacion[i][j][0] == '' || vm.arr_evaluacion[i][j][0] === undefined) && (vm.arr_evaluacion[i][j][1] == '' || vm.arr_evaluacion[i][j][1] === undefined) ) {
    //   // 				vm.datos[i][1][j].fecha_evaluacion = ''; //actualizar = true;
    //   // 				vm.arr_evaluacion[i][j][2] = '';
    //   // 			} else {
    //   // 				vm.datos[i][1][j].fecha_evaluacion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss"); //actualizar = true;
    //   // 				vm.arr_evaluacion[i][j][2] = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
    //   // 			}

    //   // 		}
    //   // 	}
    //   // }

    //   for (let i = 0; i < vm.tablaFormatoBetsy_1.length; i++) {

    //     vm.arr_evaluacion2[i][3] = vm.tablaFormatoBetsy_1[i].operador_monitoreo;


    //       if (vm.tablaFormatoBetsy_1[i].criterio_evaluacion == vm.arr_evaluacion2[i][0] && vm.tablaFormatoBetsy_1[i].observacion_evaluacion == vm.arr_evaluacion2[i][1] ) {
    //       } else {
    //         // console.log("========valor diferente al anterior :::::::");
    //         // console.log(vm.tablaFormatoBetsy_1[i].criterio_evaluacion+" - "+vm.arr_evaluacion2[i][0]+" - "+vm.tablaFormatoBetsy_1[i].observacion_evaluacion+" - "+vm.arr_evaluacion2[i][1]);





    //         //FUNCION PARA GUARDAR

    //         vm.arr_evaluacion2[i][0] = vm.tablaFormatoBetsy_1[i].criterio_evaluacion;
    //         vm.arr_evaluacion2[i][1] = vm.tablaFormatoBetsy_1[i].observacion_evaluacion;



    //         if ( (vm.tablaFormatoBetsy_1[i].criterio_evaluacion != '' || vm.tablaFormatoBetsy_1[i].observacion_evaluacion != '') && vm.tablaFormatoBetsy_1[i].fecha_evaluacion == '') {
    //           vm.tablaFormatoBetsy_1[i].fecha_evaluacion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss"); //actualizar = true;
    //           vm.arr_evaluacion2[i][2] = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
    //         }

    //         // if ( (vm.arr_evaluacion2[i][0] == '' || vm.arr_evaluacion2[i][0] === undefined) && (vm.arr_evaluacion2[i][1] == '' || vm.arr_evaluacion2[i][1] === undefined) ) {
    //         // 	vm.tablaFormatoBetsy_1[i].fecha_evaluacion = ''; //actualizar = true;
    //         // 	vm.arr_evaluacion2[i][2] = 'S';
    //         // } else {
    //         // 	vm.tablaFormatoBetsy_1[i].fecha_evaluacion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss"); //actualizar = true;
    //         // 	vm.arr_evaluacion2[i][2] = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
    //         // }


    //       }

    //   }
    // }


    // console.log(vm.datos);
    // console.log(vm.arr_evaluacion);
    //console.log("_______________fatigaExtremaNewFormato FIN");

    return  false;
  }

  guardarReporteFatigaExtrema() {
    console.log("================ guardarReporteFatigaExtrema");


    console.log("===================================this.arr_evaluacion2");
    console.log(this.arr_evaluacion2);
    console.log(this.arr_evaluacion2[0][0]);
    console.log("===================================this.arr_evaluacion_ini");
    console.log(this.arr_evaluacion_ini);
    console.log(this.arr_evaluacion_ini[0][0]);

    var arr_params = [];
    // $arr_params.push([ vm.tablaFormatoBetsy_1[i].criterio_evaluacion, vm.tablaFormatoBetsy_1[i].observacion_evaluacion, vm.tablaFormatoBetsy_1[i].fecha_evaluacion, vm.tablaFormatoBetsy_1[i].operador_monitoreo, vm.tablaFormatoBetsy_1[i].fecha, vm.tablaFormatoBetsy_1[i].nombre, i]);

    for (let i = 0; i < this.arr_evaluacion2.length; i++) {

      if (this.arr_evaluacion_ini[i][0] == this.arr_evaluacion2[i][0] &&
        this.arr_evaluacion_ini[i][1] == this.arr_evaluacion2[i][1] &&
        this.arr_evaluacion_ini[i][3] == this.arr_evaluacion2[i][3] ) {
      } else {
        console.log("CAMBIAR============================================");
        console.log(this.tablaFormatoBetsy_1[i]);
        arr_params.push( this.tablaFormatoBetsy_1[i] );

        this.arr_evaluacion_ini[i][0] = this.arr_evaluacion2[i][0];
        this.arr_evaluacion_ini[i][1] = this.arr_evaluacion2[i][1];
        this.arr_evaluacion_ini[i][3] = this.arr_evaluacion2[i][3];
      }

    }

    var dataParams = {array_items:arr_params, user_id:this.reportService.getUserId()};
    console.log("====== PARAMETROS =====0=");
    console.log(dataParams);
    //reportServices.setSpinnerValue(true);
    this.spinner.show("reportSpinner");

    console.log(environment.apiUrl + "/api/saveEventUserEvaluacion");
    this.http.post(environment.apiUrl + "/api/saveEventUserEvaluacion", dataParams).subscribe({
      next: datos => {

        console.log("========== values");
        console.log(datos);
        this.spinner.hide("reportSpinner");
      }
    });




  }

  actualizarReporteFatigaExtrema() {

			console.log("===================================");
			// console.log(vm.datos);
			// console.log(contador);

      console.log("===== this.data =====");
      console.log(this.data);
			console.log(this.arr_evaluacion2);


			// var tipoR = vm.optionR();
			// var rutaUrl = "X";
			// if (tipoR == 101) {
			// 	rutaUrl = "informes/informes_fatigas_SF";
			// } else if (tipoR == 102) {
			// 	rutaUrl = "informes/informes_fatiga_extrema";
			// }

			var dataParams:any =  this.reportService.getParams();



			dataParams['fecha_hasta2'] = dataParams['fecha_hasta'];
			dataParams['fecha_hasta'] = moment(new Date()).format("YYYY-MM-DD") + 'T' + moment(new Date()).format("HH:mm:ss") + '-05:00';

			console.log(dataParams);

      this.spinner.show("reportSpinner");
      this.http.post(environment.apiUrl + dataParams.url, dataParams).subscribe({
        next: datos => {
          console.log("========== values");
          console.log(typeof datos);
          console.log(datos);
          var values:any = datos;
          console.log(values[0]);

          console.log("===== this.data");
          console.log(this.data);


          for (let i = 0; i < this.data.length; i++) {

            console.log("-------------- nuevas tramas "+i);
            console.log(this.data);

            console.log(values[i][1]);
            this.data[i][0] = values[i][0];
            this.data[i][1] = values[i][1];


            for (let j = 0; j < this.data[i][1].length; j++) {
                var row = this.data[i][1][j];

                for (let i2 = 0; i2 < this.arr_evaluacion2.length; i2++) {
                    const element = this.arr_evaluacion2[i2];
                    if (row.fecha == this.arr_evaluacion2[i2][4] && row.nombre == this.arr_evaluacion2[i2][5]) {
                        // row.criterio_evaluacion		  = this.arr_evaluacion2[i2][0];
                        // row.observacion_evaluacion  = this.arr_evaluacion2[i2][1];
                        // row.fecha_evaluacion		    = this.arr_evaluacion2[i2][2];
                        // row.operador_monitoreo		  = this.arr_evaluacion2[i2][3];
                    }

                }

            }

          }

          console.log("==========  this.data :");
          console.log(this.data);
          console.log("==========  this.arr_evaluacion 2 :");
          // console.log(vm.arr_evaluacion);
          console.log(this.arr_evaluacion2);
          this.arr_evaluacion = undefined;
          this.arr_evaluacion2 = undefined;
          // console.log(vm.arr_evaluacion);
          console.log(this.arr_evaluacion2);
          this.spinner.hide("reportSpinner");


          this.fatigaExtremaNewFormato();

          // this.reportService.modalActive = true;
          // this.reportService.objGeneral.data = data;
          // this.reportService.objGeneral.periodo = periodo;//this.period;
          // this.reportService.objGeneral.vehiculo = vehiculo;//this.period;
          // this.reportService.objGeneral.dateHour = dateHour;//this.period;
          // console.log(this.reportService.objGeneral);
          // this.spinner.hide("reportSpinner");
          // console.log("MODAL ACTIVATE");
        }
      });



			// reportServices.setSpinnerValue(true);
			// $q.all([
		  //   	api.post(rutaUrl, dataParams),
		  //   ]).then(values => {
			// 	console.log("========== values");
			// 	console.log(values);
			// 	console.log(values[0]);
			// 	// vm.datos = values[0];

			// 	for (let i = 0; i < vm.datos.length; i++) {
			// 		//const lista_eventos = vm.datos[i][1];
			// 		console.log("-------------- nuevas tramas");
			// 		console.log(values[0][i][1]);
			// 		vm.datos[i][0] = values[0][i][0];
			// 		vm.datos[i][1] = values[0][i][1];

			// 		for (let j = 0; j < vm.datos[i][1].length; j++) {
			// 			var row = vm.datos[i][1][j];
			// 			for (let i2 = 0; i2 < vm.arr_evaluacion2.length; i2++) {
			// 				const element = vm.arr_evaluacion2[i2];
			// 				if (row.fecha == vm.arr_evaluacion2[i2][4] && row.nombre == vm.arr_evaluacion2[i2][5]) {
			// 					row.criterio_evaluacion		= vm.arr_evaluacion2[i2][0];
			// 					row.observacion_evaluacion  = vm.arr_evaluacion2[i2][1];
			// 					row.fecha_evaluacion		= vm.arr_evaluacion2[i2][2];
			// 					row.operador_monitoreo		= vm.arr_evaluacion2[i2][3];
			// 				}
			// 			}
			// 		}
			// 	}
			// 	console.log("==========  vm.datos :");
			// 	console.log(vm.datos);
			// 	console.log("==========  vm.arr_evaluacion 2 :");

			// 	// console.log(vm.arr_evaluacion);
			// 	console.log(vm.arr_evaluacion2);
			// 	vm.arr_evaluacion = undefined;
			// 	vm.arr_evaluacion2 = undefined;
			// 	// console.log(vm.arr_evaluacion);
			// 	console.log(vm.arr_evaluacion2);
			// 	reportServices.setSpinnerValue(false);

			// });

			// console.log("============= 2 ============");
			// console.log(vm.datos);


  }


  compare( a:any, b:any ) {
    if ( a.fecha < b.fecha ){
      return -1;
    }
    if ( a.fecha > b.fecha ){
      return 1;
    }
    return 0;
  }


      repSensorFatigaBtnEliminar(obj:any) {
        console.log('==============repSensorFatigaBtnEliminar2');
        obj.mostrar = !obj.mostrar;
      }


      runReportGerencial(contador:any) {
        console.log("a-- " + this.contador + "-- ");
        // vm.contador

        // reportServices.getNroGenReport();
        // this.setNroGenReport =

        // reportServices.getPeriodo();

        // if (this.contador == reportServices.getNroGenReport()) {
        if (true) {

          console.log("b--" + this.contador);
          this.contador = this.contador +1;
          console.log("c--" + this.contador);

          // console.log("----- GAAA -----");
          // console.log(vm.datos);
          // console.log(vm.periodo());
          this.arrDataTabla.distraccion = 0;
          this.arrDataTabla.posible_fatiga = 0;
          this.arrDataTabla.fatiga_extrema = 0;

          this.arrDataGrafico  = [true,true,true,true,true,true,true,true,true,true,true,true];


          for (let i = 0; i < this.data.length; i++) {
            const placa_unidad = this.data[i][0][1];
            for (let j = 0; j < this.data[i][1].length; j++) {
              if (this.data[i][1][j].mostrar) {

                  const descripcion = this.data[i][1][j].descripcion_evento;
                  // console.log(placa_unidad+" - "+descripcion+" - "+vm.datos[i][1][j].fecha_tracker+" - "+vm.datos[i][1][j].nombre_zona+" - "+vm.datos[i][1][j].conductor);
                  // console.log(vm.datos[i][1][j].velocidad_limite);

                  if (descripcion == "Distraccion") {
                    this.arrDataTabla.distraccion = this.arrDataTabla.distraccion + 1;
                  } else if (descripcion == "Somnolencia") { //posible_fatiga
                    this.arrDataTabla.posible_fatiga = this.arrDataTabla.posible_fatiga+1;
                  } else if (descripcion == "Fatiga Extrema") {
                    this.arrDataTabla.fatiga_extrema = this.arrDataTabla.fatiga_extrema+1;
                  }
              }

            }
          }



          var colorArray = [
          '#3A6598',
          '#EFA252',
          '#029471',
          '#DD581E',
          '#A22D62',
          '#FECE5F',
          '#27758B',
          '#D8695B',
          '#447711',
          '#C82859',
          '#5D069C',
          '#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
          '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
          '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
          '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
          '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
          '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
          '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
          '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
          '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
          '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'];



          var arrData : any[] = [[[],[],[],[]],[[],[],[],[]],[[],[],[],[]]]; // distraccion:[],posible_fatiga:[],fatiga_extrema
          var arrtick : any[] = []; // labels del eje Y
          // var id1 = -1; //indice del array 'arrtick'




          // vm.arrData  = [true,true,true,true,true,true,true,true,true,];

          for (let h = 0; h < arrData.length; h++) {
            // arrData[h] = [];

            var select_evento = "";
            switch (h) {
              case 0:
                select_evento = "Distraccion";
                break;
              case 1:
                select_evento = "Somnolencia"; //posible_fatiga
                break;
              case 2:
                select_evento = "Fatiga Extrema";
                break;
              default:
                break;
            }

            //=========================== EVENTOS POR UNIDAD =======================
            // arrData[h].push([]); //[0] = [];
            // // console.log(h);
            // // console.log(arrData);
            // //arrData[h][0] = [];

            // 	for (let i = 0; i < vm.datos.length; i++) {
            // 		const placa_unidad = vm.datos[i][0][1];
            // 		// console.log(placa_unidad);
            // 		var num_eventos = 0;
            // 		for (let j = 0; j < vm.datos[i][1].length; j++) {
            // 			if (vm.datos[i][1][j].descripcion_evento == select_evento) {

            // 				const element1 = vm.datos[i][1][j].descripcion_evento;
            // 				// console.log(element1);
            // 				num_eventos++;
            // 			}
            // 		}
            // 		// console.log(h);

            // 		if ( 0 < num_eventos ) {
            // 			// console.log(arrData);
            // 			arrData[h][0].push({color: colorArray[i], data: [[placa_unidad, num_eventos]]});
            // 		}
            // 	}


            //=========================== EVENTOS POR CODIGOS =======================

              var array_codigos = [];

              // arrData[h].push([]);//[i][3] = [];
              for (let i = 0; i < this.data.length; i++) {
                for (let j = 0; j < this.data[i][1].length; j++) {
                  this.data[i][1][j].codigo = (this.data[i][1][j].codigo == "" ? this.data[i][1][j].nombre : this.data[i][1][j].codigo);

                  if (this.data[i][1][j].mostrar && this.data[i][1][j].descripcion_evento == select_evento) {

                    const nom_codigo = this.data[i][1][j].codigo;
                    var coinciden = false;
                    for (let k = 0; k < array_codigos.length; k++) {

                      if (this.data[i][1][j].codigo == array_codigos[k][0]) {
                        coinciden = true;
                        array_codigos[k][1] = array_codigos[k][1] + 1;
                      }
                      // const element = array[k];
                    }
                    if (coinciden == false) {
                      array_codigos.push([nom_codigo,1]);
                    }
                  }
                }
              }

              // console.log(array_codigos);
              arrtick.push([]);
              // id1 = id1 + 1;
              var n = arrtick.length - 1;
              var contador1 = 0;
              for (let i = 0; i < array_codigos.length; i++) {
                if (0 < array_codigos[i][1]) {
                  contador1++;
                  arrtick[n].push([ contador1, array_codigos[i][0]]);
                  // arrData[h][0].push({color: colorArray[i], data: [[array_codigos[i][0], array_codigos[i][1]]]});
                  arrData[h][0].push({color: colorArray[i], data: [[array_codigos[i][1], contador1] ]});

                  // [
                  //     [1, 'One'],
                  //     [2, 'Two'],
                  //     [3, 'Three la ultima vezs aggagagaaga '],
                  // ]
                  // {color: '#000', data : [[50, 3]] },

                }
              }

            //=========================== FIN EVENTOS POR CODIGOS =======================


            //=========================== FIN EVENTOS POR UNIDAD =======================

            //=========================== EVENTOS POR FECHA =======================
              var periodo = this.period;// vm.period();

              var ini_fin = periodo.split(" - ")
              var primer_dia = moment(ini_fin[0]).startOf('day').format("YYYY-MM-DD");
              var ultimo_dia = moment(ini_fin[1]).startOf('day').format("YYYY-MM-DD");

              var array_dias : any[] = [];

              if (primer_dia === ultimo_dia) {
                // console.log("son iguales");
                array_dias.push([primer_dia,0]);
              } else {
                var dia_temp = moment(ini_fin[0]);
                var add_day = dia_temp.startOf('day').format("YYYY-MM-DD");
                while (add_day != ultimo_dia) {
                  //console.log(add_day);
                  array_dias.push([add_day,0]);
                  dia_temp = dia_temp.add(1, 'days');
                  add_day = dia_temp.startOf('day').format("YYYY-MM-DD");
                }
                array_dias.push([ultimo_dia,0]);
              }
              // console.log(array_dias);
              // arrData[h].push([]);//[i][1] = [];
              for (let i = 0; i < this.data.length; i++) {
                // const placa_unidad = vm.datos[i][0][1];
                // console.log(placa_unidad);
                // var num_eventos = 0;
                for (let j = 0; j < this.data[i][1].length; j++) {
                  if ( this.data[i][1][j].mostrar && this.data[i][1][j].descripcion_evento == select_evento) {

                    var evento_dia = moment(this.data[i][1][j].fecha_tracker).startOf('day').format("YYYY-MM-DD");
                    for (let k = 0; k < array_dias.length; k++) {
                      if (  evento_dia ===  array_dias[k][0] ) {
                        array_dias[k][1] = array_dias[k][1]+1;
                      }
                    }
                  }
                }
              }

              // console.log(array_dias);
              arrtick.push([]);
              var n = arrtick.length - 1;
              var contador2 = 0;
              for (let i = 0; i < array_dias.length; i++) {
                if (0 < array_dias[i][1]) {
                  contador2++;
                  arrtick[n].push([contador2,array_dias[i][0]]);
                  arrData[h][1].push({color: colorArray[i], data: [[array_dias[i][1], contador2] ]});
                }
              }



            //=========================== FIN EVENTOS POR FECHA =======================
            //=========================== EVENTOS POR GEOCERCA =======================

              var array_geocercas = [];
              // arrData[h].push([]);//[i][2] = [];
              for (let i = 0; i < this.data.length; i++) {
                for (let j = 0; j < this.data[i][1].length; j++) {
                  if (this.data[i][1][j].mostrar && this.data[i][1][j].descripcion_evento == select_evento) {

                    const nom_geocerca = this.data[i][1][j].nombre_zona;
                    var coinciden = false;
                    for (let k = 0; k < array_geocercas.length; k++) {

                      if (this.data[i][1][j].nombre_zona == array_geocercas[k][0]) {
                        coinciden = true;
                        array_geocercas[k][1] = array_geocercas[k][1] + 1;
                      }
                      // const element = array[k];
                    }
                    if (coinciden == false) {
                      array_geocercas.push([nom_geocerca,1]);
                    }
                  }
                }
              }

              // console.log(array_geocercas);
              arrtick.push([]);
              var n = arrtick.length - 1;
              var contador3 = 0;
              for (let i = 0; i < array_geocercas.length; i++) {
                if (0 < array_geocercas[i][1]) {
                  contador3++;
                  arrtick[n].push([contador3,array_geocercas[i][0]]);
                  arrData[h][2].push({color: colorArray[i], data: [[array_geocercas[i][1], contador3] ]});
                }
              }


            //=========================== FIN EVENTOS POR GEOCERCA =======================
            //=========================== EVENTOS POR CONDUCTOR =======================

              var array_conductores = [];

              // arrData[h].push([]);//[i][3] = [];
              for (let i = 0; i < this.data.length; i++) {
                for (let j = 0; j < this.data[i][1].length; j++) {
                  if (this.data[i][1][j].mostrar && this.data[i][1][j].descripcion_evento == select_evento) {

                    const nom_conductor = this.data[i][1][j].conductor;
                    var coinciden = false;
                    for (let k = 0; k < array_conductores.length; k++) {

                      if (this.data[i][1][j].conductor == array_conductores[k][0]) {
                        coinciden = true;
                        array_conductores[k][1] = array_conductores[k][1] + 1;
                      }
                      // const element = array[k];
                    }
                    if (coinciden == false) {
                      array_conductores.push([nom_conductor,1]);
                    }
                  }
                }
              }

              // console.log(array_conductores);
              arrtick.push([]);
              var n = arrtick.length - 1;
              var contador4 = 0;
              for (let i = 0; i < array_conductores.length; i++) {
                if (0 < array_conductores[i][1]) {
                  contador4++;
                  arrtick[n].push([contador4,array_conductores[i][0]]);
                  arrData[h][3].push({color: colorArray[i], data: [[array_conductores[i][1], contador4] ]});
                }
              }
            //=========================== FIN EVENTOS POR GEOCERCA =======================
          }


            //Distracción, posible fatiga y fatiga extrema.
            var arrG = [
              {div:'#placeholder_x_unidad_distraccion',data:arrData[0][0],ph:null,orden:0},
              {div:'#placeholder_x_unidad_posible_fatiga',data:arrData[1][0],ph:null,orden:4},
              {div:'#placeholder_x_unidad_fatiga_extrema',data:arrData[2][0],ph:null,orden:8},

              {div:'#placeholder_x_fecha_distraccion',data:arrData[0][1],ph:null,orden:1},
              {div:'#placeholder_x_fecha_posible_fatiga',data:arrData[1][1],ph:null,orden:5},
              {div:'#placeholder_x_fecha_fatiga_extrema',data:arrData[2][1],ph:null,orden:9},

              {div:'#placeholder_x_geocerca_distraccion',data:arrData[0][2],ph:null,orden:2},
              {div:'#placeholder_x_geocerca_posible_fatiga',data:arrData[1][2],ph:null,orden:6},
              {div:'#placeholder_x_geocerca_fatiga_extrema',data:arrData[2][2],ph:null,orden:10},

              {div:'#placeholder_x_conductor_distraccion',data:arrData[0][3],ph:null,orden:3},
              {div:'#placeholder_x_conductor_posible_fatiga',data:arrData[1][3],ph:null,orden:7},
              {div:'#placeholder_x_conductor_fatiga_extrema',data:arrData[2][3],ph:null,orden:11}

            ];


            for (let j = 0; j < arrG.length; j++) {
                // const element = arrG[j];
                this.dibujar(arrG[j].div, arrG[j].data, arrG[j].orden, arrtick);

            }

          return '';

        }



      }



      dibujar(a:any,b:any,c:any,d:any) {
        console.log(a,b,c);
        if (b.length > 0 ) {

          // this.arrDataGrafico[c] = true;

          var options = {
            series: {
              stack: 1,
              bars: {
                order: 1,
                show: 1,
                barWidth: 0.6,
                fill: 0.9,
                align: 'center',
                horizontal: true
              },
            },
            grid: {
              hoverable: true,
              borderWidth: 0
            },
            tooltip: true,
            tooltipOpts: {
              cssClass: "flotTip",
              content: "%s: %y",
              defaultTheme: false
            },
            legend: {
              show: false
            },
            yaxis: {
              ticks: d[c]
            },
          };

          var somePlot = $j.plot(a,  b , options );

          this.arrDataPlot[c] = somePlot;

          var ctx = somePlot.getCanvas().getContext("2d"); // get the context
          var allSeries = somePlot.getData();  // get your series data
          var xaxis = somePlot.getXAxes()[0]; // xAxis
          var yaxis = somePlot.getYAxes()[0]; // yAxis
          var offset = somePlot.getPlotOffset(); // plots offset
          ctx.font = "12px 'Segoe UI'"; // set a pretty label font
          ctx.fillStyle = "black";
          for (var i = 0; i < allSeries.length; i++){
            var series = allSeries[i];
            var dataPoint = series.datapoints.points; // one point per series
            var x = dataPoint[0];
            var y = dataPoint[1];
            var text = x + '';
            var metrics = ctx.measureText(text);
            var xPos = (xaxis.p2c(x)/2) +offset.left - metrics.width; // place at end of bar
            var yPos = yaxis.p2c(y) + offset.top + 2;// - 2;
            ctx.fillText(text, xPos, yPos);
          }


          // var myCanvas = somePlot.getCanvas();
          // var image = myCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream");  /// here is the most important part because if you dont replace you will get a DOM 18 exception.
          // document.location.href=image;



        } else {
          this.arrDataGrafico[c] = false;
          this.arrDataPlot[c] = '';
        }

      }


		showGeneralDireccion(trama:any, gT:any=[]) {
			console.log("Averiguar la direccion");
			console.log(trama);
			console.log(gT);

			console.log(this.reportService.chkApiGoogle);
			// trama.referencia = "direccion nueva xDDD"
			if (trama.lat === undefined) {
				trama.lat = trama.latitud;
				trama.lng = trama.longitud;
	   		}
      // var cbd = { lat:trama.lat, lng:trama.lng, status:'BD' };

      // this.http.post(environment.apiUrl + 'geocoder/fnDireccion', cbd).subscribe({
      //   next: data => {
      //     // console.log(this.selectedConvoy.length);
      //     // console.log(this.selectedGroup.length);
      //   }
      // });

      // var cbd = { lat:trama.lat, lng:trama.lng, status:'BD' };
      // $q.all([
			// 	api.post('geocoder/fnDireccion',cbd)
			// ]).then(responseP => {
			// 		console.log("0 BD ------->>>>> " + responseP);
			// 		if (responseP[0] !== 'NN') {
			// 			trama.referencia = responseP;
			// 		} else {

			// 			if (reportServices.chkApiGoogle) {

			// 				console.log("API ACTIVADA");



			// 				console.log("fnc_direccion--xD");
			// 				var f = new google.maps.Geocoder();
			// 				var g = '';
			// 				var h = new google.maps.LatLng(trama.lat, trama.lng);
			// 				f.geocode({
			// 						'latLng': h
			// 				}, function (a, b) {
			// 						console.log("*********************1");
			// 						console.log(a);
			// 						console.log(b);
			// 						console.log("*********************2");

			// 						if (b == "OK") {
			// 									console.log("Api google : OK");
			// 									var g = "";
			// 									if (a[0]) {
			// 											g = a[0].formatted_address;
			// 									} else if (a[1]) {
			// 											g = a[1].formatted_address;
			// 									} else {
			// 											console.log("DIRECCION AMBIGUA");
			// 									}
			// 									// item.layer.setPopupContent(vehiclesHelper.getContentPopup(item, g,tiempoParada));
			// 									if (g !== "") {
			// 										console.log("1------->>>>> " + g);
			// 										trama.referencia = g;
			// 										// var cnav = { lat:trama.lat, lng:trama.lng, status:'js' ,dir:g };
			// 										var cnav = { lat:trama.lat, lng:trama.lng ,dir:g };
			// 										$q.all([
			// 											api.post('geocoder/save',cnav)
			// 										]).then(responseG => {
			// 												console.log(responseG);//Se guardo elemento
			// 										});
			// 									}
			// 						} else if (b == "OVER_QUERY_LIMIT") {
			// 									console.log("Api google : VER_QUERY_LIMIT");
			// 									var cphp = { lat:trama.lat, lng:trama.lng, status:'php' };
			// 									$q.all([
			// 										api.post('geocoder/fnDireccion',cphp)
			// 									]).then(responseP => {
			// 											trama.referencia = responseP;
			// 											// item.layer.setPopupContent(vehiclesHelper.getContentPopup(item,responseP,tiempoParada));
			// 											console.log("2------->>>>> " + responseP);
			// 									});
			// 						} else {
			// 							// item.layer.setPopupContent(vehiclesHelper.getContentPopup(item,"No encontrado...",tiempoParada));
			// 							trama.referencia = "No encontrado...";
			// 							console.log("3------->>>>> " + "No encontrado...");
			// 						}

			// 				});


			// 			} else {
			// 				console.log("NO TIENE API ACTIVADA");
			// 				//============== OSM
			// 				var coord = { lat:trama.lat, lng:trama.lng };
			// 				$q.all([
			// 					api.post('geocoder/show',coord)  //funcion OSM
			// 				]).then(responseG => {
			// 						console.log("osm------->>>>> " + responseP);
			// 						console.log(responseG);//Se guardo elemento
			// 						console.log(responseG[0]);//Se guardo elemento
			// 						g = responseG[0];
			// 						if (g != 'NN') {
			// 							console.log(g);//Se guardo elemento
			// 							// console.log(g[0]);//Se guardo elemento
			// 							trama.referencia = g;

			// 							//============puntos cercanos
			// 							var count = 0;
			// 							for (let i = 0; i < gT.length; i++) {
			// 								if ( ( trama.lat - 0.0015 <= gT[i].lat &&  gT[i].lat <= trama.lat + 0.0015 ) && ( trama.lng - 0.0015 <= gT[i].lng && gT[i].lng <= trama.lng + 0.0015 ) ) {
			// 									if (gT[i].referencia == 'NN') {
			// 										console.log("punto cercano :  cambio de nombre");
			// 										gT[i].referencia = trama.referencia;
			// 										count = count + 1;
			// 										console.log(gT[i].referencia);
			// 									} else {
			// 										console.log("no cambio de nombre");
			// 										console.log(gT[i].referencia);
			// 									}
			// 								}
			// 							}
			// 							console.log("se encontrarton "+count);
			// 							//============puntos cercanos

			// 							//============guardar nueva direccion
			// 							var cnav = { lat:trama.lat, lng:trama.lng ,dir:g };
			// 							$q.all([
			// 								api.post('geocoder/save',cnav)
			// 							]).then(responseG => {
			// 									console.log(responseG);//Se guardo elemento
			// 							});
			// 							//============guardar nueva direccion


			// 						} else {
			// 							trama.referencia = 'desconocido ... ';
			// 														// //=============PHP
			// 							console.log("No tiene API - Api OSM arroja NN");

			// 							var cphp = { lat:trama.lat, lng:trama.lng, status:'php' };
			// 							console.log(cphp);
			// 							$q.all([
			// 								api.post('geocoder/fnDireccion', cphp)
			// 							]).then(responseP => {
			// 									console.log(responseP);

			// 									// console.log("php------->>>>> " + responseP);
			// 									if (responseP == "NN php") {
			// 										trama.referencia = 'desconocido';
			// 									} else {
			// 										trama.referencia = responseP;
			// 									}
			// 									// console.log(responseP);//Se guardo elemento
			// 									// item.layer.setPopupContent(vehiclesHelper.getContentPopup(item,responseP,tiempoParada));
			// 							});
			// 						}
			// 				});


			// 				// //=============PHP
			// 				// console.log("No tiene API - Api OSM arroja NN");

			// 				// var cphp = { lat:trama.lat, lng:trama.lng, status:'php' };
			// 				// $q.all([
			// 				// 	api.post('geocoder/fnDireccion', cphp)
			// 				// ]).then(responseP => {
			// 				// 		console.log(responseP);

			// 				// 		// console.log("php------->>>>> " + responseP);
			// 				// 		if (responseP == "NN php") {
			// 				// 			trama.referencia = 'desconocido';
			// 				// 		} else {
			// 				// 			trama.referencia = responseP;
			// 				// 		}
			// 				// 		// console.log(responseP);//Se guardo elemento
			// 				// 		// item.layer.setPopupContent(vehiclesHelper.getContentPopup(item,responseP,tiempoParada));
			// 				// });

			// 			}

			// 		}


			// });


		}




    // /* EXPORTAR */
    // t1=18; // Titulo Principal
    // t2=16; // Sub titulos
    // t3=14; // Cabeceras
    // c1=12; // Cuerpo
    // r1=12; // RESUMEN

    // t1_2=18; // Titulo Principal
    // tt1_2=16; // Titulo Principal linea 2
    // t2_2=15; // Sub titulos
    // c1_2=12; // Cuerpo del nuevo formato

    //--> 1

    exportPdfParadasMovimientos() {
      var exportFilePdf :any = [];
      var bol_datos_pdf = false;


      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);

      this.data.forEach((data:any, index:any) => {
        console.log(data);
        console.log(index);
        if(data[1].length > 0){
          bol_datos_pdf = true;

          exportFilePdf.push({
            columns: [
              [
                {
                  text: 'REPORTE DE PARADAS Y MOVIMIENTOS',
                  fontSize: this.c1,
                  bold: true,
                  alignment: 'left',
                  margin: [0, 25, 0, 0]
                },
                {
                  text: 'Nombre del vehículo: ' + data[0][1],
                  fontSize: 10,
                  alignment: 'left'
                },
                {
                  text: 'Fechas: ' + this.period,
                  fontSize: 10,
                  alignment: 'left'
                }
              ]
              //,
              // {
              // 	image: logo_gltracker,
              // 	width: 125,
              // 	height: 80,
              // 	alignment: 'justify'
              // }
            ],
            pageBreak: index != 0 ? 'before' : ''
          });

          exportFilePdf.push({
            table: {
              widths: ['*'],
              body: [[" "], [" "]]
            },
            layout: {
              hLineWidth: function(i:any, node:any) {
                return (i === 0 || i === node.table.body.length) ? 0 : 2;
              },
              vLineWidth: function(i:any, node:any) {
                return 0;
              },
            }
          });

          var tabla = [];

          var cabecera = [];

          cabecera.push({ text: 'Item', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          cabecera.push({ text: 'Estado', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

          if(this.chkDateHour) {
            cabecera.push({ text: 'Fecha de Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            cabecera.push({ text: 'Hora de Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            cabecera.push({ text: 'Fecha de Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            cabecera.push({ text: 'Hora de Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          } else {
            cabecera.push({ text: 'Fecha Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            cabecera.push({ text: 'Fecha Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          };

          cabecera.push({ text: 'Duración', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

          if ( data[2].Paradas == true) 	{ cabecera.push({ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }) };
          if ( data[2].Movimientos == true) 	{ cabecera.push({ text: 'Distancia Recorrida', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }) };
          if ( data[2].Movimientos == true) 	{ cabecera.push({ text: 'Velocidad Máxima GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }) };
          if ( data[2].Movimientos == true) 	{ cabecera.push({ text: 'Velocidad Máxima CAN', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }) };

          if ( data[2].Paradas == true) 	{ cabecera.push({ text: 'Punto Cercano', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }) };
          if ( data[2].Movimientos == true) 	{ cabecera.push({ text: 'Velocidad Promedio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }) };
          if ( data[2].Movimientos == true) 	{ cabecera.push({ text: 'Vel. prom. CAN', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }) };

          if ( data[2].Paradas == true) 	{ cabecera.push({ text: 'Referencia', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }) };

          tabla.push(cabecera);

          if ( data[2].Paradas == true && data[2].Movimientos == true ) {
            data[1].forEach((item:any, index2:any) => {
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
                            var cellsCuerpo = [];

              cellsCuerpo.push({ text: index2 + 1, bold: true, fontSize: 6, alignment: 'center' });
              cellsCuerpo.push({ text: item.estado, bold: true, fontSize: 6, alignment: 'center' });

              if (this.chkDateHour) {
                cellsCuerpo.push({ text: this.isChe(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: this.isChs(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: this.isChe(item.fechasig), bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: this.isChs(item.fechasig), bold: true, fontSize: 6, alignment: 'center' });
              } else {
                cellsCuerpo.push({ text: this.isChe(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: this.isChe(item.fechasig), bold: true, fontSize: 6, alignment: 'center' });
              }

              cellsCuerpo.push({ text: item.duracion, bold: true, fontSize: 6, alignment: 'center' });

              if (item.esInt == 0) {
                cellsCuerpo.push({ text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' });

                cellsCuerpo.push({ text: "--", bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: "--", bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: "--", bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.pCercano, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: "--", bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: "--", bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.referencia, bold: true, fontSize: 6, alignment: 'center' });
              }

              if (item.esInt == 1) {
                cellsCuerpo.push({ text: "--", bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.recorrido, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.maxima_velocidad, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.vel_max_can, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: "--", bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.vel_promedio, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.vel_prom_can, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: "--", bold: true, fontSize: 6, alignment: 'center' });
              }

              tabla.push(cellsCuerpo);

            });
          }


          if ( data[2].Paradas == true && data[2].Movimientos == false ) {
            data[1].forEach((item:any, index2:any) => {
              if (item.esInt==0) {

                var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
                var cellsCuerpo = [];

                cellsCuerpo.push({ text: ( Math.floor(index2/2) + 1 ), bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.estado, bold: true, fontSize: 6, alignment: 'center' });

                if (this.chkDateHour) {
                  cellsCuerpo.push({ text: this.isChe(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
                  cellsCuerpo.push({ text: this.isChs(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
                  cellsCuerpo.push({ text: this.isChe(item.fechasig), bold: true, fontSize: 6, alignment: 'center' });
                  cellsCuerpo.push({ text: this.isChs(item.fechasig), bold: true, fontSize: 6, alignment: 'center' });
                } else {
                  cellsCuerpo.push({ text: this.isChe(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
                  cellsCuerpo.push({ text: this.isChe(item.fechasig), bold: true, fontSize: 6, alignment: 'center' });
                }

                cellsCuerpo.push({ text: item.duracion, bold: true, fontSize: 6, alignment: 'center' });

                // cellsCuerpo.push({ text: ubicacion, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' });

                cellsCuerpo.push({ text: item.pCercano, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.referencia, bold: true, fontSize: 6, alignment: 'center' });

                tabla.push(cellsCuerpo);

              }

            });
          }



          if ( data[2].Paradas == false && data[2].Movimientos == true ) {
            data[1].forEach((item:any, index2:any) => {

              if (item.esInt==1) {

                var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
                var cellsCuerpo = [];

                cellsCuerpo.push({ text: ( Math.floor(index2/2) + 1 ), bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.estado, bold: true, fontSize: 6, alignment: 'center' });

                if (this.chkDateHour) {
                  cellsCuerpo.push({ text: this.isChe(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
                  cellsCuerpo.push({ text: this.isChs(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
                  cellsCuerpo.push({ text: this.isChe(item.fechasig), bold: true, fontSize: 6, alignment: 'center' });
                  cellsCuerpo.push({ text: this.isChs(item.fechasig), bold: true, fontSize: 6, alignment: 'center' });
                } else {
                  cellsCuerpo.push({ text: this.isChe(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
                  cellsCuerpo.push({ text: this.isChe(item.fechasig), bold: true, fontSize: 6, alignment: 'center' });
                }

                cellsCuerpo.push({ text: item.duracion, bold: true, fontSize: 6, alignment: 'center' });

                cellsCuerpo.push({ text: item.recorrido, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.maxima_velocidad, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.vel_max_can, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.vel_promedio, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.vel_prom_can, bold: true, fontSize: 6, alignment: 'center' });

                tabla.push(cellsCuerpo);

              }

            });
          }



          console.log("despues del for ");
          exportFilePdf.push({
            columns: [
              { width: '*', text: ''},
              {
                width: 'auto',
                table: {
                body: tabla
                }
              },
              { width: '*', text: ''}
            ]
          });


          var tabla2 = [];

          tabla2.push([
            { text: 'Longitud de Ruta : ', bold: true, fontSize: 10, alignment: 'center' },
            { text: data[3][0], bold: true, fontSize: 6, alignment: 'center' }
            ]);
          tabla2.push([
              { text: 'Duración de Movimiento : ', bold: true, fontSize: 10, alignment: 'center' },
              { text: data[3][1], bold: true, fontSize: 6, alignment: 'center' }
            ]);
          tabla2.push([
              { text: 'Duración Detenido : ', bold: true, fontSize: 10, alignment: 'center' },
              { text: data[3][2], bold: true, fontSize: 6, alignment: 'center' }
            ]);
          tabla2.push([
              { text: 'Velocidad más Alta : ', bold: true, fontSize: 10, alignment: 'center' },
              { text: data[3][3], bold: true, fontSize: 6, alignment: 'center' }
            ]);
          tabla2.push([
              { text: 'Velocidad Promedio : ', bold: true, fontSize: 10, alignment: 'center' },
              { text: data[3][4], bold: true, fontSize: 6, alignment: 'center' }
          ]);


          // console.log("despues del for 222222");
          exportFilePdf.push({
            columns: [
              { width: '*', text: ''},
              {
                width: 'auto',
                table: {
                body: tabla2
                }
              },
              { width: '*', text: ''}
            ]
          });



        }
      });

      console.log(" ===> bol_datos_pdf ");

      console.log(exportFilePdf);



      if(bol_datos_pdf){
        var docDefinition = {
          pageOrientation: 'landscape',
          pageSize: 'A4',
          //pageMargins: [ 0, 0, 0, 0 ],
          pageMargins: [ 40, 40, 40, 40 ],

            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    // {
                    //   text: page.toString() + '/' + pages.toString(),
                    //   alignment: 'Left',
                    //   fontSize: 8,
                    //   margin: [30, 0, 0, 15]
                    // },
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            //header: function(currentPage:any, pageCount:any, pageSize:any) {
            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download('ReporteParadasMovimientos.pdf');

      } else {
        alert('No se han encontrado datos para exportar');
      }
    }


    exportPdfExcesosVelocidad() {
      var exportFilePdf :any = [];
      var bol_datos_pdf = false;


      this.data.forEach((data:any, index:any) => {
        console.log(data);
        console.log(index);
        if(data[1].length > 0){
          bol_datos_pdf = true;

          exportFilePdf.push({
            columns: [
              [
                {
                  text: 'REPORTE DE EXCESOS DE VELOCIDAD',
                  fontSize: this.c1,
                  bold: true,
                  alignment: 'left',
                  margin: [0, 25, 0, 0]
                },
                {
                  text: 'Nombre del vehículo: ' + data[0][1],
                  fontSize: 10,
                  alignment: 'left'
                },
                {
                  text: 'Fechas: ' + this.period,
                  fontSize: 10,
                  alignment: 'left'
                }
              ]
              //,
              // {
              // 	image: img,
              // 	width: 125,
              // 	height: 80,
              // 	alignment: 'justify'
              // }
            ],
            pageBreak: index != 0 ? 'before' : ''
          });

          exportFilePdf.push({
            table: {
              widths: ['*'],
              body: [[" "], [" "]]
            },
            layout: {
              hLineWidth: function(i:any, node:any) {
                return (i === 0 || i === node.table.body.length) ? 0 : 2;
              },
              vLineWidth: function(i:any, node:any) {
                return 0;
              },
            }
          });

          var tabla = [];

          var cabecera = [];

          cabecera.push({ text: 'Item', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          cabecera.push({ text: 'Nombre', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

          if(this.chkDateHour) {
            cabecera.push({ text: 'Fecha', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            cabecera.push({ text: 'Hora', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          } else {
            cabecera.push({ text: 'Fecha y Hora', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          };

          cabecera.push({ text: 'Máxima Velocidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          cabecera.push({ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          cabecera.push({ text: 'Punto Cercano', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

          tabla.push(cabecera);


          data[1].forEach((item:any, index2:any) => {
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

              var cellsCuerpo = [];

              cellsCuerpo.push({ text: index2 + 1, bold: true, fontSize: 6, alignment: 'center' });
              cellsCuerpo.push({ text: item.nombre, bold: true, fontSize: 6, alignment: 'center' });

              if (this.chkDateHour) {
                cellsCuerpo.push({ text: this.isChe(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: this.isChs(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
              } else {
                cellsCuerpo.push({ text: this.isChe(item.fecha), bold: true, fontSize: 6, alignment: 'center' });
              }

              cellsCuerpo.push({ text: item.maxima_velocidad, bold: true, fontSize: 6, alignment: 'center' });
              cellsCuerpo.push({ text: ubicacion, bold: true, fontSize: 6, alignment: 'center' });
              cellsCuerpo.push({ text: item.PC, bold: true, fontSize: 6, alignment: 'center' });

                tabla.push(cellsCuerpo);

          });


          console.log("despues del for ");
          exportFilePdf.push({
            columns: [
              { width: '*', text: ''},
              {
                width: 'auto',
                table: {
                body: tabla
                }
              },
              { width: '*', text: ''}
            ]
          });


        }
      });

      console.log(" ===> bol_datos_pdf ");

      console.log(exportFilePdf);

      if(bol_datos_pdf){
        var docDefinition = {
          pageOrientation: 'landscape',
            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
              columns: [
                {
                  alignment: 'center',
                  text: [
                    { text: '----------------------------------------------------------------------- ' + page.toString()},
                    ' de ',
                    { text: pages.toString() + ' -----------------------------------------------------------------------'}
                  ]
                }
              ],
              margin: [0, 0]

              };
            }

        };
        pdfMake.createPdf(docDefinition).download('ReporteExcesosVelocidad.pdf');

      } else {
        alert('No se han encontrado datos para exportar');
      }
    }


    exportPdfEntradaSalida() {
			//vm.dateHour();
      var exportFilePdf :any = [];
			var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);



			this.data.forEach((data:any, index:any) =>{
				if(data[1].length > 0){
					bol_datos_pdf = true;

					exportFilePdf.push({
						columns: [
							[
								{
									text: 'REPORTE DE ENTRADA Y SALIDA',
									fontSize: this.c1,
									bold: true,
									alignment: 'left',
									margin: [0, 25, 0, 0]
								},
								{
									text: 'Nombre del vehículo: ' + data[0][1],
									fontSize: 10,
									alignment: 'left'
								},
								{
									text: 'Fechas: ' + this.period,
									fontSize: 10,
									alignment: 'left'
								}
							]
							// ,
							// {
							// 	image: img,
							// 	width: 125,
							// 	height: 80,
							// 	alignment: 'justify'
							// }
						],
						pageBreak: index != 0 ? 'before' : ''
					});

          exportFilePdf.push({
            table: {
              widths: ['*'],
              body: [[" "], [" "]]
            },
            layout: {
              hLineWidth: function(i:any, node:any) {
                return (i === 0 || i === node.table.body.length) ? 0 : 2;
              },
              vLineWidth: function(i:any, node:any) {
                return 0;
              },
            }
          });


          //============================================================================================

          console.log("===============================================================================");
          console.log(data);
          var tabla : any[] = [];

					//--------- CABECERA ------------
					if(this.chkDateHour){
						tabla.push([
							{ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Fecha de Entrada', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Hora de Entrada', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

							{ text: 'Fecha de Salida', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Hora de Salida', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

              { text: 'Duración', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Nombre de Geocerca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Posición de Geocerca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Punto Cercano', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }
						]);

						data[1].forEach((item:any, index2:any) => {

							var fh_ini  = '-';
              var fh_out  = '-';
              var fh2_ini = '-';
              var fh2_out = '-';
              if (item.fecha != "n/a") {
                var fh = item.fecha.split(" ");
                fh_ini  = fh[0];
                fh_out  = fh[1];
              }
              if (item.fecha_out != "n/a") {
                var fh2 = item.fecha_out.split(" ");
                fh2_ini  = fh2[0];
                fh2_out  = fh2[1];
              }

							var a = (index2 + 1).toString();
							//var ubicacion = item.latitud + "," + item.longitud;
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

							tabla.push([
								{ text: a, bold: true, fontSize: 6, alignment: 'center' },
                { text: fh_ini, bold: true, fontSize: 6, alignment: 'center' },
                { text: fh_out, bold: true, fontSize: 6, alignment: 'center' },
								{ text: fh2_ini, bold: true, fontSize: 6, alignment: 'center' },
                { text: fh2_out, bold: true, fontSize: 6, alignment: 'center' },

								{ text: item.duracion, bold: true, fontSize: 6, alignment: 'center'},
								{ text: item.nombre_zona, bold: true, fontSize: 6, alignment: 'center'},
                // { text: ubicacion, bold: true, fontSize: 6, alignment: 'center' },
                { text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' },

                { text: item.PC, bold: true, fontSize: 6, alignment: 'center' },
		        	]);

						});

					} else {

						tabla.push([
							{ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Fecha de Entrada', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Fecha de Salida', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Duración', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Nombre de Geocerca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Posición de Geocerca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Punto Cercano', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
						]);

						data[1].forEach((item:any, index2:any) => {

							var a = (index2 + 1).toString();
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

							tabla.push([
                  { text: a, bold: true, fontSize: 6, alignment: 'center' },
                  { text: item.fecha, bold: true, fontSize: 6, alignment: 'center' },
                  { text: item.fecha_out, bold: true, fontSize: 6, alignment: 'center'},

                  { text: item.duracion, bold: true, fontSize: 6, alignment: 'center'},
                  { text: item.nombre_zona, bold: true, fontSize: 6, alignment: 'center'},
                  // { text: ubicacion, bold: true, fontSize: 6, alignment: 'center' },
                  { text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' },

                  { text: item.PC, bold: true, fontSize: 6, alignment: 'center' },
              ]);

						});
					}

					exportFilePdf.push({
				        columns: [
				            { width: '*', text: ''},
				            {
				              width: 'auto',
				              table: {
				                body: tabla
				              }
				            },
				            { width: '*', text: ''}
				        ]
			        });

				}
			});

      // console.log("==========================================");
      // //console.log(tabla);
			// console.log(exportFilePdf);

      if(bol_datos_pdf){
        var docDefinition = {
          // pageOrientation: 'landscape',
          pageSize: 'A4',
          //pageMargins: [ 0, 0, 0, 0 ],
          pageMargins: [ 40, 40, 40, 40 ],

            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    // {
                    //   text: page.toString() + '/' + pages.toString(),
                    //   alignment: 'Left',
                    //   fontSize: 8,
                    //   margin: [30, 0, 0, 15]
                    // },
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            //header: function(currentPage:any, pageCount:any, pageSize:any) {
            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download('ReporteEntradaSalida.pdf');

      } else {
        alert('No se han encontrado datos para exportar');
      }



			// if(bol_datos_pdf){
			// 		var docDefinition = {
			//       	content: exportFilePdf,
			//       	footer: function(page:any, pages:any) {
			//           	return {
			//                 columns: [
			//                     {
			//                         alignment: 'center',
			//                         text: [
			//                             { text: '----------------------------------------------------------------------- ' + page.toString()},
			//                             ' de ',
			//                             { text: pages.toString() + ' -----------------------------------------------------------------------'}
			//                         ]
			//                     }
			//                 ],
			//                 margin: [0, 0]

			//           	};
			//       	}

			//     };
			//     pdfMake.createPdf(docDefinition).download('ReporteEntradaSalida.pdf');

			// } else {
			// 	alert('No se han encontrado datos para exportar');
			// }

		}


    exportPdfCombustible() {
			//vm.dateHour();
      var exportFilePdf :any = [];
			var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);


			this.data.forEach((data:any, index:any) =>{
				if(data[1].length > 0){
					bol_datos_pdf = true;

					exportFilePdf.push({
						columns: [
							[
								{
									text: 'REPORTE DE COMBUSTIBLE GENERAL',
									fontSize: this.c1,
									bold: true,
									alignment: 'left',
									margin: [0, 25, 0, 0]
								},
								{
									text: 'Nombre del vehículo: ' + data[0][1],
									fontSize: 10,
									alignment: 'left'
								},
								{
									text: 'Fechas: ' + this.period,
									fontSize: 10,
									alignment: 'left'
								}
							]
							// ,
							// {
							// 	image: img,
							// 	width: 125,
							// 	height: 80,
							// 	alignment: 'justify'
							// }
						],
						pageBreak: index != 0 ? 'before' : ''
					});

          exportFilePdf.push({
            table: {
              widths: ['*'],
              body: [[" "], [" "]]
            },
            layout: {
              hLineWidth: function(i:any, node:any) {
                return (i === 0 || i === node.table.body.length) ? 0 : 2;
              },
              vLineWidth: function(i:any, node:any) {
                return 0;
              },
            }
          });


          //============================================================================================

          console.log("===============================================================================");
          console.log(data);
          var tabla : any[] = [];

					//--------- CABECERA ------------

          var campo_odometro = (this.chkOdomV) ? "Odómetro Virtual": "Odómetro";

					if(this.chkDateHour){
						tabla.push([
							{ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Fecha', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Hora', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

							{ text: 'Vel. CAN (km/h)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Nivel de Combustible (%)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Consumo de Combustible (litros)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Consumo HRFC (litros)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Combustible Restante (galones)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Contacto de Motor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

              { text: campo_odometro , bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'can_rpm', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Altitud', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
						]);


						data[1].forEach((item:any, index2:any) => {

							var a = (index2 + 1).toString();
              var fh = item.fecha.split(" ");
							//var ubicacion = item.latitud + "," + item.longitud;
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
              var campo_odometro_cuerpo = (this.chkOdomV) ? item.virtual_odom: item.can_dist;

							tabla.push([
								{ text: a, bold: true, fontSize: 6, alignment: 'center' },
                { text: fh[0], bold: true, fontSize: 6, alignment: 'center' },
                { text: fh[1], bold: true, fontSize: 6, alignment: 'center' },
								{ text: item.can_speed, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.fuel_level, bold: true, fontSize: 6, alignment: 'center' },

								{ text: item.fuel_used, bold: true, fontSize: 6, alignment: 'center'},
								{ text: item.can_HRFC, bold: true, fontSize: 6, alignment: 'center'},
                { text: item.combusrestante, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.di4, bold: true, fontSize: 6, alignment: 'center' },

								{ text: campo_odometro_cuerpo, bold: true, fontSize: 6, alignment: 'center'},
								// { text: ubicacion, bold: true, fontSize: 6, alignment: 'center'},
                { text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' },
								{ text: item.can_rpm, bold: true, fontSize: 6, alignment: 'center'},
								{ text: item.altitude, bold: true, fontSize: 6, alignment: 'center'},

		        	]);


						});

					} else {

            tabla.push([
							{ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Fecha', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

							{ text: 'Vel. CAN (km/h)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Nivel de Combustible (%)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Consumo de Combustible (litros)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Consumo HRFC (litros)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Combustible Restante (galones)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Contacto de Motor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

              { text: campo_odometro , bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'can_rpm', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Altitud', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
						]);



						data[1].forEach((item:any, index2:any) => {

							var a = (index2 + 1).toString();
              var fh = item.fecha.split(" ");
							//var ubicacion = item.latitud + "," + item.longitud;
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
              var campo_odometro_cuerpo = (this.chkOdomV) ? item.virtual_odom: item.can_dist;

              tabla.push([
								{ text: a, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.fecha, bold: true, fontSize: 6, alignment: 'center' },
								{ text: item.can_speed, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.fuel_level, bold: true, fontSize: 6, alignment: 'center' },

								{ text: item.fuel_used, bold: true, fontSize: 6, alignment: 'center'},
								{ text: item.can_HRFC, bold: true, fontSize: 6, alignment: 'center'},
                { text: item.combusrestante, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.di4, bold: true, fontSize: 6, alignment: 'center' },

                { text: campo_odometro_cuerpo, bold: true, fontSize: 6, alignment: 'center'},
								// { text: ubicacion, bold: true, fontSize: 6, alignment: 'center'},
                { text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' },
								{ text: item.can_rpm, bold: true, fontSize: 6, alignment: 'center'},
								{ text: item.altitude, bold: true, fontSize: 6, alignment: 'center'},

		        	]);

						});

					}

					exportFilePdf.push({
				        columns: [
				            { width: '*', text: ''},
				            {
				              width: 'auto',
				              table: {
				                body: tabla
				              }
				            },
				            { width: '*', text: ''}
				        ]
			        });

          var tabla2 = [];

          tabla2.push([
              { text: 'TOTAL DE DISTANCIA RECORRIDA : ', bold: true, fontSize: 8, alignment: 'center' },
              { text: data[2][0], bold: true, fontSize: 6, alignment: 'center' }
            ]);
          tabla2.push([
              { text: 'TOTAL DE COMBUSTIBLE CONSUMIDO : ', bold: true, fontSize: 8, alignment: 'center' },
              { text: data[2][1], bold: true, fontSize: 6, alignment: 'center' }
            ]);
          tabla2.push([
              { text: 'TOTAL DE COMBUSTIBLE HRFC CONSUMIDO : ', bold: true, fontSize: 8, alignment: 'center' },
              { text: data[2][2], bold: true, fontSize: 6, alignment: 'center' }
            ]);
          tabla2.push([
              { text: 'RENDIMIENTO POR GALÓN : ', bold: true, fontSize: 8, alignment: 'center' },
              { text: data[2][3], bold: true, fontSize: 6, alignment: 'center' }
            ]);


          // console.log("despues del for 222222");
          exportFilePdf.push({
            columns: [
              { width: '*', text: ''},
              {
                width: 'auto',
                table: {
                body: tabla2
                }
              },
              { width: '*', text: ''}
            ]
          });



				}
			});

      // console.log("==========================================");
      // //console.log(tabla);
			// console.log(exportFilePdf);

      if(bol_datos_pdf){
        var docDefinition = {
          pageOrientation: 'landscape',
          pageSize: 'A4',
          //pageMargins: [ 0, 0, 0, 0 ],
          pageMargins: [ 40, 40, 40, 40 ],

            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    // {
                    //   text: page.toString() + '/' + pages.toString(),
                    //   alignment: 'Left',
                    //   fontSize: 8,
                    //   margin: [30, 0, 0, 15]
                    // },
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            //header: function(currentPage:any, pageCount:any, pageSize:any) {
            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download('ReporteCombustibleGeneral.pdf');

      } else {
        alert('No se han encontrado datos para exportar');
      }



			// if(bol_datos_pdf){
			// 		var docDefinition = {
			//       	content: exportFilePdf,
			//       	footer: function(page:any, pages:any) {
			//           	return {
			//                 columns: [
			//                     {
			//                         alignment: 'center',
			//                         text: [
			//                             { text: '----------------------------------------------------------------------- ' + page.toString()},
			//                             ' de ',
			//                             { text: pages.toString() + ' -----------------------------------------------------------------------'}
			//                         ]
			//                     }
			//                 ],
			//                 margin: [0, 0]

			//           	};
			//       	}

			//     };
			//     pdfMake.createPdf(docDefinition).download('ReporteEntradaSalida.pdf');

			// } else {
			// 	alert('No se han encontrado datos para exportar');
			// }

		}



    exportPdfCombustibleResumen() {
			//vm.dateHour();
      var exportFilePdf :any = [];
			var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);



			this.data.forEach((data:any, index:any) =>{
				if(data[1].length > 0){
					bol_datos_pdf = true;

					exportFilePdf.push({
						columns: [
							[
								{
									text: 'REPORTE DE COMBUSTIBLE RESUMEN',
									fontSize: this.c1,
									bold: true,
									alignment: 'left',
									margin: [0, 25, 0, 0]
								},
								// {
								// 	text: 'Nombre del vehículo: ' + data[0][1],
								// 	fontSize: 10,
								// 	alignment: 'left'
								// },
								{
									text: 'Fechas: ' + this.period,
									fontSize: 10,
									alignment: 'left'
								}
							]
							// ,
							// {
							// 	image: img,
							// 	width: 125,
							// 	height: 80,
							// 	alignment: 'justify'
							// }
						],
						pageBreak: index != 0 ? 'before' : ''
					});

          exportFilePdf.push({
            table: {
              widths: ['*'],
              body: [[" "], [" "]]
            },
            layout: {
              hLineWidth: function(i:any, node:any) {
                return (i === 0 || i === node.table.body.length) ? 0 : 2;
              },
              vLineWidth: function(i:any, node:any) {
                return 0;
              },
            }
          });


          //============================================================================================

          console.log("===============================================================================");
          console.log(data);
          var tabla : any[] = [];

					//--------- CABECERA ------------

						tabla.push([
							{ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Código', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Placa', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

							{ text: 'Fecha Inicio GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Hora Inicio GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Fecha Fin GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Hora Fin GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

							{ text: 'Distancia Recorrida', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Combustible Consumido', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Rendimiento por Galón', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Vel. Promedio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

							{ text: 'Tiempo en Movimiento', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Tiempo Relenti', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Tiempo Apagado', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

							{ text: 'Odómetro Inicial', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Odometro Final', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
						]);

						data[1].forEach((item:any, index2:any) => {

							var a = (index2 + 1).toString();

							tabla.push([
								{ text: a, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.codigo, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.placa, bold: true, fontSize: 6, alignment: 'center' },

								{ text: item.fecha_inicio, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.hora_inicio, bold: true, fontSize: 6, alignment: 'center' },
								{ text: item.fecha_final, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.hora_final, bold: true, fontSize: 6, alignment: 'center' },

                { text: item.total_distancia, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.combustible_consumido, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.rendimiento_por_galon, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.velocidad_promedio, bold: true, fontSize: 6, alignment: 'center' },

                { text: item.tiempo_movimiento, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.tiempo_relenti, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.tiempo_apagado, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.odometro_ini, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.odometro_fin, bold: true, fontSize: 6, alignment: 'center' }

		        	]);


						});


					exportFilePdf.push({
				        columns: [
				            { width: '*', text: ''},
				            {
				              width: 'auto',
				              table: {
				                body: tabla
				              }
				            },
				            { width: '*', text: ''}
				        ]
			        });

				}
			});

      // console.log("==========================================");
      // //console.log(tabla);
			// console.log(exportFilePdf);

      if(bol_datos_pdf){
        var docDefinition = {
          pageOrientation: 'landscape',
          pageSize: 'A4',
          //pageMargins: [ 0, 0, 0, 0 ],
          pageMargins: [ 40, 40, 40, 40 ],

            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    // {
                    //   text: page.toString() + '/' + pages.toString(),
                    //   alignment: 'Left',
                    //   fontSize: 8,
                    //   margin: [30, 0, 0, 15]
                    // },
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            //header: function(currentPage:any, pageCount:any, pageSize:any) {
            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download('ReporteCombustibleResumen.pdf');

      } else {
        alert('No se han encontrado datos para exportar');
      }



			// if(bol_datos_pdf){
			// 		var docDefinition = {
			//       	content: exportFilePdf,
			//       	footer: function(page:any, pages:any) {
			//           	return {
			//                 columns: [
			//                     {
			//                         alignment: 'center',
			//                         text: [
			//                             { text: '----------------------------------------------------------------------- ' + page.toString()},
			//                             ' de ',
			//                             { text: pages.toString() + ' -----------------------------------------------------------------------'}
			//                         ]
			//                     }
			//                 ],
			//                 margin: [0, 0]

			//           	};
			//       	}

			//     };
			//     pdfMake.createPdf(docDefinition).download('ReporteEntradaSalida.pdf');

			// } else {
			// 	alert('No se han encontrado datos para exportar');
			// }

		}


    exportPdfEstadoTransmision() {

			//vm.dateHour();
      var exportFilePdf :any = [];
			var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);

			this.data.forEach((data:any, index:any) =>{
				if(data[1].length > 0){
					bol_datos_pdf = true;

					exportFilePdf.push({
						columns: [
							[
								{
									text: this.report_data.rep_title,//'REPORTE DE EXCESOS DE VELOCIDAD DE LÍMITE PERSONALIZADO',
									fontSize: this.c1,
									bold: true,
									alignment: 'left',
									margin: [0, 25, 0, 0]
								},
								{
									text: 'Nombre del vehículo: ' + data[0][1],
									fontSize: 10,
									alignment: 'left'
								},
								{
									text: 'Fechas: ' + this.period,
									fontSize: 10,
									alignment: 'left'
								}
							]
						],
						pageBreak: index != 0 ? 'before' : ''
					});

          exportFilePdf.push({
            table: {
              widths: ['*'],
              body: [[" "], [" "]]
            },
            layout: {
              hLineWidth: function(i:any, node:any) {
                return (i === 0 || i === node.table.body.length) ? 0 : 2;
              },
              vLineWidth: function(i:any, node:any) {
                return 0;
              },
            }
          });

          //============================================================================================
          // console.log("===============================================================================");
          // console.log(data);

          var tabla : any[] = [];
          var cellsCampos = [];
					//--------- CABECERA ------------


              cellsCampos.push({ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Estado', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

              if(this.chkDateHour) {
                cellsCampos.push({ text: 'Fecha Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Hora Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Fecha Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Hora Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              } else {
                cellsCampos.push({ text: 'Fecha/Hora de Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Fecha/Hora de Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              }
              cellsCampos.push({ text: 'Duración', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Punto Cercano', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Geocerca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Referencia', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });


					tabla.push(cellsCampos);

              data[1].forEach( (item:any, index:any) => {

                var cellsCuerpo = [];

                var a = (index + 1).toString();
                var fh = item.fecha_ini.split(" ");
                var ffh = item.fecha_fin.split(" ");
                var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6);
                // var rreeff = ((item.referencia == "NN") ? '' : item.referencia);

                cellsCuerpo.push({ text: a, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.estado, bold: true, fontSize: 6, alignment: 'center' });

                if (this.chkDateHour) {
                    var fh = item.fecha.split(" ");
                    cellsCuerpo.push({ text: fh[0], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: fh[1], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: ffh[0], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: ffh[1], bold: true, fontSize: 6, alignment: 'center' });
                } else {
                    cellsCuerpo.push({ text: item.fecha_inicial, bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: item.fecha_final, bold: true, fontSize: 6, alignment: 'center' });
                }

                cellsCuerpo.push({ text: item.duracion, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.punto_cercano, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.zona, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.reference, bold: true, fontSize: 6, alignment: 'center' });
                // cellsCuerpo.push({ text: ubicacion, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' });

                tabla.push(cellsCuerpo);

              });


					exportFilePdf.push({
				        columns: [
				            { width: '*', text: ''},
				            {
				              width: 'auto',
				              table: {
				                body: tabla
				              }
				            },
				            { width: '*', text: ''}
				        ]
			        });

				}
			});

      if(bol_datos_pdf){
        var docDefinition = {
          pageOrientation: 'landscape',
          pageSize: 'A4',
          //pageMargins: [ 0, 0, 0, 0 ],
          pageMargins: [ 40, 40, 40, 40 ],

            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            //header: function(currentPage:any, pageCount:any, pageSize:any) {
            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download('ReporteEstadoTransmision.pdf');

      } else {
        alert('No se han encontrado datos para exportar');
      }

		}

    exportPdfEstadoTransmisionEventos() {

			//vm.dateHour();
      var exportFilePdf :any = [];
			var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);

			this.data.forEach((data:any, index:any) =>{
				if(data[1].length > 0){
					bol_datos_pdf = true;

					exportFilePdf.push({
						columns: [
							[
								{
									text: this.report_data.rep_title,//'REPORTE DE EXCESOS DE VELOCIDAD DE LÍMITE PERSONALIZADO',
									fontSize: this.c1,
									bold: true,
									alignment: 'left',
									margin: [0, 25, 0, 0]
								},
								{
									text: 'Nombre del vehículo: ' + data[0][1],
									fontSize: 10,
									alignment: 'left'
								},
								{
									text: 'Fechas: ' + this.period,
									fontSize: 10,
									alignment: 'left'
								}
							]
						],
						pageBreak: index != 0 ? 'before' : ''
					});

          exportFilePdf.push({
            table: {
              widths: ['*'],
              body: [[" "], [" "]]
            },
            layout: {
              hLineWidth: function(i:any, node:any) {
                return (i === 0 || i === node.table.body.length) ? 0 : 2;
              },
              vLineWidth: function(i:any, node:any) {
                return 0;
              },
            }
          });

          //============================================================================================
          // console.log("===============================================================================");
          // console.log(data);

          var tabla : any[] = [];
          var cellsCampos = [];
					//--------- CABECERA ------------
              cellsCampos.push({ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Estado', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

              if(this.chkDateHour) {
                cellsCampos.push({ text: 'Fecha Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Hora Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Fecha Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Hora Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

                cellsCampos.push({ text: 'Fecha Servidor Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Hora Servidor Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Fecha Servidor Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Hora Servidor Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

              } else {
                cellsCampos.push({ text: 'Fecha/Hora de Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Fecha/Hora de Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Fecha/Hora Servidor de Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Fecha/Hora Servidor de Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              }
              cellsCampos.push({ text: 'Duración', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Velocidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Ignición', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Punto Cercano', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Geocerca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Referencia', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

					tabla.push(cellsCampos);

              data[1].forEach( (item:any, index:any) => {

                var cellsCuerpo = [];

                var a = (index + 1).toString();

                var fh  = item.fecha_tracker.split(" ");
                var ffh = item.fecha_tracker_fin.split(" ");

                var fh_servidor  = item.fecha_servidor.split(" ");
                var ffh_servidor = item.fecha_servidor_fin.split(" ");

                var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6);
                // var rreeff = ((item.referencia == "NN") ? '' : item.referencia);

                cellsCuerpo.push({ text: a, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.descripcion_evento, bold: true, fontSize: 6, alignment: 'center' });

                if (this.chkDateHour) {
                    cellsCuerpo.push({ text: fh[0], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: fh[1], bold: true, fontSize: 6, alignment: 'center' });


                    if (item.fecha_tracker_fin === "") {
                      cellsCuerpo.push({ text: "", bold: true, fontSize: 6, alignment: 'center' });
                      cellsCuerpo.push({ text: "", bold: true, fontSize: 6, alignment: 'center' });
                    } else {
                      cellsCuerpo.push({ text: ffh[0], bold: true, fontSize: 6, alignment: 'center' });
                      cellsCuerpo.push({ text: ffh[1], bold: true, fontSize: 6, alignment: 'center' });
                    }

                    cellsCuerpo.push({ text: fh_servidor[0], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: fh_servidor[1], bold: true, fontSize: 6, alignment: 'center' });

                    if (item.fecha_servidor_fin === "") {
                      cellsCuerpo.push({ text: "", bold: true, fontSize: 6, alignment: 'center' });
                      cellsCuerpo.push({ text: "", bold: true, fontSize: 6, alignment: 'center' });
                    } else {
                      cellsCuerpo.push({ text: ffh_servidor[0], bold: true, fontSize: 6, alignment: 'center' });
                      cellsCuerpo.push({ text: ffh_servidor[1], bold: true, fontSize: 6, alignment: 'center' });
                    }

                } else {
                    cellsCuerpo.push({ text: item.fecha_tracker, bold: true, fontSize: 6, alignment: 'center' });

                    if (item.fecha_tracker_fin === "") {
                      cellsCuerpo.push({ text: "", bold: true, fontSize: 6, alignment: 'center' });
                    } else {
                      cellsCuerpo.push({ text: item.fecha_tracker_fin, bold: true, fontSize: 6, alignment: 'center' });
                    }

                    cellsCuerpo.push({ text: item.fecha_servidor, bold: true, fontSize: 6, alignment: 'center' });

                    if (item.fecha_servidor_fin === "") {
                      cellsCuerpo.push({ text: "", bold: true, fontSize: 6, alignment: 'center' });
                    } else {
                      cellsCuerpo.push({ text: item.fecha_servidor_fin, bold: true, fontSize: 6, alignment: 'center' });
                    }

                }

                cellsCuerpo.push({ text: item.duracion_servidor, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.vel_gps+" km/h", bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.ignicion, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.PC, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.tramo, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.referencia, bold: true, fontSize: 6, alignment: 'center' });
                // cellsCuerpo.push({ text: ubicacion, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' });

                tabla.push(cellsCuerpo);

              });


					exportFilePdf.push({
				        columns: [
				            { width: '*', text: ''},
				            {
				              width: 'auto',
				              table: {
				                body: tabla
				              }
				            },
				            { width: '*', text: ''}
				        ]
			        });

				}
			});

      if(bol_datos_pdf){
        var docDefinition = {
          pageOrientation: 'landscape',
          pageSize: 'A4',
          //pageMargins: [ 0, 0, 0, 0 ],
          pageMargins: [ 40, 40, 40, 40 ],

            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            //header: function(currentPage:any, pageCount:any, pageSize:any) {
            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download('ReporteEstadoTransmisionEventos.pdf');

      } else {
        alert('No se han encontrado datos para exportar');
      }

		}

		exportPdfGeneral() {
			var exportFilePdf :any = [];
			var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);

			this.data.forEach((data:any, index:any) =>{
				if(data[1].length > 0){
					bol_datos_pdf = true;

					exportFilePdf.push({
						columns: [
							[
								{
									text: 'REPORTE GENERAL',
									fontSize: this.c1,
									bold: true,
									alignment: 'left',
									margin: [0, 25, 0, 0]
								},
								{
									text: 'Nombre del vehículo: ' + data[0][1],
									fontSize: 10,
									alignment: 'left'
								},
								{
									text: 'Fechas: ' + this.period,
									fontSize: 10,
									alignment: 'left'
								}
							]
							// ,
							// {
							// 	image: img,
							// 	width: 125,
							// 	height: 80,
							// 	alignment: 'justify'
							// }
						],
						pageBreak: index != 0 ? 'before' : ''
					});

					exportFilePdf.push({
				        table: {
				            widths: ['*'],
				            body: [[" "], [" "]]
				        },
				        layout: {
				            hLineWidth: function(i:any, node:any) {
				                return (i === 0 || i === node.table.body.length) ? 0 : 2;
				            },
				            vLineWidth: function(i:any, node:any) {
				                return 0;
				            },
				        }
				    });

					//---**
					var tabla = [];
					var cellsCampos = [];

					cellsCampos.push({ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
					if (this.chkDateHour) {
						cellsCampos.push({ text: 'Fecha', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
						cellsCampos.push({ text: 'Hora', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
					} else {
						cellsCampos.push({ text: 'Fecha', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
					}

          if (data[2].fServidor) {
              if(this.chkDateHour) {
                  cellsCampos.push({ text: 'Fecha servidor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                  cellsCampos.push({ text: 'Hora servidor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              } else {
                  cellsCampos.push({ text: 'Fecha servidor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              }
          };

          if (data[2].pCercano) { cellsCampos.push({ text: 'Punto Cercano', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].velCAN) { cellsCampos.push({ text: 'Velocidad CAN', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].velGPS) { cellsCampos.push({ text: 'Velocidad GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].velGPS_speed) { cellsCampos.push({ text: 'Velocidad GPS speed', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].velMobileye_ME460) { cellsCampos.push({ text: 'Velocidad Mobileye', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].velECO) { cellsCampos.push({ text: 'Velocidad ECO', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].DUOT2state) { cellsCampos.push({ text: 'DUOT2 state', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].RxM) { cellsCampos.push({ text: 'Rev.X.Min', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].RPMAlta) { cellsCampos.push({ text: 'RPM Alta', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].cNivel) { cellsCampos.push({ text: 'Nivel de Combustible', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].cRestante) { cellsCampos.push({ text: 'C.Restante', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].cMotor) { cellsCampos.push({ text: 'C.Motor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].odometro) { cellsCampos.push({ text: 'Odómetro', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].altitud) { cellsCampos.push({ text: 'Altitud', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].angulo) { cellsCampos.push({ text: 'Angulo', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

          if (data[2].alimentGps) { cellsCampos.push({ text: 'Alimentación GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].nivelBateria) { cellsCampos.push({ text: 'Nivel de Batería', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].nivelCobertura) { cellsCampos.push({ text: 'Nivel de Cobertura', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].temperaturaGps) { cellsCampos.push({ text: 'Temperatura GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].satelite) { cellsCampos.push({ text: 'Satélite', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

					if (data[2].recFacial) { cellsCampos.push({ text: 'Reconocimiento Facial', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].onOff) { cellsCampos.push({ text: 'On/Off', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].alcoholemia) { cellsCampos.push({ text: 'Alcoholemia', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].parametros) { cellsCampos.push({ text: 'Parámetros', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].ubicacion) { cellsCampos.push({ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].referencia) { cellsCampos.push({ text: 'Referencia', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].fatiga) { cellsCampos.push({ text: 'Fatiga', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].fExBrusca) { cellsCampos.push({ text: 'Frenada Extrema Brusca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].fBrusca) { cellsCampos.push({ text: 'Frenada Brusca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
					if (data[2].aBrusca) { cellsCampos.push({ text: 'Aceleración Brusca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };



					tabla.push(cellsCampos);

					data[1].forEach( (item:any, index:any) => {

						var cellsCuerpo = [];

						var a = (index + 1).toString();
						var ubicacion = item.lat + "," + item.lng + "";

            var rreeff = ((item.referencia == "NN") ? '' : item.referencia);


						cellsCuerpo.push({ text: a, bold: true, fontSize: 6, alignment: 'center' });

						if (this.chkDateHour) {
							var fh = item.fecha.split(" ");
							cellsCuerpo.push({ text: fh[0], bold: true, fontSize: 6, alignment: 'center' });
							cellsCuerpo.push({ text: fh[1], bold: true, fontSize: 6, alignment: 'center' });
						} else {
							cellsCuerpo.push({ text: item.fecha, bold: true, fontSize: 6, alignment: 'center' });
						}

            if (data[2].fServidor) {
              if (this.chkDateHour) {
                var fh = item.fServidor.split(" ");
                cellsCuerpo.push({ text: fh[0], bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: fh[1], bold: true, fontSize: 6, alignment: 'center' });
              } else {
                cellsCuerpo.push({ text: item.fServidor, bold: true, fontSize: 6, alignment: 'center' });
              }
            };


            if (data[2].pCercano) { cellsCuerpo.push({ text: item.pCercano, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].velCAN) { cellsCuerpo.push({ text: item.velCAN, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].velGPS) { cellsCuerpo.push({ text: item.velGPS, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].velGPS_speed) { cellsCuerpo.push({ text: item.velGPS_speed, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].velMobileye_ME460) { cellsCuerpo.push({ text: item.velMobileye_ME460, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].velECO) { cellsCuerpo.push({ text: item.velECO, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].DUOT2state) { cellsCuerpo.push({ text: item.DUOT2state, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].RxM) { cellsCuerpo.push({ text: item.RxM, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].RPMAlta) { cellsCuerpo.push({ text: item.RPMAlta, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].cNivel) { cellsCuerpo.push({ text: item.cNivel, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].cRestante) { cellsCuerpo.push({ text: item.cRestante, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].cMotor) { cellsCuerpo.push({ text: item.cMotor, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].odometro) { cellsCuerpo.push({ text: item.odometro, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].altitud) { cellsCuerpo.push({ text: item.altitud, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].angulo) { cellsCuerpo.push({ text: item.angulo, bold: true, fontSize: 6, alignment: 'center' }); };

						if (data[2].alimentGps) { cellsCuerpo.push({ text: item.alimentGps, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].nivelBateria) { cellsCuerpo.push({ text: item.nivelBateria, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].nivelCobertura) { cellsCuerpo.push({ text: item.nivelCobertura, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].temperaturaGps) { cellsCuerpo.push({ text: item.temperaturaGps, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].satelite) { cellsCuerpo.push({ text: item.satelite, bold: true, fontSize: 6, alignment: 'center' }); };

            if (data[2].recFacial) { cellsCuerpo.push({ text: item.recFacial, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].onOff) { cellsCuerpo.push({ text: item.onOff, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].alcoholemia) { cellsCuerpo.push({ text: item.alcohol_nombre, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].parametros) { cellsCuerpo.push({ text: item.parametros, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].ubicacion) { cellsCuerpo.push(
              { text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' }); };
						if (data[2].referencia) { cellsCuerpo.push({ text: rreeff, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].fatiga) { cellsCuerpo.push({ text: item.fatiga, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].fExBrusca) { cellsCuerpo.push({ text: item.fExBrusca, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].fBrusca) { cellsCuerpo.push({ text: item.fBrusca, bold: true, fontSize: 6, alignment: 'center' }); };
						if (data[2].aBrusca) { cellsCuerpo.push({ text: item.aBrusca, bold: true, fontSize: 6, alignment: 'center' }); };


						tabla.push(cellsCuerpo);
					});

					exportFilePdf.push({
				        columns: [
				            { width: '*', text: ''},
				            {
				              width: 'auto',
				              table: {
				                body: tabla
				              }
				            },
				            { width: '*', text: ''}
				        ]
			        });
				}
			});

			console.log(exportFilePdf);



      if(bol_datos_pdf){
        var docDefinition = {
            pageOrientation: 'landscape',
            pageSize: 'A4',
            pageMargins: [ 40, 40, 40, 40 ],
            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download('ReporteGeneral.pdf');

      } else {
        alert('No se han encontrado datos para exportar');
      }

		}

    exportPdfEventosCIPIA() {
			var exportFilePdf :any = [];
			var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);

      var rs = this.eC;  //this.reportService.eC;

      var nom_pdf = '';
      if (this.report_data.num_rep == 'R040') {
          nom_pdf = "ReporteEventosInternos.pdf"; //'REPORTE DE EVENTOS INTERNO';
      } else if(this.report_data.num_rep == 'R037') {
          nom_pdf = "ReporteEventos.pdf"; //'REPORTE DE EVENTOS';
      }


			this.data.forEach((data:any, index:any) =>{
				if(data[1].length > 0){
					bol_datos_pdf = true;

					exportFilePdf.push({
						columns: [
							[
								{
                  text: this.report_data.rep_title+" "+this.str_nombre_eventos,//'REPORTE GENERAL',
									fontSize: this.c1,
									bold: true,
									alignment: 'left',
									margin: [0, 25, 0, 0]
								},
								{
									text: 'Nombre del vehículo: ' + data[0][1],
									fontSize: 10,
									alignment: 'left'
								},
								{
									text: 'Fechas: ' + this.period,
									fontSize: 10,
									alignment: 'left'
								}
							]
							// ,
							// {
							// 	image: img,
							// 	width: 125,
							// 	height: 80,
							// 	alignment: 'justify'
							// }
						],
						pageBreak: index != 0 ? 'before' : ''
					});

					exportFilePdf.push({
				        table: {
				            widths: ['*'],
				            body: [[" "], [" "]]
				        },
				        layout: {
				            hLineWidth: function(i:any, node:any) {
				                return (i === 0 || i === node.table.body.length) ? 0 : 2;
				            },
				            vLineWidth: function(i:any, node:any) {
				                return 0;
				            },
				        }
				    });

					//---**
					var tabla = [];
					var cellsCampos = [];

					cellsCampos.push({ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

          if (rs.Fecha) {
              if(this.chkDateHour) {
                  cellsCampos.push({ text: 'Fecha Evento', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                  cellsCampos.push({ text: 'Hora Evento', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              } else {
                  cellsCampos.push({ text: 'Fecha/Hora Evento', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              }
          };

          if (rs.FechaServidor) {
              if(this.chkDateHour) {
                  cellsCampos.push({ text: 'Fecha Servidor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                  cellsCampos.push({ text: 'Hora Servidor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              } else {
                  cellsCampos.push({ text: 'Fecha/Hora Servidor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              }
          };


          if (rs.NombreEvento) { cellsCampos.push({ text: 'Nombre del Evento', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Evento) { cellsCampos.push({ text: 'Descripción', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Codigo) { cellsCampos.push({ text: 'Código', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Placa) { cellsCampos.push({ text: 'Placa', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.TipoUnidad) { cellsCampos.push({ text: 'Tipo de Unidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

          if (rs.IdConductor) { cellsCampos.push({ text: 'ID Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Conductor) { cellsCampos.push({ text: 'Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

          if (rs.VelMobileye) { cellsCampos.push({ text: 'Vel.Mobileye', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.VelGPS) { cellsCampos.push({ text: 'Vel.GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.VelGPSspeed) { cellsCampos.push({ text: 'Vel.GPS speed', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.VelCAN) { cellsCampos.push({ text: 'Vel.CAN', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.VelECO) { cellsCampos.push({ text: 'Vel.ECO', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.ConMasDetalle) { cellsCampos.push({ text: 'Motivo', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

          if (rs.Zona) { cellsCampos.push({ text: 'Geocerca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.PuntoCercano) { cellsCampos.push({ text: 'Punto Cercano', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Ubicacion) { cellsCampos.push({ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Referencia) { cellsCampos.push({ text: 'Referencia', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.EnlaceArchivo) {
              cellsCampos.push({ text: 'Enlace a Archivos', colSpan:2, bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ });
            };
          if (rs.Parametros) { cellsCampos.push({ text: 'Parámetros', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };



					tabla.push(cellsCampos);

					data[1].forEach( (item:any, index:any) => {

						var cellsCuerpo = [];

						var a = (index + 1).toString();

            //var fh = item.fecha.split(" ");
            var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6);
            var rreeff = ((item.referencia == "NN") ? '' : item.referencia);


						cellsCuerpo.push({ text: a, bold: true, fontSize: 6, alignment: 'center' });

            if (rs.Fecha) {
                if (this.chkDateHour) {
                    var fh = item.fecha.split(" ");
                    cellsCuerpo.push({ text: fh[0], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: fh[1], bold: true, fontSize: 6, alignment: 'center' });
                } else {
                    cellsCuerpo.push({ text: item.fecha, bold: true, fontSize: 6, alignment: 'center' });
                }
            }

            if (rs.FechaServidor) {
                if (this.chkDateHour) {
                    var fh = item.fecha_servidor.split(" ");
                    cellsCuerpo.push({ text: fh[0], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: fh[1], bold: true, fontSize: 6, alignment: 'center' });
                } else {
                    cellsCuerpo.push({ text: item.fecha_servidor, bold: true, fontSize: 6, alignment: 'center' });
                }
            };

            // if (rs.Evento) { cellsCuerpo.push({ text: item.pCercano, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.NombreEvento) { cellsCuerpo.push({ text: item.nombre_evento, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.Evento) { cellsCuerpo.push({ text: item.descripcion_evento, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.Codigo) { cellsCuerpo.push({ text: item.codigo, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.Placa)  { cellsCuerpo.push({ text: item.placa, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.TipoUnidad) { cellsCuerpo.push({ text: item.tipo_unidad, bold: true, fontSize: 6, alignment: 'center' }); };

            if (rs.IdConductor) { cellsCuerpo.push({ text: item.idConductor, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.Conductor) { cellsCuerpo.push({ text: item.conductor, bold: true, fontSize: 6, alignment: 'center' }); };

            if (rs.VelMobileye) { cellsCuerpo.push({ text: item.vel_mobileye, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.VelGPS) { cellsCuerpo.push({ text: item.vel_gps, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.VelGPSspeed) { cellsCuerpo.push({ text: item.vel_gps_speed, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.VelCAN) { cellsCuerpo.push({ text: item.vel_can, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.VelECO) { cellsCuerpo.push({ text: item.vel_eco, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.ConMasDetalle) { cellsCuerpo.push({ text: item.motivo, bold: true, fontSize: 6, alignment: 'center' }); };

            if (rs.Zona) { cellsCuerpo.push({ text: item.tramo, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.PuntoCercano) { cellsCuerpo.push({ text: item.PC, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.Ubicacion) { cellsCuerpo.push(
                  { text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' }); };

            if (rs.Referencia) { cellsCuerpo.push({ text: rreeff, bold: true, fontSize: 6, alignment: 'center' }); };

            if (rs.EnlaceArchivo) {
              // cellsCuerpo.push({ text: item.vel_gps, bold: true, fontSize: 6, alignment: 'center' });
              // cellsCuerpo.push({ text: item.vel_gps, bold: true, fontSize: 6, alignment: 'center' });

              cellsCuerpo.push({ text: 'Imagen', link: item.enlaceImageCIPIA, bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' });
              cellsCuerpo.push({ text: 'Video', link: item.enlaceVideoCIPIA, bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' });
            };
            if (rs.Parametros) { cellsCuerpo.push({ text: item.parametros, bold: true, fontSize: 6, alignment: 'center' }); };

            //{ text: 'google', link: 'http://google.com' }


						tabla.push(cellsCuerpo);
					});


          console.log(tabla);
					exportFilePdf.push({
				        columns: [
				            { width: '*', text: ''},
				            {
				              width: 'auto',
				              table: {
				                body: tabla
				              }
				            },
				            { width: '*', text: ''}
				        ]
			        });
				}
			});



			console.log(exportFilePdf);



      if(bol_datos_pdf){
        var docDefinition = {
            pageOrientation: 'landscape',
            pageSize: 'A4',
            pageMargins: [ 40, 40, 40, 40 ],
            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download(nom_pdf);

      } else {
        alert('No se han encontrado datos para exportar');
      }

		}

    exportPdfEventosEvaluacionCIPIA() {
			var exportFilePdf :any = [];
			var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);

      var rs = this.eC; //this.reportService.eC;

      var nom_pdf = '';
      nom_pdf = "ReporteAtencionEventos.pdf"; //'REPORTE DE EVENTOS INTERNO';


			this.data.forEach((data:any, index:any) =>{
				if(data[1].length > 0){
					bol_datos_pdf = true;

					exportFilePdf.push({
						columns: [
							[
								{
									text: this.report_data.rep_title+" "+this.str_nombre_eventos,//'REPORTE GENERAL',
									fontSize: this.c1,
									bold: true,
									alignment: 'left',
									margin: [0, 25, 0, 0]
								},
								// {
								// 	text: 'Nombre del vehículo: ' + data[0][1],
								// 	fontSize: 10,
								// 	alignment: 'left'
								// },
								{
									text: 'Fechas: ' + this.period,
									fontSize: 10,
									alignment: 'left'
								}
							]
							// ,
							// {
							// 	image: img,
							// 	width: 125,
							// 	height: 80,
							// 	alignment: 'justify'
							// }
						],
						pageBreak: index != 0 ? 'before' : ''
					});

					exportFilePdf.push({
				        table: {
				            widths: ['*'],
				            body: [[" "], [" "]]
				        },
				        layout: {
				            hLineWidth: function(i:any, node:any) {
				                return (i === 0 || i === node.table.body.length) ? 0 : 2;
				            },
				            vLineWidth: function(i:any, node:any) {
				                return 0;
				            },
				        }
				    });

					//---**
					var tabla = [];
					var cellsCampos = [];

					cellsCampos.push({ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

          if (rs.Fecha) {
              if(this.chkDateHour) {
                  cellsCampos.push({ text: 'Fecha Evento', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                  cellsCampos.push({ text: 'Hora Evento', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              } else {
                  cellsCampos.push({ text: 'Fecha/Hora Evento', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              }
          };

          if (rs.FechaServidor) {
              if(this.chkDateHour) {
                  cellsCampos.push({ text: 'Fecha Servidor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                  cellsCampos.push({ text: 'Hora Servidor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              } else {
                  cellsCampos.push({ text: 'Fecha/Hora Servidor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              }
          };


          if (rs.NombreEvento) { cellsCampos.push({ text: 'Nombre del Evento', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Evento) { cellsCampos.push({ text: 'Descripción', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Codigo) { cellsCampos.push({ text: 'Código', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Placa) { cellsCampos.push({ text: 'Placa', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.TipoUnidad) { cellsCampos.push({ text: 'Tipo de Unidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

          if (rs.IdConductor) { cellsCampos.push({ text: 'ID Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Conductor) { cellsCampos.push({ text: 'Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };


          if (rs.FechaEvaluacion) {
            if(this.chkDateHour) {
                cellsCampos.push({ text: 'Fecha de Evaluación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Hora de Evaluación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            } else {
                cellsCampos.push({ text: 'Fecha/Hora de Evaluación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            }
          };

          if (rs.CriterioEvaluacion) { cellsCampos.push({ text: 'Criterio de Evaluación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Observacion) { cellsCampos.push({ text: 'Observación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.ComRadial) { cellsCampos.push({ text: 'Comunicación Radial', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };


          if (rs.VelMobileye) { cellsCampos.push({ text: 'Vel.Mobileye', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.VelGPS) { cellsCampos.push({ text: 'Vel.GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.VelGPSspeed) { cellsCampos.push({ text: 'Vel.GPS speed', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.VelCAN) { cellsCampos.push({ text: 'Vel.CAN', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.VelECO) { cellsCampos.push({ text: 'Vel.ECO', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

          if (rs.Zona) { cellsCampos.push({ text: 'Geocerca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.PuntoCercano) { cellsCampos.push({ text: 'Punto Cercano', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Ubicacion) { cellsCampos.push({ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Referencia) { cellsCampos.push({ text: 'Referencia', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.EnlaceArchivo) {
              cellsCampos.push({ text: 'Enlace a Archivos', colSpan:2, bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ });
            };
          //if (rs.Parametros) { cellsCampos.push({ text: 'Parámetros', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.OperadorMonitoreo) { cellsCampos.push({ text: 'Operador de Monitoreo', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };


					tabla.push(cellsCampos);

					data[1].forEach( (item:any, index:any) => {

						var cellsCuerpo = [];

						var a = (index + 1).toString();
            // console.log(a);


            //var fh = item.fecha.split(" ");
            var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6);
            var rreeff = ((item.referencia == "NN") ? '' : item.referencia);


						cellsCuerpo.push({ text: a, bold: true, fontSize: 6, alignment: 'center' });

            if (rs.Fecha) {
                if (this.chkDateHour) {
                    var fh = item.fecha.split(" ");
                    cellsCuerpo.push({ text: fh[0], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: fh[1], bold: true, fontSize: 6, alignment: 'center' });
                } else {
                    cellsCuerpo.push({ text: item.fecha, bold: true, fontSize: 6, alignment: 'center' });
                }
            }

            if (rs.FechaServidor) {
                if (this.chkDateHour) {
                    var fh = item.fecha_servidor.split(" ");
                    cellsCuerpo.push({ text: fh[0], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: fh[1], bold: true, fontSize: 6, alignment: 'center' });
                } else {
                    cellsCuerpo.push({ text: item.fecha_servidor, bold: true, fontSize: 6, alignment: 'center' });
                }
            };


            // if (rs.Evento) { cellsCuerpo.push({ text: item.pCercano, bold: true, fontSize: 6, alignment: 'center' }); };

            if (rs.NombreEvento) { cellsCuerpo.push({ text: item.nombre_evento, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.Evento) { cellsCuerpo.push({ text: item.descripcion_evento, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.Codigo) { cellsCuerpo.push({ text: item.codigo, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.Placa)  { cellsCuerpo.push({ text: item.placa, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.TipoUnidad) { cellsCuerpo.push({ text: item.tipo_unidad, bold: true, fontSize: 6, alignment: 'center' }); };

            if (rs.IdConductor) { cellsCuerpo.push({ text: item.idConductor, bold: true, fontSize: 6, alignment: 'center' }); };

            var conductor = '';
            if (item.conductor == null) {
              conductor = '';
            } else {
              conductor = item.conductor;
            }

            if (rs.Conductor) { cellsCuerpo.push({ text: conductor, bold: true, fontSize: 6, alignment: 'center' }); };

            if (rs.FechaEvaluacion) {
                if(this.chkDateHour) {
                    var fh: any  = ['',''];
                    var fh_full: any = '';
                    if (item.fecha_evaluacion == "" || item.fecha_evaluacion == null) {
                    } else {
                        fh = item.fecha_evaluacion.split(" ");
                        fh_full = item.fecha_evaluacion;
                    }
                    cellsCuerpo.push({ text: fh[0], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: fh[1], bold: true, fontSize: 6, alignment: 'center' });
                } else {
                    cellsCuerpo.push({ text: fh_full, bold: true, fontSize: 6, alignment: 'center' });
                }
            };

            var criterio_evaluacion = '';
            if (item.criterio_evaluacion == null) {
              criterio_evaluacion = '';
            } else {
              criterio_evaluacion = item.criterio_evaluacion;
            }


            if (rs.CriterioEvaluacion) { cellsCuerpo.push({ text: criterio_evaluacion, bold: true, fontSize: 6, alignment: 'center' }); };

            var observacion_evaluacion = '';
            if (item.observacion_evaluacion == null) {
              observacion_evaluacion = '';
            } else {
              observacion_evaluacion = item.observacion_evaluacion;
            }

            if (rs.Observacion) { cellsCuerpo.push({ text: observacion_evaluacion, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.Observacion) { cellsCuerpo.push({ text: item.ComRadial, bold: true, fontSize: 6, alignment: 'center' }); };

            if (rs.VelMobileye) { cellsCuerpo.push({ text: item.vel_mobileye, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.VelGPS) { cellsCuerpo.push({ text: item.vel_gps, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.VelGPSspeed) { cellsCuerpo.push({ text: item.vel_gps_speed, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.VelCAN) { cellsCuerpo.push({ text: item.vel_can, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.VelECO) { cellsCuerpo.push({ text: item.vel_eco, bold: true, fontSize: 6, alignment: 'center' }); };

            if (rs.Zona) { cellsCuerpo.push({ text: item.tramo, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.PuntoCercano) { cellsCuerpo.push({ text: item.PC, bold: true, fontSize: 6, alignment: 'center' }); };
            if (rs.Ubicacion) { cellsCuerpo.push(
              { text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' }); };

            if (rs.Referencia) { cellsCuerpo.push({ text: rreeff, bold: true, fontSize: 6, alignment: 'center' }); };

            if (rs.EnlaceArchivo) {
              // cellsCuerpo.push({ text: item.vel_gps, bold: true, fontSize: 6, alignment: 'center' });
              // cellsCuerpo.push({ text: item.vel_gps, bold: true, fontSize: 6, alignment: 'center' });

              cellsCuerpo.push({ text: 'Imagen', link: item.enlaceImageCIPIA, bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' });
              cellsCuerpo.push({ text: 'Video', link: item.enlaceVideoCIPIA, bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' });
            };
            //if (rs.Parametros) { cellsCuerpo.push({ text: item.parametros, bold: true, fontSize: 6, alignment: 'center' }); };

            var operador_monitoreo = '';
            if (item.operador_monitoreo == null) {
              operador_monitoreo = '';
            } else {
              operador_monitoreo = item.operador_monitoreo;
            }

            if (rs.OperadorMonitoreo) { cellsCuerpo.push({ text: operador_monitoreo, bold: true, fontSize: 6, alignment: 'center' }); };

            //{ text: 'google', link: 'http://google.com' }


						tabla.push(cellsCuerpo);
					});

          console.log("==================3");

          console.log(tabla);
					exportFilePdf.push({
				        columns: [
				            { width: '*', text: ''},
				            {
				              width: 'auto',
				              table: {
				                body: tabla
				              }
				            },
				            { width: '*', text: ''}
				        ]
			        });
				}
			});


      console.log("==================4");

			//console.log(exportFilePdf);



      if(bol_datos_pdf){
        var docDefinition = {
            pageOrientation: 'landscape',
            pageSize: 'A4',
            pageMargins: [ 40, 40, 40, 40 ],
            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download(nom_pdf);

      } else {
        alert('No se han encontrado datos para exportar');
      }

		}

    exportPdfPosicion() {
      //vm.dateHour();
      var exportFilePdf :any = [];
      var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);
      console.log("============= DATA ==============");
      console.log(this.data);

      //this.data.forEach((data:any, index:any) =>{
        //if(data[1].length > 0){
        if(this.sortedData.length > 0){
          bol_datos_pdf = true;

          exportFilePdf.push({
            columns: [
              [
                {
                  text: this.report_data.rep_title, //'REPORTE DE POSICIÓN',
                  fontSize: 10,//this.c1,
                  bold: true,
                  alignment: 'left',
                  margin: [0, 25, 0, 0]
                },
                {
                  text: this.report_data.rep_subtitle, //'Nombre del vehículo: ' + data[0][1],
                  fontSize: this.c1,//10,
                  alignment: 'left'
                },
                // {
                //   text: 'Fechas: ' + this.period,
                //   fontSize: 10,
                //   alignment: 'left'
                // }
              ]
            ],
            //pageBreak: index != 0 ? 'before' : ''
            pageBreak: 0 != 0 ? 'before' : ''

          });

          exportFilePdf.push({
            table: {
              widths: ['*'],
              body: [[" "], [" "]]
            },
            layout: {
              hLineWidth: function(i:any, node:any) {
                return (i === 0 || i === node.table.body.length) ? 0 : 2;
              },
              vLineWidth: function(i:any, node:any) {
                return 0;
              },
            }
          });

          var tabla : any[] = [];
          //--------- CABECERA ------------
          if(this.chkDateHour){
            tabla.push([
              { text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Código', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Placa', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

              { text: 'Fecha', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Hora', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

              { text: 'Status', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Velocidad GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Velocidad CAN', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Odómetro', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Geocerca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Referencia', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

            ]);

            this.sortedData.forEach((item:any, index2:any) => {


              var a = (index2 + 1).toString();
              //var ubicacion = item.latitud + "," + item.longitud;
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

              var fh = item.fecha.split(" ");
              var fh_ini  = fh[0];
              var fh_out  = fh[1];

              tabla.push([
                { text: a, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.codigo, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.placa, bold: true, fontSize: 6, alignment: 'center' },

                { text: fh_ini, bold: true, fontSize: 6, alignment: 'center' },
                { text: fh_out, bold: true, fontSize: 6, alignment: 'center' },

                { text: item.estado, bold: true, fontSize: 6, alignment: 'center'},
                { text: item.conductor, bold: true, fontSize: 6, alignment: 'center'},
                { text: item.velocidad, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.velocidad_can, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.odometro, bold: true, fontSize: 6, alignment: 'center'},
                // { text: ubicacion , bold: true, fontSize: 6, alignment: 'center'},
                { text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' },

                { text: item.tramo, bold: true, fontSize: 6, alignment: 'center' },
                { text: item.referencia, bold: true, fontSize: 6, alignment: 'center' },

              ]);

            });

          } else {

            tabla.push([
              { text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Código', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Placa', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

              { text: 'Fecha y Hora', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

              { text: 'Status', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Velocidad GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Velocidad CAN', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Odómetro', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Geocerca', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Referencia', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
            ]);

            this.sortedData.forEach((item:any, index2:any) => {

              var a = (index2 + 1).toString();
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

              tabla.push([
                  { text: a, bold: true, fontSize: 6, alignment: 'center' },
                  { text: item.codigo, bold: true, fontSize: 6, alignment: 'center' },
                  { text: item.placa, bold: true, fontSize: 6, alignment: 'center' },

                  { text: item.fecha, bold: true, fontSize: 6, alignment: 'center' },

                  { text: item.estado, bold: true, fontSize: 6, alignment: 'center'},
                  { text: item.conductor, bold: true, fontSize: 6, alignment: 'center'},
                  { text: item.velocidad, bold: true, fontSize: 6, alignment: 'center' },
                  { text: item.velocidad_can, bold: true, fontSize: 6, alignment: 'center' },
                  { text: item.odometro, bold: true, fontSize: 6, alignment: 'center'},
                  // { text: ubicacion , bold: true, fontSize: 6, alignment: 'center'},
                  { text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' },
                  { text: item.tramo, bold: true, fontSize: 6, alignment: 'center' },
                  { text: item.referencia, bold: true, fontSize: 6, alignment: 'center' },
              ]);

            });
          }

          exportFilePdf.push({
                columns: [
                    { width: '*', text: ''},
                    {
                      width: 'auto',
                      table: {
                        body: tabla
                      }
                    },
                    { width: '*', text: ''}
                ]
              });

        }
      //});

      if(bol_datos_pdf){
        var docDefinition = {
          pageOrientation: 'landscape',
          pageSize: 'A4',
          //pageMargins: [ 0, 0, 0, 0 ],
          pageMargins: [ 40, 40, 40, 40 ],

            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },
            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download('ReportePosicion.pdf');

      } else {
        alert('No se han encontrado datos para exportar');
      }

    }


    exportPdfExcesosVelocidadDuracionToleranciaRiesgo_1() {
        //vm.dateHour();
        var exportFilePdf :any = [];
        var bol_datos_pdf = false;

        var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
        console.log(fecha_ejecucion);
        console.log("============= DATA ============== exportPdfExcesosVelocidadDuracionToleranciaRiesgo ");
        console.log(this.data);

        var rs = this.eC; //this.reportService.eC;

        //this.data.forEach((data:any, index:any) =>{
          //if(data[1].length > 0){
          if(this.sortedData.length > 0) {
            bol_datos_pdf = true;

            exportFilePdf.push({
              columns: [
                [
                  {
                    text: this.report_data.rep_title, //'REPORTE DE POSICIÓN',
                    fontSize: 10,//this.c1,
                    bold: true,
                    alignment: 'left',
                    margin: [0, 25, 0, 0]
                  },
                  {
                    text: this.report_data.rep_subtitle, //'Nombre del vehículo: ' + data[0][1],
                    fontSize: this.c1,//10,
                    alignment: 'left'
                  },
                  // {
                  //   text: 'Fechas: ' + this.period,
                  //   fontSize: 10,
                  //   alignment: 'left'
                  // }
                ]
              ],
              //pageBreak: index != 0 ? 'before' : ''
              pageBreak: 0 != 0 ? 'before' : ''

            });

            exportFilePdf.push({
              table: {
                widths: ['*'],
                body: [[" "], [" "]]
              },
              layout: {
                hLineWidth: function(i:any, node:any) {
                  return (i === 0 || i === node.table.body.length) ? 0 : 2;
                },
                vLineWidth: function(i:any, node:any) {
                  return 0;
                },
              }
            });

              var tabla : any = [];

              var cabecera:any = [];

              cabecera.push({ text: 'Item', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              if (rs.Fecha) { cabecera.push({ text: 'Fecha', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              if (rs.Hora) { cabecera.push({ text: 'Hora', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              if (rs.Codigo) { cabecera.push({ text: 'Unidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              if (rs.Placa) { cabecera.push({ text: 'Placa', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              if (rs.Zona) { cabecera.push({ text: 'Zona', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              cabecera.push({ text: 'Límite de Velocidad de Zona', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

              if (!this.chkRiesgo) { cabecera.push({ text: 'Exceso de Velocidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

              if (this.chkRiesgo) { cabecera.push({ text: 'Leve(1,2)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              if (this.chkRiesgo) { cabecera.push({ text: 'Grave(3,5)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              if (this.chkRiesgo) { cabecera.push({ text: 'Muy Grave(>=6)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

              cabecera.push({ text: 'Inicio del Exceso', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cabecera.push({ text: 'Hora del Exceso', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cabecera.push({ text: 'Fin del Exceso', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cabecera.push({ text: 'Duración', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

              if (rs.IdConductor) { cabecera.push({ text: 'ID Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              if (rs.Conductor) { cabecera.push({ text: 'Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

              if (rs.VelMobileye) { cabecera.push({ text: 'Vel.ADAS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              if (rs.VelGPSspeed) { cabecera.push({ text: 'Vel.GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              if (rs.VelCAN) { cabecera.push({ text: 'Vel.CAN', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              if (rs.Satelite) { cabecera.push({ text: 'Satélite', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
              if (rs.Ubicacion) { cabecera.push({ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

              tabla.push(cabecera);

              this.sortedData.forEach((item:any, index2:any) => {

                // var a = (index2 + 1).toString();
                // var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

                var cuerpo:any = [];

                var fhi =  (item.fecha_inicio === undefined) ? ["",""]: item.fecha_inicio.split(" ");

                var fhi_1 =  (item.fecha_inicio === undefined) ? ["",""]: item.fecha_inicio.split(" ");
                var fhi_2 =  (item.hora_exceso === undefined) ? ["",""]: item.fecha_inicio.split(" ");
                var fhi_3 =  (item.fin_exceso === undefined) ? ["",""]: item.fecha_inicio.split(" ");

                console.log("====================== ITEM");
                console.log(item);

                var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";


                cuerpo.push({ text: item.col1, bold: true, fontSize: 6, alignment: 'center' });
                if (rs.Fecha) { cuerpo.push({ text: fhi[0], bold: true, fontSize: 6, alignment: 'center' }); };
                if (rs.Hora) { cuerpo.push({ text: fhi[1], bold: true, fontSize: 6, alignment: 'center' }); };
                if (rs.Codigo) { cuerpo.push({ text: item.codigo, bold: true, fontSize: 6, alignment: 'center' }); };
                if (rs.Placa) { cuerpo.push({ text: item.placa, bold: true, fontSize: 6, alignment: 'center' }); };
                if (rs.Zona) { cuerpo.push({ text: item.nombre_zona, bold: true, fontSize: 6, alignment: 'center' }); };
                cuerpo.push({ text: item.v0, bold: true, fontSize: 6, alignment: 'center' });

                if (!this.chkRiesgo) { cuerpo.push({ text: item.velocidad, bold: true, fontSize: 6, alignment: 'center' }); };

                if (this.chkRiesgo) { cuerpo.push({ text: item.vel_leve, bold: true, fontSize: 6, alignment: 'center' }); };
                if (this.chkRiesgo) { cuerpo.push({ text: item.vel_grave, bold: true, fontSize: 6, alignment: 'center' }); };
                if (this.chkRiesgo) { cuerpo.push({ text: item.vel_muy_grave, bold: true, fontSize: 6, alignment: 'center' }); };

                cuerpo.push({ text: fhi_1[1], bold: true, fontSize: 6, alignment: 'center' });
                cuerpo.push({ text: fhi_2[1], bold: true, fontSize: 6, alignment: 'center' });
                cuerpo.push({ text: fhi_3[1], bold: true, fontSize: 6, alignment: 'center' });
                cuerpo.push({ text: item.duracion2, bold: true, fontSize: 6, alignment: 'center' });

                if (rs.IdConductor) { cuerpo.push({ text: item.idConductor, bold: true, fontSize: 6, alignment: 'center' }); };
                if (rs.Conductor) { cuerpo.push({ text: item.conductor, bold: true, fontSize: 6, alignment: 'center' }); };

                if (rs.VelMobileye) { cuerpo.push({ text: item.velMobileye_ME460, bold: true, fontSize: 6, alignment: 'center' }); };
                if (rs.VelGPSspeed) { cuerpo.push({ text: item.GPS_speed, bold: true, fontSize: 6, alignment: 'center' }); };
                if (rs.VelCAN) { cuerpo.push({ text: item.can_speed, bold: true, fontSize: 6, alignment: 'center' }); };
                if (rs.Satelite) { cuerpo.push({ text: item.sat, bold: true, fontSize: 6, alignment: 'center' }); };
                if (rs.Ubicacion) { cuerpo.push({ text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' }); };

                tabla.push(cuerpo);

              });


            exportFilePdf.push({
                  columns: [
                      { width: '*', text: ''},
                      {
                        width: 'auto',
                        table: {
                          body: tabla
                        }
                      },
                      { width: '*', text: ''}
                  ]
                });

          }
        //});

        if(bol_datos_pdf){
          var docDefinition = {
            pageOrientation: 'landscape',
            pageSize: 'A4',
            //pageMargins: [ 0, 0, 0, 0 ],
            pageMargins: [ 40, 40, 40, 40 ],

              content: exportFilePdf,
              footer: function(page:any, pages:any) {
                return {
                    columns: [
                      {
                        text: page.toString() + '/' + pages.toString(),
                        alignment: 'right',
                        fontSize: 8,
                        margin: [0, 0, 30, 15]
                      }
                    ]

                };
              },
              header: (currentPage:any, pageCount:any, pageSize:any) => {
                  return {
                      columns: [
                        { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                        {
                          image: this.logo_gltracker2,
                          width: 90,
                          height: 25,
                          alignment: 'right',
                          margin: [0, 5, 0, 0]
                        },
                        { width: 30, text: ''},
                      ]
                  };
              },

          };
          pdfMake.createPdf(docDefinition).download('ReportePosicion.pdf');

        } else {
          alert('No se han encontrado datos para exportar');
        }

    }

    exportPdfExcesosVelocidadDuracionToleranciaRiesgo() {
			var exportFilePdf :any = [];
			var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);

      var rs = this.eC; //this.reportService.eC;

      var nom_pdf = '';
      // nom_pdf = "ReporteExcesosVelocidad.pdf"; //'REPORTE DE EVENTOS INTERNO';
      var nom_pdf: string = '';
      if (this.report_data.num_rep == 'R041') {
        nom_pdf = "ReporteExcesosVelocidad.pdf";
      } else  if (this.report_data.num_rep == 'R044') {
        nom_pdf = "ReporteExcesosVelocidadDireccion.pdf";
      }

			this.data.forEach((data:any, index:any) =>{
				if(data[1].length > 0){
					bol_datos_pdf = true;

					exportFilePdf.push({
						columns: [
							[
								{
									text: this.report_data.rep_title+" "+this.str_nombre_eventos,//'REPORTE GENERAL',
									fontSize: this.c1,
									bold: true,
									alignment: 'left',
									margin: [0, 25, 0, 0]
								},
								// {
								// 	text: 'Nombre del vehículo: ' + data[0][1],
								// 	fontSize: 10,
								// 	alignment: 'left'
								// },
								{
									text: 'Fechas: ' + this.period,
									fontSize: 10,
									alignment: 'left'
								}
							]
							// ,
							// {
							// 	image: img,
							// 	width: 125,
							// 	height: 80,
							// 	alignment: 'justify'
							// }
						],
						pageBreak: index != 0 ? 'before' : ''
					});

					exportFilePdf.push({
				        table: {
				            widths: ['*'],
				            body: [[" "], [" "]]
				        },
				        layout: {
				            hLineWidth: function(i:any, node:any) {
				                return (i === 0 || i === node.table.body.length) ? 0 : 2;
				            },
				            vLineWidth: function(i:any, node:any) {
				                return 0;
				            },
				        }
				    });

					//---**
					var tabla = [];

          var cabecera:any = [];

          cabecera.push({ text: 'Item', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          if (rs.Fecha) { cabecera.push({ text: 'Fecha', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Hora) { cabecera.push({ text: 'Hora', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Codigo) { cabecera.push({ text: 'Unidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Placa) { cabecera.push({ text: 'Placa', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Zona) { cabecera.push({ text: 'Zona', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          cabecera.push({ text: 'Límite de Velocidad de Zona', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

          if (!this.chkRiesgo) { cabecera.push({ text: 'Exceso de Velocidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

          if (this.chkRiesgo) { cabecera.push({ text: 'Leve(1,2)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (this.chkRiesgo) { cabecera.push({ text: 'Grave(3,5)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (this.chkRiesgo) { cabecera.push({ text: 'Muy Grave(>=6)', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

          cabecera.push({ text: 'Inicio del Exceso', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          cabecera.push({ text: 'Hora del Exceso', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          cabecera.push({ text: 'Fin del Exceso', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
          cabecera.push({ text: 'Duración', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

          if (rs.IdConductor) { cabecera.push({ text: 'ID Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Conductor) { cabecera.push({ text: 'Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

          if (rs.VelMobileye) { cabecera.push({ text: 'Vel.ADAS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.VelGPSspeed) { cabecera.push({ text: 'Vel.GPS', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.VelCAN) { cabecera.push({ text: 'Vel.CAN', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Satelite) { cabecera.push({ text: 'Satélite', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };
          if (rs.Ubicacion) { cabecera.push({ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }); };

          tabla.push(cabecera);

					data[1].forEach( (item:any, index:any) => {


            var cuerpo:any = [];

            var fhi =  (item.fecha_inicio == "") ? ["",""]: item.fecha_inicio.split(" ");

            var fhi_1 =  (item.fecha_inicio === "") ? ["",""]: item.fecha_inicio.split(" ");
            var fhi_2 =  (item.hora_exceso === "") ? ["",""]: item.hora_exceso.split(" ");
            var fhi_3 =  (item.fin_exceso === "") ? ["",""]: item.fin_exceso.split(" ");

            console.log("====================== ITEM");
            console.log(item);
            console.log(fhi_1[1]+" - "+fhi_2[1]+" - "+fhi_3[1]);


            var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

            var color = "";
            if (item.es_resumen) {
              color = "#E5E3D9";
              ubicacion = "";
            }


            cuerpo.push({ text: item.col1, bold: true, fontSize: 6, alignment: 'center', fillColor: color });
            if (rs.Fecha) { cuerpo.push({ text: fhi[0], bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            if (rs.Hora) { cuerpo.push({ text: fhi[1], bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            if (rs.Codigo) { cuerpo.push({ text: item.codigo, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            if (rs.Placa) { cuerpo.push({ text: item.placa, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            if (rs.Zona) { cuerpo.push({ text: item.nombre_zona, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            cuerpo.push({ text: item.v0, bold: true, fontSize: 6, alignment: 'center', fillColor: color  });

            if (!this.chkRiesgo) { cuerpo.push({ text: item.velocidad, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };

            if (this.chkRiesgo) { cuerpo.push({ text: item.vel_leve, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            if (this.chkRiesgo) { cuerpo.push({ text: item.vel_grave, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            if (this.chkRiesgo) { cuerpo.push({ text: item.vel_muy_grave, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };

            cuerpo.push({ text: fhi_1[1], bold: true, fontSize: 6, alignment: 'center', fillColor: color });
            cuerpo.push({ text: fhi_2[1], bold: true, fontSize: 6, alignment: 'center', fillColor: color });
            cuerpo.push({ text: fhi_3[1], bold: true, fontSize: 6, alignment: 'center', fillColor: color });
            cuerpo.push({ text: item.duracion2, bold: true, fontSize: 6, alignment: 'center', fillColor: color });

            if (rs.IdConductor) { cuerpo.push({ text: item.idConductor, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            if (rs.Conductor) { cuerpo.push({ text: item.conductor, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };

            if (rs.VelMobileye) { cuerpo.push({ text: item.velMobileye_ME460, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            if (rs.VelGPSspeed) { cuerpo.push({ text: item.GPS_speed, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            if (rs.VelCAN) { cuerpo.push({ text: item.can_speed, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            if (rs.Satelite) { cuerpo.push({ text: item.sat, bold: true, fontSize: 6, alignment: 'center', fillColor: color }); };
            if (rs.Ubicacion) { cuerpo.push({ text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF', fillColor: color }); };

            tabla.push(cuerpo);


					});

          console.log("==================3");

          console.log(tabla);
					exportFilePdf.push({
				        columns: [
				            { width: '*', text: ''},
				            {
				              width: 'auto',
				              table: {
				                body: tabla
				              }
				            },
				            { width: '*', text: ''}
				        ]
			        });
				}
			});


      console.log("==================4");

			//console.log(exportFilePdf);



      if(bol_datos_pdf){
        var docDefinition = {
            pageOrientation: 'landscape',
            pageSize: 'A4',
            pageMargins: [ 40, 40, 40, 40 ],
            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download(nom_pdf);

      } else {
        alert('No se han encontrado datos para exportar');
      }

		}



    //exportPdfExcesosVelocidadNuevoFormato
    exportPdfExcesosVelocidadNuevoFormato() {
			//vm.dateHour();
      var exportFilePdf :any = [];
			var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);

			this.data.forEach((data:any, index:any) =>{
				if(data[1].length > 0){
					bol_datos_pdf = true;

					exportFilePdf.push({
						columns: [
							[
								{
									text: this.report_data.rep_title,//'REPORTE DE EXCESOS DE VELOCIDAD (NUEVO FORMATO)',
									fontSize: this.c1,
									bold: true,
									alignment: 'left',
									margin: [0, 25, 0, 0]
								},
								{
									text: 'Nombre del vehículo: ' + data[0][1],
									fontSize: 10,
									alignment: 'left'
								},
								{
									text: 'Fechas: ' + this.period,
									fontSize: 10,
									alignment: 'left'
								}
							]
						],
						pageBreak: index != 0 ? 'before' : ''
					});

          exportFilePdf.push({
            table: {
              widths: ['*'],
              body: [[" "], [" "]]
            },
            layout: {
              hLineWidth: function(i:any, node:any) {
                return (i === 0 || i === node.table.body.length) ? 0 : 2;
              },
              vLineWidth: function(i:any, node:any) {
                return 0;
              },
            }
          });

          //============================================================================================
          console.log("===============================================================================");
          console.log(data);

          var tabla : any[] = [];
					//--------- CABECERA ------------
					if(this.chkDateHour){
						tabla.push([
							{ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Fecha', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Hora', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

							{ text: 'Código', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Placa', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Tipo de Unidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

              { text: 'Id Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

              { text: 'Tramo', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Límite de Velocidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Exceso de Velocidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }
						]);

						data[1].forEach((item:any, index2:any) => {

              var a = (index2 + 1).toString();
              var fh = item.fecha_inicio.split(" ");

							//var ubicacion = item.latitud + "," + item.longitud;
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

							tabla.push([
								{ text: a, bold: true, fontSize: 6, alignment: 'center' },
                { text: fh[0], bold: true, fontSize: 6, alignment: 'center' },
                { text: fh[1], bold: true, fontSize: 6, alignment: 'center' },

								{ text: item.codigo, bold: true, fontSize: 6, alignment: 'center'},
                { text: item.placa, bold: true, fontSize: 6, alignment: 'center'},
                { text: item.tipo_unidad, bold: true, fontSize: 6, alignment: 'center'},

								{ text: item.idConductor, bold: true, fontSize: 6, alignment: 'center'},
								{ text: item.conductor, bold: true, fontSize: 6, alignment: 'center'},

								{ text: item.nombre_zona, bold: true, fontSize: 6, alignment: 'center'},
                { text: item.v0+" Km/h", bold: true, fontSize: 6, alignment: 'center' },
                { text: item.velocidad+" Km/h", bold: true, fontSize: 6, alignment: 'center' },
                { text: ubicacion, bold: true, fontSize: 6, alignment: 'center' },

		        	]);

						});

					} else {

						tabla.push([
							{ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Fecha', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

							{ text: 'Código', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Placa', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Tipo de Unidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

              { text: 'Id Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
              { text: 'Conductor', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },

              { text: 'Tramo', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Límite de Velocidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Exceso de Velocidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' },
							{ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' }
						]);

						data[1].forEach((item:any, index2:any) => {

							var a = (index2 + 1).toString();
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

							tabla.push([
                  { text: a, bold: true, fontSize: 6, alignment: 'center' },
                  { text: item.fecha_inicio, bold: true, fontSize: 6, alignment: 'center' },

                  { text: item.codigo, bold: true, fontSize: 6, alignment: 'center'},
                  { text: item.placa, bold: true, fontSize: 6, alignment: 'center'},
                  { text: item.tipo_unidad, bold: true, fontSize: 6, alignment: 'center'},

                  { text: item.idConductor, bold: true, fontSize: 6, alignment: 'center'},
                  { text: item.conductor, bold: true, fontSize: 6, alignment: 'center'},

                  { text: item.nombre_zona, bold: true, fontSize: 6, alignment: 'center'},
                  { text: item.v0+" Km/h", bold: true, fontSize: 6, alignment: 'center' },
                  { text: item.velocidad+" Km/h", bold: true, fontSize: 6, alignment: 'center' },
                  { text: ubicacion, bold: true, fontSize: 6, alignment: 'center' },

              ]);

						});
					}

					exportFilePdf.push({
				        columns: [
				            { width: '*', text: ''},
				            {
				              width: 'auto',
				              table: {
				                body: tabla
				              }
				            },
				            { width: '*', text: ''}
				        ]
			        });

				}
			});

      if(bol_datos_pdf){
        var docDefinition = {
          pageOrientation: 'landscape',
          pageSize: 'A4',
          //pageMargins: [ 0, 0, 0, 0 ],
          pageMargins: [ 40, 40, 40, 40 ],

            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            //header: function(currentPage:any, pageCount:any, pageSize:any) {
            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download('ReporteExcesosVelocidadFormatoExtendido.pdf');

      } else {
        alert('No se han encontrado datos para exportar');
      }

		}



    //exportPdfExcesosVelocidadNuevoFormato
    exportPdfExcesosVelocidadLimitePersonalizado() {

			//vm.dateHour();
      var exportFilePdf :any = [];
			var bol_datos_pdf = false;

      var fecha_ejecucion = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      console.log(fecha_ejecucion);

			this.data.forEach((data:any, index:any) =>{
				if(data[1].length > 0){
					bol_datos_pdf = true;

					exportFilePdf.push({
						columns: [
							[
								{
									text: this.report_data.rep_title,//'REPORTE DE EXCESOS DE VELOCIDAD DE LÍMITE PERSONALIZADO',
									fontSize: this.c1,
									bold: true,
									alignment: 'left',
									margin: [0, 25, 0, 0]
								},
								{
									text: 'Nombre del vehículo: ' + data[0][1],
									fontSize: 10,
									alignment: 'left'
								},
								{
									text: 'Fechas: ' + this.period,
									fontSize: 10,
									alignment: 'left'
								}
							]
						],
						pageBreak: index != 0 ? 'before' : ''
					});

          exportFilePdf.push({
            table: {
              widths: ['*'],
              body: [[" "], [" "]]
            },
            layout: {
              hLineWidth: function(i:any, node:any) {
                return (i === 0 || i === node.table.body.length) ? 0 : 2;
              },
              vLineWidth: function(i:any, node:any) {
                return 0;
              },
            }
          });

          //============================================================================================
          // console.log("===============================================================================");
          // console.log(data);

          var tabla : any[] = [];
          var cellsCampos = [];
					//--------- CABECERA ------------

          if(this.chkDuracion){

              cellsCampos.push({ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              if(this.chkDateHour) {
                cellsCampos.push({ text: 'Fecha de Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Hora de Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Fecha de Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Hora de Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              } else {
                cellsCampos.push({ text: 'Inicio', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
                cellsCampos.push({ text: 'Fin', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              }
              cellsCampos.push({ text: 'Duración', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Cant. de Tramas', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Tramas', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Vel. Min.', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Vel. Máx.', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Punto Cercano', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Zona Cercana', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

          } else {

            cellsCampos.push({ text: 'Ítem', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            cellsCampos.push({ text: 'Nombre', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            if(this.chkDateHour) {
              cellsCampos.push({ text: 'Fecha', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
              cellsCampos.push({ text: 'Hora', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            } else {
              cellsCampos.push({ text: 'Fecha y Hora', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            }
            cellsCampos.push({ text: 'Máxima Velocidad', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            cellsCampos.push({ text: 'Ubicación', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            cellsCampos.push({ text: 'Punto Cercano', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });
            cellsCampos.push({ text: 'Referencia', bold: true, fontSize: 10, color: '#005277', alignment: 'center' });

          }

					tabla.push(cellsCampos);

          if(this.chkDuracion){
              data[1].forEach( (item:any, index:any) => {

                var cellsCuerpo = [];

                var a = (index + 1).toString();
                var fh = item.fecha_inicial.split(" ");
                var ffh = item.fecha_final.split(" ");
                var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6);
                // var rreeff = ((item.referencia == "NN") ? '' : item.referencia);

                cellsCuerpo.push({ text: a, bold: true, fontSize: 6, alignment: 'center' });

                if (this.chkDateHour) {
                    var fh = item.fecha.split(" ");
                    cellsCuerpo.push({ text: fh[0], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: fh[1], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: ffh[0], bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: ffh[1], bold: true, fontSize: 6, alignment: 'center' });
                } else {
                    cellsCuerpo.push({ text: item.fecha_inicial, bold: true, fontSize: 6, alignment: 'center' });
                    cellsCuerpo.push({ text: item.fecha_final, bold: true, fontSize: 6, alignment: 'center' });
                }

                cellsCuerpo.push({ text: item.duracion, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.cant_tramas, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.string_tramas, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.vel_min, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.vel_max, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.PC, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: item.ZC, bold: true, fontSize: 6, alignment: 'center' });
                // cellsCuerpo.push({ text: ubicacion, bold: true, fontSize: 6, alignment: 'center' });
                cellsCuerpo.push({ text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' });


                tabla.push(cellsCuerpo);

              });
          } else {
            data[1].forEach( (item:any, index:any) => {

              var cellsCuerpo = [];

              var a = (index + 1).toString();
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6);
              var rreeff = ((item.referencia == "NN") ? '' : item.referencia);

              cellsCuerpo.push({ text: a, bold: true, fontSize: 6, alignment: 'center' });
              cellsCuerpo.push({ text: item.nombre, bold: true, fontSize: 6, alignment: 'center' });
              if (this.chkDateHour) {
                  var fh = item.fecha.split(" ");
                  cellsCuerpo.push({ text: fh[0], bold: true, fontSize: 6, alignment: 'center' });
                  cellsCuerpo.push({ text: fh[1], bold: true, fontSize: 6, alignment: 'center' });
              } else {
                  cellsCuerpo.push({ text: item.fecha, bold: true, fontSize: 6, alignment: 'center' });
              }
              cellsCuerpo.push({ text: item.maxima_velocidad, bold: true, fontSize: 6, alignment: 'center' });
              // cellsCuerpo.push({ text: ubicacion, bold: true, fontSize: 6, alignment: 'center' });
              cellsCuerpo.push({ text: ubicacion, link: "http://maps.google.com/maps?q="+ubicacion+"&t=m" ,bold: true, fontSize: 6, alignment: 'center', color:'#0000FF' });
              cellsCuerpo.push({ text: item.PC, bold: true, fontSize: 6, alignment: 'center' });
              cellsCuerpo.push({ text: rreeff, bold: true, fontSize: 6, alignment: 'center' });

              tabla.push(cellsCuerpo);

            });

          }

					exportFilePdf.push({
				        columns: [
				            { width: '*', text: ''},
				            {
				              width: 'auto',
				              table: {
				                body: tabla
				              }
				            },
				            { width: '*', text: ''}
				        ]
			        });

				}
			});

      if(bol_datos_pdf){
        var docDefinition = {
          pageOrientation: 'landscape',
          pageSize: 'A4',
          //pageMargins: [ 0, 0, 0, 0 ],
          pageMargins: [ 40, 40, 40, 40 ],

            content: exportFilePdf,
            footer: function(page:any, pages:any) {
              return {
                  columns: [
                    {
                      text: page.toString() + '/' + pages.toString(),
                      alignment: 'right',
                      fontSize: 8,
                      margin: [0, 0, 30, 15]
                    }
                  ]

              };
            },

            //header: function(currentPage:any, pageCount:any, pageSize:any) {
            header: (currentPage:any, pageCount:any, pageSize:any) => {
                return {
                    columns: [
                      { text: fecha_ejecucion, alignment: 'left',fontSize: 8, margin: [30, 15, 0, 0]},
                      {
                        image: this.logo_gltracker2,
                        width: 90,
                        height: 25,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                      },
                      { width: 30, text: ''},
                    ]
                };
            },

        };
        pdfMake.createPdf(docDefinition).download('ReporteExcesosVelocidad.pdf');

      } else {
        alert('No se han encontrado datos para exportar');
      }

		}




      // exportPdfReporteGerencial() {

      //     console.log("===================================");
      //     console.log(this.arrDataGrafico);
      //     console.log(this.arrDataPlot);

      // }




  exportPdfReporteGerencial() {
    var exportFilePdf = [];
    var bol_datos_pdf = true;

    // console.log(vm.arrDataGrafico);
    // console.log(vm.arrDataPlot);


    var titulos = ['Eventos Por Unidad','Eventos Por Fecha','Eventos Por Geocerca','Eventos Por Conductor',
        'Eventos Por Unidad','Eventos Por Fecha','Eventos Por Geocerca','Eventos Por Conductor',
        'Eventos Por Unidad','Eventos Por Fecha','Eventos Por Geocerca','Eventos Por Conductor'];

    // var titulosEvento = ['DISTRACCIÓN','','  ','',
    //     'POSIBLE FATIGA','','  ','',
    //     'FATIGA EXTREMA','','  ',''];

    var titulosEvento = ['DISTRACCIÓN','DISTRACCIÓN','DISTRACCIÓN','DISTRACCIÓN',
        'POSIBLE FATIGA','POSIBLE FATIGA','POSIBLE FATIGA','POSIBLE FATIGA',
        'FATIGA EXTREMA','FATIGA EXTREMA','FATIGA EXTREMA','FATIGA EXTREMA'];
    // var myCanvas = somePlot.getCanvas();

    var tabla = [];

    tabla.push([
      { text: 'EVENTOS', bold: true, fontSize: 10, alignment: 'center' },
      { text: 'NRO DE EVENTOS', bold: true, fontSize: 10, alignment: 'center' },
    ]);

    tabla.push([
      { text: "DISTRACCIÓN", bold: true, fontSize: 6, alignment: 'center' },
      { text: this.arrDataTabla.distraccion, bold: true, fontSize: 6, alignment: 'center' },
    ]);
    tabla.push([
      { text: "POSIBLE FATIGA", bold: true, fontSize: 6, alignment: 'center' },
      { text: this.arrDataTabla.posible_fatiga, bold: true, fontSize: 6, alignment: 'center' },
    ]);
    tabla.push([
      { text: "FATIGA EXTREMA", bold: true, fontSize: 6, alignment: 'center' },
      { text: this.arrDataTabla.fatiga_extrema, bold: true, fontSize: 6, alignment: 'center' },
    ]);

    exportFilePdf.push({
      columns: [
        {
          image: this.logo_cruzdelsur,
          width: 120,
          height: 36,
          alignment: 'left'
        },
        { width: '*', text: ''},
        { text: "", bold: true, fontSize: 12, alignment: 'center' },
        { width: '*', text: ''},
        {
          image: this.logo_gltracker,
          width: 120,
          height: 36,
          alignment: '‘right’'
        }
      ]

    });





    var p1 = this.period; //"2022-06-02 00:00:00  -  2022-06-03 23:59:00";
    console.log(p1);//['2022-03-31 00:00:00.000 - 2022-06-09 23:59:59']
    console.log(p1[0]);//['2022-03-31 00:00:00.000 - 2022-06-09 23:59:59']
    console.log(p1[0].split(" - "));//['2022-03-31 00:00:00.000 - 2022-06-09 23:59:59']

    var p11 = p1.split(" - "); //"2022-06-02"
    console.log(p11);
    // p11[0].split(" "); //"2022-06-02"
    // p11[1].split(" "); //"2022-06-02"

    var p3 = p11[0].split(" ")[0].split("-");
    var p4 = p11[1].split(" ")[0].split("-");

    // var p2 = p1.split(" "); //"2022-06-02"

    // var p3 = p2[0].split("-");
    // var p4 = p2[3].split("-");
    console.log(p3);
    console.log(p4);

    console.log(p3[2]+"/"+p3[1]+"/"+p3[0].substring(2));
    console.log(p4[2]+"/"+p4[1]+"/"+p4[0].substring(2));

    console.log("DE "+p3[2]+"/"+p3[1]+"/"+p3[0].substring(2)+" AL "+p4[2]+"/"+p4[1]+"/"+p4[0].substring(2));

    var rango_fecha = "DE "+p3[2]+"/"+p3[1]+"/"+p3[0].substring(2)+" AL "+p4[2]+"/"+p4[1]+"/"+p4[0].substring(2);

    exportFilePdf.push({
      columns: [
        { width: '*', text: ''},
        { text: rango_fecha, bold: true, fontSize: 12, alignment: 'center' },
        { width: '*', text: ''},
      ]
    });

    exportFilePdf.push({
      table: {
        widths: ['*'],
        body: [[" "], [" "]]
      },
      layout: {
        hLineWidth: function(i:any, node:any) {
          return  0;
        },
        vLineWidth: function(i:any, node:any) {
          return 0;
        },
      }
    });

    exportFilePdf.push({
      columns: [
        { width: '*', text: ''},
        { text: "RESUMEN DE EVENTOS", bold: true, fontSize: 12, alignment: 'center' },
        { width: '*', text: ''},
      ]
    });


    // console.log(logo_cruzdelsur);

    // exportFilePdf.push({
    // 	columns: [
    // 		{ width: '*', text: ''},
    // 		{
    // 			image: logo_cruzdelsur,
    // 			width: 400,
    // 			height: 200,
    // 			alignment: 'left'
    // 		},
    // 		{ width: '*', text: ''}
    // 	]
    // });




    exportFilePdf.push({
      table: {
        widths: ['*'],
        body: [[" "], [" "]]
      },
      layout: {
        hLineWidth: function(i:any, node:any) {
          return  0;
        },
        vLineWidth: function(i:any, node:any) {
          return 0;
        },
      }
    });

    exportFilePdf.push({
      columns: [
        { width: '*', text: ''},
        {
          width: 'auto',
          table: {
          body: tabla
          }
        },
        { width: '*', text: ''}
      ]
    });

    exportFilePdf.push({
      columns: [
        { width: '*', text: ''},
      ],
      pageBreak:  'before'
    });


    for (let index = 0; index < this.arrDataPlot.length; index++) {

      //if (titulosEvento[index] != '') {

        //Titulos => DISTRACCION - POSIBLE FATIGA - FATIGA EXTREMA
        exportFilePdf.push({
          columns: [
            {
              image: this.logo_cruzdelsur,
              width: 120,
              height: 36,
              alignment: 'left'
            },
            { width: '*', text: ''},
            {
              width: 'auto',
              text: titulosEvento[index],
              fontSize: 12,
              bold: true
            },
            { width: '*', text: ''},
            {
              image: this.logo_gltracker,
              width: 120,
              height: 36,
              alignment: 'right'
            }
          ]
        });

      //}



      exportFilePdf.push({
        columns: [
          { width: '*', text: ''},
          {
            width: 'auto',
            text: titulos[index]
          },
          { width: '*', text: ''}
        ]
      });

      //espacio luego del titulos
      exportFilePdf.push({
      	table: {
      		widths: ['*'],
      		body: [[" "]]
      	},
      	layout: {
      		hLineWidth: function(i:any, node:any) {
      			return  0;
      		},
      		vLineWidth: function(i:any, node:any) {
      			return 0;
      		},
      	}
      });


      const somePlot :any = this.arrDataPlot[index];

      if (somePlot != '') {


        var myCanvas = somePlot.getCanvas();
        var image = myCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream");  /// here is the most important part because if you dont replace you will get a DOM 18 exception.
        // console.log(image);
        // document.location.href=image;

        exportFilePdf.push({
          columns: [
            { width: '*', text: ''},
            {
              image: image,
              width: 400,
              height: 350,//195,
              alignment: 'left'
            },
            { width: '*', text: ''}
          ]
        });

        // Espacio debajo del grafico
        exportFilePdf.push({
          table: {
            widths: ['*'],
            body: [[" "]]
          },
          layout: {
            hLineWidth: function(i:any, node:any) {
              return  0;
            },
            vLineWidth: function(i:any, node:any) {
              return 0;
            },
          }
        });

      }

      //Salto de pagina cada 2 imagenes
      //if (index==1 || index==3 || index==5 || index == 7 || index==9) {
      if ( index != (this.arrDataPlot.length - 1) ) {
        exportFilePdf.push({
          columns: [
            { width: '*', text: ''},
          ],
          pageBreak: 'before'        //index != 0 ? 'before' : ''
        });
      }

    }

    // console.log(exportFilePdf);

    if(bol_datos_pdf){
      var docDefinition = {
        pageOrientation: 'landscape',
            content: exportFilePdf,
            footer: function(page:any, pages:any) {
                return {
                    columns: [
                        {
                            alignment: 'center',
                            text: [
                                { text: '----------------------------------------------------------------------- ' + page.toString()},
                                ' de ',
                                { text: pages.toString() + ' -----------------------------------------------------------------------'}
                            ]
                        }
                    ],
                    margin: [0, 0]

                };
            }

        };
        pdfMake.createPdf(docDefinition).download('ReporteSensorFatiga.pdf');

    } else {
      alert('No se han encontrado datos para exportar');
    }
  }

  getOptionsForRow(evento : any){
    return this.evaluationCriteriaService.getOptionBySlug(evento);
  }

}
